import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import './index.css';



        // COMPONENTES DE INTERFACE
        const FormSection = ({ title, children }) => (
          <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-slate-200 mb-6">
            <h3 className="text-lg font-bold text-emerald-800 mb-4 border-b pb-2">{title}</h3>
            <div className="space-y-4">{children}</div>
          </div>
        );

        function formatTimeBlock(timeStr) {
          if (!timeStr) return '';
          const parts = timeStr.split(':');
          if (parts.length >= 2) return `${parts[0]}:${parts[1]}`;
          return timeStr;
        }

        const generatePixPayload = (key, name, city, amount) => {
          try {
            const pad = (s) => String(s.length).padStart(2, '0');
            const formatField = (id, value) => id + pad(value) + value;

            let payload = '';
            payload += formatField('00', '01');
            payload += formatField('01', '11');
            
            const gui = formatField('00', 'br.gov.bcb.pix');
            const keyField = formatField('01', key);
            payload += formatField('26', gui + keyField);
            
            payload += formatField('52', '0000');
            payload += formatField('53', '986');
            
            if (amount) {
              payload += formatField('54', Number(amount).toFixed(2));
            }
            
            payload += formatField('58', 'BR');
            
            const safeName = (name || 'Clinica').substring(0, 25).normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^A-Za-z0-9 ]/g, "");
            const safeCity = (city || 'Cidade').substring(0, 15).normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^A-Za-z0-9 ]/g, "");
            
            payload += formatField('59', safeName || 'Clinica');
            payload += formatField('60', safeCity || 'Cidade');
            
            payload += formatField('62', formatField('05', '***'));
            payload += '6304';
            
            let crc = 0xFFFF;
            for (let i = 0; i < payload.length; i++) {
              crc ^= payload.charCodeAt(i) << 8;
              for (let j = 0; j < 8; j++) {
                if ((crc & 0x8000) !== 0) {
                  crc = (crc << 1) ^ 0x1021;
                } else {
                  crc = crc << 1;
                }
              }
            }
            const crcHex = (crc & 0xFFFF).toString(16).toUpperCase().padStart(4, '0');
            return payload + crcHex;
          } catch (e) {
            return '';
          }
        };

        const InputGroup = ({ label, type = "text", value, onChange, placeholder = "", className = "", readOnly = false, required = false, actionIcon = null, onActionClick = null }) => (
          <div className={`flex flex-col ${className}`}>
            <label className="text-sm font-semibold text-slate-600 mb-1">{label}</label>
            <div className="relative flex">
              <input type={type} value={value} onChange={onChange} placeholder={placeholder} readOnly={readOnly} required={required} className={`px-3 py-2 border border-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 w-full ${actionIcon ? 'rounded-l-md border-r-0' : 'rounded-md'}`} />
              {actionIcon && (
                <button type="button" onClick={onActionClick} className="bg-emerald-50 border border-slate-300 border-l-0 text-emerald-700 px-3 rounded-r-md hover:bg-emerald-100 transition-colors flex items-center justify-center flex-shrink-0 min-w-[46px]">
                  {actionIcon}
                </button>
              )}
            </div>
          </div>
        );

        const TextAreaGroup = ({ label, value, onChange, rows = 3 }) => (
          <div className="flex flex-col">
            <label className="text-sm font-semibold text-slate-600 mb-1">{label}</label>
            <textarea value={value} onChange={onChange} rows={rows} className="px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500" />
          </div>
        );

         const SelectGroup = ({ label, value, options, onChange, className = "" }) => (
            <div className={`flex flex-col ${className}`}>
              <label className="text-xs font-bold text-slate-500 uppercase mb-1">{label}</label>
              <select 
                value={value} 
                onChange={(e) => onChange(e.target.value)}
                className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:border-emerald-500 bg-white text-sm outline-none"
              >
                {options.map(opt => <option key={opt} value={opt}>{opt}</option>)}
              </select>
            </div>
          );

          const ZoomModal = ({ imageUrl, onClose }) => {
            if (!imageUrl) return null;
            return (
              <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[1000] p-4 cursor-zoom-out animate-fadeIn" onClick={onClose}>
                <div className="relative max-w-5xl max-h-screen">
                  <img src={imageUrl} className="max-w-full max-h-[90vh] rounded-lg shadow-2xl scale-in" onClick={e => e.stopPropagation()} />
                  <button onClick={onClose} className="absolute -top-12 right-0 text-white hover:text-emerald-400 transition-colors">
                    <i className="ph ph-x-circle text-[40px]"></i>
                  </button>
                </div>
              </div>
            );
          };

         const RadioYesNo = ({ label, value, onChange }) => (
           <div className="flex flex-col">
             <label className="text-xs font-bold text-slate-500 uppercase mb-1">{label}</label>
             <div className="flex gap-4 mt-1">
               <label className="flex items-center gap-2 cursor-pointer text-sm">
                 <input type="radio" checked={value === 'Sim'} onChange={() => onChange('Sim')} className="text-emerald-600" /> Sim
               </label>
               <label className="flex items-center gap-2 cursor-pointer text-sm">
                 <input type="radio" checked={value === 'Não'} onChange={() => onChange('Não')} className="text-emerald-600" /> Não
               </label>
             </div>
           </div>
         );

        const SignatureModal = ({ isOpen, onClose, onConfirm, role, callback }) => {
           const canvasRef = useRef(null);
           const videoRef = useRef(null);
           const [isDrawing, setIsDrawing] = useState(false);
           const [hasSignature, setHasSignature] = useState(false);
           const [cameraError, setCameraError] = useState('');
           const streamRef = useRef(null);

           useEffect(() => {
               if (isOpen) {
                   navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' } })
                   .then(stream => {
                       streamRef.current = stream;
                       if (videoRef.current) {
                           videoRef.current.srcObject = stream;
                           videoRef.current.play();
                       }
                   })
                   .catch(err => {
                       console.error("Camera error:", err);
                       setCameraError('Câmera indisponível.');
                   });
                   
                   setTimeout(() => {
                       if (canvasRef.current) {
                           const canvas = canvasRef.current;
                           canvas.width = canvas.offsetWidth;
                           canvas.height = canvas.offsetHeight;
                           const ctx = canvas.getContext('2d');
                           ctx.lineWidth = 2;
                           ctx.lineCap = 'round';
                           ctx.strokeStyle = '#000';
                       }
                   }, 100);
               } else {
                   if (streamRef.current) {
                       streamRef.current.getTracks().forEach(track => track.stop());
                       streamRef.current = null;
                   }
                   setHasSignature(false);
               }
           }, [isOpen]);

           const startDrawing = (e) => {
               const canvas = canvasRef.current;
               if (!canvas) return;
               const ctx = canvas.getContext('2d');
               const rect = canvas.getBoundingClientRect();
               const clientX = e.touches ? e.touches[0].clientX : e.clientX;
               const clientY = e.touches ? e.touches[0].clientY : e.clientY;
               ctx.beginPath();
               ctx.moveTo(clientX - rect.left, clientY - rect.top);
               setIsDrawing(true);
           };

           const draw = (e) => {
               if (!isDrawing) return;
               e.preventDefault(); 
               const canvas = canvasRef.current;
               const ctx = canvas.getContext('2d');
               const rect = canvas.getBoundingClientRect();
               const clientX = e.touches ? e.touches[0].clientX : e.clientX;
               const clientY = e.touches ? e.touches[0].clientY : e.clientY;
               ctx.lineTo(clientX - rect.left, clientY - rect.top);
               ctx.stroke();
               setHasSignature(true);
           };

           const stopDrawing = () => {
               setIsDrawing(false);
               if (canvasRef.current) canvasRef.current.getContext('2d').closePath();
           };
           
           const clearSignature = () => {
               const canvas = canvasRef.current;
               if (!canvas) return;
               const ctx = canvas.getContext('2d');
               ctx.clearRect(0, 0, canvas.width, canvas.height);
               setHasSignature(false);
               setIsDrawing(false);
           };

           const handleConfirm = () => {
               if (!hasSignature) {
                   alert("Por favor, assine antes de confirmar.");
                   return;
               }
               const signatureBase64 = canvasRef.current.toDataURL('image/png');
               let photoBase64 = null;
               
               if (videoRef.current && streamRef.current && !cameraError) {
                   const canvas = document.createElement('canvas');
                   canvas.width = videoRef.current.videoWidth;
                   canvas.height = videoRef.current.videoHeight;
                   const ctx = canvas.getContext('2d');
                   ctx.translate(canvas.width, 0);
                   ctx.scale(-1, 1);
                   ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
                   photoBase64 = canvas.toDataURL('image/jpeg', 0.8);
               }
               if (callback) { callback(signatureBase64, photoBase64); } else { onConfirm({ signature: signatureBase64, photo: photoBase64, role }); }
               onClose();
           };

           if (!isOpen) return null;

           return (
               <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[200] p-4 text-slate-800 animate-fadeIn">
                   <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl overflow-hidden flex flex-col scale-in">
                       <div className="bg-emerald-800 text-white p-4 flex justify-between items-center">
                           <h3 className="text-xl font-bold flex items-center"><i className="ph ph-pen-nib mr-2"></i> Coleta de Assinatura - {role}</h3>
                           <button onClick={onClose} className="text-white/80 hover:text-white"><i className="ph ph-x text-2xl"></i></button>
                       </div>
                       <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                           <div>
                               <h4 className="font-semibold text-slate-700 mb-2 border-b pb-2 flex items-center"><i className="ph ph-camera mr-2"></i> Selfie de Segurança</h4>
                               <div className="bg-black rounded-xl overflow-hidden aspect-video relative flex items-center justify-center shadow-inner">
                                   {cameraError ? (
                                       <div className="text-white/50 text-sm">{cameraError}</div>
                                   ) : (
                                       <video ref={videoRef} className="w-full h-full object-cover transform scale-x-[-1]" playsInline muted autoPlay></video>
                                   )}
                                   {!cameraError && <div className="absolute bottom-2 left-2 bg-black/50 text-white text-xs px-2 py-1 rounded">Câmera Ativa</div>}
                               </div>
                               <p className="text-xs text-slate-500 mt-2">A foto será capturada automaticamente ao confirmar a assinatura.</p>
                           </div>
                           <div className="flex flex-col">
                               <div className="flex justify-between items-center mb-2 border-b pb-2">
                                   <h4 className="font-semibold text-slate-700 flex items-center"><i className="ph ph-signature mr-2"></i> Assine no quadro</h4>
                                   <button type="button" onClick={clearSignature} className="text-xs text-red-500 hover:text-red-700 font-semibold flex items-center"><i className="ph ph-eraser mr-1"></i> Limpar</button>
                               </div>
                               <div className="flex-1 bg-slate-50 border-2 border-dashed border-slate-300 rounded-xl relative overflow-hidden min-h-[200px]" style={{ touchAction: 'none' }}>
                                   <canvas 
                                       ref={canvasRef}
                                       onMouseDown={startDrawing}
                                       onMouseMove={draw}
                                       onMouseUp={stopDrawing}
                                       onMouseLeave={stopDrawing}
                                       onTouchStart={startDrawing}
                                       onTouchMove={draw}
                                       onTouchEnd={stopDrawing}
                                       className="w-full h-full cursor-crosshair absolute inset-0"
                                   ></canvas>
                               </div>
                           </div>
                       </div>
                       <div className="p-4 bg-slate-50 border-t flex justify-end gap-3">
                           <button onClick={onClose} className="px-6 py-2 rounded-lg font-bold border border-slate-300 text-slate-600 hover:bg-slate-100 transition-colors">Cancelar</button>
                           <button onClick={handleConfirm} disabled={!hasSignature} className={`px-8 py-2 rounded-lg font-bold flex items-center gap-2 transition-colors ${hasSignature ? 'bg-emerald-600 hover:bg-emerald-700 text-white shadow-md' : 'bg-slate-200 text-slate-400 cursor-not-allowed'}`}>
                               <i className="ph ph-check-circle text-xl"></i> Confirmar Coleta
                           </button>
                       </div>
                   </div>
               </div>
           );
        };

        const ConfirmPresenceFlow = ({ open, context, onClose, onSaved, onShowToast }) => {
          const canvasRef = useRef(null);
          const videoRef = useRef(null);
          const streamRef = useRef(null);
          const sigDataUrlRef = useRef(null);
          const [step, setStep] = useState('choose');
          const [isDrawing, setIsDrawing] = useState(false);
          const [hasSignature, setHasSignature] = useState(false);
          const [cameraError, setCameraError] = useState('');
          const [linkUrl, setLinkUrl] = useState('');
          const [patientNameInput, setPatientNameInput] = useState('');

          useEffect(() => {
            if (!open || !context) return;
            setStep(context.startAtStep || 'choose');
            setHasSignature(false);
            setIsDrawing(false);
            setCameraError('');
            setLinkUrl('');
            setPatientNameInput(String(context.patientName || '').trim());
            sigDataUrlRef.current = null;
          }, [open, context]);

          useEffect(() => {
            if (!open || step !== 'sign') return;
            const t = setTimeout(() => {
              const c = canvasRef.current;
              if (!c) return;
              c.width = c.offsetWidth || 400;
              c.height = c.offsetHeight || 220;
            const ctx = c.getContext('2d');
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, c.width, c.height);
            ctx.lineWidth = 3;
            ctx.lineCap = 'round';
            ctx.strokeStyle = '#0f172a';
            }, 100);
            return () => clearTimeout(t);
          }, [open, step]);

          useEffect(() => {
            if (!open || step !== 'selfie') {
              if (streamRef.current) {
                streamRef.current.getTracks().forEach((tr) => tr.stop());
                streamRef.current = null;
              }
              return undefined;
            }
            setCameraError('');
            navigator.mediaDevices
              .getUserMedia({ video: { facingMode: 'user' } })
              .then((stream) => {
                streamRef.current = stream;
                if (videoRef.current) {
                  videoRef.current.srcObject = stream;
                  videoRef.current.play();
                }
              })
              .catch(() => setCameraError('Câmera indisponível.'));
            return () => {
              if (streamRef.current) {
                streamRef.current.getTracks().forEach((tr) => tr.stop());
                streamRef.current = null;
              }
            };
          }, [open, step]);

          const clearCanvas = () => {
            const c = canvasRef.current;
            if (!c) return;
            const ctx = c.getContext('2d');
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, c.width, c.height);
            setHasSignature(false);
          };

          const startDraw = (e) => {
            const c = canvasRef.current;
            if (!c) return;
            const ctx = c.getContext('2d');
            const r = c.getBoundingClientRect();
            const x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
            const y = (e.touches ? e.touches[0].clientY : e.clientY) - r.top;
            ctx.beginPath();
            ctx.moveTo(x, y);
            setIsDrawing(true);
          };
          const draw = (e) => {
            if (!isDrawing) return;
            e.preventDefault();
            const c = canvasRef.current;
            const ctx = c.getContext('2d');
            const r = c.getBoundingClientRect();
            const x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
            const y = (e.touches ? e.touches[0].clientY : e.clientY) - r.top;
            ctx.lineTo(x, y);
            ctx.stroke();
            setHasSignature(true);
          };
          const endDraw = () => setIsDrawing(false);

          const goSignNext = () => {
            if (!hasSignature) {
              if (onShowToast) onShowToast('Assine no quadro antes de continuar.', 'error');
              return;
            }
            sigDataUrlRef.current = canvasRef.current.toDataURL('image/png');
            setStep('selfie');
          };

          const captureSelfie = () => {
            let selfie = null;
            if (videoRef.current && streamRef.current && !cameraError) {
              try {
                const cv = document.createElement('canvas');
                cv.width = videoRef.current.videoWidth || 640;
                cv.height = videoRef.current.videoHeight || 480;
                const ctx = cv.getContext('2d');
                ctx.translate(cv.width, 0);
                ctx.scale(-1, 1);
                ctx.drawImage(videoRef.current, 0, 0, cv.width, cv.height);
                selfie = cv.toDataURL('image/jpeg', 0.85);
              } catch (e) {
                console.error('Selfie error', e);
              }
            }
            const record = {
              id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
              patientName: (patientNameInput || '').trim() || context.patientName,
              professionalName: context.professionalName,
              professionalId: context.professionalId || '',
              agendaEventId: context.agendaEventId || null,
              date: context.date,
              time: context.time,
              procedure: context.procedure || '',
              type: context.type || '',
              method: context.remoteToken ? 'link' : 'device',
              signatureDataUrl: sigDataUrlRef.current,
              selfieDataUrl: selfie,
              createdAt: new Date().toISOString(),
            };
            onSaved(record, context.remoteToken);
            onClose();
          };

          const createLink = () => {
            const pname = (patientNameInput || '').trim() || String(context.patientName || '').trim() || 'Paciente';
            const token = rcPresenceGenToken();
            const item = {
              token,
              patientName: pname,
              professionalName: context.professionalName,
              professionalId: context.professionalId || '',
              agendaEventId: context.agendaEventId || null,
              date: context.date,
              time: context.time,
              procedure: context.procedure || '',
              type: context.type || '',
              createdAt: new Date().toISOString(),
            };
            const list = rcPresencePendingLoad();
            rcPresencePendingSave([item, ...list.filter((x) => x.token !== token)]);
            let u = '';
            try {
              u = `${window.location.origin}${window.location.pathname}?remote_presence=${encodeURIComponent(token)}`;
            } catch (e) {
              u = `?remote_presence=${encodeURIComponent(token)}`;
            }
            setLinkUrl(u);
            setStep('link');
          };

          const copyLink = () => {
            if (!linkUrl) return;
            navigator.clipboard.writeText(linkUrl).then(
              () => onShowToast && onShowToast('Link copiado.'),
              () => onShowToast && onShowToast('Não foi possível copiar.', 'error')
            );
          };

          const whatsappLink = () => {
            if (!linkUrl) return;
            const msg = `Olá! Confirme sua presença na clínica abrindo este link:\n${linkUrl}`;
            
            let phoneStr = '';
            if (context.patientPhone) {
               phoneStr = context.patientPhone.replace(/\D/g, '');
               if (phoneStr.length === 11 || phoneStr.length === 10) {
                 phoneStr = '55' + phoneStr;
               }
            }
            if (phoneStr) {
               window.open(`https://wa.me/${phoneStr}?text=${encodeURIComponent(msg)}`, '_blank', 'noopener,noreferrer');
            } else {
               window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank', 'noopener,noreferrer');
            }
          };

          if (!open || !context) return null;
          const pname = (patientNameInput || '').trim() || context.patientName || 'Paciente';

                  const header = (
            <div className="flex items-start justify-between gap-3 px-6 pt-6 pb-2">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-emerald-500 text-white shadow-md">
                  <i className="ph ph-check text-[22px] font-bold"></i>
                </span>
                <div>
                  <h3 className="text-lg font-bold text-slate-900">Confirmar Presença</h3>
                  {step === 'choose' ? (
                    <p className="text-sm text-slate-600 mt-1 pr-2">
                      Como deseja confirmar a presença de <strong className="text-slate-900">{pname}</strong>?
                    </p>
                  ) : null}
                </div>
              </div>
              <button type="button" onClick={onClose} className="p-2 rounded-full text-slate-500 hover:bg-slate-200/80" aria-label="Fechar">
                <i className="ph ph-x text-xl"></i>
              </button>
            </div>
          );

          return (
            <div
              className="fixed inset-0 z-[220] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-fadeIn"
              onClick={() => step === 'choose' && onClose()}
            >
              <div className="bg-[#d9d9d9] rounded-3xl shadow-2xl w-full max-w-2xl overflow-hidden max-h-[95vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                {header}
                <div className="px-6 pb-6">
                  {step === 'choose' && (
                    <div className="flex flex-col gap-3 mt-2">
                      <div className="bg-white rounded-2xl border border-slate-200/80 p-4 shadow-sm">
                        <label className="text-xs font-bold text-slate-600">Nome do paciente</label>
                        <input
                          className="mt-2 w-full px-4 py-3 rounded-xl border border-slate-200 text-sm font-semibold text-slate-800 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                          value={patientNameInput}
                          onChange={(e) => setPatientNameInput(e.target.value)}
                          placeholder="Digite o nome do paciente…"
                        />
                      </div>
                      <button
                        type="button"
                        onClick={() => setStep('sign')}
                        className="flex w-full items-start gap-4 rounded-2xl bg-white p-4 text-left shadow-sm border border-slate-200/80 hover:border-violet-300 hover:shadow-md transition-all"
                      >
                        <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-violet-100 text-violet-600">
                          <i className="ph ph-pen-nib text-2xl"></i>
                        </span>
                        <div>
                          <div className="font-bold text-slate-900">Assinar Agora</div>
                          <p className="text-sm text-slate-500 mt-1">O paciente assina e tira selfie neste dispositivo.</p>
                        </div>
                      </button>
                      <button
                        type="button"
                        onClick={createLink}
                        className="flex w-full items-start gap-4 rounded-2xl bg-white p-4 text-left shadow-sm border border-slate-200/80 hover:border-emerald-300 hover:shadow-md transition-all"
                      >
                        <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-emerald-100 text-emerald-700">
                          <i className="ph ph-device-mobile text-2xl"></i>
                        </span>
                        <div>
                          <div className="font-bold text-slate-900">Enviar Link p/ Celular</div>
                          <p className="text-sm text-slate-500 mt-1">Gera um link e envia via WhatsApp para o paciente.</p>
                        </div>
                      </button>
                    </div>
                  )}
                  {step === 'sign' && (
                    <div className="mt-2">
                      <p className="text-sm text-slate-600 mb-3">Assinatura de <strong>{pname}</strong></p>
                      <div
                        className="rounded-2xl border-2 border-dashed border-slate-300 bg-white overflow-hidden"
                        style={{ touchAction: 'none' }}
                      >
                        <canvas
                          ref={canvasRef}
                          onMouseDown={startDraw}
                          onMouseMove={draw}
                          onMouseUp={endDraw}
                          onMouseLeave={endDraw}
                          onTouchStart={startDraw}
                          onTouchMove={draw}
                          onTouchEnd={endDraw}
                          className="w-full h-[260px] md:h-[280px] cursor-crosshair block"
                        />
                      </div>
                      <div className="flex gap-3 mt-4 justify-between">
                        <button type="button" onClick={clearCanvas} className="px-10 py-3 rounded-xl font-bold bg-slate-200 text-slate-700 hover:bg-slate-300">
                          Limpar
                        </button>
                        <button
                          type="button"
                          onClick={goSignNext}
                          className="flex-1 ml-3 px-6 py-3 rounded-xl font-bold bg-violet-600 text-white hover:bg-violet-700 shadow-md"
                        >
                          Próximo
                        </button>
                      </div>
                    </div>
                  )}
                  {step === 'selfie' && (
                    <div className="mt-2">
                      <p className="text-sm text-slate-600 mb-3">Selfie de <strong>{pname}</strong></p>
                      <div className="rounded-2xl overflow-hidden bg-black w-full h-[65vh] md:h-[400px] flex items-center justify-center relative">
                        {cameraError ? (
                          <span className="text-white/70 text-sm px-4 text-center absolute">{cameraError}</span>
                        ) : (
                          <video ref={videoRef} className="absolute inset-0 w-full h-full object-cover" style={{ transform: 'scaleX(-1)' }} playsInline muted autoPlay />
                        )}
                      </div>
                      <button
                        type="button"
                        onClick={captureSelfie}
                        className="mt-4 w-full py-3 rounded-xl font-bold bg-violet-600 text-white hover:bg-violet-700 shadow-md"
                      >
                        Capturar Selfie
                      </button>
                    </div>
                  )}
                  {step === 'link' && (
                    <div className="mt-2">
                      <p className="text-sm text-slate-600 mb-3">Envie este link para <strong>{pname}</strong> confirmar no celular.</p>
                      <input readOnly className="w-full text-xs p-3 rounded-xl border border-slate-300 bg-white font-mono mb-3" value={linkUrl} onFocus={(e) => e.target.select()} />
                      <div className="flex flex-col sm:flex-row gap-2">
                        <button type="button" onClick={copyLink} className="flex-1 py-3 rounded-xl font-bold bg-slate-700 text-white hover:bg-slate-800">
                          Copiar link
                        </button>
                        <button type="button" onClick={whatsappLink} className="flex-1 py-3 rounded-xl font-bold bg-emerald-600 text-white hover:bg-emerald-700 flex items-center justify-center gap-2">
                          <i className="ph ph-whatsapp-logo text-xl"></i> WhatsApp
                        </button>
                      </div>
                      <button type="button" onClick={onClose} className="mt-3 w-full py-2 text-sm font-semibold text-slate-600">
                        Fechar
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        };

        /** Extrai dia/mês (1–31 / 1–12): YYYY-MM-DD, DD-MM-YYYY, DD/MM/YYYY, etc. */
        const parseBirthMonthDay = (dataNasc) => {
          if (dataNasc == null || dataNasc === '') return null;
          const s = String(dataNasc).trim().split(/[\sT]/)[0];
          if (!s) return null;
          if (s.includes('-')) {
            const partes = s.split('-').map((x) => String(x).replace(/\D.*/, ''));
            if (partes.length >= 3 && partes.every(Boolean)) {
              const n0 = parseInt(partes[0], 10);
              const n1 = parseInt(partes[1], 10);
              const n2 = parseInt(partes[2], 10);
              // YYYY-MM-DD (ano com 4 dígitos no primeiro bloco)
              if (partes[0].length === 4 && !Number.isNaN(n0) && !Number.isNaN(n1) && !Number.isNaN(n2)) {
                if (n1 >= 1 && n1 <= 12 && n2 >= 1 && n2 <= 31) return { dia: n2, mes: n1 };
              }
              // DD-MM-YYYY ou MM-DD-YYYY (ano com 4 dígitos no último bloco)
              if (partes[2].length === 4 && !Number.isNaN(n0) && !Number.isNaN(n1) && !Number.isNaN(n2)) {
                if (n1 >= 1 && n1 <= 12 && n0 >= 1 && n0 <= 31) return { dia: n0, mes: n1 };
                if (n0 >= 1 && n0 <= 12 && n1 >= 1 && n1 <= 31) return { dia: n1, mes: n0 };
              }
            }
          }
          if (s.includes('/')) {
            const partes = s.split('/');
            if (partes.length >= 3) {
              const dia = parseInt(partes[0], 10);
              const mes = parseInt(partes[1], 10);
              if (!Number.isNaN(dia) && !Number.isNaN(mes)) return { dia, mes };
            }
          }
          return null;
        };

        /** Valor aceito por <input type="date"> (YYYY-MM-DD). */
        const toDateInputValue = (raw) => {
          if (raw == null || raw === '') return '';
          const s = String(raw).trim().split(/[\sT]/)[0];
          if (!s) return '';
          if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
          if (s.includes('-')) {
            const partes = s.split('-').map((x) => String(x).replace(/\D.*/, ''));
            if (partes.length >= 3 && partes[2].length === 4) {
              const d = partes[0].padStart(2, '0');
              const m = partes[1].padStart(2, '0');
              const y = partes[2].slice(0, 4);
              if (y.length === 4 && parseInt(m, 10) >= 1 && parseInt(m, 10) <= 12) return `${y}-${m}-${d}`;
            }
          }
          if (s.includes('/')) {
            const partes = s.split('/');
            if (partes.length >= 3) {
              const d = String(partes[0]).replace(/\D.*/, '').padStart(2, '0');
              const m = String(partes[1]).replace(/\D.*/, '').padStart(2, '0');
              const y = String(partes[2]).replace(/\D.*/, '').slice(0, 4);
              if (y.length === 4 && d.length === 2 && m.length === 2) return `${y}-${m}-${d}`;
            }
          }
          return '';
        };

        /** Valida dígitos verificadores do CPF (11 números). */
        const validarDigitosCPF = (cpfDigits) => {
          const s = String(cpfDigits || '').replace(/\D/g, '');
          if (s.length !== 11 || /^(\d)\1{10}$/.test(s)) return false;
          let soma = 0;
          for (let i = 0; i < 9; i++) soma += parseInt(s[i], 10) * (10 - i);
          let d1 = (soma * 10) % 11;
          if (d1 === 10) d1 = 0;
          if (d1 !== parseInt(s[9], 10)) return false;
          soma = 0;
          for (let i = 0; i < 10; i++) soma += parseInt(s[i], 10) * (11 - i);
          let d2 = (soma * 10) % 11;
          if (d2 === 10) d2 = 0;
          return d2 === parseInt(s[10], 10);
        };

        /** Idade a partir de YYYY-MM-DD. */
        const idadeApartirDeISO = (iso) => {
          if (!iso || !/^\d{4}-\d{2}-\d{2}/.test(iso)) return '';
          const [y, m, d] = iso.slice(0, 10).split('-').map((x) => parseInt(x, 10));
          const dataNasc = new Date(y, m - 1, d);
          const hoje = new Date();
          let idade = hoje.getFullYear() - dataNasc.getFullYear();
          const mo = hoje.getMonth() - dataNasc.getMonth();
          if (mo < 0 || (mo === 0 && hoje.getDate() < dataNasc.getDate())) idade--;
          return idade >= 0 && idade < 130 ? String(idade) : '';
        };

        /** Converte registro da API (snake_case) para o estado do formulário de cadastro (camelCase). */
        const patientRecordToNewPatientForm = (p) => {
          if (!p) return null;
          const rawDn = p.dataNascimento ?? p.data_nascimento ?? '';
          return {
            id: p.id,
            nome: p.nome ?? '',
            cpf: p.cpf != null ? String(p.cpf) : '',
            rg: p.rg ?? '',
            dataNascimento: toDateInputValue(rawDn),
            idade: p.idade !== undefined && p.idade !== null ? String(p.idade) : '',
            sexo: p.sexo ?? '',
            estadoCivil: p.estadoCivil ?? p.estado_civil ?? '',
            profissao: p.profissao ?? '',
            telefone: p.telefone ?? '',
            telefone2: p.telefone2 ?? '',
            cep: p.cep ?? '',
            endereco: p.endereco ?? '',
            numero: p.numero ?? '',
            bairro: p.bairro ?? '',
            cidade: p.cidade ?? '',
            uf: p.uf ?? '',
            planoSaude: String(p.planoSaude ?? p.plano_saude ?? '').trim() || 'Não',
            qualPlano: p.qualPlano ?? p.qual_plano ?? '',
            indicacao: p.indicacao ?? '',
            responsavel: p.responsavel ?? '',
            fisio1_id: p.fisio1_id != null && p.fisio1_id !== '' ? p.fisio1_id : null,
            fisio2_id: p.fisio2_id != null && p.fisio2_id !== '' ? p.fisio2_id : null,
            faz_pilates: !!p.faz_pilates,
            faz_fisio: !!p.faz_fisio,
            valor_mensalidade_pilates: p.valor_mensalidade_pilates ?? '',
            dia_vencimento_pilates: p.dia_vencimento_pilates ?? '',
            valor_sessao_fisio: p.valor_sessao_fisio ?? '',
            horario_fisio: p.horario_fisio ?? '',
            dias_semana_fisio: p.dias_semana_fisio ?? '',
            forma_pagamento_fisio: p.forma_pagamento_fisio ?? '',
          };
        };

        /** Unifica chaves API (snake_case) com o payload do formulário antes de save_patient. */
        const normalizePatientForSave = (p) => {
          if (!p || typeof p !== 'object') return p;
          const rawDn = p.dataNascimento ?? p.data_nascimento ?? '';
          const dataNascimento = rawDn
            ? (toDateInputValue(String(rawDn)) || String(rawDn).trim().split(/[\sT]/)[0].slice(0, 10))
            : '';
          const rawF1 = p.fisio1_id;
          const rawF2 = p.fisio2_id;
          const fisio1_id = rawF1 != null && rawF1 !== '' ? Number(rawF1) : null;
          const fisio2_id = rawF2 != null && rawF2 !== '' ? Number(rawF2) : null;
          return {
            ...p,
            dataNascimento,
            estadoCivil: p.estadoCivil ?? p.estado_civil ?? '',
            planoSaude: String(p.planoSaude ?? p.plano_saude ?? '').trim() || 'Não',
            disfuncaoOP: p.disfuncaoOP ?? p.disfuncao_op ?? '',
            tratamentoGeral: p.tratamentoGeral ?? p.tratamento_geral ?? '',
            fisio1_id,
            fisio2_id,
            faz_pilates: !!p.faz_pilates,
            faz_fisio: !!p.faz_fisio,
            faz_osteopatia: !!p.faz_osteopatia,
            valor_mensalidade_pilates: String(p.valor_mensalidade_pilates || ''),
            dia_vencimento_pilates: String(p.dia_vencimento_pilates || ''),
            valor_sessao_fisio: String(p.valor_sessao_fisio || ''),
            horario_fisio: p.horario_fisio ?? '',
            dias_semana_fisio: p.dias_semana_fisio ?? '',
            forma_pagamento_fisio: p.forma_pagamento_fisio ?? '',
          };
        };

        /** Data de nascimento para exibição (ex.: impressão): DD/MM/AAAA quando possível. */
        const formatDnForDisplay = (patient) => {
          const raw = patient?.dataNascimento ?? patient?.data_nascimento ?? '';
          if (raw == null || raw === '') return '';
          const iso = toDateInputValue(raw);
          if (iso && /^\d{4}-\d{2}-\d{2}$/.test(iso)) {
            const [y, m, d] = iso.split('-');
            return `${d}/${m}/${y}`;
          }
          return String(raw);
        };

        const RC_NIVEL_DELIM = '|';
        const RC_NIVEIS_ADMIN = ['Super Administrador', 'Administrador', 'Recepcionista'];
        const RC_NIVEIS_PRO = ['Fisioterapeuta', 'Instrutor de Pilates'];

        const parseUserNiveis = (nivel) => {
          if (nivel == null || nivel === '') return [];
          let s = String(nivel).trim();
          if (!s) return [];
          s = s.replace(/\s*\/\s*/g, '|');
          return s.split(/\s*[|,/;·]+\s*/).map((x) => x.trim()).filter(Boolean);
        };

        const normalizadoNivel = (s) => String(s ?? '').trim().toLowerCase();

        const nivelCampoUsuario = (user) => {
          if (!user) return '';
          for (const k of ['nivel', 'Nivel', 'NIVEL']) {
            const v = user[k];
            if (v != null && String(v).trim() !== '') return v;
          }
          return '';
        };

        const userTemNivel = (user, papel) => {
          if (!papel || !user) return false;
          const alvo = normalizadoNivel(papel);
          return parseUserNiveis(nivelCampoUsuario(user)).some((x) => normalizadoNivel(x) === alvo);
        };

        /**
         * Profissionais elegíveis no select de paciente. A API (get_data) devolve todos os usuários; o filtro é só aqui.
         * Nunca usar user.nivel === 'Fisioterapeuta' — níveis são texto com múltiplos papéis (| / , ; ·).
         */
        const userPodeAtribuirComoProfissional = (user) => {
          if (!user) return false;
          const nivelStr = String(nivelCampoUsuario(user)).trim();
          if (!nivelStr) return false;
          if (RC_NIVEIS_PRO.some((p) => userTemNivel(user, p))) return true;
          const blob = normalizadoNivel(nivelStr);
          if (RC_NIVEIS_PRO.some((p) => blob.includes(normalizadoNivel(p)))) return true;
          const tokens = parseUserNiveis(nivelStr);
          for (const t of tokens) {
            const n = normalizadoNivel(t);
            if (RC_NIVEIS_ADMIN.some((a) => normalizadoNivel(a) === n)) continue;
            if (n.includes('fisioterap')) return true;
            if (n.includes('pilates')) return true;
            if (n.includes('instrutor')) return true;
          }
          return false;
        };

        const usuarioRestritoComoFisio = (user) => {
          if (!user || user.ver_todos) return false;
          if (userTemNivel(user, 'Administrador') || userTemNivel(user, 'Super Administrador') || userTemNivel(user, 'Recepcionista')) {
            return false;
          }
          return userTemNivel(user, 'Fisioterapeuta') || userTemNivel(user, 'Instrutor de Pilates');
        };

        const formatNiveisLabel = (nivel) => {
          const p = parseUserNiveis(nivel);
          return p.length ? p.join(' · ') : (nivel ? String(nivel) : 'Acesso');
        };

        const badgeClassNiveis = (nivel) => {
          const p = parseUserNiveis(nivel);
          if (p.includes('Super Administrador')) return 'bg-amber-100 text-amber-800';
          if (p.includes('Administrador')) return 'bg-purple-100 text-purple-800';
          if (p.includes('Recepcionista')) return 'bg-blue-100 text-blue-800';
          return 'bg-emerald-100 text-emerald-800';
        };

        const badgeClassUsuarioLista = (user) => badgeClassNiveis(nivelCampoUsuario(user));

        const usuarioTemFisioEPilates = (user) => {
          if (!user) return false;
          const a = userTemNivel(user, 'Fisioterapeuta');
          const b = userTemNivel(user, 'Instrutor de Pilates');
          if (a && b) return true;
          const blob = normalizadoNivel(nivelCampoUsuario(user));
          if (!blob) return false;
          const hasFisio = a || blob.includes('fisioterap');
          const hasInst = b || (blob.includes('instrutor') && blob.includes('pilates'));
          return hasFisio && hasInst;
        };

        const ETIQUETA_FISIO_E_PILATES = 'Fisioterapeuta / Instrutor de Pilates';

        const splitNiveisEditor = (nivel) => {
          const all = parseUserNiveis(nivel);
          const adminRaw =
            all.find((r) => RC_NIVEIS_ADMIN.some((a) => normalizadoNivel(a) === normalizadoNivel(r))) || '';
          const admin = adminRaw
            ? RC_NIVEIS_ADMIN.find((a) => normalizadoNivel(a) === normalizadoNivel(adminRaw)) || adminRaw
            : '';
          const pros = [];
          const canonProToken = (r) => {
            const nr = normalizadoNivel(r);
            let c = RC_NIVEIS_PRO.find((p) => normalizadoNivel(p) === nr);
            if (c) return c;
            if (nr.includes('fisioterap')) return 'Fisioterapeuta';
            if (nr.includes('instrutor') && nr.includes('pilates')) return 'Instrutor de Pilates';
            return null;
          };
          for (const r of all) {
            const canon = canonProToken(r);
            if (canon) pros.push(canon);
          }
          let uniq = [...new Set(pros)];
          if (uniq.length < 2 && all.length) {
            const blob = normalizadoNivel(nivel);
            if (blob.includes('fisioterap') && !uniq.includes('Fisioterapeuta')) uniq.push('Fisioterapeuta');
            if (blob.includes('instrutor') && blob.includes('pilates') && !uniq.includes('Instrutor de Pilates')) {
              uniq.push('Instrutor de Pilates');
            }
          }
          return { admin, pros: uniq };
        };

        const buildNivelFromEditor = (admin, pros) => {
          const parts = [];
          if (admin) {
            const aCanon =
              RC_NIVEIS_ADMIN.find((a) => normalizadoNivel(a) === normalizadoNivel(admin)) || admin;
            parts.push(aCanon);
          }
          const uniqPros = [
            ...new Set(
              (pros || [])
                .map((p) => RC_NIVEIS_PRO.find((x) => normalizadoNivel(x) === normalizadoNivel(p)))
                .filter(Boolean)
            ),
          ];
          parts.push(...uniqPros);
          let out = [...new Set(parts)];
          if (out.includes('Super Administrador')) {
            out = out.filter((x) => x !== 'Administrador');
          }
          return out.join(RC_NIVEL_DELIM);
        };

        /** Lista de usuários: ambos os papéis de sala → rótulo combinado; «Acesso» + só um pro → nome; demais → nível formatado. */
        const etiquetaNivelOuNomeLista = (user) => {
          if (!user) return 'Acesso';
          const nv = nivelCampoUsuario(user);
          const { pros } = splitNiveisEditor(nv);
          if (pros.includes('Fisioterapeuta') && pros.includes('Instrutor de Pilates')) {
            return ETIQUETA_FISIO_E_PILATES;
          }
          if (usuarioTemFisioEPilates(user)) return ETIQUETA_FISIO_E_PILATES;
          const texto = formatNiveisLabel(nv);
          if (texto === 'Fisioterapeuta · Instrutor de Pilates') return ETIQUETA_FISIO_E_PILATES;
          if (texto === 'Acesso' && userPodeAtribuirComoProfissional(user)) {
            const nome = user.nome != null ? String(user.nome).trim() : '';
            if (nome) return nome;
          }
          return texto;
        };

        const editorTemFisioEPilates = (nivel) => {
          const { pros } = splitNiveisEditor(nivel);
          return pros.includes('Fisioterapeuta') && pros.includes('Instrutor de Pilates');
        };

        const RC_AGENDA_LS = 'clinic_agenda_events_v1';
        const rcAgendaPad2 = (n) => String(n).padStart(2, '0');
        const rcAgendaToDateKey = (d) => `${d.getFullYear()}-${rcAgendaPad2(d.getMonth() + 1)}-${rcAgendaPad2(d.getDate())}`;
        const rcAgendaStartOfWeekSun = (d) => {
          const x = new Date(d);
          x.setHours(0, 0, 0, 0);
          x.setDate(x.getDate() - x.getDay());
          return x;
        };
        const rcAgendaAddDays = (d, n) => {
          const x = new Date(d);
          x.setDate(x.getDate() + n);
          return x;
        };
        const rcAgendaAddMonths = (d, n) => {
          const x = new Date(d);
          x.setMonth(x.getMonth() + n);
          return x;
        };
        const rcAgendaLoad = () => { return []; };
        // Guard: impede salvar no banco antes de carregar. Evita sobrescrever o banco com [] na inicialização.
        const _rcDbSaveGuard = { loaded: false };
        const rcAgendaSave = (arr) => {
          if (!_rcDbSaveGuard.loaded) return Promise.resolve(); // Ainda carregando, não sobrescreve
          try {
            return fetch('api.php?action=sync_state&type=agenda', { method: 'POST', credentials: 'include', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(arr) }).then(() => {}).catch(() => {});
          } catch (e) { return Promise.resolve(); }
        };

        const RC_FINANCEIRO_LS = 'clinic_financeiro_entries_v1';
        const rcFinanceiroLoad = () => { return []; };
        const rcFinanceiroSave = (arr) => {
          if (!_rcDbSaveGuard.loaded) return Promise.resolve();
          try {
            return fetch('api.php?action=sync_state&type=financeiro', { method: 'POST', credentials: 'include', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(arr) }).then(() => {}).catch(() => {});
          } catch (e) { return Promise.resolve(); }
        };

        const RC_PACKAGES_LS = 'clinic_packages_v1';
        const rcPackagesLoad = () => { return []; };
        const rcPackagesSave = (arr) => {
          if (!_rcDbSaveGuard.loaded) return;
          try {
            fetch('api.php?action=sync_state&type=pacotes', { method: 'POST', credentials: 'include', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(arr) });
          } catch (e) { /* ignore */ }
        };

        const RC_PRESENCE_RECORDS_LS = 'clinic_presence_records_v1';
        const rcPresenceRecordsLoad = () => { return []; };
        const rcPresenceRecordsSave = (arr) => {
          if (!_rcDbSaveGuard.loaded) return;
          try {
            fetch('api.php?action=sync_state&type=presence_records', { method: 'POST', credentials: 'include', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(arr) });
          } catch (e) { /* ignore */ }
        };

        const RC_PRESENCE_PENDING_LS = 'clinic_presence_pending_v1';
        const rcPresencePendingLoad = () => { return []; };
        const rcPresencePendingSave = (arr) => {
          if (!_rcDbSaveGuard.loaded) return;
          try {
            fetch('api.php?action=sync_state&type=presence_pending', { method: 'POST', credentials: 'include', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(arr) });
          } catch (e) { /* ignore */ }
        };

        const rcPresenceGenToken = () => {
          try {
            const a = new Uint8Array(16);
            crypto.getRandomValues(a);
            return Array.from(a, (b) => b.toString(16).padStart(2, '0')).join('');
          } catch (e) {
            return String(Date.now()) + Math.random().toString(36).slice(2, 12);
          }
        };
        const AgendaStatusDropdown = ({ status, onChange }) => {
          const [open, setOpen] = useState(false);
          const [panelPos, setPanelPos] = useState({ top: 0, left: 0 });
          const btnRef = useRef(null);

          const getStyle = (s) => {
            switch(s) {
              case 'Marcado':   return {bg: 'bg-blue-50 text-blue-700',    icon: 'ph-calendar-check text-blue-500'};
              case 'Aguardando':return {bg: 'bg-amber-50 text-amber-700',  icon: 'ph-hourglass text-amber-500'};
              case 'Confirmado':return {bg: 'bg-emerald-50 text-emerald-700', icon: 'ph-check-circle text-emerald-500'};
              case 'Atendido':  return {bg: 'bg-purple-50 text-purple-700', icon: 'ph-stethoscope text-purple-500'};
              case 'Falta':     return {bg: 'bg-orange-50 text-orange-700', icon: 'ph-x-square text-orange-500'};
              case 'Cancelado': return {bg: 'bg-red-50 text-red-700',      icon: 'ph-x-circle text-red-500'};
              default:          return {bg: 'bg-slate-50 text-slate-700',   icon: 'ph-circle text-slate-500'};
            }
          };
          const style = getStyle(status);
          const OPTIONS = ['Marcado', 'Aguardando', 'Confirmado', 'Atendido', 'Falta', 'Cancelado'];

          const handleOpen = () => {
            if (btnRef.current) {
              const rect = btnRef.current.getBoundingClientRect();
              setPanelPos({ top: rect.bottom + 6, left: rect.left });
            }
            setOpen(v => !v);
          };

          useEffect(() => {
            if (!open) return;
            const close = () => setOpen(false);
            document.addEventListener('click', close, true);
            return () => document.removeEventListener('click', close, true);
          }, [open]);

          return (
            <div className="relative inline-block">
              <button
                ref={btnRef}
                type="button"
                onClick={(e) => { e.stopPropagation(); handleOpen(); }}
                className={`inline-flex items-center gap-1 min-w-[115px] justify-between rounded-full px-2.5 py-1 text-[11px] font-bold border border-transparent shadow-sm transition-colors ${style.bg} hover:brightness-95`}
              >
                <div className="flex items-center gap-1.5">
                  <i className={`ph ${style.icon} text-sm`}></i>
                  <span>{status || 'Marcado'}</span>
                </div>
                <i className={`ph ph-caret-down text-[10px] opacity-70 transition-transform ${open ? 'rotate-180' : ''}`}></i>
              </button>

              {open && ReactDOM.createPortal(
                <div
                  style={{ position: 'fixed', top: panelPos.top, left: panelPos.left, zIndex: 99999 }}
                  className="w-44 bg-white border border-slate-200 rounded-2xl shadow-2xl p-1.5 flex flex-col gap-0.5 animate-fadeIn"
                  onClick={(e) => e.stopPropagation()}
                >
                  {OPTIONS.map(opt => {
                    const optSt = getStyle(opt);
                    const isActive = (status || 'Marcado') === opt;
                    return (
                      <button
                        key={opt}
                        type="button"
                        onClick={() => { onChange(opt); setOpen(false); }}
                        className={`flex items-center gap-2.5 px-3 py-2 text-[12px] font-bold rounded-xl text-left w-full transition-colors ${isActive ? optSt.bg : 'text-slate-600 hover:bg-slate-50'}`}
                      >
                        <i className={`ph ${optSt.icon} text-base ${!isActive ? 'opacity-40' : ''}`}></i>
                        {opt}
                        {isActive && <i className="ph ph-check ml-auto text-sm opacity-60"></i>}
                      </button>
                    );
                  })}
                </div>,
                document.body
              )}
            </div>
          );
        };



        const AppointmentConfirmFlow = ({ context, onResponse }) => {
          const [loading, setLoading] = useState(false);
          const handle = async (status) => {
            setLoading(true);
            await onResponse(status);
            setLoading(false);
          };
          if (!context) return null;

          // Calcula o rótulo correto da data (hoje / amanhã / DD/MM/AAAA)
          const calcDiaLabel = (dateStr) => {
            if (!dateStr) return 'hoje';
            const now = new Date();
            const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
            const tomorrowDate = new Date(now);
            tomorrowDate.setDate(tomorrowDate.getDate() + 1);
            const tomorrowStr = `${tomorrowDate.getFullYear()}-${String(tomorrowDate.getMonth() + 1).padStart(2, '0')}-${String(tomorrowDate.getDate()).padStart(2, '0')}`;
            if (dateStr === todayStr) return 'hoje';
            if (dateStr === tomorrowStr) return 'amanhã';
            // Outra data: exibe DD/MM/AAAA
            const parts = dateStr.split('-');
            if (parts.length === 3) return `dia ${parts[2]}/${parts[1]}/${parts[0]}`;
            return dateStr;
          };

          const diaLabel = calcDiaLabel(context.date);
          const diaLabelCapital = diaLabel.charAt(0).toUpperCase() + diaLabel.slice(1);

          return (
            <div className="bg-white p-8 rounded-3xl shadow-xl w-full max-w-md border border-slate-200 animate-fadeIn text-center">
              <div className="mb-6 flex justify-center">
                <span className="flex h-20 w-20 items-center justify-center rounded-full bg-emerald-100 text-emerald-600 shadow-sm ring-8 ring-emerald-50">
                   <i className="ph ph-calendar-check text-5xl"></i>
                </span>
              </div>
              <h2 className="text-2xl font-black text-slate-800 mb-2">Confirmação de Sessão</h2>
              <p className="text-slate-500 mb-6 font-medium">Olá <strong>{context.patientName}</strong>! Por favor, confirme se você comparecerá à sua sessão de <strong>{diaLabel}</strong>:</p>
              
              <div className="bg-slate-50 rounded-2xl p-4 mb-8 text-left border border-slate-100">
                <div className="flex items-center gap-3 mb-2">
                  <i className="ph ph-clock text-emerald-600 text-xl"></i>
                  <span className="text-slate-700 font-bold">{diaLabelCapital} às {context.time}</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ph ph-user-focus text-emerald-600 text-xl"></i>
                  <span className="text-slate-700 font-bold">{context.profName}</span>
                </div>
              </div>

              <div className="flex flex-col gap-3">
                <button
                  disabled={loading}
                  onClick={() => handle('confirmed')}
                  className="w-full py-4 rounded-2xl bg-emerald-600 text-white font-black text-lg shadow-lg shadow-emerald-700/20 active:scale-[0.98] transition-transform flex items-center justify-center gap-3 disabled:opacity-70"
                >
                  {loading ? <div className="w-6 h-6 border-4 border-white border-t-transparent rounded-full animate-spin"></div> : <><i className="ph ph-check-circle text-2xl"></i> SIM, VOU COMPARECER</>}
                </button>
                <button
                  disabled={loading}
                  onClick={() => handle('rejected')}
                  className="w-full py-3 rounded-2xl bg-white text-slate-500 font-bold border-2 border-slate-100 hover:bg-red-50 hover:text-red-600 hover:border-red-100 active:scale-[0.98] transition-all disabled:opacity-50"
                >
                  Não poderei comparecer
                </button>
              </div>
            </div>
          );
        };


        const App = () => {
          const defaultLogoPath = window.APP_ASSETS.logo;
          
          // --- ESTADOS DE AUTENTICAíǁƒá€šÂ¡ǁƒdž'ǁ†á€™O E USUáRIOS ---
          const [isAuthenticated, setIsAuthenticated] = useState(() => {
            return window.localStorage.getItem('clinic_auth') === 'true';
          });
          const [currentUser, setCurrentUser] = useState(() => {
            const saved = window.localStorage.getItem('clinic_current_user');
            return saved ? JSON.parse(saved) : null;
          });
          const [usersList, setUsersList] = useState([
            { id: 1, nome: 'Administrador', email: 'admin@realclinica.com', senha: '123', nivel: 'Super Administrador' }
          ]);
          const [loginData, setLoginData] = useState({ email: '', password: '' });
          const [isForgotPassword, setIsForgotPassword] = useState(false);
          const [forgotSending, setForgotSending] = useState(false);
          const [resetTokenUrl, setResetTokenUrl] = useState(() => {
            try {
              return new URLSearchParams(window.location.search).get('reset_token');
            } catch (e) {
              return null;
            }
          });
          const [resetNewPass, setResetNewPass] = useState('');
          const [resetConfirmPass, setResetConfirmPass] = useState('');
          const [resetSubmitting, setResetSubmitting] = useState(false);
          const [editingUser, setEditingUser] = useState(null);
          const [userToDelete, setUserToDelete] = useState(null);

          // --- ESTADOS DE TEMA E UI (hidrata logo do localStorage para login / favicon antes do get_data) ---
          const [theme, setTheme] = useState(() => {
            try {
              const raw = window.localStorage.getItem('clinic_theme');
              if (raw) {
                const parsed = JSON.parse(raw);
                let { logoUrl, backgroundUrl, appIconUrl } = parsed;
                if (logoUrl && typeof logoUrl === 'string' && (logoUrl.startsWith('./') || logoUrl.startsWith('image_') || logoUrl.startsWith('Gemini_'))) {
                  logoUrl = null;
                }
                if (backgroundUrl && typeof backgroundUrl === 'string' && (backgroundUrl.startsWith('./') || backgroundUrl.startsWith('image_') || backgroundUrl.startsWith('Gemini_'))) {
                  backgroundUrl = null;
                }
                if (appIconUrl && typeof appIconUrl === 'string' && (appIconUrl.startsWith('./') || appIconUrl.startsWith('image_') || appIconUrl.startsWith('Gemini_'))) {
                  appIconUrl = null;
                }
                return { color: 'emerald', logoUrl: null, backgroundUrl: null, appIconUrl: null, ...parsed, logoUrl, backgroundUrl, appIconUrl };
              }
            } catch (e) {}
            return { color: 'emerald', logoUrl: null, backgroundUrl: null, appIconUrl: null };
          });
          const [pwaIconFileRev, setPwaIconFileRev] = useState(0);
          const [toasts, setToasts] = useState([]);
          const [activeTab, setActiveTab] = useState('list');
          const [settingsTab, setSettingsTab] = useState('geral');
          const [searchTerm, setSearchTerm] = useState('');
          const [signatureModal, setSignatureModal] = useState({ isOpen: false, role: null });
          const [zoomedImage, setZoomedImage] = useState(null);
          const [patientListView, setPatientListView] = useState('all'); // 'all' or 'mine'

          const [remoteSessionLoading, setRemoteSessionLoading] = useState(() => {
            const params = new URLSearchParams(window.location.search);
            try { return !!params.get('remote_presence') || !!params.get('confirm_appointment'); } 
            catch(e) { return false; }
          });
          const [remoteSessionSuccess, setRemoteSessionSuccess] = useState(false);
          const [remoteSessionInvalid, setRemoteSessionInvalid] = useState(false);
          const [confirmAppointmentCtx, setConfirmAppointmentCtx] = useState(null);
          const [remoteAppointmentResponse, setRemoteAppointmentResponse] = useState(null); // 'confirmed', 'rejected'

          const [agendaViewMode, setAgendaViewMode] = useState('week');
          const [agendaAnchorTs, setAgendaAnchorTs] = useState(() => {
            const t = new Date();
            t.setHours(0, 0, 0, 0);
            return t.getTime();
          });
          const [agendaTeamFilter, setAgendaTeamFilter] = useState('');
          const [agendaEvents, setAgendaEvents] = useState(() => rcAgendaLoad());
          const agendaEventsRef = useRef(agendaEvents);
          useEffect(() => { agendaEventsRef.current = agendaEvents; }, [agendaEvents]);
          const [agendaModalOpen, setAgendaModalOpen] = useState(false);
          const [professionalArrivalAlert, setProfessionalArrivalAlert] = useState(null);
          const [receptionResponseAlert, setReceptionResponseAlert] = useState(null);
          const [paymentModalCtx, setPaymentModalCtx] = useState(null);
          const [activePaymentTab, setActivePaymentTab] = useState('PIX');
          const [packageModalCtx, setPackageModalCtx] = useState(null);
          const [packages, setPackages] = useState(() => rcPackagesLoad());
          const persistPackages = (next) => { setPackages(next); rcPackagesSave(next); };
          const [renewalModalCtx, setRenewalModalCtx] = useState(null);
          const [agendaEditId, setAgendaEditId] = useState(null);
          const [finPeriodo, setFinPeriodo] = useState('mes');
          const [finProf, setFinProf] = useState('');
          const [finMetodo, setFinMetodo] = useState('');
          const [finEntries, setFinEntries] = useState(() => {
            const loaded = rcFinanceiroLoad();
            /* ── auto-gerar recorrentes do mês ── */
            const today = new Date();
            const mesAtual = today.toISOString().split('T')[0].slice(0, 7); // YYYY-MM
            const templates = loaded.filter(e => e.recorrente);
            let gerados = [...loaded];
            templates.forEach(tpl => {
              const tplMes = (tpl.data || '').slice(0, 7);
              const dia = (tpl.data || '').slice(8, 10) || '01';
              if (tplMes < mesAtual) {
                /* verificar se já existe instância deste template no mês atual */
                const recId = 'rec_' + tpl.id + '_' + mesAtual;
                const jaExiste = gerados.some(e => e.id === recId);
                if (!jaExiste) {
                  gerados.push({
                    ...tpl,
                    id: recId,
                    data: mesAtual + '-' + dia,
                    status: 'pendente',
                    recorrente: false,
                    origemRecorrente: tpl.id,
                  });
                }
              }
            });
            if (gerados.length !== loaded.length) rcFinanceiroSave(gerados);
            return gerados;
          });
          const finEntriesRef = useRef(finEntries);
          useEffect(() => { finEntriesRef.current = finEntries; }, [finEntries]);
          const [finModalOpen, setFinModalOpen] = useState(false);
          const [finModalForm, setFinModalForm] = useState({ id: null, tipo: 'receita', descricao: '', valor: '', data: new Date().toISOString().split('T')[0], categoria: '', metodo: '', status: 'pendente', recorrente: false });
          const persistFinEntries = (next) => { setFinEntries(next); rcFinanceiroSave(next); };

          function handleFinSave() {
            if (!finModalForm.descricao || !finModalForm.valor) { showToast('Preencha a descrição e o valor.', 'error'); return; }

            if (finModalForm.id) {
              if (String(finModalForm.id).startsWith('ag_')) {
                /* Update Agenda Event — patchEv não disponível aqui, usamos persistAgendaEvents diretamente */
                const realId = String(finModalForm.id).replace('ag_', '');
                persistAgendaEvents(agendaEvents.map(x => x.id === realId ? {
                  ...x,
                  paymentValue: finModalForm.valor,
                  paymentMethod: finModalForm.metodo,
                  paymentStatus: finModalForm.status === 'pago' ? 'Pago' : 'Pendente',
                  paymentPending: finModalForm.status !== 'pago',
                  paymentDeletedFromFin: false
                } : x));
                showToast('Agendamento atualizado!', 'success');
              } else {
                /* Update Manual Entry */
                persistFinEntries(finEntries.map(e => String(e.id) === String(finModalForm.id) ? { ...finModalForm } : e));
                showToast('Lançamento atualizado!', 'success');
              }
            } else {
              /* Create New Manual Entry */
              const entry = { ...finModalForm, id: 'fin_' + Date.now() };
              persistFinEntries([entry, ...finEntries]);
              showToast(finModalForm.tipo === 'receita' ? 'Receita cadastrada!' : 'Despesa cadastrada!', 'success');
            }
            setFinModalOpen(false);
          }

          const DIAS_SEMANA = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
          /** Converte rótulo de dia (Seg, TER, Terça…) em 0=Dom … 6=Sáb para gerar a agenda. */
          const pilatesDayLabelToNum = (raw) => {
            const s = String(raw || '').trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
            if (!s) return undefined;
            if (s.startsWith('dom')) return 0;
            if (s.startsWith('seg')) return 1;
            if (s.startsWith('ter')) return 2;
            if (s.startsWith('qua')) return 3;
            if (s.startsWith('qui')) return 4;
            if (s.startsWith('sex')) return 5;
            if (s.startsWith('sab')) return 6;
            return undefined;
          };
          const buildPilatesAgendaEventsForPatient = (patientRow, professionalIdOpt) => {
            const patientName = String(patientRow.nome || 'Paciente').trim() || 'Paciente';
            const diasSemanaArr = String(patientRow.dias_semana_pilates || '')
              .split(',')
              .map((d) => d.trim())
              .filter(Boolean);
            const horario = String(patientRow.horario_pilates || '').trim();
            if (!diasSemanaArr.length || !horario) return [];
            const targetDays = diasSemanaArr.map(pilatesDayLabelToNum).filter((d) => d !== undefined);
            if (!targetDays.length) return [];
            const startTime = horario.slice(0, 5);
            const [hh, mm] = startTime.split(':').map(Number);
            const totalEnd = (Number(hh) || 0) * 60 + (Number(mm) || 0) + 50;
            const endTime = `${String(Math.floor(totalEnd / 60) % 24).padStart(2, '0')}:${String(totalEnd % 60).padStart(2, '0')}`;
            const today = new Date();
            const toLocalDateStr = (d) =>
              `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
            const pid =
              professionalIdOpt != null && professionalIdOpt !== ''
                ? String(professionalIdOpt)
                : String(patientRow.fisio1_id || patientRow.fisio2_id || '');
            const profObj = usersList.find((u) => String(u.id) === String(pid));
            const professionalName = profObj ? profObj.nome : '';
            const novosEventos = [];
            for (let week = 0; week < 4; week++) {
              targetDays.forEach((dayOfWeek) => {
                const d = new Date(today);
                const diff = (dayOfWeek - d.getDay() + 7) % 7 + week * 7;
                d.setDate(d.getDate() + diff);
                novosEventos.push({
                  id: `pil_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
                  date: toLocalDateStr(d),
                  start: startTime,
                  end: endTime,
                  title: `Pilates - ${patientName}`,
                  patientId: String(patientRow.id),
                  patientName,
                  professionalId: pid,
                  professionalName,
                  appointmentStatus: 'Marcado',
                  confirmed: false,
                  notified: false,
                  paymentPending: true,
                  paymentOk: false,
                  arrived: false,
                  presence: 'none',
                  paymentValue: String(patientRow.valor_mensalidade_pilates ?? '0').replace('.', ','),
                  paymentStatus: 'Pendente',
                  paymentMethod: '',
                  paymentDeletedFromFin: false,
                  pilatesEvent: true,
                });
              });
            }
            return novosEventos;
          };

          const buildFisioAgendaEventsForPatient = (patientRow, fisioForm, isPacote, qtdSessoes) => {
            const patientName = String(patientRow.nome || 'Paciente').trim() || 'Paciente';
            const diasSemanaArr = (fisioForm.diasSemana || []);
            const horario = String(fisioForm.horario || '').trim();
            if (!diasSemanaArr.length || !horario) return [];
            
            const targetDays = diasSemanaArr.map(pilatesDayLabelToNum).filter((d) => d !== undefined);
            if (!targetDays.length) return [];
            
            const startTime = horario.slice(0, 5);
            const [hh, mm] = startTime.split(':').map(Number);
            const totalEnd = (Number(hh) || 0) * 60 + (Number(mm) || 0) + 50;
            const endTime = `${String(Math.floor(totalEnd / 60) % 24).padStart(2, '0')}:${String(totalEnd % 60).padStart(2, '0')}`;
            const today = new Date();
            const toLocalDateStr = (d) =>
              `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
              
            const pid = String(fisioForm.fisio1_id || '');
            const profObj = usersList.find((u) => String(u.id) === String(pid));
            const professionalName = profObj ? profObj.nome : '';
            
            const novosEventos = [];
            
            if (isPacote) {
                const totalSessions = parseInt(qtdSessoes) || 10;
                let generatedCount = 0;
                let week = 0;
                while (generatedCount < totalSessions) {
                    for (let dayOfWeek of targetDays) {
                        if (generatedCount >= totalSessions) break;
                        const d = new Date(today);
                        const diff = (dayOfWeek - d.getDay() + 7) % 7 + week * 7;
                        d.setDate(d.getDate() + diff);
                        
                        novosEventos.push({
                          id: `fisio_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
                          date: toLocalDateStr(d),
                          start: startTime,
                          end: endTime,
                          title: `Fisioterapia - ${patientName}`,
                          patientId: String(patientRow.id),
                          patientName,
                          professionalId: pid,
                          professionalName,
                          appointmentStatus: 'Marcado',
                          confirmed: false,
                          notified: false,
                          paymentPending: false, 
                          paymentOk: true,
                          arrived: false,
                          presence: 'none',
                          paymentValue: '0,00',
                          paymentStatus: 'Pacote',
                          paymentMethod: 'Pacote',
                          fisioEvent: true,
                        });
                        generatedCount++;
                    }
                    week++;
                }
            } else {
                for (let week = 0; week < 4; week++) {
                  targetDays.forEach((dayOfWeek) => {
                    const d = new Date(today);
                    const diff = (dayOfWeek - d.getDay() + 7) % 7 + week * 7;
                    d.setDate(d.getDate() + diff);
                    novosEventos.push({
                      id: `fisio_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
                      date: toLocalDateStr(d),
                      start: startTime,
                      end: endTime,
                      title: `Fisioterapia - ${patientName}`,
                      patientId: String(patientRow.id),
                      patientName,
                      professionalId: pid,
                      professionalName,
                      appointmentStatus: 'Marcado',
                      confirmed: false,
                      notified: false,
                      paymentPending: true,
                      paymentOk: false,
                      arrived: false,
                      presence: 'none',
                      paymentValue: String(fisioForm.valorSessao ?? '0').replace('.', ','),
                      paymentStatus: 'Pendente',
                      paymentMethod: '',
                      fisioEvent: true,
                    });
                  });
                }
            }
            return novosEventos;
          };
          const [pilatesEnrollOpen, setPilatesEnrollOpen] = useState(false);
          const [pilatesEnrollSearch, setPilatesEnrollSearch] = useState('');
          const [pilatesEnrollForm, setPilatesEnrollForm] = useState({ patientId: '', valorMensalidade: '150.00', diaVencimento: '10', diasSemana: [], horario: '', professionalId: '' });
          const [pilatesHistoryModal, setPilatesHistoryModal] = useState({ open: false, patientId: null, pacienteNome: '' });

          const [fisioEnrollModalOpen, setFisioEnrollModalOpen] = useState(false);
          const [fisioEnrollSearch, setFisioEnrollSearch] = useState('');
          const [fisioEnrollForm, setFisioEnrollForm] = useState({ patientId: '', fisio1_id: '', valorSessao: '150.00', diasSemana: [], horario: '', formaPagamento: 'sessao', qtdSessoes: '10' });
          const [suspenderFisioModal, setSuspenderFisioModal] = useState({ open: false, patient: null, motivo: '', dataRetorno: '', tipo: 'fisio' });
          const [reativarModal, setReativarModal] = useState({ open: false, patient: null, tipo: 'fisio' });
          const [pilatesCancelModal, setPilatesCancelModal] = useState({ open: false, patient: null });
          const [isSubmittingFisio, setIsSubmittingFisio] = useState(false);

          // Paginação e Pesquisa
          const [pageFila, setPageFila] = useState(1);
          const [limitFila, setLimitFila] = useState(10);
          const [searchFila, setSearchFila] = useState('');

          const [pageList, setPageList] = useState(1);
          const [limitList, setLimitList] = useState(10);

          const [pageFisio, setPageFisio] = useState(1);
          const [limitFisio, setLimitFisio] = useState(10);

          const [pagePilates, setPagePilates] = useState(1);
          const [limitPilates, setLimitPilates] = useState(10);

          const [pageFin, setPageFin] = useState(1);
          const [limitFin, setLimitFin] = useState(10);

          const renderPagination = (currentPage, setPage, limit, setLimit, totalItems) => {
            const totalPages = Math.ceil(totalItems / limit) || 1;
            return (
              <div className="flex flex-col sm:flex-row items-center justify-between mt-4 px-4 py-3 bg-white border border-slate-200 rounded-xl shadow-sm gap-4 animate-fadeIn">
                <div className="flex items-center gap-2 text-sm text-slate-600">
                  <span className="font-medium">Mostrar:</span>
                  <select value={limit} onChange={(e) => { setLimit(Number(e.target.value)); setPage(1); }} className="border-slate-200 rounded-lg text-sm focus:ring-emerald-500 focus:border-emerald-500 py-1 pl-2 pr-6 bg-slate-50">
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                  </select>
                  <span className="ml-2">Total: <strong className="text-slate-800">{totalItems}</strong></span>
                </div>
                <div className="flex items-center gap-2">
                  <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} className="px-3 py-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 hover:text-emerald-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm font-medium flex items-center gap-1">
                    <i className="ph ph-caret-left"></i> Anterior
                  </button>
                  <span className="text-sm font-medium text-slate-600 px-2">Página {currentPage} de {totalPages}</span>
                  <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} className="px-3 py-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 hover:text-emerald-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm font-medium flex items-center gap-1">
                    Próxima <i className="ph ph-caret-right"></i>
                  </button>
                </div>
              </div>
            );
          };

          const handleFisioEnrollSubmit = async () => {
            if (isSubmittingFisio) return;
            if (!fisioEnrollForm.patientId) return alert("Selecione um paciente!");
            
            setIsSubmittingFisio(true);
            
            if (!String(fisioEnrollForm.horario || '').trim()) { setIsSubmittingFisio(false); return alert('Informe o horário.'); }
            if (!fisioEnrollForm.diasSemana || fisioEnrollForm.diasSemana.length === 0) {
              setIsSubmittingFisio(false); return alert('Selecione pelo menos um dia da semana.');
            }
            
            const patientObj = patients.find(p => String(p.id) === String(fisioEnrollForm.patientId));
            const isEditing = patientObj && patientObj.faz_fisio == 1 && !patientObj.fisio_cancelado_em && !patientObj.fisio_suspenso_em;
            try {
              const res = await fetch('api.php?action=update_fisio_enroll', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: fisioEnrollForm.patientId,
                  faz_fisio: 1,
                  fisio_cancelado_em: null,
                  fisio_suspenso_em: null,
                  fisio1_id: fisioEnrollForm.fisio1_id,
                  valor_sessao_fisio: fisioEnrollForm.valorSessao,
                  dias_semana_fisio: fisioEnrollForm.diasSemana.join(','),
                  horario_fisio: fisioEnrollForm.horario,
                  forma_pagamento_fisio: fisioEnrollForm.formaPagamento,
                  qtd_sessoes_fisio: fisioEnrollForm.formaPagamento === 'pacote' ? fisioEnrollForm.qtdSessoes : null
                })
              });
              const json = await res.json();
              if (json.success) {
                // Auto create package if it's a new enrollment and formaPagamento is 'pacote'
                if (!isEditing && fisioEnrollForm.formaPagamento === 'pacote') {
                   const pName = fisioEnrollSearch || patientObj?.nome || 'Paciente';
                   const qty = parseInt(fisioEnrollForm.qtdSessoes) || 10;
                   const today = new Date().toISOString().split('T')[0];
                   const newPkg = {
                      id: 'pkg_' + Date.now(),
                      patientName: pName,
                      patientId: fisioEnrollForm.patientId,
                      totalSessions: qty,
                      remaining: qty,
                      valorTotal: fisioEnrollForm.valorSessao,
                      metodoPagamento: 'Pacote Fechado (Matrícula)',
                      created: today,
                      active: true,
                      history: []
                   };
                   const currentPkgs = packages.map(p => (p.patientName === pName && p.active) ? { ...p, active: false } : p);
                   persistPackages([...currentPkgs, newPkg]);

                   const finEntry = {
                     id: 'pkg_fin_' + Date.now(),
                     tipo: 'receita',
                     descricao: `Venda de Pacote Fisio: ${qty} sessões - ${pName}`,
                     valor: fisioEnrollForm.valorSessao,
                     data: today,
                     categoria: 'Fisioterapia',
                     metodo: 'Matrícula',
                     status: 'pendente',
                     origem: 'manual'
                   };
                   persistFinEntries([...(finEntries || []), finEntry]);
                }
                
                if (!isEditing) {
                   const isPacote = fisioEnrollForm.formaPagamento === 'pacote';
                   const todayStr = new Date().toISOString().split('T')[0];
                   const cleanAgenda = agendaEventsRef.current.filter(ev => !(String(ev.patientId) === String(patientObj.id) && ev.fisioEvent && String(ev.date || '') >= todayStr));
                   const novosEv = buildFisioAgendaEventsForPatient(patientObj, fisioEnrollForm, isPacote, fisioEnrollForm.qtdSessoes);
                   if (novosEv && novosEv.length > 0) {
                      const proxAgenda = [...cleanAgenda, ...novosEv];
                      persistAgendaEvents(proxAgenda);
                      agendaEventsRef.current = proxAgenda;
                   } else if (cleanAgenda.length !== agendaEventsRef.current.length) {
                      persistAgendaEvents(cleanAgenda);
                      agendaEventsRef.current = cleanAgenda;
                   }
                }
                
                showToast(isEditing ? "Dados atualizados com sucesso!" : "Aluno matriculado na Fisioterapia com sucesso!");
                setFisioEnrollModalOpen(false);
                const data = await apiFetch('get_data');
                if (data && data.patients) setPatients(data.patients);
              } else {
                showToast("Erro: " + json.error, "error");
              }
            } catch (err) {
              console.error(err);
              showToast("Erro de conexão.", "error");
            } finally {
              setIsSubmittingFisio(false);
            }
          };

          const handleFisioSoftCancel = async (id) => {
            if (!window.confirm("Deseja finalizar o tratamento deste paciente? O histórico será mantido.")) return;
            try {
              const cancelDate = new Date().toISOString().split('T')[0];
              const res = await fetch('api.php?action=update_fisio_enroll', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id, fisio_soft_cancel: true, fisio_cancelado_em: cancelDate })
              });
              const json = await res.json();
              if (json.success) {
                const nextCancel = agendaEventsRef.current.filter(ev => !(String(ev.patientId) === String(id) && ev.fisioEvent && String(ev.date || '') >= cancelDate));
                persistAgendaEvents(nextCancel);
                agendaEventsRef.current = nextCancel;
                showToast("Tratamento finalizado com sucesso!");
                const data = await apiFetch('get_data');
                if (data && data.patients) setPatients(data.patients);
              }
            } catch (e) {
              console.error(e);
            }
          };

          const handleFisioReativar = async (patient, skipConfirm = false) => {
            if (!skipConfirm && !window.confirm("Deseja retomar o tratamento deste paciente?")) return;
            try {
              const res = await fetch('api.php?action=update_fisio_enroll', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: patient.id, fisio_reativar: true })
              });
              const json = await res.json();
              if (json.success) {
                showToast("Tratamento retomado com sucesso!");
                setPatients(prev => prev.map(p => String(p.id) === String(patient.id)
                  ? { ...p, faz_fisio: true, faz_osteopatia: true, fisio_cancelado_em: null, fisio_suspenso_em: null, fisio_motivo_suspensao: null, fisio_retorno_previsto: null }
                  : p));
                const data = await apiFetch('get_data');
                if (data && data.patients) setPatients(data.patients);
              }
            } catch (e) {
              console.error(e);
            }
          };

          const handleFisioSuspender = async () => {
            const { patient, motivo, dataRetorno, tipo } = suspenderFisioModal;
            if (!patient) return;
            try {
              const today = new Date().toISOString().split('T')[0];
              const promises = [];
              const suspenderFisio = (tipo === 'fisio' || tipo === 'ambos') && (patient.faz_fisio || patient.faz_osteopatia || patient.fisio_cancelado_em || patient.fisio_suspenso_em);
              const suspenderPilates = (tipo === 'pilates' || tipo === 'ambos') && (patient.faz_pilates || patient.pilates_cancelado_em || patient.pilates_suspenso_em);

              if (suspenderFisio) {
                promises.push(fetch('api.php?action=update_fisio_enroll', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: patient.id, fisio_suspender: true, fisio_suspenso_em: today, fisio_motivo_suspensao: motivo || '', fisio_retorno_previsto: dataRetorno || '' })
                }));
              }
              if (suspenderPilates) {
                promises.push(fetch('api.php?action=update_pilates_plan', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: patient.id, pilates_suspender: true, pilates_suspenso_em: today, pilates_motivo_suspensao: motivo || '', pilates_retorno_previsto: dataRetorno || '' })
                }));
              }
              const results = await Promise.all(promises);
              const jsons = await Promise.all(results.map(r => r.json()));
              if (jsons.every(j => j.success)) {
                showToast(`Tratamento de ${patient.nome} suspenso(a)! Clique em Retomar para reativar.`, 'info');
                setSuspenderFisioModal({ open: false, patient: null, motivo: '', dataRetorno: '', tipo: 'fisio' });
                
                const nextAgenda = agendaEventsRef.current.filter(ev => {
                  if (String(ev.patientId) !== String(patient.id)) return true;
                  if (String(ev.date || '') < today) return true;
                  if (suspenderFisio && ev.fisioEvent) return false;
                  if (suspenderPilates && ev.pilatesEvent) return false;
                  return true;
                });
                persistAgendaEvents(nextAgenda);
                agendaEventsRef.current = nextAgenda;

                setPatients(prev => prev.map(p => {
                  if (String(p.id) !== String(patient.id)) return p;
                  const upd = {};
                  if (suspenderFisio) {
                    upd.faz_fisio = false; upd.faz_osteopatia = false; upd.fisio_suspenso_em = today;
                    upd.fisio_motivo_suspensao = motivo || ''; upd.fisio_retorno_previsto = dataRetorno || null; upd.fisio_cancelado_em = null;
                  }
                  if (suspenderPilates) {
                    upd.faz_pilates = false; upd.pilates_suspenso_em = today;
                    upd.pilates_motivo_suspensao = motivo || ''; upd.pilates_retorno_previsto = dataRetorno || null; upd.pilates_cancelado_em = null;
                  }
                  return { ...p, ...upd };
                }));
              } else {
                const err = jsons.find(j => !j.success)?.error || 'desconhecido';
                showToast('Erro ao suspender: ' + err, 'error');
              }
            } catch (e) {
              showToast('Erro de conexão.', 'error');
            }
          };
          const [isSubmittingPilates, setIsSubmittingPilates] = useState(false);

          const handlePilatesEnrollSubmit = async () => {
            if (isSubmittingPilates) return;
            if (!pilatesEnrollForm.patientId) return alert("Selecione um paciente!");
            setIsSubmittingPilates(true);
            const patientObjPre = patients.find((p) => String(p.id) === String(pilatesEnrollForm.patientId));
            const isEditingPre = patientObjPre && !!patientObjPre.faz_pilates && !patientObjPre.pilates_cancelado_em && !patientObjPre.pilates_suspenso_em;
            if (!isEditingPre) {
              if (!String(pilatesEnrollForm.horario || '').trim()) { setIsSubmittingPilates(false); return alert('Informe o horário das aulas.'); }
              if (!pilatesEnrollForm.diasSemana || pilatesEnrollForm.diasSemana.length === 0) {
                setIsSubmittingPilates(false); return alert('Selecione pelo menos um dia de aula (obrigatório para gerar na Agenda e na Fila de Hoje).');
              }
              const tdPre = pilatesEnrollForm.diasSemana.map(pilatesDayLabelToNum).filter((d) => d !== undefined);
              if (!tdPre.length) {
                setIsSubmittingPilates(false); return alert('Não foi possível interpretar os dias da semana. Use Seg, Ter, Qua, Qui, Sex ou Sáb.');
              }
            }
            try {
              const res = await fetch('api.php?action=update_pilates_plan', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: pilatesEnrollForm.patientId,
                  faz_pilates: true,
                  pilates_cancelado_em: null,
                  pilates_suspenso_em: null,
                  valor_mensalidade_pilates: pilatesEnrollForm.valorMensalidade,
                  dia_vencimento_pilates: pilatesEnrollForm.diaVencimento,
                  dias_semana_pilates: pilatesEnrollForm.diasSemana.join(','),
                  horario_pilates: pilatesEnrollForm.horario,
                  fisio1_id: pilatesEnrollForm.professionalId
                })
              });
              let json;
              try { json = await res.json(); } catch(e) {
                alert("Erro ao receber resposta do servidor. Código de Status: " + res.status); return;
              }
              if (json && json.success) {
                // Atualiza state local
                const patientObj = patients.find(p => String(p.id) === String(pilatesEnrollForm.patientId));
                const patientName = patientObj ? patientObj.nome : '';
                const isEditing = patientObj && !!patientObj.faz_pilates && !patientObj.pilates_cancelado_em && !patientObj.pilates_suspenso_em;
                setPatients(prev => prev.map(p => String(p.id) === String(pilatesEnrollForm.patientId)
                  ? { ...p, faz_pilates: true, valor_mensalidade_pilates: pilatesEnrollForm.valorMensalidade, dia_vencimento_pilates: pilatesEnrollForm.diaVencimento, dias_semana_pilates: pilatesEnrollForm.diasSemana.join(','), horario_pilates: pilatesEnrollForm.horario }
                  : p));

                // --- Gerar eventos na Agenda (só ao adicionar, não ao editar) ---
                if (!isEditing && pilatesEnrollForm.diasSemana.length > 0 && pilatesEnrollForm.horario) {
                  const todayStr = new Date().toISOString().split('T')[0];
                  const cleanAgenda = agendaEventsRef.current.filter(ev => !(String(ev.patientId) === String(pilatesEnrollForm.patientId) && ev.pilatesEvent && String(ev.date || '') >= todayStr));
                  const novosEventos = buildPilatesAgendaEventsForPatient(
                    {
                      id: pilatesEnrollForm.patientId,
                      nome: patientName,
                      dias_semana_pilates: pilatesEnrollForm.diasSemana.join(','),
                      horario_pilates: pilatesEnrollForm.horario,
                      valor_mensalidade_pilates: pilatesEnrollForm.valorMensalidade,
                      fisio1_id: pilatesEnrollForm.professionalId,
                    },
                    pilatesEnrollForm.professionalId
                  );
                  if (novosEventos.length > 0) {
                    const nextAgenda = [...cleanAgenda, ...novosEventos];
                    persistAgendaEvents(nextAgenda);
                    agendaEventsRef.current = nextAgenda;
                  } else if (cleanAgenda.length !== agendaEventsRef.current.length) {
                    persistAgendaEvents(cleanAgenda);
                    agendaEventsRef.current = cleanAgenda;
                  }
                }

                // --- Lançamento Financeiro (só ao adicionar, não ao editar) ---
                if (!isEditing) {
                  const today2 = new Date();
                  const todayStr = today2.toISOString().split('T')[0];
                  const dueDay = String(pilatesEnrollForm.diaVencimento || '10').padStart(2, '0');
                  
                  // Calcular data do vencimento no próximo mês
                  const nextMonthDate = new Date(today2);
                  nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
                  const nextMonthStr = `${nextMonthDate.getFullYear()}-${String(nextMonthDate.getMonth()+1).padStart(2,'0')}`;
                  const templateDateStr = `${nextMonthStr}-${dueDay}`;

                  const finEntryHoje = {
                    id: `fin_pil_${Date.now()}_reativacao`,
                    tipo: 'receita',
                    descricao: `${patientName} - Pilates - 1ª Mensalidade`,
                    valor: String(pilatesEnrollForm.valorMensalidade || '0').replace('.', ','),
                    data: todayStr,
                    categoria: 'Pilates',
                    metodo: '',
                    status: 'pendente',
                    recorrente: false
                  };
                  
                  const nextFin = [finEntryHoje, ...finEntriesRef.current];
                  setFinEntries(nextFin);
                  finEntriesRef.current = nextFin;
                  await rcFinanceiroSave(nextFin);
                } // end !isEditing financeiro

                setPilatesEnrollOpen(false);
                setPilatesEnrollSearch('');
                showToast(isEditing ? `Dados de ${patientName} atualizados!` : `${patientName} adicionado ao Pilates! Agenda e Financeiro atualizados.`, 'success');
              } else alert("Erro ao salvar: " + (json ? json.error : "desconhecido"));
            } catch (e) { alert("Erro de conexão com o banco."); }
            finally { setIsSubmittingPilates(false); }
          };

          const handlePilatesCancelEnroll = (patient) => {
            setPilatesCancelModal({ open: true, patient });
          };

          const confirmPilatesCancelEnroll = async () => {
            const patient = pilatesCancelModal.patient;
            if (!patient) return;
            
            setPilatesCancelModal({ open: false, patient: null });
            try {
              const cancelDate = rcAgendaToDateKey(new Date());
              const res = await fetch('api.php?action=update_pilates_plan', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: patient.id, pilates_soft_cancel: true, pilates_cancelado_em: cancelDate }),
              });
              const json = await res.json();
              if (json && json.success) {
                const nextCancel = agendaEventsRef.current.filter(
                  (ev) =>
                    !(
                      String(ev.patientId) === String(patient.id) &&
                      ev.pilatesEvent &&
                      String(ev.date || '') >= cancelDate
                    )
                );
                persistAgendaEvents(nextCancel);
                agendaEventsRef.current = nextCancel;

                const nomeLower = String(patient.nome || '')
                  .trim()
                  .toLowerCase();
                const nextFin = finEntriesRef.current.filter((e) => {
                  const dataEv = String(e.data || '').slice(0, 10);
                  if (!dataEv) return true;
                  const idStr = String(e.id || '');
                  if (idStr.match(new RegExp(`^pil_\\d{4}-\\d{2}_${patient.id}$`))) {
                    return dataEv <= cancelDate;
                  }
                  if (String(e.categoria || '') === 'Pilates' && nomeLower && String(e.descricao || '').toLowerCase().includes(nomeLower)) {
                    return dataEv <= cancelDate;
                  }
                  return true;
                });
                if (nextFin.length !== finEntriesRef.current.length) {
                  setFinEntries(nextFin);
                  finEntriesRef.current = nextFin;
                  await rcFinanceiroSave(nextFin);
                }

                setPatients((prev) =>
                  prev.map((p) =>
                    String(p.id) === String(patient.id) ? { ...p, faz_pilates: false, pilates_cancelado_em: cancelDate } : p
                  )
                );
                showToast(`Matrícula cancelada. Financeiro e agenda: apenas até ${cancelDate}.`, 'info');
              } else alert('Erro ao cancelar: ' + (json ? json.error : 'desconhecido'));
            } catch (err) {
              alert('Erro de conexão.');
            }
          };

          const handlePilatesReativar = async (patient, skipConfirm = false) => {
            if (!skipConfirm && !confirm(`Reativar ${patient.nome} no Pilates?\n\nSerão gerados novamente os agendamentos das próximas semanas e as mensalidades voltam a ser lançadas automaticamente.`)) return;
            try {
              const res = await fetch('api.php?action=update_pilates_plan', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: patient.id, pilates_reativar: true }),
              });
              const json = await res.json();
              if (json && json.success) {
                const merged = { ...patient, faz_pilates: true, pilates_cancelado_em: null, pilates_suspenso_em: null, pilates_motivo_suspensao: null, pilates_retorno_previsto: null };
                setPatients((prev) => prev.map((p) => (String(p.id) === String(patient.id) ? { ...p, ...merged } : p)));
                const novos = buildPilatesAgendaEventsForPatient(merged, merged.fisio1_id || merged.fisio2_id || '');
                if (novos.length > 0) {
                  const nextAgenda = [...agendaEventsRef.current, ...novos];
                  setAgendaEvents(nextAgenda);
                  agendaEventsRef.current = nextAgenda;
                  await rcAgendaSave(nextAgenda);
                }
                showToast(`${patient.nome} reativado no Pilates.`, 'success');
              } else alert('Erro: ' + (json ? json.error : 'desconhecido'));
            } catch (e) {
              alert('Erro de conexão.');
            }
          };

          const [agendaForm, setAgendaForm] = useState({
            date: '',
            start: '',
            end: '',
            patientId: '',
            patientName: '',
            title: '',
            professionalId: '',
            paymentValue: '150,00',
            paymentStatus: 'Pendente',
            paymentMethod: '',
          });
          const [agendaPatientSearch, setAgendaPatientSearch] = useState('');
          const [agendaPatientDropdownOpen, setAgendaPatientDropdownOpen] = useState(false);

          const persistAgendaEvents = (next) => {
            setAgendaEvents(next);
            rcAgendaSave(next);
          };

          // ── Blindagem central de visibilidade de pacientes ──────────────────
          // Retorna true se o currentUser pode ver este paciente.
          // Fisio/Instrutor restrito: só vê pacientes onde é fisio1 ou fisio2.
          // Admin/Recepcionista/Super/ver_todos: vê todos.
          const patientVisivel = (patient) => {
            if (!patient) return false;
            if (!usuarioRestritoComoFisio(currentUser)) return true;
            return (
              String(patient.fisio1_id) === String(currentUser.id) ||
              String(patient.fisio2_id) === String(currentUser.id)
            );
          };


          const [presenceRecords, setPresenceRecords] = useState(() => rcPresenceRecordsLoad());
          const [presenceFlowCtx, setPresenceFlowCtx] = useState(null);
          const [presenceSearch, setPresenceSearch] = useState('');
          const [filaDate, setFilaDate] = useState(() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; });
          const [presenceDateFilter, setPresenceDateFilter] = useState('');
          const [presenceSelectedPatient, setPresenceSelectedPatient] = useState(null);

          // Sincroniza dados do Banco de Dados (API).
          useEffect(() => {
            const loadAllData = async () => {
              try {
                const [agenda, fin, pkgs, records, pending] = await Promise.all([
                  fetch('api.php?action=load_state&type=agenda', { credentials: 'include', cache: 'no-store' }).then(r => r.json()),
                  fetch('api.php?action=load_state&type=financeiro', { credentials: 'include', cache: 'no-store' }).then(r => r.json()),
                  fetch('api.php?action=load_state&type=pacotes', { credentials: 'include', cache: 'no-store' }).then(r => r.json()),
                  fetch('api.php?action=load_state&type=presence_records', { credentials: 'include', cache: 'no-store' }).then(r => r.json()),
                  fetch('api.php?action=load_state&type=presence_pending', { credentials: 'include', cache: 'no-store' }).then(r => r.json())
                ]);

                // Helper para migrar dados do localStorage para o Banco de Dados na primeira vez
                const getWithMigration = (serverData, lsKey, saveFn) => {
                  if (Array.isArray(serverData) && serverData.length > 0) return serverData;
                  try {
                    const localRaw = window.localStorage.getItem(lsKey);
                    if (localRaw) {
                      const local = JSON.parse(localRaw);
                      if (Array.isArray(local) && local.length > 0) {
                        saveFn(local); // Sobe para o banco
                        return local;
                      }
                    }
                  } catch(e) {}
                  return Array.isArray(serverData) ? serverData : [];
                };

                const finalAgenda = getWithMigration(agenda, 'clinic_agenda_events_v1', rcAgendaSave);
                const finalFin = getWithMigration(fin, 'clinic_financeiro_entries_v1', rcFinanceiroSave);
                const finalPkgs = getWithMigration(pkgs, 'clinic_packages_v1', rcPackagesSave);
                const finalRecords = getWithMigration(records, 'clinic_presence_records_v1', rcPresenceRecordsSave);
                
                if (Array.isArray(finalAgenda)) setAgendaEvents(finalAgenda);
                if (Array.isArray(finalPkgs)) setPackages(finalPkgs);
                if (Array.isArray(finalRecords)) setPresenceRecords(finalRecords);

                // Libera o guard APÓS carregar do banco — agora salvar está seguro
                _rcDbSaveGuard.loaded = true;

                if (Array.isArray(finalFin)) {
                  /* ── auto-gerar recorrentes do mês ── */
                  const today = new Date();
                  const mesAtual = today.toISOString().split('T')[0].slice(0, 7);
                  const templates = finalFin.filter(e => e.recorrente);
                  let gerados = [...finalFin];
                  let changed = false;
                  templates.forEach(tpl => {
                    const tplMes = (tpl.data || '').slice(0, 7);
                    const dia = (tpl.data || '').slice(8, 10) || '01';
                    if (tplMes < mesAtual) {
                      const recId = 'rec_' + tpl.id + '_' + mesAtual;
                      const jaExiste = gerados.some(e => String(e.id) === String(recId));
                      if (!jaExiste) {
                        gerados.push({
                          ...tpl,
                          id: recId,
                          data: mesAtual + '-' + dia,
                          status: 'pendente',
                          recorrente: false,
                          origemRecorrente: tpl.id,
                        });
                        changed = true;
                      }
                    }
                  });
                  setFinEntries(gerados);
                  if (changed) rcFinanceiroSave(gerados);
                }
              } catch (e) {
                console.error("Erro ao sincronizar com o banco:", e);
              }
            };

            loadAllData();
            
            // Sincronização periódica (substitui o storage event para dados de servidor)
            const id = setInterval(loadAllData, 3000); 

            const onStorage = (e) => {
              if (!e || !e.key) return;
              if (e.key === 'rc_system_pings' && e.newValue) {
                try {
                  const payload = JSON.parse(e.newValue);
                  if (payload.type === 'ARRIVAL_ALERT' && currentUser) {
                     if (String(payload.targetProfId) === String(currentUser.id)) {
                        setProfessionalArrivalAlert({
                           id: payload.eventId,
                           patientName: payload.patientName
                        });
                        setTimeout(loadAllData, 1000);
                     }
                  } else if (payload.type === 'RESPONSE_ALERT' && currentUser) {
                     if (String(currentUser.id) !== String(payload.senderProfId)) {
                        setReceptionResponseAlert({
                           patientName: payload.patientName,
                           professionalResponse: payload.professionalResponse || (payload.statusMsg && payload.statusMsg.includes('entrada') ? 'pode_entrar' : 'aguardar')
                        });
                        setTimeout(loadAllData, 500);
                     }
                  }
                } catch(err) {}
              }
            };
            window.addEventListener('storage', onStorage);
            window.addEventListener('focus', loadAllData);
            return () => {
              window.removeEventListener('storage', onStorage);
              window.removeEventListener('focus', loadAllData);
              clearInterval(id);
            };
          }, [currentUser]);

          // Alerta remoto de chegada (funciona entre computadores diferentes usando a API)
          useEffect(() => {
            if (!currentUser || !agendaEvents || agendaEvents.length === 0) return;
            const today = new Date().toISOString().split('T')[0];
            
            // 1. Verificação para o PROFISSIONAL: o paciente chegou na recepção?
            const arrivedAlerts = agendaEvents.filter(ev => 
              ev.date === today && 
              ev.arrived === true && 
              !ev.receptionNotified && 
              String(ev.professionalId) === String(currentUser.id)
            );
            if (arrivedAlerts.length > 0) {
              const newEvents = [...agendaEvents];
              const firstAlert = arrivedAlerts[0];
              setProfessionalArrivalAlert(firstAlert);
              
              const idx = newEvents.findIndex(e => e.id === firstAlert.id);
              if (idx >= 0) newEvents[idx] = { ...newEvents[idx], receptionNotified: true };
              
              persistAgendaEvents(newEvents);
            }

            // 2. Verificação para a RECEPÇÃO: o profissional já respondeu?
            const responseAlerts = agendaEvents.filter(ev => 
              ev.date === today && 
              ev.professionalResponse && 
              !ev.responseNotified &&
              String(ev.professionalId) !== String(currentUser.id)
            );
            if (responseAlerts.length > 0) {
              const newEvents = [...agendaEvents];
              responseAlerts.forEach(alert => {
                 setReceptionResponseAlert({
                   patientName: alert.patientName || 'O paciente',
                   professionalResponse: alert.professionalResponse
                 });
                 
                 const idx = newEvents.findIndex(e => e.id === alert.id);
                 if (idx >= 0) newEvents[idx] = { ...newEvents[idx], responseNotified: true };
              });
              persistAgendaEvents(newEvents);
            }
          }, [agendaEvents, currentUser]);

          // --- ESTADOS DE PACIENTES E FORMULáRIOS ---
          const [patients, setPatients] = useState([]);
          // Lista de pacientes visiveis para o usuario logado (fonte unica de verdade)
          // IMPORTANTE: definida APOS o useState de patients
          const patientsVisiveis = patients.filter(patientVisivel);

          const [selectedPatient, setSelectedPatient] = useState(null);
          const [patientSubTab, setPatientSubTab] = useState('perfil');
          const [patientToDelete, setPatientToDelete] = useState(null);
          const [isEditingPatient, setIsEditingPatient] = useState(false);
          const [editingPatientId, setEditingPatientId] = useState(null);
          const [isLoadingDetails, setIsLoadingDetails] = useState(false);
          const [birthdayPatients, setBirthdayPatients] = useState([]);

          useEffect(() => {
            if (!_rcDbSaveGuard.loaded || patients.length === 0) return;
            const today = new Date();
            const currYYYYMM = today.toISOString().split('T')[0].slice(0, 7);
            let changes = false;
            let current = [...finEntries];
            
            patients.forEach(p => {
              if (p.faz_pilates && !p.pilates_cancelado_em && p.dia_vencimento_pilates && p.valor_mensalidade_pilates) {
                const dia = String(p.dia_vencimento_pilates).padStart(2, '0');
                const recId = `pil_${currYYYYMM}_${p.id}`;
                const expectedData = currYYYYMM + '-' + dia;
                const expectedDesc = `${p.nome} - Pilates - Mensalidade`;
                
                // Evitar duplicação se já gerou uma Mensalidade normal ou uma 1ª Mensalidade de Reativação no mesmo mês
                const existingIndex = current.findIndex(e => 
                   e.id === recId || 
                   (e.categoria === 'Pilates' && String(e.data).startsWith(currYYYYMM) && e.descricao.includes(p.nome))
                );
                
                // Calculate diff in days
                const expectedDateObj = new Date(`${expectedData}T00:00:00`);
                const todayObj = new Date(today.toISOString().split('T')[0] + 'T00:00:00');
                const diffTime = expectedDateObj - todayObj;
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                if (existingIndex === -1) {
                   if (diffDays <= 7) {
                     current.push({
                       id: recId,
                       data: expectedData,
                       descricao: expectedDesc,
                       valor: String(p.valor_mensalidade_pilates).replace('.', ','),
                       tipo: 'receita',
                       status: 'pendente',
                       profissionalId: '',
                       metodo: '',
                       categoria: 'Pilates',
                       recorrente: false,
                       origemRecorrente: null
                     });
                     changes = true;
                   }
                } else {
                   // Se já existe, atualiza a data de vencimento e valor se a recepcionista mudou no cadastro
                   // (Apenas se ainda estiver pendente, para não bagunçar algo já pago)
                   const ex = current[existingIndex];
                   if (ex.status === 'pendente' && !ex.descricao.includes('1ª Mensalidade')) {
                     if (ex.data !== expectedData || ex.valor !== String(p.valor_mensalidade_pilates).replace('.', ',') || ex.descricao !== expectedDesc) {
                       current[existingIndex] = { ...ex, data: expectedData, valor: String(p.valor_mensalidade_pilates).replace('.', ','), descricao: expectedDesc };
                       changes = true;
                     }
                   }
                }
              }
            });
            if (changes) {
               setFinEntries(current);
               rcFinanceiroSave(current);
            }
          }, [patients, finEntries.length]);

          const [newPatient, setNewPatient] = useState({
            nome: '', cpf: '', rg: '', dataNascimento: '', idade: '', sexo: '', estadoCivil: '', profissao: '', telefone: '', telefone2: '', cep: '', endereco: '', numero: '', bairro: '', cidade: '', uf: '', planoSaude: 'Não', qualPlano: '', indicacao: '', responsavel: '',
            fisio1_id: null, fisio2_id: null,
            faz_pilates: false, valor_mensalidade_pilates: '', dia_vencimento_pilates: '',
            faz_fisio: false, valor_sessao_fisio: '', horario_fisio: '', dias_semana_fisio: '', forma_pagamento_fisio: ''
          });
          const [isDualFisio, setIsDualFisio] = useState(false);

          const [fisioEval, setFisioEval] = useState({
            id: null, data: new Date().toISOString().split('T')[0], rg: '', indicacao: '', responsavel: '', queixaPrincipal: '', hda: '', antecedentes: '', habitosVida: '', exames: '', inspecao: '', palpacao: '', goniometria: '', grauForca: '', objetivos: '', conduta: '', evolucoes: []
          });

          const getEmptyFisioEvol = () => ({ 
            id: null, evolucao: '', assinaturaFisio: null, fotoFisio: null, assinaturaPaciente: null, fotoPaciente: null
          });
          const [fisioEvol, setFisioEvol] = useState(getEmptyFisioEvol());

          const getEmptyPilatesEval = () => ({
            id: null, data: new Date().toISOString().split('T')[0],
            escolaridade: '', ocupacao: '',
            indicacaoMedica: 'Não', praticouPilates: 'Não', tempoPratica: '', sedentario: 'Não', tempoSedentario: '', outraAtividade: '', frequencia: '',
            queixaPrincipal: '', outrasQueixas: '',
            neurologicos: 'Não', respiratorios: 'Não', cardiacos: 'Não', osteomioarticulares: 'Não', psicologicos: 'Não', fraturaCirurgia: 'Não', descFraturaCirurgia: '', hipertensao: 'Não', diabetes: 'Não',
            fumante: 'Não', alcool: 'Não', alcoolFreq: '', medicamentos: '', examesImagem: '',
            // Postural
            cabecaAnt: 'Normal', cabecaLat: 'Normal',
            ombrosAnt: 'Simǩtricos', ombrosLat: 'Normal', ombrosPost: 'Normal',
            colunaLatCervical: 'Normal', colunaLatToracica: 'Normal', colunaLatLombar: 'Normal', colunaPost: 'Normal', colunaPostDesc: '',
            quadril: 'Normal',
            joelhosAnt: 'Normal', joelhosLat: 'Normal',
            pesNormal: true, pesPlanoD: false, pesPlanoE: false, pesCavoD: false, pesCavoE: false, pesValgoD: false, pesValgoE: false, pesVaroD: false, pesVaroE: false,
            conclusoes: '', objetivos: '',
            assinaturaFisio: null, fotoFisio: null
          });
          const [pilatesEval, setPilatesEval] = useState(getEmptyPilatesEval());

          const getEmptyPilatesEvol = () => ({
            id: null, reposicao: 'Não', instrutor: currentUser?.nome || '', matPilates: false, maquinario: false, equilibrio: false,
            mmssAlong: false, mmssFort: false, mmisAlong: false, mmisFort: false,
            caAlong: false, caFort: false, cpAlong: false, cpFort: false, clAlong: false, clFort: false, rotsAlong: false, rotsFort: false, obs: ''
          });
          const [pilatesEvol, setPilatesEvol] = useState(getEmptyPilatesEvol());

          const [osteopatiaEval, setOsteopatiaEval] = useState({
            id: null, data: new Date().toISOString().split('T')[0], queixaPrincipal: '', inspecao: '', palpacao: ''
          });
          const getEmptyOsteopatiaEvol = () => ({
            id: null, evolucao: '', assinaturaFisio: null, fotoFisio: null, assinaturaPaciente: null, fotoPaciente: null
          });
          const [osteopatiaEvol, setOsteopatiaEvol] = useState(getEmptyOsteopatiaEvol());
          const [showOsteoHistorico, setShowOsteoHistorico] = useState(false);
          const [showOsteoVisualizar, setShowOsteoVisualizar] = useState(false);

          const [viewingPilatesEvol, setViewingPilatesEvol] = useState(null);
          const [viewingPilatesAval, setViewingPilatesAval] = useState(null);
          const [viewingFisioAval, setViewingFisioAval] = useState(null);
          const [viewingFisioEvolTable, setViewingFisioEvolTable] = useState(null);
          const [viewSignatures, setViewSignatures] = useState(null);
          const [dualSignatureFlow, setDualSignatureFlow] = useState({ isOpen: false, fisioData: null, ptData: null, payload: null });
 
           // --- ESTADOS DE PWA E MOBILE ---
           const [isMenuOpen, setIsMenuOpen] = useState(false);
           const [deferredPrompt, setDeferredPrompt] = useState(null);
           const deferredPromptRef = useRef(null);
           const [showInstallBanner, setShowInstallBanner] = useState(false);
           const [showInstallHelpModal, setShowInstallHelpModal] = useState(false);
           const [showManualInstallModal, setShowManualInstallModal] = useState(false);
           const [showVersionUpdateModal, setShowVersionUpdateModal] = useState(false);
           const [newVersionLabel, setNewVersionLabel] = useState('');
           const [displayStandalone, setDisplayStandalone] = useState(false);
           const [sidebarInstallDismissed, setSidebarInstallDismissed] = useState(() => {
             try {
               return window.localStorage.getItem('rc_sidebar_install_dismissed') === '1';
             } catch (e) {
               return false;
             }
           });
          const manifestBlobUrlRef = useRef(null);
          const pwaIconWriteLock = useRef(false);
          const patientDeepLinkConsumedRef = useRef(false);

          // --- ESTADOS DE API E CARREGAMENTO ---
          const [isApiReady, setIsApiReady] = useState(false);
          const [isConnected, setIsConnected] = useState(false);
          const [remoteSignId, setRemoteSignId] = useState(null);
          const [isLoadingCep, setIsLoadingCep] = useState(false);
          const [isLoadingCpf, setIsLoadingCpf] = useState(false);
          const [isLoadingCnpj, setIsLoadingCnpj] = useState(false);

          const [systemSettings, setSystemSettings] = useState({ tokenCpf: '', tokenCep: '', birthdayMessage: 'Olá {nome}, a Real Clínica Integrada deseja um feliz aniversário!' });

          const [companyData, setCompanyData] = useState({
            razaoSocial: '', nomeFantasia: '', cnpj: '', inscricaoEstadual: '', telefone: '', email: '', endereco: '', regimeTributario: ''
          });

          const [smtpSettings, setSmtpSettings] = useState({ server: '', port: '', user: '', password: '' });

          const showToast = (message, type = 'success') => {
            const id = Date.now();
            setToasts(prev => [...prev, { id, message, type }]);
            setTimeout(() => setToasts(prev => prev.filter((x) => x.id !== id)), 4000);
          };

          const decrementPackageForPatient = (pName, eventId) => {
            if (!pName) return false;
            // Usa o estado `packages` diretamente, em vez de rcPackagesLoad(), pois ele retorna [] no modo DB
            const currentPkgs = packages; 
            const pkgIdx = currentPkgs.findIndex(p => p.patientName === pName && p.active && p.remaining > 0);
            if (pkgIdx !== -1) {
              const pkg = { ...currentPkgs[pkgIdx] };
              pkg.remaining = Math.max(0, pkg.remaining - 1);
              pkg.usedSessions = (pkg.usedSessions || 0) + 1;
              pkg.history = [...(pkg.history || []), { date: new Date().toISOString().split('T')[0], eventId: eventId }];

              if (pkg.remaining === 0) { pkg.active = false; }

              const updatedPkgs = [...currentPkgs];
              updatedPkgs[pkgIdx] = pkg;
              persistPackages(updatedPkgs);

              /* avisos contextuais */
              if (pkg.remaining === 0) {
                setTimeout(() => {
                  showToast(`⚠️ Pacote de ${pName} FINALIZADO! Todas as sessões foram utilizadas.`, 'error');
                  setRenewalModalCtx({ patientName: pName, pkg });
                }, 1500);
              } else if (pkg.remaining === 1) {
                setTimeout(() => showToast(`🔔 ÚLTIMA SESSÃO! ${pName} tem apenas 1 sessão restante no pacote.`, 'error'), 1500);
              } else if (pkg.remaining <= 3) {
                setTimeout(() => showToast(`⚠️ ${pName} tem ${pkg.remaining} sessões restantes no pacote.`, 'warning'), 1500);
              } else {
                setTimeout(() => showToast(`📋 ${pName}: 1 Sessão debitada! Restam ${pkg.remaining} sessões.`, 'success'), 1500);
              }
              return true;
            }
            return false;
          };

          const handlePresenceSaved = (record, remoteToken) => {
            setPresenceRecords((prev) => {
              const next = [record, ...prev];
              rcPresenceRecordsSave(next);
              return next;
            });
            if (remoteToken) {
              fetch('api.php?action=load_state&type=presence_pending', { cache: 'no-store' })
                .then(r => r.json())
                .then(list => {
                  fetch('api.php?action=sync_state&type=presence_pending', {
                    method: 'POST', credentials: 'include', headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify(list.filter((x) => String(x.token) !== String(remoteToken)))
                  });
                });
            } else {
              if (record.agendaEventId) {
                setAgendaEvents((prev) => {
                  const next = prev.map((e) => (e.id === record.agendaEventId ? { ...e, presence: 'registered' } : e));
                  rcAgendaSave(next);
                  return next;
                });
              }
            }

            /* ── AUTO-DEDUCT de pacote ── */
            decrementPackageForPatient((record.patientName || '').trim(), record.agendaEventId);

            if (remoteToken) {
               setRemoteSessionSuccess(true);
            } else {
               setPresenceFlowCtx(null);
               showToast('Presença confirmada com sucesso!');
            }
          };

          const handleAppointmentResponse = async (status) => {
            if (!confirmAppointmentCtx?.agendaEventId) return;
            try {
              const res = await fetch(`api.php?action=update_appointment_status&id=${confirmAppointmentCtx.agendaEventId}&status=${status}`, { cache: 'no-store' });
              const data = await res.json();
              if (data.success) {
                setRemoteAppointmentResponse(status);
              } else {
                showToast(data.error || 'Erro ao salvar resposta', 'error');
              }
            } catch (e) {
              showToast('Erro de conexão com o servidor', 'error');
            }
          };

           // --- EFEITOS (SIDE EFFECTS) ---

           // Aniversariantes do dia: mesma regra de visibilidade da lista; menu lateral só existe se length > 0
           useEffect(() => {
             if (!patients.length) {
               setBirthdayPatients([]);
               return;
             }
             const hoje = new Date();
             const diaHoje = hoje.getDate();
             const mesHoje = hoje.getMonth() + 1;

             const patientVisibleForBirthdays = (patient) => {
               if (usuarioRestritoComoFisio(currentUser)) {
                 return patient.fisio1_id == currentUser.id || patient.fisio2_id == currentUser.id;
               }
               if (currentUser?.ver_todos && patientListView === 'mine') {
                 return patient.fisio1_id == currentUser.id || patient.fisio2_id == currentUser.id;
               }
               return true;
             };

             const aniversariantes = patients.filter(p => {
               if (!patientVisibleForBirthdays(p)) return false;
               const dataNasc = p.data_nascimento || p.dataNascimento;
               const parsed = parseBirthMonthDay(dataNasc);
               if (!parsed) return false;
               return parsed.dia === diaHoje && parsed.mes === mesHoje;
             });

             setBirthdayPatients(aniversariantes);
           }, [patients, currentUser, patientListView]);

           useEffect(() => {
             if (activeTab === 'birthday' && birthdayPatients.length === 0) {
               setActiveTab('list');
             }
           }, [activeTab, birthdayPatients.length]);

           useEffect(() => {
              try {
                const urlParams = new URLSearchParams(window.location.search);
                const remotePresenceParam = urlParams.get('remote_presence');
                const confirmAppointmentParam = urlParams.get('confirm_appointment');

                if (remotePresenceParam) {
                  fetch('api.php?action=load_state&type=presence_pending', { cache: 'no-store' })
                    .then(r => r.json())
                    .then(list => {
                      const item = list.find((x) => String(x.token) === String(remotePresenceParam));
                      if (!item) {
                        setRemoteSessionInvalid(true);
                        setRemoteSessionLoading(false);
                        window.history.replaceState({}, document.title, window.location.pathname);
                        return;
                      }
                      setPresenceFlowCtx({
                        patientName: item.patientName,
                        professionalName: item.professionalName,
                        professionalId: item.professionalId,
                        agendaEventId: item.agendaEventId,
                        date: item.date,
                        time: item.time,
                        startAtStep: 'sign',
                        remoteToken: item.token,
                      });
                      window.history.replaceState({}, document.title, window.location.pathname);
                      setRemoteSessionLoading(false);
                    })
                    .catch(() => {
                      setRemoteSessionInvalid(true);
                      setRemoteSessionLoading(false);
                    });
                  return;
                }

                if (confirmAppointmentParam) {
                  try {
                    const decoded = JSON.parse(atob(decodeURIComponent(confirmAppointmentParam)));
                    setConfirmAppointmentCtx(decoded);
                  } catch (parseErr) {
                    setRemoteSessionInvalid(true);
                  }
                  window.history.replaceState({}, document.title, window.location.pathname);
                  setRemoteSessionLoading(false);
                  return;
                }

                setRemoteSessionLoading(false);
              } catch (e) {
                setRemoteSessionLoading(false);
              }
            }, []);

           
           // Detecção de Assinatura Remota
           useEffect(() => {
             const urlParams = new URLSearchParams(window.location.search);
             const patientSignId = urlParams.get('patient_sign');
             if (patientSignId && patients.length > 0) {
                 const patient = patients.find(p => p.id == patientSignId);
                 if (patient) {
                     setSelectedPatient(patient);
                     setSignatureModal({ isOpen: true, role: 'Paciente' });
                     setRemoteSignId(patientSignId);
                     window.history.replaceState({}, document.title, window.location.pathname);
                 }
             }
           }, [patients]);
 
           // Tema: persistência, favicon, apple-touch (app instalado iOS) e manifest PWA (ícone Android / instalável)
           useEffect(() => {
             document.title = "Real Clínica Integrada";
             window.localStorage.setItem('clinic_theme', JSON.stringify(theme));

             const apiBundledIcon = (size) => {
               try {
                 const u = new URL('api.php', window.location.href);
                 u.searchParams.set('action', 'bundled_icon');
                 u.searchParams.set('size', String(size));
                 return u.href;
               } catch (e) {
                 return `api.php?action=bundled_icon&size=${size}`;
               }
             };
             const icon512Href = apiBundledIcon(512);
             const pwaVer = (() => {
               try {
                 return window.localStorage.getItem('rc_pwa_icon_ver') || '';
               } catch (e) {
                 return '';
               }
             })();
             const hostedPwaIcon = (() => {
               if (!pwaVer) return '';
               try {
                 const u = new URL('api.php', window.location.href);
                 u.searchParams.set('action', 'pwa_icon');
                 u.searchParams.set('v', String(pwaVer));
                 return u.href;
               } catch (e) {
                 return `api.php?action=pwa_icon&v=${encodeURIComponent(pwaVer)}`;
               }
             })();
             const pwaIconData = theme.appIconUrl || theme.logoUrl;
             const manifestMimeFor = (s) => {
               if (s.startsWith('data:image/png')) return 'image/png';
               if (s.startsWith('data:image/jpeg')) return 'image/jpeg';
               if (s.startsWith('data:image/webp')) return 'image/webp';
               if (/[?&]action=pwa_icon/i.test(s)) return 'image/png';
               if (/[?&]action=bundled_icon/i.test(s)) return 'image/png';
               if (/\.png($|\?|#)/i.test(s)) return 'image/png';
               if (/\.jpe?g($|\?|#)/i.test(s)) return 'image/jpeg';
               if (/\.webp($|\?|#)/i.test(s)) return 'image/webp';
               return 'image/png';
             };
             let manifestIcons;
             if (hostedPwaIcon) {
               manifestIcons = [
                 { src: hostedPwaIcon, sizes: '192x192', type: 'image/png', purpose: 'any' },
                 { src: hostedPwaIcon, sizes: '512x512', type: 'image/png', purpose: 'any' }
               ];
             } else if (pwaIconData && String(pwaIconData).startsWith('data:')) {
               const t = manifestMimeFor(String(pwaIconData));
               manifestIcons = [
                 { src: pwaIconData, sizes: '192x192', type: t, purpose: 'any' },
                 { src: pwaIconData, sizes: '512x512', type: t, purpose: 'any' }
               ];
             } else if (pwaIconData) {
               const t = manifestMimeFor(String(pwaIconData));
               manifestIcons = [
                 { src: pwaIconData, sizes: '192x192', type: t, purpose: 'any' },
                 { src: pwaIconData, sizes: '512x512', type: t, purpose: 'any' }
               ];
             } else {
               manifestIcons = [
                 { src: apiBundledIcon(192), sizes: '192x192', type: 'image/png', purpose: 'any' },
                 { src: apiBundledIcon(512), sizes: '512x512', type: 'image/png', purpose: 'any' }
               ];
             }

             let favicon = document.querySelector("link[rel~='icon']");
             if (!favicon) {
               favicon = document.createElement('link');
               favicon.rel = 'icon';
               document.head.appendChild(favicon);
             }
             const faviconSrc = hostedPwaIcon || pwaIconData || defaultLogoPath;
             favicon.href = faviconSrc;
             favicon.type = hostedPwaIcon
               ? 'image/png'
               : pwaIconData
                 ? (String(pwaIconData).startsWith('data:image/png')
                   ? 'image/png'
                   : String(pwaIconData).startsWith('data:image/webp')
                     ? 'image/webp'
                     : 'image/jpeg')
                 : 'image/jpeg';

             let appleTouch = document.querySelector("link[rel='apple-touch-icon']");
             if (!appleTouch) {
               appleTouch = document.createElement('link');
               appleTouch.rel = 'apple-touch-icon';
               document.head.appendChild(appleTouch);
             }
             appleTouch.setAttribute('sizes', '180x180');
             try {
               appleTouch.href = hostedPwaIcon || pwaIconData || apiBundledIcon(192);
             } catch (e) {
               appleTouch.href = hostedPwaIcon || pwaIconData || 'api.php?action=bundled_icon&size=192';
             }

             const scopeBase = new URL('./', window.location.href).href;
             let startUrl;
             try {
               startUrl = new URL('index.html', window.location.href).href;
             } catch (e) {
               startUrl = window.location.href;
             }
             const manifestObj = {
               name: 'Real Clínica Integrada',
               short_name: 'Real Clínica',
               description: 'Sistema de Gestão Clínica Integrada',
               start_url: startUrl,
               scope: scopeBase,
               display: 'standalone',
               background_color: '#ffffff',
               theme_color: '#047857',
               icons: manifestIcons
             };
             const blob = new Blob([JSON.stringify(manifestObj)], { type: 'application/json' });
             const blobUrl = URL.createObjectURL(blob);
             if (manifestBlobUrlRef.current) {
               URL.revokeObjectURL(manifestBlobUrlRef.current);
             }
             manifestBlobUrlRef.current = blobUrl;
             let manifestLink = document.querySelector('link[rel="manifest"]');
             if (!manifestLink) {
               manifestLink = document.createElement('link');
               manifestLink.rel = 'manifest';
               document.head.appendChild(manifestLink);
             }
             manifestLink.href = blobUrl;

             return () => {
               if (manifestBlobUrlRef.current) {
                 URL.revokeObjectURL(manifestBlobUrlRef.current);
                 manifestBlobUrlRef.current = null;
               }
             };
           }, [theme, pwaIconFileRev]);
 
           // PWA: modo instalado (standalone)
           useEffect(() => {
             const st = window.matchMedia('(display-mode: standalone)').matches === true
               || window.navigator.standalone === true;
             setDisplayStandalone(st);
           }, []);

           // Registro de Service Worker, atualização do SW e Prompt PWA
           useEffect(() => {
             const onBip = (e) => {
               e.preventDefault();
               try { window.__rcInstallPrompt = e; } catch (err) {}
               deferredPromptRef.current = e;
               setDeferredPrompt(e);
               if (!localStorage.getItem('pwa_installed')) {
                 setTimeout(() => setShowInstallBanner(true), 5000);
               }
             };
             window.addEventListener('beforeinstallprompt', onBip);

             if ('serviceWorker' in navigator) {
               const regSw = () => {
                 let swUrl = 'api.php?action=service_worker';
                 let scopeUrl = './';
                 try {
                   const u = new URL('api.php', window.location.href);
                   u.searchParams.set('action', 'service_worker');
                   u.searchParams.set('v', String(Date.now()));
                   swUrl = u.href;
                   scopeUrl = new URL('./', window.location.href).href;
                 } catch (e) { /* fallback relativos */ }
                 navigator.serviceWorker.register(swUrl, { scope: scopeUrl })
                   .then((reg) => {
                     console.log('SW registrado', reg);
                     const pending = window.__rcInstallPrompt;
                     if (pending) {
                       deferredPromptRef.current = pending;
                       setDeferredPrompt(pending);
                     }
                     const pingUpdate = () => { try { reg.update(); } catch (e) {} };
                     pingUpdate();
                     setInterval(pingUpdate, 2 * 60 * 1000);
                     window.addEventListener('focus', pingUpdate);
                   })
                   .catch(err => console.log('Erro SW', err));
               };
               if (document.readyState === 'complete') regSw();
               else window.addEventListener('load', regSw);
             } else {
               const pending = window.__rcInstallPrompt;
               if (pending) {
                 deferredPromptRef.current = pending;
                 setDeferredPrompt(pending);
               }
             }

             window.addEventListener('appinstalled', () => {
               setShowInstallBanner(false);
               try { window.__rcInstallPrompt = null; } catch (err) {}
               deferredPromptRef.current = null;
               setDeferredPrompt(null);
               localStorage.setItem('pwa_installed', 'true');
               setDisplayStandalone(true);
             });

             return () => window.removeEventListener('beforeinstallprompt', onBip);
           }, []);

           /** Novo deploy: em TODA publicação altere version e/ou build em version.json (na pasta da hospedagem). */
           useEffect(() => {
             let cancelled = false;
             const STORAGE_KEY = 'rc_deploy_version';
             const versionUrl = () => {
               try {
                 const u = new URL('version.json', window.location.href);
                 u.searchParams.set('t', Date.now().toString());
                 return u.href;
               } catch (e) {
                 return `version.json?t=${Date.now()}`;
               }
             };
             const checkVersion = async () => {
               try {
                 const res = await fetch(versionUrl(), { cache: 'no-store', headers: { 'Cache-Control': 'no-cache' } });
                 if (!res.ok) return;
                 const data = await res.json();
                 const v = data.version != null ? String(data.version).trim() : '';
                 const b = data.build != null ? String(data.build).trim() : '';
                 const remote = [v, b].filter(Boolean).join(':');
                 if (!remote) return;
                 const local = localStorage.getItem(STORAGE_KEY);
                 if (!local) {
                   localStorage.setItem(STORAGE_KEY, remote);
                   return;
                 }
                 if (remote !== local && !cancelled) {
                   const label = [v && `v${v}`, b].filter(Boolean).join(' · ') || remote;
                   setNewVersionLabel(label);
                   setShowVersionUpdateModal(true);
                 }
               } catch (e) { /* offline ou sem version.json */ }
             };
             const t0 = setTimeout(checkVersion, 400);
             const iv = setInterval(checkVersion, 60 * 1000);
             const onFocus = () => checkVersion();
             const onVis = () => {
               if (!document.hidden) checkVersion();
             };
             const onPageShow = (e) => {
               if (e.persisted) checkVersion();
             };
             window.addEventListener('focus', onFocus);
             document.addEventListener('visibilitychange', onVis);
             window.addEventListener('pageshow', onPageShow);
             return () => {
               cancelled = true;
               clearTimeout(t0);
               clearInterval(iv);
               window.removeEventListener('focus', onFocus);
               document.removeEventListener('visibilitychange', onVis);
               window.removeEventListener('pageshow', onPageShow);
             };
           }, []);

           const applyDeploymentUpdate = async () => {
             setShowVersionUpdateModal(false);
             try {
               const keys = await caches.keys();
               await Promise.all(keys.map((k) => caches.delete(k)));
             } catch (e) {}
             try {
               const regs = await navigator.serviceWorker.getRegistrations();
               await Promise.all(regs.map((r) => r.unregister()));
             } catch (e) {}
             setIsAuthenticated(false);
             setCurrentUser(null);
             try { window.localStorage.clear(); } catch (e) {}
             const base = window.location.pathname.split('?')[0] || '/';
             window.location.href = `${base}?updated=${Date.now()}`;
           };
 
           const dismissSidebarInstallCta = (e) => {
             if (e) {
               e.preventDefault();
               e.stopPropagation();
             }
             try {
               window.localStorage.setItem('rc_sidebar_install_dismissed', '1');
             } catch (err) { /* noop */ }
             setSidebarInstallDismissed(true);
           };

           const handleInstallApp = async () => {
             try {
               setIsMenuOpen(false);
               setShowManualInstallModal(false);
               const standalone = window.matchMedia('(display-mode: standalone)').matches === true
                 || window.navigator.standalone === true;
               if (standalone) {
                 showToast('O aplicativo já está instalado neste dispositivo.', 'info');
                 return;
               }
               const hostOk = /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname || '');
               if (!window.isSecureContext && !hostOk) {
                 showToast('A instalação só funciona em HTTPS (ou localhost).', 'error');
                 setTimeout(() => setShowManualInstallModal(true), 0);
                 return;
               }
               if ('serviceWorker' in navigator) {
                 try {
                   let swUrl = 'api.php?action=service_worker';
                   let scopeUrl = './';
                   try {
                     const u = new URL('api.php', window.location.href);
                     u.searchParams.set('action', 'service_worker');
                     swUrl = u.href;
                     scopeUrl = new URL('./', window.location.href).href;
                   } catch (e2) { /* noop */ }
                   const reg = await navigator.serviceWorker.getRegistration();
                   if (reg) {
                     await reg.update();
                   } else {
                     await navigator.serviceWorker.register(swUrl, { scope: scopeUrl });
                   }
                   await navigator.serviceWorker.ready;
                 } catch (e) { /* noop */ }
               }
               const ev = deferredPromptRef.current || window.__rcInstallPrompt || deferredPrompt;
               if (ev && typeof ev.prompt === 'function') {
                 try {
                   await ev.prompt();
                   const choice = await ev.userChoice;
                   try { window.__rcInstallPrompt = null; } catch (e2) {}
                   deferredPromptRef.current = null;
                   setDeferredPrompt(null);
                   if (choice && choice.outcome === 'accepted') {
                     setShowInstallBanner(false);
                   }
                   if (choice && choice.outcome !== 'accepted') {
                     showToast('Instalação cancelada. Use o menu ⋮ → Instalar aplicativo.', 'info');
                   }
                 } catch (err) {
                   try { window.__rcInstallPrompt = null; } catch (e2) {}
                   deferredPromptRef.current = null;
                   setDeferredPrompt(null);
                   showToast('Abrindo instruções para instalar pelo navegador…', 'info');
                   setTimeout(() => setShowManualInstallModal(true), 0);
                 }
                 return;
               }
               const isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent)
                 || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
               if (isIOS) {
                 showToast('No iPhone/iPad: Compartilhar → Adicionar à Tela de Início.', 'info');
                 setTimeout(() => setShowInstallHelpModal(true), 0);
                 return;
               }
               showToast('Abra o guia de instalação na próxima janela.', 'info');
               setTimeout(() => setShowManualInstallModal(true), 0);
             } catch (err) {
               console.error('handleInstallApp', err);
               showToast('Use o menu do navegador (⋮) → Instalar aplicativo.', 'error');
               setTimeout(() => setShowManualInstallModal(true), 0);
             }
           };

           // Persistência em LocalStorage (Apenas Sessão)
           useEffect(() => { window.localStorage.setItem('clinic_auth', isAuthenticated); }, [isAuthenticated]);
           useEffect(() => { window.localStorage.setItem('clinic_current_user', JSON.stringify(currentUser)); }, [currentUser]);

           // Inicialização da API
           useEffect(() => {
             const init = async () => {
               try {
                 const data = await apiFetch('get_data');
                 if (data && !data.error) {
                   setUsersList(data.users || []);
                   setCurrentUser((prev) => {
                     if (!prev?.id || !(data.users && data.users.length)) return prev;
                     const fresh = data.users.find((u) => String(u.id) === String(prev.id));
                     return fresh ? { ...fresh } : prev;
                   });
                   setPatients(data.patients || []);
                   if (data.settings) {
                      setSystemSettings(data.settings.api || { tokenCpf: '', tokenCep: '' });
                      setCompanyData(data.settings.company || {
                        razaoSocial: '', nomeFantasia: '', cnpj: '', inscricaoEstadual: '', telefone: '', email: '', endereco: '', regimeTributario: ''
                      });
                      setSmtpSettings(data.settings.smtp || { server: '', port: '', user: '', password: '' });
                      if (data.settings.theme) setTheme(data.settings.theme);
                   }
                   if (data.states) {
                     if (Array.isArray(data.states.agenda)) {
                       setAgendaEvents(data.states.agenda);
                     }
                     if (Array.isArray(data.states.pacotes)) {
                       setPackages(data.states.pacotes);
                     }
                     if (Array.isArray(data.states.presence_records)) {
                       setPresenceRecords(data.states.presence_records);
                     }
                     if (Array.isArray(data.states.financeiro)) {
                       // Liberar guard para não haver problemas nos hooks
                       _rcDbSaveGuard.loaded = true;
                       
                       const finalFin = data.states.financeiro;
                       const today = new Date();
                       const mesAtual = today.toISOString().split('T')[0].slice(0, 7);
                       const templates = finalFin.filter(e => e.recorrente);
                       let gerados = [...finalFin];
                       let changed = false;
                       templates.forEach(tpl => {
                         const tplMes = (tpl.data || '').slice(0, 7);
                         const dia = (tpl.data || '').slice(8, 10) || '01';
                         if (tplMes < mesAtual) {
                           const recId = 'rec_' + tpl.id + '_' + mesAtual;
                           const jaExiste = gerados.some(e => String(e.id) === String(recId));
                           if (!jaExiste) {
                             gerados.push({
                               ...tpl,
                               id: recId,
                               data: mesAtual + '-' + dia,
                               status: 'pendente',
                               recorrente: false,
                               origemRecorrente: tpl.id,
                             });
                             changed = true;
                           }
                         }
                       });
                       setFinEntries(gerados);
                       if (changed) rcFinanceiroSave(gerados);
                     }
                   }

                  setIsConnected(true);
                  showToast("Banco de dados sincronizado!");
                } else {
                  setIsConnected(false);
                  showToast("Modo Offline (LocalStorage)", "info");
                }
              } catch (err) {
                setIsConnected(false);
              } finally {
                setIsApiReady(true);
                // Oculta o splash screen com um pequeno delay para suavidade
                setTimeout(() => {
                  const splash = document.getElementById('splash-screen');
                  if (splash) splash.classList.add('hidden');
                }, 800);
              }
            };
            init(); setTimeout(() => { const splash = document.getElementById('splash-screen'); if (splash) splash.classList.add('hidden'); }, 5000);
          }, []);

          // Recarregar configurações ao abrir abas administrativas (Fonte da Verdade)
          useEffect(() => {
            if (activeTab === 'settings') {
              const refresh = async () => {
                const data = await apiFetch('get_data');
                if (data && data.settings) {
                   if (data.settings.api) setSystemSettings(data.settings.api);
                   if (data.settings.company) setCompanyData(data.settings.company);
                   if (data.settings.smtp) setSmtpSettings(data.settings.smtp);
                   if (data.settings.theme) setTheme(data.settings.theme);
                }
                if (data?.users) {
                  setUsersList(data.users);
                  setCurrentUser((prev) => {
                    if (!prev?.id) return prev;
                    const fresh = data.users.find((u) => String(u.id) === String(prev.id));
                    return fresh ? { ...fresh } : prev;
                  });
                }
              };
              refresh();
            }
          }, [activeTab]);

          // --- FUNíǁƒá€šÂ¡íǁƒá€šÂ¢ES AUXILIARES ---
          const apiFetch = async (action, body = null) => {
            try {
              const options = body ? { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json' } } : {};
              const res = await fetch(`api.php?action=${action}`, options);
              return await res.json();
            } catch (e) {
              return null;
            }
          };

          useEffect(() => {
            if (activeTab !== 'new_patient' || !isApiReady) return;
            let cancelled = false;
            (async () => {
              try {
                const data = await apiFetch('get_data');
                if (!cancelled && data?.users) {
                  setUsersList(data.users);
                  setCurrentUser((prev) => {
                    if (!prev?.id) return prev;
                    const fresh = data.users.find((u) => String(u.id) === String(prev.id));
                    return fresh ? { ...fresh } : prev;
                  });
                }
              } catch (_) {}
            })();
            return () => { cancelled = true; };
          }, [activeTab, isApiReady]);

          const syncThemeIconToPwaFile = async (th) => {
            if (!th) return;
            const iconData = th.appIconUrl || th.logoUrl;
            if (iconData && String(iconData).startsWith('data:')) {
              const wr = await apiFetch('write_pwa_icon', { dataUrl: iconData });
              if (wr && wr.success && wr.v) {
                try {
                  window.localStorage.setItem('rc_pwa_icon_ver', String(wr.v));
                } catch (e) {}
              }
              return;
            }
            if (!th.appIconUrl && !th.logoUrl) {
              await apiFetch('write_pwa_icon', { clear: true });
              try {
                window.localStorage.removeItem('rc_pwa_icon_ver');
              } catch (e) {}
            }
          };

          /** Primeira carga: gera PNG no servidor para o iOS/Android aceitarem o ícone (data: costuma virar "R"). */
          useEffect(() => {
            if (!isApiReady || !isConnected) return;
            const iconData = theme.appIconUrl || theme.logoUrl;
            if (!iconData || !String(iconData).startsWith('data:')) return;
            try {
              if (window.localStorage.getItem('rc_pwa_icon_ver')) return;
            } catch (e) {
              return;
            }
            if (pwaIconWriteLock.current) return;
            pwaIconWriteLock.current = true;
            let cancelled = false;
            (async () => {
              try {
                const wr = await apiFetch('write_pwa_icon', { dataUrl: iconData });
                if (cancelled || !wr || !wr.success || !wr.v) return;
                try {
                  window.localStorage.setItem('rc_pwa_icon_ver', String(wr.v));
                } catch (e) {}
                setPwaIconFileRev((x) => x + 1);
              } finally {
                if (!cancelled) pwaIconWriteLock.current = false;
              }
            })();
            return () => {
              cancelled = true;
            };
          }, [isApiReady, isConnected, theme.appIconUrl, theme.logoUrl]);

          const themeMap = {
            emerald: { sidebar: 'bg-emerald-900', sidebarBorder: 'border-emerald-800', sidebarActive: 'bg-emerald-800 border-emerald-400', icon: 'text-emerald-400', btn: 'bg-emerald-600 hover:bg-emerald-700', text: 'text-emerald-800', activeTab: 'border-emerald-600 text-emerald-700', installCta: 'bg-emerald-800 hover:bg-emerald-700 border-emerald-500/35', installCtaIcon: 'bg-emerald-700', installCtaSub: 'text-emerald-100', installCtaCaret: 'text-emerald-200', modalAccent: 'text-emerald-600' },
            blue: { sidebar: 'bg-blue-900', sidebarBorder: 'border-blue-800', sidebarActive: 'bg-blue-800 border-blue-400', icon: 'text-blue-400', btn: 'bg-blue-600 hover:bg-blue-700', text: 'text-blue-800', activeTab: 'border-blue-600 text-blue-700', installCta: 'bg-blue-800 hover:bg-blue-700 border-blue-500/35', installCtaIcon: 'bg-blue-700', installCtaSub: 'text-blue-100', installCtaCaret: 'text-blue-200', modalAccent: 'text-blue-600' },
            indigo: { sidebar: 'bg-indigo-900', sidebarBorder: 'border-indigo-800', sidebarActive: 'bg-indigo-800 border-indigo-400', icon: 'text-indigo-400', btn: 'bg-indigo-600 hover:bg-indigo-700', text: 'text-indigo-800', activeTab: 'border-indigo-600 text-indigo-700', installCta: 'bg-indigo-800 hover:bg-indigo-700 border-indigo-500/35', installCtaIcon: 'bg-indigo-700', installCtaSub: 'text-indigo-100', installCtaCaret: 'text-indigo-200', modalAccent: 'text-indigo-600' },
            rose: { sidebar: 'bg-rose-900', sidebarBorder: 'border-rose-800', sidebarActive: 'bg-rose-800 border-rose-400', icon: 'text-rose-400', btn: 'bg-rose-600 hover:bg-rose-700', text: 'text-rose-800', activeTab: 'border-rose-600 text-rose-700', installCta: 'bg-rose-800 hover:bg-rose-700 border-rose-500/35', installCtaIcon: 'bg-rose-700', installCtaSub: 'text-rose-100', installCtaCaret: 'text-rose-200', modalAccent: 'text-rose-600' }
          };
          const t = themeMap[theme?.color] || themeMap.emerald;

          const handleSignatureConfirm = (data) => {
              if (data.role === 'Fisioterapeuta') {
                  setFisioEvol(prev => ({ ...prev, assinaturaFisio: data.signature, fotoFisio: data.photo }));
                  showToast('Assinatura do Fisioterapeuta coletada com sucesso!');
              } else if (data.role === 'Paciente') {
                  setFisioEvol(prev => ({ ...prev, assinaturaPaciente: data.signature, fotoPaciente: data.photo }));
                  showToast('Assinatura do Paciente coletada com sucesso!');
              } else if (data.role === 'FisioPilates') {
                  setPilatesEval(prev => ({ ...prev, assinaturaFisio: data.signature, fotoFisio: data.photo }));
                  showToast('Assinatura do Profissional coletada com sucesso!');
              } else if (data.role === 'OsteoFisio') {
                  setOsteopatiaEvol(prev => ({ ...prev, assinaturaFisio: data.signature, fotoFisio: data.photo }));
                  showToast('Assinatura do Osteopata coletada com sucesso!');
              } else if (data.role === 'OsteoPaciente') {
                  setOsteopatiaEvol(prev => ({ ...prev, assinaturaPaciente: data.signature, fotoPaciente: data.photo }));
                  showToast('Assinatura do Paciente coletada com sucesso!');
              } else if (data.callback) {
                  data.callback(data.signature, data.photo);
              }
          };

          const handleUpdateFisioEvolTable = (evolId, field, value) => {
            setViewingFisioEvolTable(prev => ({
              ...prev,
              evolucoes: prev.evolucoes.map(ev => ev.id === evolId ? { ...ev, [field]: value } : ev)
            }));
          };

          const handleAddFisioEvolRow = () => {
            const newRow = { 
              id: Date.now(), 
              data: new Date().toLocaleDateString('pt-BR'), 
              evolucao: '', 
              assinaturaFisio: null, 
              assinaturaPaciente: null 
            };
            setViewingFisioEvolTable(prev => ({
              ...prev,
              evolucoes: [...(prev.evolucoes || []), newRow]
            }));
          };





          const filteredPatients = patients.filter(patient => {
            // Blindagem central: fisio restrito só vê os seus pacientes
            if (!patientVisivel(patient)) return false;

            const term = searchTerm.toLowerCase();
            const matchesSearch = patient.nome.toLowerCase().includes(term) || patient.cpf.includes(term);
            if (!matchesSearch) return false;

            // Dono com toggle "Meus Pacientes"
            if (currentUser?.ver_todos && patientListView === 'mine') {
              return patient.fisio1_id == currentUser.id || patient.fisio2_id == currentUser.id;
            }

            return true;
          });


          const handleBuscarCEP = async () => {
            const cepApenasNumeros = newPatient.cep.replace(/\D/g, '');
            if (cepApenasNumeros.length !== 8) {
              alert("Por favor, digite um CEP válido com 8 dígitos.");
              return;
            }
            setIsLoadingCep(true);
            try {
              const response = await fetch(`https://viacep.com.br/ws/${cepApenasNumeros}/json/`);
              const data = await response.json();
              if (data.erro) {
                showToast("CEP Não encontrado.", "error");
              } else {
                setNewPatient({
                  ...newPatient,
                  endereco: data.endereco || data.logradouro || '', 
                  bairro: data.bairro || '',
                  cidade: data.cidade || data.localidade || '',
                  uf: data.uf || '' 
                });
              }
            } catch (error) {
              console.error("Erro ao buscar CEP:", error);
              showToast("Erro de conexão ao buscar o CEP.", "error");
            } finally {
              setIsLoadingCep(false);
            }
          };

          const handleBuscarCPF = async () => {
            const cpfApenasNumeros = newPatient.cpf.replace(/\D/g, '');
            if (cpfApenasNumeros.length !== 11) {
              showToast("Por favor, digite um CPF válido com 11 dígitos.", "info");
              return;
            }
            const localPac = patients.find((p) => String(p.cpf || "").replace(/\D/g, "") === cpfApenasNumeros);

            if (!validarDigitosCPF(cpfApenasNumeros)) {
              showToast(
                "CPF com dígitos verificadores inválidos — confira o número. A API não será consultada (evita demora).",
                "info"
              );
              if (localPac) {
                const form = patientRecordToNewPatientForm(localPac);
                setNewPatient((prev) => ({
                  ...prev,
                  nome: form.nome || prev.nome,
                  rg: form.rg || prev.rg,
                  dataNascimento: form.dataNascimento || prev.dataNascimento,
                  idade: form.idade || prev.idade,
                  sexo: form.sexo || prev.sexo,
                  estadoCivil: form.estadoCivil || prev.estadoCivil,
                  telefone: form.telefone || prev.telefone,
                  telefone2: form.telefone2 || prev.telefone2,
                  cep: form.cep || prev.cep,
                  endereco: form.endereco || prev.endereco,
                  numero: form.numero || prev.numero,
                  bairro: form.bairro || prev.bairro,
                  cidade: form.cidade || prev.cidade,
                  uf: form.uf || prev.uf,
                  cpf: prev.cpf,
                }));
                showToast("Dados carregados do cadastro local.", "info");
              }
              return;
            }

            const token = (systemSettings.tokenCpf || "").trim();
            if (!token) {
              showToast("Insira seu Token primeiro nas configurações.", "info");
              return;
            }
            if (localPac) {
              const form = patientRecordToNewPatientForm(localPac);
              setNewPatient((prev) => ({
                ...prev,
                nome: form.nome || prev.nome,
                rg: form.rg || prev.rg,
                dataNascimento: form.dataNascimento || prev.dataNascimento,
                idade: form.idade || prev.idade,
                sexo: form.sexo || prev.sexo,
                estadoCivil: form.estadoCivil || prev.estadoCivil,
                telefone: form.telefone || prev.telefone,
                telefone2: form.telefone2 || prev.telefone2,
                cep: form.cep || prev.cep,
                endereco: form.endereco || prev.endereco,
                numero: form.numero || prev.numero,
                bairro: form.bairro || prev.bairro,
                cidade: form.cidade || prev.cidade,
                uf: form.uf || prev.uf,
                cpf: prev.cpf,
              }));
              showToast("Dados do cadastro local carregados. Consultando API…", "info");
            }

            const hubRespostaOk = (data) =>
              data &&
              data.status &&
              (data.return === "OK" || data.return === true || String(data.return).toUpperCase() === "OK");

            const extrairResultObj = (data) => {
              let res = data?.result;
              if (typeof res === "string") {
                try {
                  res = JSON.parse(res);
                } catch {
                  return null;
                }
              }
              return res && typeof res === "object" ? res : null;
            };

            const parseDataNascHub = (resObj) => {
              const rawTrim = String(
                resObj.data_de_nascimento ||
                  resObj.nascimento ||
                  resObj.data_nascimento ||
                  resObj.Nascimento ||
                  ""
              ).trim();
              let dataFormatada = "";
              let idadeCalculada = "";
              if (!rawTrim) return { dataFormatada, idadeCalculada };
              if (rawTrim.includes("/")) {
                const partesData = rawTrim.split("/").map((x) => String(x).replace(/\D.*/, "").trim());
                if (partesData.length === 3) {
                  const [dd, mm, yy] = partesData;
                  dataFormatada = `${yy}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
                  const dataNasc = new Date(parseInt(yy, 10), parseInt(mm, 10) - 1, parseInt(dd, 10));
                  const hoje = new Date();
                  let idade = hoje.getFullYear() - dataNasc.getFullYear();
                  const m = hoje.getMonth() - dataNasc.getMonth();
                  if (m < 0 || (m === 0 && hoje.getDate() < dataNasc.getDate())) idade--;
                  idadeCalculada = idade >= 0 && idade < 130 ? String(idade) : "";
                }
              } else if (/^\d{4}-\d{2}-\d{2}/.test(rawTrim)) {
                dataFormatada = rawTrim.slice(0, 10);
                idadeCalculada = idadeApartirDeISO(dataFormatada);
              }
              return { dataFormatada, idadeCalculada };
            };

            const aplicarResultadoHub = (resObj) => {
              let nomeImportado =
                resObj.nome ||
                resObj.nome_da_pessoa ||
                resObj.nome_completo ||
                resObj.Nome ||
                resObj.nome_socio ||
                "";
              if (!nomeImportado) {
                const fuzzyKey = Object.keys(resObj).find(
                  (k) =>
                    k.toLowerCase().includes("nome") &&
                    typeof resObj[k] === "string" &&
                    resObj[k].length > 3
                );
                if (fuzzyKey) nomeImportado = resObj[fuzzyKey];
              }
              const { dataFormatada, idadeCalculada } = parseDataNascHub(resObj);
              setNewPatient((prev) => ({
                ...prev,
                nome: nomeImportado || prev.nome,
                dataNascimento: dataFormatada || prev.dataNascimento,
                idade: idadeCalculada || prev.idade,
              }));
              return !!nomeImportado;
            };

            setIsLoadingCpf(true);
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 15000);

            try {
              const response = await fetch('https://gateway.apibrasil.io/api/v2/consulta/cpf/credits', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                  tipo: 'cpf-lite',
                  cpf: cpfApenasNumeros,
                  homolog: false
                }),
                signal: controller.signal
              });

              if (!response.ok) {
                throw new Error(`Erro na integração (HTTP Status ${response.status})`);
              }

              const result = await response.json();
              
              if (result.error) {
                throw new Error(result.message || 'Erro reportado pela API Brasil');
              }

              const resObj = result.data || result;

              const importouNome = aplicarResultadoHub(resObj);
              if (importouNome) {
                showToast("Dados do CPF importados pela API Brasil.");
              } else {
                showToast(
                  localPac
                    ? "API não trouxe o nome — mantenha os dados do cadastro local ou complete manualmente."
                    : "API respondeu sem nome — preencha manualmente ou confira o token.",
                  "info"
                );
              }
            } catch (error) {
              console.error("Erro ao buscar CPF:", error);
              if (error.name === 'AbortError') {
                showToast(
                  localPac
                    ? "API demorou — use os dados já carregados ou tente de novo."
                    : "Consulta passou de 15s. Tente de novo ou preencha manualmente.",
                  "error"
                );
              } else {
                showToast(
                  localPac
                    ? "API falhou - usando dados locais."
                    : `Falha na consulta: ${error.message || "CPF não encontrado."}`,
                  "error"
                );
              }
            } finally {
              clearTimeout(timeoutId);
              setIsLoadingCpf(false);
            }
          };

          const handleBuscarCNPJ = async () => {
            const cnpjApenasNumeros = companyData.cnpj.replace(/\D/g, '');
            if (cnpjApenasNumeros.length !== 14) {
              alert("Por favor, digite um CNPJ válido com 14 dígitos.");
              return;
            }
            const token = (systemSettings.tokenCpf || "").trim();
            if (!token) {
              alert("Por favor, vá na aba de 'Sistema e APIs' e insira seu Token da APIBrasil primeiro.");
              return;
            }
            setIsLoadingCnpj(true);
            try {
              const response = await fetch(`https://ws.hubdodesenvolvedor.com.br/v2/cnpj/?cnpj=${cnpjApenasNumeros}&token=${token}`);
              const data = await response.json();
              if (data.status && data.return === "OK") {
                setCompanyData({
                  ...companyData,
                  razaoSocial: data.result.nome || data.result.nome_empresarial || '',
                  nomeFantasia: data.result.fantasia || data.result.nome || data.result.nome_empresarial || '',
                  endereco: data.result.logradouro ? `${data.result.logradouro}, ${data.result.numero} - ${data.result.bairro}, ${data.result.municipio} - ${data.result.uf}` : '',
                  telefone: data.result.telefone || '',
                  email: data.result.email || '',
                  regimeTributario: data.result.situacao_simples_nacional || ''
                });
              } else {
                const fallback = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${cnpjApenasNumeros}`);
                const fbData = await fallback.json();
                if (fbData.razao_social) {
                  setCompanyData({
                    ...companyData,
                    razaoSocial: fbData.razao_social || '',
                    nomeFantasia: fbData.nome_fantasia || fbData.razao_social || '',
                    endereco: `${fbData.logradouro}, ${fbData.numero} - ${fbData.bairro}, ${fbData.municipio} - ${fbData.uf}`,
                    telefone: fbData.ddd_telefone_1 || '',
                    email: fbData.email || '',
                    regimeTributario: fbData.opcao_pelo_simples ? 'Optante pelo Simples Nacional' : 'Não optante pelo Simples Nacional'
                  });
                } else {
                  alert(`Falha na consulta: ${data.message || 'CNPJ Não encontrado.'}`);
                }
              }
            } catch (error) {
              console.error("Erro ao buscar CNPJ:", error);
              alert("Erro ao conectar com a API. Verifique a conexão.");
            } finally {
              setIsLoadingCnpj(false);
            }
          };

          const handleImageUpload = (e, type) => {
            const file = e.target.files[0];
            if (file) {
              const reader = new FileReader();
              reader.onloadend = () => {
                if (type === 'logo') setTheme({...theme, logoUrl: reader.result});
                if (type === 'bg') setTheme({...theme, backgroundUrl: reader.result});
                if (type === 'appIcon') setTheme({...theme, appIconUrl: reader.result});
                if (type === 'pixQr') setSystemSettings(prev => ({...prev, pixQrCode: reader.result}));
              };
              reader.readAsDataURL(file);
            }
          };

          const handleLogin = (e) => {
            e.preventDefault();

            if (loginData.email.toLowerCase() === 'gauthioramon3003@gmail.com' && 
                (loginData.password === 'gr300397@' || loginData.password === 'Gr300397@')) {
              setCurrentUser({
                id: 0,
                nome: 'Gauthio Ramon',
                email: 'gauthioramon3003@gmail.com',
                nivel: 'Super Administrador'
              });
              setIsAuthenticated(true);
              setLoginData({ email: '', password: '' });
              return;
            }

            const user = usersList.find(u => u.email === loginData.email && u.senha === loginData.password);
            if (user) {
              setCurrentUser(user);
              setIsAuthenticated(true);
              setLoginData({ email: '', password: '' }); 
            } else {
              showToast("E-mail ou senha incorretos!", "error");
            }
          };

          const handleLogout = () => {
             setIsAuthenticated(false);
             setCurrentUser(null);
             window.localStorage.clear(); // Limpeza total para segurança
             showToast('Sessão encerrada.', 'info');
           };

                     const handlePrintTermoImagem = (patient) => {
               const printWindow = window.open('', '_blank');
               const logoBase64 = theme.logoUrl || defaultLogoPath;
               const term = patient.termoImagem;
               if (!term) return alert("Termo não assinado!");

               const html = `
                 <html>
                   <head>
                     <meta charset="UTF-8" />
                     <title>Termo de Imagem - ${patient.nome}</title>
                     <style>
                       @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;800&display=swap');
                       body { font-family: 'Inter', sans-serif; padding: 60px; color: #1e293b; line-height: 1.6; }
                       .header { text-align: center; margin-bottom: 50px; border-bottom: 1px solid #eee; padding-bottom: 20px; }
                       .logo { height: 90px; margin-bottom: 15px; }
                       .title { font-size: 22px; font-weight: 800; text-transform: uppercase; color: #000; margin-top: 10px; }
                       .content { text-align: justify; margin: 40px 0; font-size: 15px; }
                       .content p { margin-bottom: 20px; }
                       .footer { margin-top: 80px; text-align: center; }
                       .signatures { display: flex; justify-content: space-around; align-items: flex-end; margin-top: 60px; gap: 40px; }
                       .sig-box { text-align: center; flex: 1; }
                       .sig-img { height: 100px; width: 100%; object-fit: contain; border-bottom: 1.5px solid #000; margin-bottom: 10px; }
                       .photo-container { width: 150px; height: 150px; border-radius: 15px; overflow: hidden; border: 3px solid #f1f5f9; box-shadow: 0 4px 10px rgba(0,0,0,0.1); margin: 0 auto 10px auto; }
                       .photo-img { width: 100%; height: 100%; object-fit: cover; }
                       .sig-label { font-weight: 800; font-size: 12px; text-transform: uppercase; color: #64748b; }
                     </style>
                   </head>
                   <body>
                     <div class="header">
                       <img src="${logoBase64}" class="logo" />
                       <div class="title">Consentimento de Liberação de Imagem</div>
                     </div>
                     <div class="content">
                       <p>Eu, <b>${patient.nome}</b>, autorizo a <b>Real Clínica Integrada - Unidade de Saúde</b>, a utilizar a minha imagem (ou a imagem de meu dependente menor de idade), capturada durante meu tratamento/procedimento, nas redes sociais e outros canais de comunicação da instituição, para fins de divulgação e informação.</p>
                       <p>Entendo que minha imagem pode ser utilizada para:</p>
                       <ul>
                         <li>Compartilhar resultados de tratamentos</li>
                         <li>Promover a instituição e seus serviços</li>
                         <li>Informar sobre condições de saúde e tratamentos</li>
                       </ul>
                       <p>Autorizo a utilização da minha imagem sem qualquer Ç´nus ou reivindicação de direitos.</p>
                     </div>
                     
                     <div class="footer">
                       <p style="font-weight: bold; font-size: 16px;">Arapiraca/AL, ${term.data}</p>
                       
                       <div class="signatures">
                         <div class="sig-box">
                           <img src="${term.assinatura}" class="sig-img" />
                           <div class="sig-label">Assinatura do Paciente / Responsável</div>
                         </div>
                         ${term.foto ? `
                           <div class="sig-box">
                             <div class="photo-container">
                               <img src="${term.foto}" class="photo-img" />
                             </div>
                             <div class="sig-label">Foto de Identificação</div>
                           </div>
                         ` : ''}
                       </div>
                     </div>
                     <script>window.onload = () => { window.print(); setTimeout(() => window.close(), 1000); };<\/script>
                   </body>
                 </html>
               `;
               printWindow.document.write(html);
               printWindow.document.close();
           };

           const handlePrintTermoComparecimento = (patient) => {
               const printWindow = window.open('', '_blank');
               const logoBase64 = theme.logoUrl || defaultLogoPath;
               const term = patient.termoComparecimento;
               if (!term) return alert("Termo não assinado!");

               const html = `
                 <html>
                   <head>
                     <meta charset="UTF-8" />
                     <title>Termo de Comparecimento - ${patient.nome}</title>
                     <style>
                       @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;800&display=swap');
                       body { font-family: 'Inter', sans-serif; padding: 60px; color: #1e293b; line-height: 1.6; }
                       .header { text-align: center; margin-bottom: 50px; border-bottom: 1px solid #eee; padding-bottom: 20px; }
                       .logo { height: 90px; margin-bottom: 15px; }
                       .title { font-size: 22px; font-weight: 800; text-transform: uppercase; color: #000; margin-top: 10px; }
                       .content { text-align: justify; margin: 40px 0; font-size: 14px; }
                       .content p { margin-bottom: 18px; }
                       .footer { margin-top: 60px; text-align: center; }
                       .signatures { display: flex; justify-content: space-around; align-items: flex-end; margin-top: 60px; gap: 40px; }
                       .sig-box { text-align: center; flex: 1; }
                       .sig-img { height: 100px; width: 100%; object-fit: contain; border-bottom: 1.5px solid #000; margin-bottom: 10px; }
                       .photo-container { width: 150px; height: 150px; border-radius: 15px; overflow: hidden; border: 3px solid #f1f5f9; box-shadow: 0 4px 10px rgba(0,0,0,0.1); margin: 0 auto 10px auto; }
                       .photo-img { width: 100%; height: 100%; object-fit: cover; }
                       .sig-label { font-weight: 800; font-size: 12px; text-transform: uppercase; color: #64748b; }
                     </style>
                   </head>
                   <body>
                     <div class="header">
                       <img src="${logoBase64}" class="logo" />
                       <div class="title">Termo de Comparecimento e Cancelamento</div>
                     </div>
                     <div class="content">
                       <p>Eu, <b>${patient.nome}</b>, Estado civil <b>${patient.estadoCivil || '__________'}</b>, inscrito no CPF sob o nº <b>${patient.cpf}</b>, residente e domiciliado na rua: <b>${patient.endereco || '__________'}</b>, Nº <b>${patient.numero || '___'}</b>. Bairro: <b>${patient.bairro || '__________'}</b>, Cidade: <b>${patient.cidade || 'Arapiraca/AL'}</b>.</p>
                       
                       <p>O atendimento é um horário reservado exclusivamente para você. Para garantir organização e respeito à agenda, seguem as orientações:</p>
                       
                       <p>Me comprometo a <b>Real Clínica Integrada - Unidade de Saúde</b>, a comunicar minha remarcação ou o cancelamento do meu atendimento com 24 horas de antecedência, caso o aviso não seja dado dentro desse prazo, a sessão será considerada realizada e o valor cobrado normalmente.</p>
                       
                       <p>Em casos de doença ou imprevistos justificáveis, a sessão poderá ser remarcada sem prejuízo, mediante comunicação o quanto antes.</p>
                       
                       <p>O não comparecimento sem aviso prÇ©vio será considerado como falta, sem reposição.</p>
                       
                       <p>Agradecemos pela compreensão e colaboração.</p>
                     </div>
                     
                     <div class="footer">
                       <p style="font-weight: bold; font-size: 16px;">Arapiraca/AL, ${term.data}</p>
                       
                       <div class="signatures">
                         <div class="sig-box">
                           <img src="${term.assinatura}" class="sig-img" />
                           <div class="sig-label">Assinatura do Paciente / Responsável</div>
                         </div>
                         ${term.foto ? `
                           <div class="sig-box">
                             <div class="photo-container">
                               <img src="${term.foto}" class="photo-img" />
                             </div>
                             <div class="sig-label">Foto de Identificação</div>
                           </div>
                         ` : ''}
                       </div>
                     </div>
                     <script>window.onload = () => { window.print(); setTimeout(() => window.close(), 1000); };<\/script>
                   </body>
                 </html>
               `;
               printWindow.document.write(html);
               printWindow.document.close();
           };

           const handlePrintFisioCompleto = (evalData, patient = selectedPatient) => {
              const printBgUrl = theme.backgroundUrl || theme.logoUrl || defaultLogoPath;
              const bgImage = printBgUrl ? `url(${printBgUrl})` : 'none';
              const printWindow = window.open('', '_blank');
              
              const logoBase64 = theme.logoUrl || defaultLogoPath;
              const primaryColor = '#8bc3cf'; // Light blue from image
              const darkText = '#1e293b';
              const printDn = formatDnForDisplay(patient);
              const printEstadoCivil = patient?.estadoCivil || patient?.estado_civil || '';

              const evolRows = (evalData.evolucoes || []).length > 0 
                ? evalData.evolucoes.map(ev => `
                    <tr>
                      <td class="col-data">${ev.data}</td>
                      <td class="col-evolucao">${ev.evolucao}</td>
                      <td class="col-ass">${ev.assinaturaFisio ? `<img src="${ev.assinaturaFisio}" class="table-sig" />` : ''}</td>
                      <td class="col-ass">${ev.assinaturaPaciente ? `<img src="${ev.assinaturaPaciente}" class="table-sig" />` : ''}</td>
                    </tr>
                  `).join('')
                : Array(25).fill('<tr><td class="col-data">/ /</td><td class="col-evolucao"></td><td class="col-ass"></td><td class="col-ass"></td></tr>').join('');

              const html = `
                <html>
                  <head>
                    <meta charset="UTF-8" />
                    <title>Prontuário - ${patient?.nome}</title>
                    <style>
                      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;800&display=swap');
                      body { font-family: 'Inter', sans-serif; margin: 0; padding: 0; color: ${darkText}; background: #fff; position: relative; }
                      .bg { position: fixed; inset: 0; background-image: ${bgImage}; background-repeat: no-repeat; background-size: cover; background-position: center; z-index: 0; opacity: 0.08; pointer-events: none; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                      .page, .print-header, .content, .print-footer { position: relative; z-index: 1; }
                      
                      .page { width: 210mm; min-height: 297mm; padding: 0; margin: 0; page-break-after: always; overflow: visible; display: flex; flex-direction: column; }
                      .print-header { flex-shrink: 0; display: flex; flex-direction: column; align-items: center; gap: 6px; padding: 12px 40px 8px; box-sizing: border-box; }
                      .header-bar { height: 36px; width: 100%; max-width: 100%; background: #e0f2f1; display: flex; align-items: center; justify-content: flex-end; padding-right: 24px; font-size: 10px; color: #5c8a95; box-sizing: border-box; }
                      .header-bar i { margin-right: 5px; }

                      .logo-container { position: static; width: auto; max-width: 200px; transform: none; z-index: 1; }
                      .logo-img { display: block; max-width: 200px; max-height: 52px; width: auto; height: auto; object-fit: contain; }

                      .content { padding: 12px 40px 100px 40px; flex-grow: 1; display: flex; flex-direction: column; }
                      .doc-title { text-align: left; font-size: 14px; font-weight: 800; text-transform: uppercase; margin-bottom: 5px; margin-top: 10px; border-bottom: 2px solid #333; }
                      
                      table.patient-info { width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 11px; }
                      table.patient-info td { border: 1.5px solid #333; padding: 4px 10px; vertical-align: middle; }
                      .label-cell { color: #000; font-weight: 700; width: 1%; white-space: nowrap; }
                      .value-cell { color: #000; }

                      .clinical-section { margin-bottom: 15px; }
                      .section-title { font-weight: 800; font-size: 13px; margin: 10px 0 5px 0; }
                      .text-box { border: 1.5px solid #333; min-height: 40px; padding: 8px 12px; font-size: 11px; margin-bottom: 10px; display: block; width: 100%; box-sizing: border-box; }
                      .line-box { border-bottom: 1.5px solid #333; height: 26px; width: 100%; margin-bottom: 0px; }

                      .evol-table { width: 100%; border-collapse: collapse; }
                      .evol-table th, .evol-table td { border: 1.5px solid #333; padding: 4px; font-size: 11px; }
                      .evol-table th { background: #fff; font-weight: 800; text-align: center; }
                      .col-data { width: 80px; text-align: center; }
                      .col-evolucao { width: auto; }
                      .col-ass { width: 130px; text-align: center; }
                      .table-sig { max-height: 25px; max-width: 120px; }

                      .print-footer { height: 90px; background: #e0f2f1; display: flex; align-items: center; justify-content: center; gap: 40px; font-size: 11px; color: #5c8a95; position: absolute; bottom: 0; width: 100%; font-weight: bold; }
                      .footer-item { display: flex; items-center: center; gap: 8px; }

                      .no-print { background: #f8fafc; padding: 20px; display: flex; justify-content: center; border-bottom: 1px solid #ddd; }
                      .print-btn { background: #5c8a95; color: white; border: none; padding: 12px 24px; border-radius: 8px; font-weight: 800; cursor: pointer; }

                      @media print {
                        @page { margin: 0; }
                        body { padding: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .bg {
                          -webkit-print-color-adjust: exact !important;
                          print-color-adjust: exact !important;
                          z-index: 0 !important;
                          opacity: 0.12 !important;
                        }
                        .no-print { display: none !important; }
                        .page { height: 296mm; }
                      }
                    </style>
                  </head>
                  <body>
                    <div class="bg"></div>
                    <div class="no-print">
                      <button onclick="window.print()" class="print-btn">CLIQUE PARA IMPRIMIR</button>
                    </div>

                    <!-- PAGINA 1: PRONTUARIO -->
                    <div class="page">
                      <div class="print-header">
                        <div class="logo-container">
                          <img src="${logoBase64}" class="logo-img" />
                        </div>
                        <div class="header-bar">
                           realclinicaintegrada
                        </div>
                      </div>

                      <div class="content">
                        <div class="doc-title">PRONTUÁRIO CLÍNICO DE FISIOTERAPIA</div>
                        
                        <table class="patient-info">
                          <tr>
                            <td colspan="3"><span class="label-cell">Nome:</span> <span class="value-cell">${patient?.nome || ''}</span></td>
                            <td colspan="1"><span class="label-cell">DN:</span> <span class="value-cell">${printDn}</span></td>
                          </tr>
                          <tr>
                            <td><span class="label-cell">Sexo:</span> <span class="value-cell">${patient?.sexo || ''}</span></td>
                            <td><span class="label-cell">Estado civil:</span> <span class="value-cell">${printEstadoCivil}</span></td>
                            <td colspan="2"><span class="label-cell">Profissão:</span> <span class="value-cell">${patient?.profissao || ''}</span></td>
                          </tr>
                          <tr>
                            <td colspan="4"><span class="label-cell">Endereço:</span> <span class="value-cell">${patient?.endereco || ''}, ${patient?.numero || ''}</span></td>
                          </tr>
                          <tr>
                            <td><span class="label-cell">Bairro:</span> <span class="value-cell">${patient?.bairro || ''}</span></td>
                            <td><span class="label-cell">CEP:</span> <span class="value-cell">${patient?.cep || ''}</span></td>
                            <td colspan="2"><span class="label-cell">Cidade:</span> <span class="value-cell">${patient?.cidade || ''}</span></td>
                          </tr>
                          <tr>
                            <td><span class="label-cell">Telefone:</span> <span class="value-cell">${patient?.telefone || ''}</span></td>
                            <td colspan="3"><span class="label-cell">Celular:</span> <span class="value-cell">${patient?.telefone2 || ''}</span></td>
                          </tr>
                          <tr>
                            <td><span class="label-cell">CPF:</span> <span class="value-cell">${patient?.cpf || ''}</span></td>
                            <td><span class="label-cell">RG:</span> <span class="value-cell">${evalData.rg || patient?.rg || ''}</span></td>
                            <td colspan="2"><span class="label-cell">Indicação:</span> <span class="value-cell">${evalData.indicacao || patient?.indicacao || ''}</span></td>
                          </tr>
                          <tr>
                            <td colspan="4"><span class="label-cell">Responsável:</span> <span class="value-cell">${evalData.responsavel || patient?.responsavel || ''}</span></td>
                          </tr>
                        </table>

                        <div class="clinical-section">
                           <div class="section-title">Queixa Principal:</div>
                           <div class="text-box">${evalData.queixaPrincipal || '<br><br>'}</div>

                           <div class="section-title">História da Doença Atual:</div>
                           <div class="text-box">${evalData.hda || '<br><br>'}</div>

                           <div class="section-title">Antecedentes Pessoais e Familiares:</div>
                           <div class="text-box">${evalData.antecedentes || '<br><br>'}</div>

                           <div class="section-title">Hábitos de Vida:</div>
                           <div class="text-box">${evalData.habitosVida || '<br><br>'}</div>

                           <div class="section-title">Exames Complementares:</div>
                           <div class="text-box">${evalData.exames || '<br><br>'}</div>

                           <div class="section-title" style="margin-top: 15px;">Exame Físico</div>
                           
                           <div class="section-title">Inspeção:</div>
                           <div class="text-box">${evalData.inspecao || '<br><br>'}</div>

                           <div class="section-title">Palpação:</div>
                           <div class="text-box">${evalData.palpacao || '<br><br>'}</div>

                           <div class="section-title">Goniometria:</div>
                           <div class="line-box">${evalData.goniometria || ''}</div>

                           <div class="section-title">Grau de força:</div>
                           <div class="line-box">${evalData.grauForca || ''}</div>

                           <div class="section-title">Objetivos do Tratamento:</div>
                           <div class="text-box">${evalData.objetivos || '<br><br>'}</div>

                           <div class="section-title">Conduta Inicial:</div>
                           <div class="text-box">${evalData.conduta || '<br><br>'}</div>
                        </div>
                      </div>

                      <div class="print-footer">
                         <div class="footer-item"><b>+55 82 3530 4187</b></div>
                         <div class="footer-item"><b>Rua Expedicionário Brasileiro<br>1275 - Cavaco - Arapiraca/AL</b></div>
                         <div class="footer-item"><b>+55 82 99927 0115</b></div>
                      </div>
                    </div>

                    <!-- PAGINA 2: EVOLUCAO -->
                    <div class="page">
                      <div class="print-header">
                        <div class="logo-container">
                          <img src="${logoBase64}" class="logo-img" />
                        </div>
                        <div class="header-bar">
                           realclinicaintegrada
                        </div>
                      </div>

                      <div class="content">
                        <div class="doc-title">EVOLUÇÃO E FICHA DE CONTROLE DO TRATAMENTO</div>
                        
                        <table class="evol-table">
                          <thead>
                            <tr>
                              <th>Data</th>
                              <th>Evolução</th>
                              <th>Ass. Fisioterapeuta</th>
                              <th>Ass. Paciente</th>
                            </tr>
                          </thead>
                          <tbody>
                            ${evolRows}
                          </tbody>
                        </table>
                      </div>

                      <div class="print-footer">
                         <div class="footer-item"><b>+55 82 3530 4187</b></div>
                         <div class="footer-item"><b>Rua Expedicionário Brasileiro<br>1275 - Cavaco - Arapiraca/AL</b></div>
                         <div class="footer-item"><b>+55 82 99927 0115</b></div>
                      </div>
                    </div>

                  </body>
                </html>
              `;
              printWindow.document.write(html);
              printWindow.document.close();
          };

          const clearResetTokenFromUrl = () => {
            try {
              const u = new URL(window.location.href);
              u.searchParams.delete('reset_token');
              const path = u.pathname + (u.search || '');
              window.history.replaceState({}, document.title, path);
            } catch (err) { /* noop */ }
            setResetTokenUrl(null);
            setResetNewPass('');
            setResetConfirmPass('');
          };

          const handleForgotPassword = async (e) => {
            e.preventDefault();
            if (!loginData.email) {
              showToast('Por favor, informe seu e-mail.', 'info');
              return;
            }
            if (!isApiReady) {
              showToast('Aguarde a conexão com o servidor.', 'info');
              return;
            }
            setForgotSending(true);
            const res = await apiFetch('request_password_reset', { email: loginData.email.trim() });
            setForgotSending(false);
            if (res && res.success) {
              showToast(res.message || 'Se o e-mail estiver cadastrado, você receberá o link em instantes.');
              setIsForgotPassword(false);
              setLoginData({ email: '', password: '' });
            } else {
              showToast(res && res.error ? res.error : 'Não foi possível enviar. Verifique o SMTP em Configurações.', 'error');
            }
          };

          const handleResetPasswordSubmit = async (e) => {
            e.preventDefault();
            if (!resetTokenUrl) return;
            if (resetNewPass.length < 4) {
              showToast('Use pelo menos 4 caracteres na nova senha.', 'info');
              return;
            }
            if (resetNewPass !== resetConfirmPass) {
              showToast('As senhas não conferem.', 'error');
              return;
            }
            setResetSubmitting(true);
            const res = await apiFetch('reset_password', { token: resetTokenUrl, password: resetNewPass });
            setResetSubmitting(false);
            if (res && res.success) {
              showToast('Senha atualizada! Entre com seu e-mail e a nova senha.');
              clearResetTokenFromUrl();
            } else {
              showToast(res && res.error ? res.error : 'Não foi possível alterar a senha.', 'error');
            }
          };

          const handleSaveUser = async (e) => {
            e.preventDefault();
            if (!isApiReady) {
              showToast('Sistema carregando ou offline. Tente em instantes.', 'info');
              return;
            }
            const { admin, pros } = splitNiveisEditor(editingUser.nivel);
            const nivelFinal = buildNivelFromEditor(admin, pros);
            if (!parseUserNiveis(nivelFinal).length) {
              showToast('Defina ao menos uma função: marque Fisioterapeuta e/ou Instrutor de Pilates ou escolha Recepcionista/Administrador.', 'info');
              return;
            }

            const payload = { ...editingUser, nivel: nivelFinal };
            if (!userTemNivel(currentUser, 'Super Administrador')) {
              delete payload.ver_todos;
            }
            const res = await apiFetch('save_user', payload);
            if (res && res.success) {
              // Recarrega lista para garantir paridade
              const data = await apiFetch('get_data');
              if (data && data.users) {
                setUsersList(data.users);
                setCurrentUser((prev) => {
                  if (!prev?.id) return prev;
                  const fresh = data.users.find((u) => String(u.id) === String(prev.id));
                  return fresh ? { ...fresh } : prev;
                });
              }
              setEditingUser(null);
              showToast('Usuário salvo com sucesso!');
            } else {
              showToast('Erro ao salvar no servidor: ' + (res?.error || 'Erro desconhecido'), 'error');
            }
          };

          const executeDeleteUser = async () => {
            const idToDelete = userToDelete.id;
            const res = await apiFetch(`delete_user&id=${idToDelete}`);
            if (res && res.success) {
              setUsersList(usersList.filter(u => u.id !== idToDelete));
              setUserToDelete(null);
              showToast('Usuário excluído!');
            } else {
              showToast('Erro ao excluir usuário.', 'error');
            }
          };

          const handleSaveSettings = async (type) => {
            if (type === 'patient_clinical_header') {
              // Snapshot the current clinical fields into avaliacoesOsteopatia history
              const now = new Date();
              const dataHora = now.toLocaleDateString('pt-BR') + ' ' + now.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
              const snapshot = {
                id: Date.now(),
                dataHora,
                queixaPrincipal: selectedPatient.avaliacoesOsteopatia?.[0]?.queixaPrincipal || '',
                inspecao: selectedPatient.avaliacoesOsteopatia?.[0]?.inspecao || '',
                palpacao: selectedPatient.avaliacoesOsteopatia?.[0]?.palpacao || '',
                disfuncaoOP: selectedPatient.disfuncaoOP ?? selectedPatient.disfuncao_op ?? '',
                tratamento: selectedPatient.tratamentoGeral ?? selectedPatient.tratamento_geral ?? ''
              };
              const historicoAnterior = (selectedPatient.avaliacoesOsteopatia || []).filter(a => a.dataHora); // apenas snapshots
              const patientToSave = {
                ...selectedPatient,
                avaliacoesOsteopatia: [selectedPatient.avaliacoesOsteopatia?.[0] || {}, ...historicoAnterior, snapshot]
              };
              const res = await apiFetch('save_patient', normalizePatientForSave(patientToSave));
              if (res && res.success) {
                showToast('Prontuário salvo com sucesso!');
                const updated = { ...selectedPatient, avaliacoesOsteopatia: patientToSave.avaliacoesOsteopatia };
                setSelectedPatient(updated);
                setPatients(patients.map(p => p.id === updated.id ? updated : p));
              } else {
                showToast('Erro ao salvar prontuário.', 'error');
              }
              return;
            }

            let payload = {};
            if (type === 'company') {
              payload = { company: companyData };
            } else if (type === 'theme') {
              payload = { theme: theme };
            } else if (type === 'mensagens') {
              payload = { api: systemSettings };
            } else {
              payload = { api: systemSettings, smtp: smtpSettings };
            }

            if (isApiReady) {
              const res = await apiFetch('save_settings', payload);
              if (res && res.success) {
                // Refresh data from server to ensure synchronization across tabs
                const data = await apiFetch('get_data');
                if (data && data.settings) {
                  if (data.settings.api) setSystemSettings(data.settings.api);
                  if (data.settings.company) setCompanyData(data.settings.company);
                  if (data.settings.smtp) setSmtpSettings(data.settings.smtp);
                  if (data.settings.theme) setTheme(data.settings.theme);
                  if (type === 'theme' && data.settings.theme) {
                    await syncThemeIconToPwaFile(data.settings.theme);
                    setPwaIconFileRev((x) => x + 1);
                  }
                }
                showToast('Configurações salvas no servidor!');
              } else {
                showToast('Erro ao salvar no servidor.', 'error');
              }
            } else {
              showToast('Modo Offline: Não foi possível salvar no servidor.', 'error');
            }
          };

          const handleEditPatient = (patient) => {
            setNewPatient(patientRecordToNewPatientForm(patient));
            setIsDualFisio(!!patient.fisio2_id);
            setIsEditingPatient(true);
            setEditingPatientId(patient.id);
            setActiveTab('new_patient');
            setSelectedPatient(null);
          };

          const executeDeletePatient = async () => {
            const idToDelete = patientToDelete.id;
            const res = await apiFetch(`delete_patient&id=${idToDelete}`);
            if (res && res.success) {
              setPatients(patients.filter(p => p.id !== idToDelete));
              setPatientToDelete(null);
              if (selectedPatient?.id === idToDelete) {
                setSelectedPatient(null);
                setActiveTab('list');
              }
              showToast('Paciente excluído!');
            } else {
              showToast('Erro ao excluir paciente no servidor.', 'error');
            }
          };

           const selectPatient = async (patient, subTab = 'perfil') => {
             // Limpa os formulários temporários para não misturar evolução/avaliação entre pacientes
             setFisioEval({
               id: null, data: new Date().toISOString().split('T')[0], rg: '', indicacao: '', responsavel: '', queixaPrincipal: '', hda: '', antecedentes: '', habitosVida: '', exames: '', inspecao: '', palpacao: '', goniometria: '', grauForca: '', objetivos: '', conduta: '', evolucoes: []
             });
             setFisioEvol({ 
               id: null, evolucao: '', assinaturaFisio: null, fotoFisio: null, assinaturaPaciente: null, fotoPaciente: null
             });
             setPilatesEval({
               id: null, data: new Date().toISOString().split('T')[0],
               escolaridade: '', ocupacao: '',
               indicacaoMedica: 'Não', praticouPilates: 'Não', tempoPratica: '', sedentario: 'Não', tempoSedentario: '', outraAtividade: '', frequencia: '',
               queixaPrincipal: '', outrasQueixas: '',
               neurologicos: 'Não', respiratorios: 'Não', cardiacos: 'Não', osteomioarticulares: 'Não', psicologicos: 'Não', fraturaCirurgia: 'Não', descFraturaCirurgia: '', hipertensao: 'Não', diabetes: 'Não',
               fumante: 'Não', alcool: 'Não', alcoolFreq: '', medicamentos: '', examesImagem: '',
               cabecaAnt: 'Normal', cabecaLat: 'Normal',
               ombrosAnt: 'Simétricos', ombrosLat: 'Normal', ombrosPost: 'Normal',
               colunaLatCervical: 'Normal', colunaLatToracica: 'Normal', colunaLatLombar: 'Normal', colunaPost: 'Normal', colunaPostDesc: '',
               quadril: 'Normal',
               joelhosAnt: 'Normal', joelhosLat: 'Normal',
               pesNormal: true, pesPlanoD: false, pesPlanoE: false, pesCavoD: false, pesCavoE: false, pesValgoD: false, pesValgoE: false, pesVaroD: false, pesVaroE: false,
               conclusoes: '', objetivos: '',
               assinaturaFisio: null, fotoFisio: null
             });
             setPilatesEvol({
               id: null, reposicao: 'Não', instrutor: currentUser?.nome || '', matPilates: false, maquinario: false, equilibrio: false,
               mmssAlong: false, mmssFort: false, mmisAlong: false, mmisFort: false,
               caAlong: false, caFort: false, cpAlong: false, cpFort: false, clAlong: false, clFort: false, rotsAlong: false, rotsFort: false, obs: ''
             });
             setOsteopatiaEval({
               id: null, data: new Date().toISOString().split('T')[0], queixaPrincipal: '', inspecao: '', palpacao: ''
             });
             setOsteopatiaEvol(getEmptyOsteopatiaEvol());

             if (!patient.isDetailsLoaded) {
               setIsLoadingDetails(true);
               try {
                 const details = await apiFetch('get_patient_details&id=' + patient.id);
                 if (details && !details.error) {
                    setPatients(prev => prev.map(p => p.id === patient.id ? details : p));
                    setSelectedPatient(details);
                 } else {
                    setSelectedPatient(patient);
                 }
               } catch (e) {
                 setSelectedPatient(patient);
               } finally {
                 setIsLoadingDetails(false);
               }
             } else {
               setSelectedPatient(patient);
             }
             setActiveTab('dashboard');
             setPatientSubTab(subTab);
             setSearchTerm(''); 
           };

          /* Deep-link ?patientId= (ex.: app Vite → legado) */
          useEffect(() => {
            if (!isApiReady || !isAuthenticated) return;
            if (patientDeepLinkConsumedRef.current) return;
            let raw = null;
            try {
              raw = new URLSearchParams(window.location.search).get('patientId');
            } catch (e) {
              return;
            }
            if (!raw || !String(raw).trim()) return;
            const pid = parseInt(String(raw).replace(/\D/g, ''), 10);
            if (!pid || pid < 1) return;
            patientDeepLinkConsumedRef.current = true;
            const clearPatientIdParam = () => {
              try {
                const u = new URL(window.location.href);
                u.searchParams.delete('patientId');
                window.history.replaceState({}, document.title, u.pathname + (u.search || ''));
              } catch (e) { /* noop */ }
            };
            const fromList = patients.find((p) => Number(p.id) === pid);
            if (fromList) {
              selectPatient(fromList, 'perfil').finally(() => clearPatientIdParam());
              return;
            }
            (async () => {
              try {
                const details = await apiFetch('get_patient_details&id=' + pid);
                if (details && !details.error) {
                  setPatients((prev) => {
                    const ix = prev.findIndex((p) => p.id === details.id);
                    if (ix >= 0) return prev.map((p) => (p.id === details.id ? details : p));
                    return [details, ...prev];
                  });
                  setSelectedPatient(details);
                  setActiveTab('dashboard');
                  setPatientSubTab('perfil');
                  setSearchTerm('');
                  showToast('Paciente aberto pelo link.');
                } else {
                  showToast('Paciente não encontrado.', 'error');
                }
              } catch (e) {
                showToast('Erro ao abrir paciente.', 'error');
              } finally {
                clearPatientIdParam();
              }
            })();
          }, [isApiReady, isAuthenticated, patients]);

          const handlePrintPilates = (dataObj, patient = selectedPatient) => {
              const printBgUrl = theme.backgroundUrl || theme.logoUrl || defaultLogoPath;
              const bgImage = printBgUrl ? `url(${printBgUrl})` : 'none';
              const printWindow = window.open('', '_blank');
              const pesAlteracoes = [
                  dataObj.pesPlanoD && 'Plano D', dataObj.pesPlanoE && 'Plano E',
                  dataObj.pesCavoD && 'Cavo D', dataObj.pesCavoE && 'Cavo E',
                  dataObj.pesValgoD && 'Valgo D', dataObj.pesValgoE && 'Valgo E',
                  dataObj.pesVaroD && 'Varo D', dataObj.pesVaroE && 'Varo E'
              ].filter(Boolean).join(', ');

              const html = `
                <html>
                  <head>
                    <meta charset="UTF-8" />
                    <title>Avaliação Pilates - ${patient?.nome}</title>
                    <style>
                      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;800&display=swap');
                      body { font-family: 'Inter', sans-serif; margin: 0; padding: 25px; color: #1e293b; background: #fff; line-height: 1.3; font-size: 12px; }
                      .bg { position: fixed; inset: 0; background-image: ${bgImage}; background-repeat: no-repeat; background-size: cover; background-position: center; z-index: 0; opacity: 0.08; pointer-events: none; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                      .header, .section, .footer, .main-content, .observations, .patient-data-row, .postural-grid { position: relative; z-index: 1; }
                      
                      .header { display: grid; grid-template-columns: 200px 1fr 200px; align-items: center; border-bottom: 2px solid #059669; padding-bottom: 12px; margin-bottom: 20px; }
                      .header-main { grid-column: 1; display: flex; align-items: center; gap: 12px; }
                      .logo { max-height: 55px; }
                      .clinic-info { color: #475569; text-align: left; }
                      .clinic-name { font-weight: 800; font-size: 13px; color: #065f46; text-transform: uppercase; line-height: 1.1; }
                      .clinic-details { font-size: 8px; line-height: 1.2; margin-top: 2px; }
                      .header-title-box { grid-column: 2; text-align: center; display: flex; flex-direction: column; gap: 2px; }
                      .header-title-box h1 { margin: 0; font-size: 18px; color: #065f46; text-transform: uppercase; font-weight: 800; }
                      .patient-header-info { font-size: 12px; color: #1e293b; font-weight: 700; }
                      .patient-header-address { font-size: 9px; color: #64748b; font-weight: 500; }
                      .header-right-spacer { grid-column: 3; }

                      .section { margin-bottom: 15px; page-break-inside: avoid; }
                      .section-title { background: #f0fdf4; color: #166534; padding: 5px 10px; font-weight: 800; font-size: 11px; border-left: 4px solid #22c55e; text-transform: uppercase; margin-bottom: 8px; display: flex; align-items: center; }
                      
                      .grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }
                      .field { border-bottom: 1px solid #e2e8f0; padding: 2px 0; }
                      .label { font-size: 9px; color: #64748b; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; }
                      .value { font-size: 12px; color: #0f172a; font-weight: 500; min-height: 1.2em; white-space: pre-wrap; }
                      
                      .full-width { grid-column: span 2; }
                      
                      .postural-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; }
                      .postural-card { background: #f8fafc; border: 1px solid #e2e8f0; padding: 6px; border-radius: 4px; }
                      
                      .footer { margin-top: 30px; border-top: 1px solid #e2e8f0; padding-top: 15px; display: flex; justify-content: space-between; align-items: flex-end; }
                      .footer-patient-data { flex: 1; }
                      .sig-box { text-align: center; width: 220px; }
                      .sig-img { max-height: 60px; max-width: 200px; margin-bottom: 4px; }
                      .sig-label { font-size: 9px; color: #94a3b8; text-transform: uppercase; font-weight: 700; }
                      
                      .no-print { background: #f8fafc; padding: 10px; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: center; margin-bottom: 15px; }
                      .print-btn { background: #059669; color: white; border: none; padding: 8px 16px; border-radius: 6px; font-weight: bold; cursor: pointer; }

                      @media print {
                        body { padding: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .bg {
                          -webkit-print-color-adjust: exact !important;
                          print-color-adjust: exact !important;
                          z-index: 0 !important;
                          opacity: 0.12 !important;
                        }
                        .section-title { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .postural-card { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .no-print { display: none !important; }
                      }
                    </style>
                  </head>
                  <body>
                    <div class="no-print">
                      <button onclick="window.print()" class="print-btn">CLIQUE AQUI PARA IMPRIMIR SE A JANELA NÃO ABRIR</button>
                    </div>
                    <div class="bg"></div>
                    
                    <div class="header">
                      <div class="header-main">
                        <img src="${theme.logoUrl || 'logo.jpg'}" class="logo" />
                        <div class="clinic-info">
                          <div class="clinic-name">${companyData.nomeFantasia || companyData.razaoSocial || 'Real Clínica Integrada'}</div>
                          <div class="clinic-details">
                            CNPJ: ${companyData.cnpj || '-'} | Tel: ${companyData.telefone || '-'}
                            <br>Email: ${companyData.email || '-'}
                          </div>
                        </div>
                      </div>
                      <div class="header-title-box">
                        <h1>Avaliação Pilates</h1>
                        <div class="patient-header-info">${patient?.nome} | CPF: ${patient?.cpf} | Data: ${dataObj.data ? new Date(dataObj.data).toLocaleDateString('pt-BR') : new Date().toLocaleDateString('pt-BR')}</div>
                      </div>
                      <div class="header-right-spacer"></div>
                    </div>

                    <div class="section">
                      <div class="section-title">1. Identificação e Hábitos de Vida</div>
                      <div class="grid">
                        <div class="field"><div class="label">Escolaridade</div><div class="value">${dataObj.escolaridade || '-'}</div></div>
                        <div class="field"><div class="label">Ocupação</div><div class="value">${dataObj.ocupacao || '-'}</div></div>
                        <div class="field"><div class="label">Já praticou Pilates?</div><div class="value">${dataObj.praticouPilates} ${dataObj.tempoPratica ? `(${dataObj.tempoPratica})` : ''}</div></div>
                        <div class="field"><div class="label">Atividade Física</div><div class="value">${dataObj.outraAtividade || 'Nenhuma'} ${dataObj.frequencia ? ` - ${dataObj.frequencia}` : ''}</div></div>
                        <div class="field"><div class="label">Tabagismo / Etilismo</div><div class="value">Fumante: ${dataObj.fumante} | Álcool: ${dataObj.alcool} ${dataObj.alcoolFreq ? `(${dataObj.alcoolFreq})` : ''}</div></div>
                        <div class="field"><div class="label">Sedentarismo</div><div class="value">${dataObj.sedentario === 'Sim' ? `Sim (${dataObj.tempoSedentario})` : 'Não'}</div></div>
                      </div>
                    </div>

                    <div class="section">
                      <div class="section-title">2. Histórico Clínico e Queixas</div>
                      <div class="grid">
                        <div class="field full-width"><div class="label">Queixa Principal</div><div class="value">${dataObj.queixaPrincipal || '-'}</div></div>
                        <div class="field full-width"><div class="label">Outras Queixas</div><div class="value">${dataObj.outrasQueixas || '-'}</div></div>
                        <div class="field"><div class="label">Antecedentes</div><div class="value">
                          ${dataObj.neurologicos === 'Sim' ? '– Neurológicos ' : ''}
                          ${dataObj.respiratorios === 'Sim' ? '– Respiratórios ' : ''}
                          ${dataObj.cardiacos === 'Sim' ? '– Cardíacos ' : ''}
                          ${dataObj.hipertensao === 'Sim' ? '– Hipertensão ' : ''}
                          ${dataObj.diabetes === 'Sim' ? '– Diabetes ' : ''}
                          ${(dataObj.neurologicos==='Não'&&dataObj.respiratorios==='Não'&&dataObj.cardiacos==='Não'&&dataObj.hipertensao==='Não'&&dataObj.diabetes==='Não') ? 'Nenhum' : ''}
                        </div></div>
                        <div class="field"><div class="label">Cirurgias/Fraturas</div><div class="value">${dataObj.fraturaCirurgia === 'Sim' ? `Sim: ${dataObj.descFraturaCirurgia}` : 'Não'}</div></div>
                        <div class="field full-width"><div class="label">Medicamentos e Exames</div><div class="value">${dataObj.medicamentos || 'Nenhum'} | ${dataObj.examesImagem || 'Sem exames anexados'}</div></div>
                      </div>
                    </div>

                    <div class="section">
                      <div class="section-title">3. Avaliação Postural</div>
                      <div class="postural-grid">
                        <div class="postural-card"><div class="label">Cabeça</div><div class="value">Anterior: ${dataObj.cabecaAnt}<br>Lateral: ${dataObj.cabecaLat}</div></div>
                        <div class="postural-card"><div class="label">Ombros</div><div class="value">Anterior: ${dataObj.ombrosAnt}<br>Lateral: ${dataObj.ombrosLat}<br>Posterior: ${dataObj.ombrosPost}</div></div>
                        <div class="postural-card"><div class="label">Coluna (Curvaturas)</div><div class="value">Cervical: ${dataObj.colunaLatCervical}<br>Torácica: ${dataObj.colunaLatToracica}<br>Lombar: ${dataObj.colunaLatLombar}</div></div>
                        <div class="postural-card"><div class="label">Pelve e Escoliose</div><div class="value">Quadril: ${dataObj.quadril}<br>Escoliose: ${dataObj.colunaPost} ${dataObj.colunaPostDesc ? `(${dataObj.colunaPostDesc})` : ''}</div></div>
                        <div class="postural-card"><div class="label">Joelhos</div><div class="value">Anterior: ${dataObj.joelhosAnt}<br>Lateral: ${dataObj.joelhosLat}</div></div>
                        <div class="postural-card"><div class="label">Pés</div><div class="value">${dataObj.pesNormal ? 'Normal' : pesAlteracoes || 'Sem alterações'}</div></div>
                      </div>
                    </div>

                    <div class="section">
                      <div class="section-title">4. Planejamento Terapêutico</div>
                      <div class="grid">
                        <div class="field full-width"><div class="label">Conclusões</div><div class="value">${dataObj.conclusoes || '-'}</div></div>
                        <div class="field full-width"><div class="label">Objetivos</div><div class="value">${dataObj.objetivos || '-'}</div></div>
                      </div>
                    </div>

                    <div class="footer" style="justify-content: flex-end;">
                      <div class="sig-section">
                        <div class="sig-box">
                          ${dataObj.assinaturaFisio ? `<img src="${dataObj.assinaturaFisio}" class="sig-img" />` : '<div style="height: 50px; border-bottom: 2px dashed #cbd5e1; margin-bottom: 5px;"></div>'}
                          <div class="sig-label">Prof. Responsável: ${currentUser?.nome || 'Fisioterapeuta'}</div>
                        </div>
                      </div>
                    </div>

                    <script>
                      window.onload = () => {
                        setTimeout(() => { window.print(); window.close(); }, 500);
                      };
                    </scr' + 'ipt>
                  </body>
                </html>
              `;
              printWindow.document.write(html);
              printWindow.document.close();
          };

          const handlePrintFisio = (dataObj, patient = selectedPatient) => {
              const printBgUrl = theme.backgroundUrl || theme.logoUrl || defaultLogoPath;
              const bgImage = printBgUrl ? `url(${printBgUrl})` : 'none';
              const printWindow = window.open('', '_blank');
              
              const html = `
                <html>
                  <head>
                    <meta charset="UTF-8" />
                    <title>Avaliação Fisioterapia - ${patient?.nome}</title>
                    <style>
                      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;800&display=swap');
                      body { font-family: 'Inter', sans-serif; margin: 0; padding: 25px; color: #1e293b; background: #fff; line-height: 1.3; font-size: 12px; }
                      .bg { position: fixed; inset: 0; background-image: ${bgImage}; background-repeat: no-repeat; background-size: cover; background-position: center; z-index: 0; opacity: 0.08; pointer-events: none; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                      .header, .section, .footer, .main-content, .observations, .patient-data-row, .postural-grid { position: relative; z-index: 1; }
                      
                      .header { display: grid; grid-template-columns: 200px 1fr 200px; align-items: center; border-bottom: 2px solid #0369a1; padding-bottom: 12px; margin-bottom: 20px; }
                      .header-main { grid-column: 1; display: flex; align-items: center; gap: 12px; }
                      .logo { max-height: 55px; }
                      .clinic-info { color: #475569; text-align: left; }
                      .clinic-name { font-weight: 800; font-size: 13px; color: #0369a1; text-transform: uppercase; line-height: 1.1; }
                      .clinic-details { font-size: 8px; line-height: 1.2; margin-top: 2px; }
                      .header-title-box { grid-column: 2; text-align: center; display: flex; flex-direction: column; gap: 2px; }
                      .header-title-box h1 { margin: 0; font-size: 18px; color: #0369a1; text-transform: uppercase; font-weight: 800; }
                      .patient-header-info { font-size: 12px; color: #1e293b; font-weight: 700; }
                      .patient-header-address { font-size: 9px; color: #64748b; font-weight: 500; }
                      .header-right-spacer { grid-column: 3; }
 
                      .section { margin-bottom: 15px; page-break-inside: avoid; }
                      .section-title { background: #f0f9ff; color: #0369a1; padding: 5px 10px; font-weight: 800; font-size: 11px; border-left: 4px solid #0ea5e9; text-transform: uppercase; margin-bottom: 8px; display: flex; align-items: center; }
                      
                      .grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }
                      .field { border-bottom: 1px solid #e2e8f0; padding: 2px 0; }
                      .label { font-size: 9px; color: #64748b; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; }
                      .value { font-size: 12px; color: #0f172a; font-weight: 500; min-height: 1.2em; white-space: pre-wrap; }
                      
                      .full-width { grid-column: span 2; }
                      
                      .footer { margin-top: 30px; border-top: 1px solid #e2e8f0; padding-top: 15px; display: flex; justify-content: space-between; align-items: flex-end; }
                      .sig-box { text-align: center; width: 220px; }
                      .sig-img { max-height: 60px; max-width: 200px; margin-bottom: 4px; }
                      .sig-label { font-size: 9px; color: #94a3b8; text-transform: uppercase; font-weight: 700; }
                      
                      .no-print { background: #f8fafc; padding: 10px; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: center; margin-bottom: 15px; }
                      .print-btn { background: #0369a1; color: white; border: none; padding: 8px 16px; border-radius: 6px; font-weight: bold; cursor: pointer; }
 
                      @media print {
                        body { padding: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .bg {
                          -webkit-print-color-adjust: exact !important;
                          print-color-adjust: exact !important;
                          z-index: 0 !important;
                          opacity: 0.12 !important;
                        }
                        .section-title { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .postural-card { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .no-print { display: none !important; }
                      }
                    </style>
                  </head>
                  <body>
                    <div class="no-print">
                      <button onclick="window.print()" class="print-btn">CLIQUE AQUI PARA IMPRIMIR SE A JANELA NÃO ABRIR</button>
                    </div>
                    <div class="bg"></div>
                    
                    <div class="header">
                      <div class="header-main">
                        <img src="${theme.logoUrl || 'logo.jpg'}" class="logo" />
                        <div class="clinic-info">
                          <div class="clinic-name">${companyData.nomeFantasia || companyData.razaoSocial || 'Real Clínica Integrada'}</div>
                          <div class="clinic-details">
                            CNPJ: ${companyData.cnpj || '-'} | Tel: ${companyData.telefone || '-'}
                            <br>Email: ${companyData.email || '-'}
                          </div>
                        </div>
                      </div>
                      <div class="header-title-box">
                        <h1>Avaliação Fisioterapia</h1>
                        <div class="patient-header-info">${patient?.nome} | CPF: ${patient?.cpf} | Data: ${dataObj.data ? new Date(dataObj.data).toLocaleDateString('pt-BR') : new Date().toLocaleDateString('pt-BR')}</div>
                        <div class="patient-header-address">
                           ${patient?.endereco}, ${patient?.numero} ${patient?.complemento ? ` - ${patient.complemento}` : ''} - ${patient?.bairro} | ${patient?.cidade}/${patient?.uf}
                        </div>
                      </div>
                      <div class="header-right-spacer"></div>
                    </div>
 
                    <div class="section">
                      <div class="section-title">1. Anamnese</div>
                      <div class="grid">
                        <div class="field full-width"><div class="label">Queixa Principal</div><div class="value">${dataObj.queixaPrincipal || '-'}</div></div>
                        <div class="field full-width"><div class="label">História da Doença Atual (HDA)</div><div class="value">${dataObj.hda || '-'}</div></div>
                        <div class="field full-width"><div class="label">Antecedentes</div><div class="value">${dataObj.antecedentes || '-'}</div></div>
                        <div class="field full-width"><div class="label">Hábitos de Vida</div><div class="value">${dataObj.habitosVida || '-'}</div></div>
                        <div class="field full-width"><div class="label">Exames Complementares</div><div class="value">${dataObj.exames || '-'}</div></div>
                      </div>
                    </div>
 
                    <div class="section">
                      <div class="section-title">2. Exame Físico</div>
                      <div class="grid">
                        <div class="field full-width"><div class="label">Inspeção</div><div class="value">${dataObj.inspecao || '-'}</div></div>
                        <div class="field full-width"><div class="label">Palpação</div><div class="value">${dataObj.palpacao || '-'}</div></div>
                        <div class="field"><div class="label">Goniometria</div><div class="value">${dataObj.goniometria || '-'}</div></div>
                        <div class="field"><div class="label">Grau de Força</div><div class="value">${dataObj.grauForca || '-'}</div></div>
                      </div>
                    </div>
 
                    <div class="section">
                      <div class="section-title">3. Planejamento Terapêutico</div>
                      <div class="grid">
                        <div class="field full-width"><div class="label">Objetivos</div><div class="value">${dataObj.objetivos || '-'}</div></div>
                        <div class="field full-width"><div class="label">Conduta Inicial</div><div class="value">${dataObj.conduta || '-'}</div></div>
                      </div>
                    </div>
 
                    <div class="footer" style="justify-content: flex-end;">
                      <div class="sig-section">
                        <div class="sig-box">
                          ${dataObj.assinaturaFisio ? `<img src="${dataObj.assinaturaFisio}" class="sig-img" />` : '<div style="height: 50px; border-bottom: 2px dashed #cbd5e1; margin-bottom: 5px;"></div>'}
                          <div class="sig-label">Prof. Responsável: ${currentUser?.nome || 'Fisioterapeuta'}</div>
                        </div>
                      </div>
                    </div>
 
                    <script>
                      window.onload = () => {
                        setTimeout(() => { window.print(); window.close(); }, 500);
                      };
                    </scr' + 'ipt>
                  </body>
                </html>
              `;
              printWindow.document.write(html);
              printWindow.document.close();
          };

          const handlePrint = (title, dataObj, patient = selectedPatient) => {
              const printBgUrl = theme.backgroundUrl || theme.logoUrl || defaultLogoPath;
              const bgImage = printBgUrl ? `url(${printBgUrl})` : 'none';
              const printWindow = window.open('', '_blank');
              let contentHtml = '';
              
              const excludeKeys = ['id', 'data', 'assinaturaPaciente', 'fotoPaciente', 'assinaturaFisio', 'fotoFisio', 'digital_sign', 'obs'];
              
              for(let key in dataObj) {
                  if (!excludeKeys.includes(key) && dataObj[key] !== '' && dataObj[key] !== false && dataObj[key] !== null) {
                      let formattedKey = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
                      let val = dataObj[key] === true ? 'Sim' : dataObj[key];
                      contentHtml += `<div class="info-group"><div class="label">${formattedKey}:</div><div class="value">${val}</div></div>`;
                  }
              }

              const html = `
                <html>
                  <head>
                    <meta charset="UTF-8" />
                    <title>${title} - ${patient?.nome}</title>
                    <style>
                      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;800&display=swap');
                      body { font-family: 'Inter', sans-serif; margin: 0; padding: 25px; color: #1e293b; background: #fff; line-height: 1.3; font-size: 11px; }
                      .bg { position: fixed; inset: 0; background-image: ${bgImage}; background-repeat: no-repeat; background-size: cover; background-position: center; z-index: 0; opacity: 0.08; pointer-events: none; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                      .header, .section, .footer, .main-content, .observations, .patient-data-row, .postural-grid { position: relative; z-index: 1; }
                      
                      .header { display: grid; grid-template-columns: 200px 1fr 200px; align-items: center; border-bottom: 2px solid #059669; padding-bottom: 12px; margin-bottom: 20px; }
                      .header-main { grid-column: 1; display: flex; align-items: center; gap: 12px; }
                      .logo { max-height: 55px; }
                      .clinic-info { color: #475569; text-align: left; }
                      .clinic-name { font-weight: 800; font-size: 13px; color: #065f46; text-transform: uppercase; line-height: 1.1; }
                      .clinic-details { font-size: 8px; line-height: 1.2; margin-top: 2px; }
                      .header-title-box { grid-column: 2; text-align: center; display: flex; flex-direction: column; gap: 2px; }
                      .header-title-box h1 { margin: 0; font-size: 18px; color: #065f46; text-transform: uppercase; font-weight: 800; }
                      .patient-header-info { font-size: 12px; color: #1e293b; font-weight: 700; }
                      .patient-header-address { font-size: 9px; color: #64748b; font-weight: 500; }
                      .header-right-spacer { grid-column: 3; }

                      .main-content { margin-bottom: 20px; display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
                      .info-group { border-bottom: 1px solid #f1f5f9; padding: 4px 0; }
                      .label { font-size: 8px; color: #64748b; font-weight: 700; text-transform: uppercase; margin-bottom: 2px; }
                      .value { font-size: 11px; color: #0f172a; font-weight: 500; min-height: 1.2em; }

                      .observations { margin-top: 15px; padding: 10px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px; }
                      .observations .label { color: #065f46; font-size: 9px; }
                      .observations .value { white-space: pre-wrap; margin-top: 4px; font-size: 11px; }

                      .footer { margin-top: 30px; border-top: 1px solid #e2e8f0; padding-top: 15px; display: flex; justify-content: space-between; align-items: flex-end; }
                      .footer-patient-data { flex: 1; }
                      .sig-box { text-align: center; width: 220px; }
                      .sig-img { max-height: 55px; max-width: 190px; margin-bottom: 4px; }
                      .sig-label { font-size: 8px; color: #94a3b8; text-transform: uppercase; font-weight: 700; }
                      
                      .no-print { background: #f8fafc; padding: 10px; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: center; margin-bottom: 15px; }
                      .print-btn { background: #059669; color: white; border: none; padding: 8px 16px; border-radius: 6px; font-weight: bold; cursor: pointer; }

                      @media print {
                        body { padding: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .bg {
                          -webkit-print-color-adjust: exact !important;
                          print-color-adjust: exact !important;
                          z-index: 0 !important;
                          opacity: 0.12 !important;
                        }
                        .observations { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .no-print { display: none !important; }
                      }
                    </style>
                  </head>
                  <body>
                    <div class="no-print">
                      <button onclick="window.print()" class="print-btn">CLIQUE AQUI PARA IMPRIMIR SE A JANELA NÃO ABRIR</button>
                    </div>
                    <div class="bg"></div>
                    
                    <div class="header">
                      <div class="header-main">
                        <img src="${theme.logoUrl || 'logo.jpg'}" class="logo" />
                        <div class="clinic-info">
                          <div class="clinic-name">${companyData.nomeFantasia || companyData.razaoSocial || 'Real Clínica Integrada'}</div>
                          <div class="clinic-details">
                            CNPJ: ${companyData.cnpj || '-'} | Tel: ${companyData.telefone || '-'}
                            <br>Email: ${companyData.email || '-'}
                          </div>
                        </div>
                      </div>
                      <div class="header-title-box">
                        <h1>${title}</h1>
                        <div class="patient-header-info">${patient?.nome} | CPF: ${patient?.cpf} | Data: ${dataObj.data || new Date().toLocaleDateString('pt-BR')}</div>
                        <div class="patient-header-address">
                           ${patient?.endereco}, ${patient?.numero} ${patient?.complemento ? ` - ${patient.complemento}` : ''} - ${patient?.bairro} | ${patient?.cidade}/${patient?.uf}
                        </div>
                      </div>
                      <div class="header-right-spacer"></div>
                    </div>

                    <div class="main-content">
                      ${contentHtml}
                    </div>

                    ${dataObj.obs ? `
                      <div class="observations">
                        <div class="label">Observações Complementares</div>
                        <div class="value">${dataObj.obs}</div>
                      </div>
                    ` : ''}

                    <div class="footer" style="justify-content: flex-end;">
                      <div class="sig-section">
                        <div class="sig-box">
                          ${dataObj.assinaturaFisio ? `<img src="${dataObj.assinaturaFisio}" class="sig-img" />` : '<div style="height: 50px; border-bottom: 2px dashed #cbd5e1; margin-bottom: 5px;"></div>'}
                          <div class="sig-label">Prof. Responsável: ${currentUser?.nome || 'Fisioterapeuta'}</div>
                        </div>
                      </div>
                    </div>

                    <script>
                      window.onload = () => {
                        setTimeout(() => { window.print(); window.close(); }, 500);
                      };
                    </scr' + 'ipt>
                  </body>
                </html>
              `;
              printWindow.document.write(html);
              printWindow.document.close();
          };

          
          const handlePrintPilatesReport = (aval, p = selectedPatient) => {
              handlePrint('AVALIAÇÃO DE PILATES', aval, p);
          };
    
          const handlePrintHistory = (title, evolucoes, patient = selectedPatient) => {
              const printBgUrl = theme.backgroundUrl || theme.logoUrl || defaultLogoPath;
              const bgImage = printBgUrl ? `url(${printBgUrl})` : 'none';
              const printWindow = window.open('', '_blank');
              let rowsHtml = '';
              
              const evs = evolucoes || [];
              if (evs.length > 0) {
                  rowsHtml += evs.map(ev => `
                     <tr>
                       <td class="col-data">${ev.data || ''}</td>
                       <td class="col-evolucao">${ev.evolucao || '-'}</td>
                       <td class="col-ass">
                         ${ev.assinaturaFisio ? `<img src="${ev.assinaturaFisio}" class="table-sig" />` : ''}
                       </td>
                       <td class="col-ass">
                         ${ev.assinaturaPaciente ? `<img src="${ev.assinaturaPaciente}" class="table-sig" />` : ''}
                       </td>
                     </tr>
                  `).join('');
              }

              const minLines = 20;
              const emptyLinesNeeded = Math.max(0, minLines - evs.length);
              for(let i = 0; i < emptyLinesNeeded; i++) {
                  rowsHtml += `<tr><td class="col-data">__/__/____</td><td class="col-evolucao"></td><td class="col-ass"></td><td class="col-ass"></td></tr>`;
              }

              const html = `
                <html>
                  <head>
                    <meta charset="UTF-8" />
                    <title>${title} - ${patient?.nome}</title>
                    <style>
                      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;800&display=swap');
                      body { font-family: 'Inter', sans-serif; margin: 0; padding: 20px; color: #1e293b; background: #fff; line-height: 1.2; font-size: 11px; }
                      .bg { position: fixed; inset: 0; background-image: ${bgImage}; background-repeat: no-repeat; background-size: cover; background-position: center; z-index: 0; opacity: 0.08; pointer-events: none; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                      .header, .section, .footer, .main-content, .observations, .patient-data-row, .postural-grid { position: relative; z-index: 1; }
                      
                      .header { display: grid; grid-template-columns: 200px 1fr 200px; align-items: center; border-bottom: 2px solid #059669; padding-bottom: 12px; margin-bottom: 20px; }
                       .header-main { grid-column: 1; display: flex; align-items: center; gap: 12px; }
                       .logo { max-height: 45px; }
                       .clinic-info { color: #475569; text-align: left; }
                       .clinic-name { font-weight: 800; font-size: 13px; color: #065f46; text-transform: uppercase; line-height: 1.1; }
                       .clinic-details { font-size: 8px; line-height: 1.2; margin-top: 2px; }
                       .header-title-box { grid-column: 2; text-align: center; display: flex; flex-direction: column; gap: 2px; }
                       .header-title-box h1 { margin: 0; font-size: 16px; color: #065f46; text-transform: uppercase; font-weight: 800; }
                       .patient-header-info { font-size: 11px; color: #1e293b; font-weight: 700; }
                       .patient-header-address { font-size: 9px; color: #64748b; font-weight: 500; }
                       .header-right-spacer { grid-column: 3; }

                      .patient-data-row { background: #f8fafc; padding: 8px 12px; border-radius: 6px; margin-bottom: 15px; display: flex; justify-content: space-between; border: 1px solid #e2e8f0; }
                      .patient-label { font-size: 8px; color: #64748b; font-weight: 700; text-transform: uppercase; }
                      .patient-value { font-size: 11px; color: #0f172a; font-weight: 800; }

                      table { width: 100%; border-collapse: collapse; table-layout: fixed; }
                      th, td { border: 1px solid #cbd5e1; padding: 6px; text-align: left; word-wrap: break-word; }
                      th { background: #f1f5f9; color: #475569; font-size: 9px; text-transform: uppercase; font-weight: 800; text-align: center; }
                      .col-data { width: 80px; text-align: center; font-weight: 700; }
                      .col-evolucao { width: auto; font-size: 10px; }
                      .col-ass { width: 110px; text-align: center; }
                      .table-sig { max-height: 35px; max-width: 100px; object-fit: contain; }

                      .footer { margin-top: 20px; border-top: 1px solid #e2e8f0; padding-top: 10px; display: flex; justify-content: space-between; align-items: flex-end; }
                      .footer-patient-data { flex: 1; }
                      .label { font-size: 8px; color: #64748b; font-weight: 700; text-transform: uppercase; }
                      .value { font-size: 9px; color: #0f172a; font-weight: 500; }
                      
                      .no-print { background: #f8fafc; padding: 8px; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: center; margin-bottom: 10px; }
                      .print-btn { background: #059669; color: white; border: none; padding: 6px 12px; border-radius: 6px; font-weight: bold; cursor: pointer; }

                      @media print {
                        body { padding: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .bg {
                          -webkit-print-color-adjust: exact !important;
                          print-color-adjust: exact !important;
                          z-index: 0 !important;
                          opacity: 0.12 !important;
                        }
                        th { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .patient-data-row { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .no-print { display: none !important; }
                        thead { display: table-header-group; }
                      }
                    </style>
                  </head>
                  <body>
                    <div class="no-print">
                      <button onclick="window.print()" class="print-btn">CLIQUE AQUI PARA IMPRIMIR SE A JANELA NÃO ABRIR</button>
                    </div>
                    <div class="bg"></div>
                    
                    <div class="header">
                      <div class="header-main">
                        <img src="${theme.logoUrl || 'logo.jpg'}" class="logo" />
                        <div class="clinic-info">
                          <div class="clinic-name">${companyData.nomeFantasia || companyData.razaoSocial || 'Real Clínica Integrada'}</div>
                          <div class="clinic-details">CNPJ: ${companyData.cnpj || '-'} | Tel: ${companyData.telefone || '-'}</div>
                        </div>
                      </div>
                      <div class="header-title-box">
                        <h1>${title}</h1>
                        <div class="patient-header-info">${patient?.nome} | CPF: ${patient?.cpf}</div>
                        <div class="patient-header-address">
                           ${patient?.endereco}, ${patient?.numero} ${patient?.complemento ? `- ${patient.complemento}` : ''} - ${patient?.bairro} | ${patient?.cidade}/${patient?.uf}
                        </div>
                      </div>
                      <div class="header-right-spacer"></div>
                    </div>

                    <table>
                      <thead>
                        <tr>
                          <th class="col-data">Data</th>
                          <th class="col-evolucao">Evolução / Conduta</th>
                          <th class="col-ass">Fisioterapeuta</th>
                          <th class="col-ass">Paciente</th>
                        </tr>
                      </thead>
                      <tbody>
                        ${rowsHtml}
                      </tbody>
                    </table>

                    <div class="footer" style="justify-content: flex-end;">
                      <div style="text-align: right; font-size: 8px; color: #94a3b8;">
                        Página 1 de 1
                      </div>
                    </div>

                    <script>
                      window.onload = () => {
                        setTimeout(() => { window.print(); window.close(); }, 500);
                      };
                    </scr' + 'ipt>
                  </body>
                </html>
              `;
              printWindow.document.write(html);
              printWindow.document.close();
          };

          const handleNewFisioEval = () => setFisioEval({ id: null, rg: '', indicacao: '', responsavel: '', queixaPrincipal: '', hda: '', antecedentes: '', habitosVida: '', exames: '', inspecao: '', palpacao: '', goniometria: '', grauForca: '', objetivos: '', conduta: '', evolucoes: [] });
          const handleVerFisioEval = (item) => { 
            setFisioEval({ 
              ...item, 
              rg: item.rg || '', 
              indicacao: item.indicacao || '', 
              responsavel: item.responsavel || '',
              evolucoes: item.evolucoes || []
            }); 
            window.scrollTo({ top: 300, behavior: 'smooth' }); 
          };
          const handleDeleteFisioEval = (item) => {
             if(window.confirm('Tem certeza que deseja excluir esta avaliação?')) {
                 const cur = selectedPatient.avaliacoesFisio || [];
                 const updatedArray = cur.filter(a => a !== item);
                 updatePatientState({ ...selectedPatient, avaliacoesFisio: updatedArray });
                 if(fisioEval.id === item.id) handleNewFisioEval();
                 showToast('Avaliação excluída!', 'info');
             }
          };
          const handleSaveFisioEval = (e) => {
            e.preventDefault();
            let finalEval = { ...fisioEval };
            
            // Auto-deduct pacote para evoluções assinadas na tabela da ficha
            if (finalEval.evolucoes && Array.isArray(finalEval.evolucoes)) {
                finalEval.evolucoes = finalEval.evolucoes.map(evol => {
                    if (evol.assinaturaPaciente && !evol.pacoteDebitado) {
                        const pName = (selectedPatient.nome || '').trim();
                        if (decrementPackageForPatient(pName, evol.id)) {
                            return { ...evol, pacoteDebitado: true };
                        }
                    }
                    return evol;
                });
            }

            const prevList = selectedPatient.avaliacoesFisio || [];
            let updatedArray;
            if (!finalEval.id) {
               finalEval.id = Date.now().toString();
               finalEval.data = new Date().toISOString().split('T')[0];
               updatedArray = [finalEval, ...prevList];
            } else {
               updatedArray = prevList.map(item => (item.id === finalEval.id || item === fisioEval) ? finalEval : item);
            }
            updatePatientState({ ...selectedPatient, avaliacoesFisio: updatedArray });
            setFisioEval(finalEval);
            showToast('Avaliação de Fisioterapia salva!');
          };

          const handleNewOsteopatiaEval = () => setOsteopatiaEval({ id: null, data: new Date().toISOString().split('T')[0], queixaPrincipal: '', inspecao: '', palpacao: '' });
          const handleDeleteOsteopatiaEval = (item) => {
             if(window.confirm('Tem certeza que deseja excluir esta avaliação de Osteopatia?')) {
                 const cur = selectedPatient.avaliacoesOsteopatia || [];
                 const updatedArray = cur.filter(a => a !== item);
                 updatePatientState({ ...selectedPatient, avaliacoesOsteopatia: updatedArray });
                 if(osteopatiaEval.id === item.id) handleNewOsteopatiaEval();
                 showToast('Avaliação excluída!', 'info');
             }
          };
          const handleSaveOsteopatiaEval = (e) => {
            e.preventDefault();
            let finalEval = { ...osteopatiaEval };
            
            const prevList = selectedPatient.avaliacoesOsteopatia || [];
            let updatedArray;
            if (!finalEval.id) {
               finalEval.id = Date.now().toString();
               finalEval.data = new Date().toISOString().split('T')[0];
               updatedArray = [finalEval, ...prevList];
            } else {
               updatedArray = prevList.map(item => (item.id === finalEval.id || item === osteopatiaEval) ? finalEval : item);
            }
            updatePatientState({ ...selectedPatient, avaliacoesOsteopatia: updatedArray });
            setOsteopatiaEval(finalEval);
            showToast('Avaliação de Osteopatia salva!');
          };


          const handleNewPilatesEval = () => setPilatesEval(getEmptyPilatesEval());
          const handleVerPilatesEval = (item) => { setPilatesEval({...item}); window.scrollTo({ top: 300, behavior: 'smooth' }); };
          const handleDeletePilatesEval = (item) => {
             if(window.confirm('Excluir esta avaliação de Pilates?')) {
                 const cur = selectedPatient.avaliacoesPilates || [];
                 const updatedArray = cur.filter(a => a !== item);
                 updatePatientState({ ...selectedPatient, avaliacoesPilates: updatedArray });
                 if(pilatesEval.id === item.id) handleNewPilatesEval();
                 showToast('Avaliação excluída!', 'info');
             }
          };
          const handleSavePilatesEval = (e) => {
            e.preventDefault();
            let finalEval = { ...pilatesEval };
            const prevList = selectedPatient.avaliacoesPilates || [];
            let updatedArray;
            if (!finalEval.id) {
               finalEval.id = Date.now().toString();
               finalEval.data = new Date().toISOString().split('T')[0];
               updatedArray = [finalEval, ...prevList];
            } else {
               updatedArray = prevList.map(item => (item.id === finalEval.id || item === pilatesEval) ? finalEval : item);
            }
            updatePatientState({ ...selectedPatient, avaliacoesPilates: updatedArray });
            setPilatesEval({ ...getEmptyPilatesEval() });
            showToast('Avaliação de Pilates salva!');
          };

          const handleNewFisioEvol = () => setFisioEvol(getEmptyFisioEvol());
          const handleVerFisioEvol = (item) => { setFisioEvol({...item}); window.scrollTo({ top: 300, behavior: 'smooth' }); };
          const handleDeleteFisioEvol = (item) => {
             if(window.confirm('Excluir esta evolução de Fisio?')) {
                 const cur = selectedPatient.evolucoesFisio || [];
                 const updatedArray = cur.filter(a => a !== item);
                 updatePatientState({ ...selectedPatient, evolucoesFisio: updatedArray });
                 if(fisioEvol.id === item.id) handleNewFisioEvol();
                 showToast('Evolução excluída!', 'info');
             }
          };
          const handleSaveFisioEvol = (e) => {
            e.preventDefault();
            let finalEval = { ...fisioEvol };

            // Auto-deduct pacote para evolução individual assinada
            if (finalEval.assinaturaPaciente && !finalEval.pacoteDebitado) {
                const pName = (selectedPatient.nome || '').trim();
                if (decrementPackageForPatient(pName, finalEval.id || Date.now().toString())) {
                    finalEval.pacoteDebitado = true;
                }
            }

            const prevList = selectedPatient.evolucoesFisio || [];
            let updatedArray;
            if (!finalEval.id) {
               finalEval.id = Date.now().toString();
               finalEval.data = new Date().toISOString().split('T')[0];
               updatedArray = [finalEval, ...prevList];
            } else {
               updatedArray = prevList.map(item => (item.id === finalEval.id || item === fisioEvol) ? finalEval : item);
            }
            updatePatientState({ ...selectedPatient, evolucoesFisio: updatedArray });
            setFisioEvol(getEmptyFisioEvol());
            showToast('Sessão de Fisioterapia registrada!');
          };

          const handleNewOsteopatiaEvol = () => setOsteopatiaEvol(getEmptyOsteopatiaEvol());
          const handleVerOsteopatiaEvol = (item) => { setOsteopatiaEvol({...item}); window.scrollTo({ top: 300, behavior: 'smooth' }); };
          const handleDeleteOsteopatiaEvol = (item) => {
             if(window.confirm('Excluir esta evolução de Osteopatia?')) {
                 const cur = selectedPatient.evolucoesOsteopatia || [];
                 const updatedArray = cur.filter(a => a !== item);
                 updatePatientState({ ...selectedPatient, evolucoesOsteopatia: updatedArray });
                 if(osteopatiaEvol.id === item.id) handleNewOsteopatiaEvol();
                 showToast('Evolução excluída!', 'info');
             }
          };
          const handleSaveOsteopatiaEvol = (e) => {
            e.preventDefault();
            let finalEval = { ...osteopatiaEvol };

            const prevList = selectedPatient.evolucoesOsteopatia || [];
            let updatedArray;
            if (!finalEval.id) {
               finalEval.id = Date.now().toString();
               finalEval.data = new Date().toISOString().split('T')[0];
               updatedArray = [finalEval, ...prevList];
            } else {
               updatedArray = prevList.map(item => (item.id === finalEval.id || item === osteopatiaEvol) ? finalEval : item);
            }
            updatePatientState({ ...selectedPatient, evolucoesOsteopatia: updatedArray });
            setOsteopatiaEvol(getEmptyOsteopatiaEvol());
            showToast('Sessão de Osteopatia registrada!');
          };

          const handleNewPilatesEvol = () => setPilatesEvol({ ...getEmptyPilatesEvol(), instrutor: localStorage.getItem('RC_USERNAME') || '' });
          const handleVerPilatesEvol = (item) => { setPilatesEvol({...item}); window.scrollTo({ top: 300, behavior: 'smooth' }); };
          const handleDeletePilatesEvol = (item) => {
             if(window.confirm('Excluir esta evolução de Pilates?')) {
                 const cur = selectedPatient.evolucoesPilates || [];
                 const updatedArray = cur.filter(a => a !== item);
                 updatePatientState({ ...selectedPatient, evolucoesPilates: updatedArray });
                 if(pilatesEvol.id === item.id) handleNewPilatesEvol();
                 showToast('Sessão excluída!', 'info');
             }
          };
          const handleSavePilatesEvol = (e) => {
            e.preventDefault();
            setDualSignatureFlow({
              isOpen: true,
              fisioData: null,
              ptData: null,
              payload: { ...pilatesEvol }
            });
          };

          const persistPatientData = async (updatedPatient) => {
            const payload = normalizePatientForSave(updatedPatient);
            const pid = payload?.id;
            if (!isApiReady) {
              showToast('Não foi possível salvar (Servidor Offline)', 'error');
              return;
            }
            const res = await apiFetch('save_patient', payload);
            if (res && res.success) {
              const data = await apiFetch('get_data');
              if (data && data.patients) {
                setPatients(data.patients);
                const fresh = data.patients.find(p => String(p.id) === String(pid));
                if (fresh) {
                  setSelectedPatient(prev => (prev && String(prev.id) === String(pid)) ? { ...fresh, ...payload, isDetailsLoaded: true } : prev);
                }
              }
            } else {
              showToast('Erro ao sincronizar dados com o servidor.', 'error');
            }
          };

          const handleSaveNewPatient = async (e) => {
            e.preventDefault();
            if (!newPatient.nome) return; 

            if (!isApiReady) {
              showToast('Aguardando conexão com o servidor...', 'info');
              return;
            }

            const payload = normalizePatientForSave(newPatient);
            const res = await apiFetch('save_patient', payload);
            if (res && res.success) {
               const data = await apiFetch('get_data');
               if (data && data.patients) {
                 setPatients(data.patients);
                 const savedPatient = data.patients.find(p => p.id == (payload.id || res.id));
                 if (savedPatient) selectPatient(savedPatient);
               }
               setIsEditingPatient(false);
               setEditingPatientId(null);
               showToast('Paciente salvo com sucesso!');
            } else {
               showToast('Erro ao salvar paciente no servidor.', 'error');
            }
          };

          const updatePatientState = async (updatedPatient) => {
            const payload = normalizePatientForSave(updatedPatient);
            const pid = payload?.id;
            setPatients(prev => prev.map(p => String(p.id) === String(pid) ? { ...p, ...payload } : p));
            setSelectedPatient(prev => (prev && String(prev.id) === String(pid)) ? { ...prev, ...payload, isDetailsLoaded: true } : prev);

            if (!isApiReady) {
              showToast('Não foi possível salvar (Servidor Offline)', 'error');
              return;
            }
            const res = await apiFetch('save_patient', payload);
            if (res && res.success) {
              // Busca detalhes completos para não perder evoluções/avaliações (get_data retorna arrays vazios)
              try {
                const freshDetails = await apiFetch('get_patient_details&id=' + pid);
                if (freshDetails && !freshDetails.error) {
                  setPatients(prev => prev.map(p => String(p.id) === String(pid) ? { ...p, ...freshDetails } : p));
                  setSelectedPatient(prev => (prev && String(prev.id) === String(pid)) ? { ...freshDetails, isDetailsLoaded: true } : prev);
                } else {
                  // Fallback: mantém o estado otimista que já foi definido no início
                  setSelectedPatient(prev => (prev && String(prev.id) === String(pid)) ? { ...prev, ...payload, isDetailsLoaded: true } : prev);
                }
              } catch(e) {
                // Fallback silencioso: estado otimista já aplicado
              }
            } else {
              showToast('Falha ao salvar no banco. Recarregando...', 'error');
              // Restaura a verdade do banco
              try {
                const data = await apiFetch('get_data');
                if (data && data.patients) {
                  setPatients(data.patients);
                  const freshDetails = await apiFetch('get_patient_details&id=' + pid);
                  if (freshDetails && !freshDetails.error) {
                     setSelectedPatient({ ...freshDetails, isDetailsLoaded: true });
                  }
                }
              } catch(e) {}
            }
          };

          const deploymentModals = (
            <>
              {showInstallHelpModal && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[300] p-4 animate-fadeIn" onClick={() => setShowInstallHelpModal(false)}>
                  <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 border border-slate-200" onClick={(e) => e.stopPropagation()}>
                    <h3 className={`text-lg font-bold text-slate-800 mb-2 flex items-center gap-2`}><i className={`ph ph-apple-logo ${t.modalAccent}`}></i> Instalar no iPhone (Safari)</h3>
                    <ol className="text-sm text-slate-600 space-y-2 list-decimal list-inside mb-6">
                      <li>Toque no botão <b>Compartilhar</b> <span className="whitespace-nowrap">(quadrado com seta para cima)</span>.</li>
                      <li>Role e escolha <b>Adicionar à Tela de Início</b>.</li>
                      <li>Confirme com <b>Adicionar</b>.</li>
                    </ol>
                    <button type="button" onClick={() => setShowInstallHelpModal(false)} className={`w-full py-3 rounded-xl text-white font-bold shadow-md transition-colors ${t.btn}`}>Entendi</button>
                  </div>
                </div>
              )}
              {showManualInstallModal && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[300] p-4 animate-fadeIn" onClick={() => setShowManualInstallModal(false)}>
                  <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-6 border border-slate-200 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                    <h3 className={`text-lg font-bold text-slate-800 mb-3 flex items-center gap-2`}><i className={`ph ph-download-simple ${t.modalAccent} text-xl`}></i> Como instalar o app</h3>
                    <p className="text-sm text-slate-600 mb-4">Se o navegador não abriu a instalação automática, use um dos caminhos abaixo (Chrome ou Edge recomendados).</p>
                    <div className="space-y-4 text-sm text-slate-700 mb-6">
                      <div>
                        <p className="font-bold text-slate-800 mb-1 flex items-center gap-2"><i className="ph ph-desktop"></i> Computador</p>
                        <ul className="list-disc list-inside space-y-1 text-slate-600 pl-1">
                          <li>Verifique o <b>final da barra de endereços</b>: ícone de instalar <span className="whitespace-nowrap">(⊕ ou monitor com seta)</span> — clique e confirme.</li>
                          <li>Ou menu <b>⋮</b> → <b>Instalar Real Clínica…</b> / <b>Aplicativos</b> → <b>Instalar esta página como aplicativo</b>.</li>
                        </ul>
                      </div>
                      <div>
                        <p className="font-bold text-slate-800 mb-1 flex items-center gap-2"><i className="ph ph-device-mobile"></i> Android</p>
                        <ul className="list-disc list-inside space-y-1 text-slate-600 pl-1">
                          <li>Menu <b>⋮</b> → <b>Instalar aplicativo</b> ou <b>Adicionar à tela inicial</b>.</li>
                        </ul>
                      </div>
                      <p className="text-xs text-slate-500 border-t border-slate-100 pt-3">A instalação exige <b>HTTPS</b> e um service worker ativo. Atualize a página (F5), aguarde alguns segundos e tente de novo.</p>
                    </div>
                    <button type="button" onClick={() => setShowManualInstallModal(false)} className={`w-full py-3 rounded-xl text-white font-bold shadow-md transition-colors ${t.btn}`}>Fechar</button>
                  </div>
                </div>
              )}
              {showVersionUpdateModal && (
                <div className="fixed inset-0 z-[350] flex items-center justify-center p-4 animate-fadeIn" role="presentation">
                  <div className="absolute inset-0 bg-slate-950/60 backdrop-blur-[3px]" aria-hidden="true" />
                  <div
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="deploy-update-title"
                    className="relative w-full max-w-[440px] overflow-hidden rounded-2xl bg-white shadow-[0_24px_48px_-12px_rgba(15,23,42,0.35)] ring-1 ring-slate-900/5"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className={`h-1.5 w-full ${t.btn}`} aria-hidden="true" />
                    <div className="px-8 pt-7 pb-8">
                      <div className="flex gap-4">
                        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-slate-100 ring-1 ring-slate-200/80">
                          <i className={`ph ph-arrows-clockwise text-[28px] ${t.modalAccent}`} aria-hidden="true"></i>
                        </div>
                        <div className="min-w-0 flex-1 pt-0.5">
                          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-400">Sincronização</p>
                          <h3 id="deploy-update-title" className="mt-1 text-xl font-semibold tracking-tight text-slate-900">
                            Nova versão no servidor
                          </h3>
                          {newVersionLabel ? (
                            <p className="mt-2 inline-flex items-center rounded-md bg-slate-50 px-2.5 py-1 font-mono text-[11px] font-medium text-slate-600 ring-1 ring-slate-200/60">
                              {newVersionLabel}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      <div className="mt-6 rounded-xl border border-slate-100 bg-slate-50/90 px-5 py-4">
                        <p className="text-sm leading-relaxed text-slate-600">
                          Publicamos uma atualização na hospedagem. Ao continuar, a página será recarregada com os arquivos mais recentes.
                        </p>
                        <div className="mt-4 flex gap-3 rounded-lg border border-amber-200/80 bg-amber-50/80 px-3.5 py-3">
                          <i className="ph ph-shield-warning shrink-0 text-lg text-amber-700/90 mt-0.5" aria-hidden="true"></i>
                          <p className="text-xs leading-relaxed text-amber-950/80">
                            <span className="font-semibold text-amber-950">Segurança:</span> por precaução, será necessário <strong className="font-semibold text-amber-950">entrar novamente</strong> após a atualização.
                          </p>
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={applyDeploymentUpdate}
                        className={`mt-6 flex w-full items-center justify-center gap-2 rounded-xl py-3.5 text-[15px] font-semibold text-white shadow-md transition-all hover:brightness-105 active:scale-[0.99] ${t.btn}`}
                      >
                        <i className="ph ph-download-simple text-lg" aria-hidden="true"></i>
                        Atualizar agora
                      </button>
                      <p className="mt-4 text-center text-[11px] text-slate-400">
                        Recomenda-se concluir qualquer cadastro em andamento antes de atualizar.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </>
          );

          if (remoteSessionSuccess) {
            return (
              <div className="font-sans min-h-screen bg-slate-100 flex flex-col items-center justify-center py-8 px-4">
                <div className="bg-white p-8 rounded-3xl shadow-xl w-full max-w-md border border-slate-200 text-center animate-fadeIn">
                  <span className="flex h-24 w-24 items-center justify-center rounded-full bg-emerald-100 text-emerald-600 mx-auto mb-6 shadow-sm ring-8 ring-emerald-50">
                    <i className="ph ph-check-circle text-6xl"></i>
                  </span>
                  <h2 className="text-3xl font-black text-slate-800 mb-3">Tudo certo!</h2>
                  <p className="text-slate-600 font-medium text-lg leading-relaxed">Sua presença foi confirmada e sua biometria foi salva na clínica.</p>
                  <div className="mt-10 p-4 bg-slate-50 border border-slate-100 rounded-xl">
                    <p className="text-sm font-bold text-slate-500 uppercase tracking-wide">Você já pode fechar esta página</p>
                  </div>
                </div>
              </div>
            );
          }

          if (remoteSessionInvalid) {
            return (
              <div className="font-sans min-h-screen bg-slate-100 flex flex-col items-center justify-center py-8 px-4">
                <div className="bg-white p-8 rounded-3xl shadow-xl w-full max-w-md border border-slate-200 text-center animate-fadeIn">
                  <span className="flex h-24 w-24 items-center justify-center rounded-full bg-red-50 text-red-500 mx-auto mb-6 shadow-sm ring-8 ring-red-50/50">
                    <i className="ph ph-x-circle text-6xl"></i>
                  </span>
                  <h2 className="text-3xl font-black text-slate-800 mb-3">Link Expirado</h2>
                  <p className="text-slate-600 font-medium text-lg leading-relaxed">Este link já foi utilizado ou não é mais válido.</p>
                  <div className="mt-10 p-4 bg-slate-50 border border-slate-100 rounded-xl">
                    <p className="text-sm font-bold text-slate-500 uppercase tracking-wide">Você pode fechar esta página</p>
                  </div>
                </div>
              </div>
            );
          }

          if (remoteSessionLoading) {
            return (
              <div className="font-sans min-h-screen bg-slate-100 flex flex-col items-center justify-center py-8 px-4">
                <div className="w-8 h-8 md:w-10 md:h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mb-4"></div>
                <p className="text-slate-600 font-semibold animate-pulse">Carregando sessão do paciente...</p>
              </div>
            );
          }

          if (remoteAppointmentResponse) {
            const isPos = remoteAppointmentResponse === 'confirmed';
            return (
              <div className="font-sans min-h-screen bg-slate-100 flex flex-col items-center justify-center py-8 px-4">
                <div className="bg-white p-8 rounded-3xl shadow-xl w-full max-w-md border border-slate-200 text-center animate-fadeIn">
                  <span className={`flex h-24 w-24 items-center justify-center rounded-full mx-auto mb-6 shadow-sm ring-8 ${isPos ? 'bg-emerald-100 text-emerald-600 ring-emerald-50' : 'bg-red-50 text-red-500 ring-red-50/50'}`}>
                    <i className={`ph ${isPos ? 'ph-check-circle' : 'ph-x-circle'} text-6xl`}></i>
                  </span>
                  <h2 className="text-3xl font-black text-slate-800 mb-3">{isPos ? 'Tudo certo!' : 'Recebido'}</h2>
                  <p className="text-slate-600 font-medium text-lg leading-relaxed">
                    {isPos 
                      ? 'Sua presença foi confirmada. Esperamos você na clínica!' 
                      : 'Sua ausência foi comunicada à clínica. Obrigado pelo aviso.'}
                  </p>
                  <div className="mt-10 p-4 bg-slate-50 border border-slate-100 rounded-xl">
                    <p className="text-sm font-bold text-slate-500 uppercase tracking-wide">Você já pode fechar esta página</p>
                  </div>
                </div>
              </div>
            );
          }

          if (confirmAppointmentCtx) {
            return (
              <div className="font-sans min-h-screen bg-slate-100 flex flex-col items-center justify-center py-8 px-4">
                 <div className="w-full max-w-md mb-8 flex justify-center">
                  {(theme.logoUrl || defaultLogoPath) ? (
                    <img src={theme.logoUrl || defaultLogoPath} alt="Real Clínica" className="w-48 h-auto object-contain drop-shadow-sm" />
                  ) : null}
                </div>
                <AppointmentConfirmFlow 
                  context={confirmAppointmentCtx} 
                  onResponse={handleAppointmentResponse} 
                />
              </div>
            );
          }

          if (presenceFlowCtx && presenceFlowCtx.remoteToken) {
            return (
              <div className="font-sans min-h-screen bg-slate-100 flex flex-col items-center justify-start py-8 px-4">
                <div className="w-full max-w-md mb-6 flex justify-center">
                  {(theme.logoUrl || defaultLogoPath) ? (
                    <img 
                      src={theme.logoUrl || defaultLogoPath} 
                      alt="Real Clínica Integrada" 
                      className="w-48 h-auto object-contain drop-shadow-sm" 
                    />
                  ) : null}
                </div>
                <ConfirmPresenceFlow
                  open={true}
                  context={presenceFlowCtx}
                  onClose={() => {}}
                  onSaved={handlePresenceSaved}
                  onShowToast={showToast}
                />
                <div className="toast-container fixed bottom-4 right-4 z-50">
                  {toasts.map(toast => (
                    <div key={toast.id} className={`toast toast-${toast.type} bg-white shadow-lg rounded-xl p-4 mb-2 flex items-center border border-slate-200`}>
                      <div className="flex-1 font-semibold text-sm">{toast.message}</div>
                    </div>
                  ))}
                </div>
              </div>
            );
          }

          if (!isAuthenticated) {
            return (
              <>
              <div className="flex items-center justify-center h-screen bg-slate-100 font-sans">
                <div className="bg-white p-10 rounded-2xl shadow-xl w-full max-w-md border border-slate-200">
                  <div className="flex flex-col items-center mb-6">
                    
                    {(theme.logoUrl || defaultLogoPath) ? (
                      <img 
                        src={theme.logoUrl || defaultLogoPath} 
                        alt="Real Clínica Integrada" 
                        className="w-64 h-auto object-contain mb-4 drop-shadow-sm" 
                        onError={() => setTheme({...theme, logoUrl: null})}
                      />
                    ) : (
                      <div className="flex flex-col items-center mb-4 text-emerald-600">
                        <i className="ph ph-pulse text-[48px]"></i>
                        <h1 className="text-2xl font-bold text-slate-800 mt-2">Real Clínica</h1>
                      </div>
                    )}
                    
                    <p className="text-slate-500 text-sm mt-1">
                      {resetTokenUrl ? 'Crie uma nova senha para sua conta' : isForgotPassword ? 'Recuperação de senha' : 'Faça login para acessar o sistema'}
                    </p>
                  </div>
                  
                  {resetTokenUrl ? (
                    <form onSubmit={handleResetPasswordSubmit} className="space-y-6">
                      <InputGroup 
                        label="Nova senha" 
                        type="password" 
                        value={resetNewPass} 
                        onChange={(e) => setResetNewPass(e.target.value)} 
                        placeholder="Mínimo 4 caracteres" 
                        required 
                      />
                      <InputGroup 
                        label="Confirmar nova senha" 
                        type="password" 
                        value={resetConfirmPass} 
                        onChange={(e) => setResetConfirmPass(e.target.value)} 
                        placeholder="Repita a senha" 
                        required 
                      />
                      <button type="submit" disabled={resetSubmitting} className={`w-full text-white font-bold py-3 px-4 rounded-lg transition-colors shadow-md mt-2 disabled:opacity-60 ${t.btn}`}>
                        {resetSubmitting ? 'Salvando…' : 'Salvar nova senha'}
                      </button>
                      <div className="text-center mt-4">
                        <button type="button" onClick={clearResetTokenFromUrl} className="text-sm font-semibold text-slate-500 hover:text-emerald-600 transition-colors">
                          Voltar para o login
                        </button>
                      </div>
                    </form>
                  ) : isForgotPassword ? (
                    <form onSubmit={handleForgotPassword} className="space-y-6">
                      <InputGroup 
                        label="E-mail cadastrado" 
                        type="email" 
                        value={loginData.email} 
                        onChange={(e) => setLoginData({...loginData, email: e.target.value})} 
                        placeholder="seu@email.com" 
                        required 
                      />
                      <p className="text-xs text-slate-500 -mt-2">O link é enviado pelo servidor usando o e-mail configurado em <strong>Configurações → SMTP</strong>.</p>
                      <button type="submit" disabled={forgotSending} className={`w-full text-white font-bold py-3 px-4 rounded-lg transition-colors shadow-md mt-2 disabled:opacity-60 ${t.btn}`}>
                        {forgotSending ? 'Enviando…' : 'Enviar link de recuperação'}
                      </button>
                      <div className="text-center mt-4">
                        <button type="button" onClick={() => setIsForgotPassword(false)} className="text-sm font-semibold text-slate-500 hover:text-emerald-600 transition-colors">
                          Voltar para o login
                        </button>
                      </div>
                    </form>
                  ) : (
                    <form onSubmit={handleLogin} className="space-y-6">
                      <InputGroup 
                        label="E-mail de acesso" 
                        type="email" 
                        value={loginData.email} 
                        onChange={(e) => setLoginData({...loginData, email: e.target.value})} 
                        placeholder="seu@email.com" 
                        required 
                      />
                      <div className="space-y-1">
                        <InputGroup 
                          label="Senha" 
                          type="password" 
                          value={loginData.password} 
                          onChange={(e) => setLoginData({...loginData, password: e.target.value})} 
                          placeholder="••••••••" 
                          required 
                        />
                        <div className="flex justify-end">
                          <button type="button" onClick={() => setIsForgotPassword(true)} className="text-xs font-semibold text-emerald-600 hover:text-emerald-700 hover:underline">
                            Esqueci minha senha
                          </button>
                        </div>
                      </div>
                      <button type="submit" className={`w-full text-white font-bold py-3 px-4 rounded-lg transition-colors shadow-md mt-2 ${t.btn}`}>
                        Entrar no Sistema
                      </button>
                    </form>
                  )}
                  
                </div>
              </div>
              <ConfirmPresenceFlow
                open={!!presenceFlowCtx}
                context={presenceFlowCtx}
                onClose={() => setPresenceFlowCtx(null)}
                onSaved={handlePresenceSaved}
                onShowToast={showToast}
              />
              <div className="toast-container">
                {toasts.map((toast) => (
                  <div key={toast.id} className={`toast toast-${toast.type}`}>
                    <div className="flex-shrink-0">
                      {toast.type === 'success' && <i className="ph ph-check-circle text-2xl"></i>}
                      {toast.type === 'error' && <i className="ph ph-warning-circle text-2xl"></i>}
                      {toast.type === 'info' && <i className="ph ph-info text-2xl"></i>}
                    </div>
                    <div className="flex-1 font-semibold text-sm">{toast.message}</div>
                    <button type="button" onClick={() => setToasts((prev) => prev.filter((t) => t.id !== toast.id))} className="text-white/60 hover:text-white transition-colors">
                      <i className="ph ph-x text-lg"></i>
                    </button>
                  </div>
                ))}
              </div>
              {deploymentModals}
              </>
            );
          }

           return (
             <div className="flex h-screen bg-slate-50 font-sans text-slate-800 overflow-hidden relative">
               
               {/* Mobile Header */}
               <div className="md:hidden fixed top-0 left-0 right-0 h-16 bg-white border-b flex items-center justify-between px-4 z-[40]">
                 <button onClick={() => setIsMenuOpen(true)} className="p-2 text-slate-600 hover:bg-slate-100 rounded-lg">
                   <i className="ph ph-list text-[28px]"></i>
                 </button>
                 <img src={theme.logoUrl || defaultLogoPath} alt="Logo" className="h-10 object-contain" />
                 <div className="w-10"></div> {/* Spacer */}
               </div>
 
               {/* Mobile Overlay */}
               {isMenuOpen && (
                 <div 
                   className="md:hidden fixed inset-0 bg-black/50 z-[45] animate-fadeIn" 
                   onClick={() => setIsMenuOpen(false)}
                 ></div>
               )}
               
               <div className={`
                 fixed md:static inset-y-0 left-0 w-64 text-white flex flex-col shadow-xl z-[50] transition-all duration-300 
                 ${t.sidebar} 
                 ${isMenuOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
               `}>
                 
                 <div className={`p-4 border-b transition-colors duration-300 ${t.sidebarBorder} flex flex-col items-center justify-center relative`}>
                   {/* Mobile Close Button */}
                   <button onClick={() => setIsMenuOpen(false)} className="md:hidden absolute top-4 right-4 text-white/70 hover:text-white">
                     <i className="ph ph-x text-[24px]"></i>
                   </button>
 
                   {(theme.logoUrl || defaultLogoPath) ? (
                     <div className="bg-white rounded-xl p-1 w-full flex items-center justify-center shadow-sm">
                       <img 
                         src={theme.logoUrl || defaultLogoPath} 
                         alt="Logo da Clínica" 
                         className="h-20 w-full object-contain" 
                         onError={() => setTheme({...theme, logoUrl: null})}
                       />
                     </div>
                   ) : (
                     <h1 className="text-xl font-bold flex items-center gap-2">
                       <i className={`ph ph-pulse ${t.icon}`}></i>
                       Real Clínica
                     </h1>
                   )}
                 </div>
                 
                 <nav className="flex-1 mt-4 overflow-y-auto rc-sidebar-scroll min-h-0">
                    <button onClick={() => { setActiveTab('list'); setSelectedPatient(null); setIsMenuOpen(false); }}
                      className={`w-full flex items-center gap-3 px-6 py-3 transition-colors ${activeTab === "list" && !selectedPatient ? t.sidebarActive : "hover:bg-black/20 text-white/80"}`}
                    >
                      <i className="ph ph-users text-[20px]"></i> Lista de Pacientes
                    </button>

                    <button onClick={() => { setActiveTab('fisioterapia'); setSelectedPatient(null); setIsMenuOpen(false); }}
                      className={`w-full flex items-center gap-3 px-6 py-3 transition-colors ${activeTab === "fisioterapia" && !selectedPatient ? t.sidebarActive : "hover:bg-black/20 text-white/80"}`}
                    >
                      <i className="ph ph-stethoscope text-[20px]"></i> Alunos Fisioterapia
                    </button>

                    <button onClick={() => { setActiveTab('pilates'); setSelectedPatient(null); setIsMenuOpen(false); }}
                      className={`w-full flex items-center gap-3 px-6 py-3 transition-colors ${activeTab === "pilates" && !selectedPatient ? t.sidebarActive : "hover:bg-black/20 text-white/80"}`}
                    >
                      <i className="ph ph-hand-heart text-[20px]"></i> Alunos de Pilates
                    </button>

                    {(!usuarioRestritoComoFisio(currentUser)) && (
                    <button onClick={() => { setActiveTab('agenda'); setSelectedPatient(null); setIsMenuOpen(false); }}
                      className={`w-full flex items-center gap-3 px-6 py-3 transition-colors ${activeTab === "agenda" && !selectedPatient ? t.sidebarActive : "hover:bg-black/20 text-white/80"}`}
                    >
                      <i className="ph ph-calendar text-[20px]"></i> Agenda
                    </button>
                    )}

                    <button onClick={() => { setActiveTab('fila_hoje'); setSelectedPatient(null); setIsMenuOpen(false); }}
                      className={`w-full flex items-center gap-3 px-6 py-3 transition-colors ${activeTab === "fila_hoje" && !selectedPatient ? t.sidebarActive : "hover:bg-black/20 text-white/80"}`}
                    >
                      <i className="ph ph-list-numbers text-[20px]"></i> Fila de Hoje
                    </button>

                    {(!usuarioRestritoComoFisio(currentUser)) && (
                    <button onClick={() => { setActiveTab('presencas'); setSelectedPatient(null); setIsMenuOpen(false); }}
                      className={`w-full flex items-center gap-3 px-6 py-3 transition-colors ${activeTab === "presencas" && !selectedPatient ? t.sidebarActive : "hover:bg-black/20 text-white/80"}`}
                    >
                      <i className="ph ph-clipboard-text text-[20px]"></i> Registro de Presenças
                    </button>
                    )}

                    {(!usuarioRestritoComoFisio(currentUser)) && (
                    <button onClick={() => { setActiveTab('financeiro'); setSelectedPatient(null); setIsMenuOpen(false); }}
                      className={`w-full flex items-center gap-3 px-6 py-3 transition-colors ${activeTab === "financeiro" && !selectedPatient ? t.sidebarActive : "hover:bg-black/20 text-white/80"}`}
                    >
                      <i className="ph ph-chart-line-up text-[20px]"></i> Financeiro
                    </button>
                    )}

                    {birthdayPatients.length > 0 && (
                    <button onClick={() => { setActiveTab('birthday'); setSelectedPatient(null); setIsMenuOpen(false); }}
                      className={`w-full flex items-center justify-between px-6 py-3 transition-colors ${activeTab === "birthday" ? t.sidebarActive : "hover:bg-black/20 text-white/80"}`}
                    >
                      <div className="flex items-center gap-3">
                        <i className="ph ph-cake text-[20px]"></i> Aniversariantes
                      </div>
                      {birthdayPatients.length > 0 && (
                        <span className="bg-rose-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full animate-pulse">
                          {birthdayPatients.length}
                        </span>
                      )}
                    </button>
                    )}
                    {(!usuarioRestritoComoFisio(currentUser)) && (
                     <button onClick={() => { setActiveTab('settings'); setSelectedPatient(null); setIsMenuOpen(false); }}
                       className={`w-full flex items-center gap-3 px-6 py-3 transition-colors ${activeTab === 'settings' && !selectedPatient ? t.sidebarActive : 'hover:bg-black/20 text-white/80'}`}>
                       <i className="ph ph-gear text-[20px]"></i> Configurações
                     </button>
                    )}
                   
                   {selectedPatient && (
                     <div className="mt-6">
                       <div className={`px-6 mb-2 text-xs font-bold uppercase tracking-wider transition-colors duration-300 ${t.icon}`}>Paciente Selecionado</div>
                       <div className="px-6 py-2 bg-black/20 flex items-center gap-3">
                         <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center font-bold">
                           {selectedPatient.nome.charAt(0)}
                         </div>
                         <div className="truncate text-sm font-medium">{selectedPatient.nome.split(' ')[0]} {selectedPatient.nome.split(' ')[1]}</div>
                       </div>
 
                       <div className="mt-2 space-y-1">
                         <button onClick={() => { setActiveTab('dashboard'); setPatientSubTab('perfil'); setIsMenuOpen(false); }}
                           className={`w-full flex items-center gap-3 px-6 py-2 text-sm transition-colors ${patientSubTab === 'perfil' ? t.sidebarActive : 'hover:bg-black/20 text-white/80'}`}>
                           <i className="ph ph-user text-[16px]"></i> Cadastro
                         </button>
                         <button onClick={() => { setActiveTab('dashboard'); setPatientSubTab('fisio_aval'); setIsMenuOpen(false); }}
                           className={`w-full flex items-center gap-3 px-6 py-2 text-sm transition-colors ${patientSubTab === 'fisio_aval' ? 'bg-emerald-800 border-l-4 border-emerald-400' : 'hover:bg-emerald-800 text-emerald-200'}`}>
                           <i className="ph ph-stethoscope text-[16px]"></i> Prontuário Fisio
                         </button>
                         <button onClick={() => { setActiveTab('dashboard'); setPatientSubTab('pilates_aval'); setIsMenuOpen(false); }}
                           className={`w-full flex items-center gap-3 px-6 py-2 text-sm transition-colors ${patientSubTab === 'pilates_aval' ? 'bg-emerald-800 border-l-4 border-emerald-400' : 'hover:bg-emerald-800 text-emerald-200'}`}>
                           <i className="ph ph-clipboard text-[16px]"></i> Avaliação Pilates
                         </button>
                          <button onClick={() => { setActiveTab('dashboard'); setPatientSubTab('fisio_evol'); setIsMenuOpen(false); }}
                            className={`w-full flex items-center gap-3 px-6 py-2 text-sm transition-colors ${patientSubTab === 'fisio_evol' ? 'bg-emerald-800 border-l-4 border-emerald-400' : 'hover:bg-emerald-800 text-emerald-200'}`}>
                            <i className="ph ph-file-plus text-[16px]"></i> Avaliação Osteopática
                          </button>
                          <button onClick={() => { setActiveTab('dashboard'); setPatientSubTab('pilates_evol'); setIsMenuOpen(false); }}
                            className={`w-full flex items-center gap-3 px-6 py-2 text-sm transition-colors ${patientSubTab === 'pilates_evol' ? 'bg-emerald-800 border-l-4 border-emerald-400' : 'hover:bg-emerald-800 text-emerald-200'}`}>
                            <i className="ph ph-pulse text-[16px]"></i> Ficha Evol. Pilates
                          </button>
                       </div>
                     </div>
                   )}
                 </nav>
                
                <div className={`p-4 border-t transition-colors duration-300 ${t.sidebarBorder}`}>
                  {!displayStandalone && !sidebarInstallDismissed && (
                    <div className="relative mb-3">
                    <button
                      type="button"
                      onClick={() => void handleInstallApp()}
                      className={`w-full rounded-xl active:scale-[0.99] flex items-center gap-3 pl-3 pr-10 py-3 text-left transition-all shadow-lg border group ${t.installCta}`}
                    >
                      <div className={`flex-shrink-0 w-11 h-11 rounded-lg flex items-center justify-center shadow-inner ${t.installCtaIcon}`}>
                        <i className="ph ph-device-mobile text-2xl text-white"></i>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="text-white font-extrabold text-[11px] tracking-wider uppercase leading-tight">Baixar app</div>
                        <div className={`${t.installCtaSub} text-[11px] leading-snug mt-0.5`}>Web, celular e versão escritório</div>
                      </div>
                      <i className={`ph ph-caret-right ${t.installCtaCaret} text-xl flex-shrink-0 group-hover:translate-x-0.5 transition-transform`}></i>
                    </button>
                    <button
                      type="button"
                      aria-label="Ocultar baixar app"
                      onClick={dismissSidebarInstallCta}
                      className="absolute top-2 right-2 z-10 flex h-8 w-8 items-center justify-center rounded-lg text-white/75 transition-colors hover:bg-white/15 hover:text-white"
                    >
                      <i className="ph ph-x text-lg leading-none" aria-hidden="true"></i>
                    </button>
                    </div>
                  )}
                  <div className="flex items-center gap-3 px-2 mb-4">
                    <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center font-bold shadow-inner">
                      {currentUser?.nome?.charAt(0) || 'U'}
                    </div>
                    <div className="text-sm truncate flex-1">
                      <p className="font-bold text-white">{currentUser?.nome || 'Usuário'}</p>
                      <p className="text-xs text-emerald-200">{formatNiveisLabel(currentUser?.nivel)}</p>
                    </div>
                  </div>
                  <button onClick={handleLogout} className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-black/20 hover:bg-red-500/80 rounded-lg transition-colors text-sm font-semibold shadow-sm">
                    <i className="ph ph-sign-out text-[16px]"></i> Sair do Sistema
                  </button>
                </div>
              </div>

               <div className="flex-1 overflow-auto bg-slate-50 pt-16 md:pt-0">
                 
                 {/* PWA Install Banner */}
                 {showInstallBanner && (
                   <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] w-[90%] max-w-md animate-slideUp">
                     <div className="bg-slate-800 text-white p-4 rounded-2xl shadow-2xl border border-white/10 flex items-center gap-4">
                       <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center flex-shrink-0">
                         <img src={theme.logoUrl || defaultLogoPath} alt="Logo" className="w-10 h-10 object-contain" />
                       </div>
                       <div className="flex-1">
                         <h4 className="font-bold text-sm">Real Clínica Integrada</h4>
                         <p className="text-xs text-slate-300">Instale nosso app para acesso rápido!</p>
                       </div>
                       <div className="flex gap-2">
                         <button onClick={() => setShowInstallBanner(false)} className="px-3 py-1 text-xs font-bold hover:bg-white/10 rounded-lg">Depois</button>
                         <button onClick={handleInstallApp} className={`px-4 py-2 text-white text-xs font-bold rounded-lg shadow-lg transition-colors ${t.btn}`}>Baixar App</button>
                       </div>
                     </div>
                   </div>
                 )}
                
                {activeTab === 'pilates' && (
                  <div className="p-4 md:p-8">
                    <div className="flex justify-between items-center mb-6">
                      <h2 className="text-2xl font-bold text-slate-800">Alunos de Pilates</h2>
                      <button type="button" onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setPilatesEnrollForm({ patientId: '', valorMensalidade: '150.00', diaVencimento: '10', diasSemana: [], horario: '' });
                        setPilatesEnrollSearch('');
                        setPilatesEnrollOpen(true);
                      }} className="flex items-center gap-2 px-4 py-2 bg-emerald-600 text-white rounded-xl font-bold hover:bg-emerald-700 transition-colors shadow-sm shadow-emerald-200">
                        <i className="ph ph-plus-circle text-lg"></i> <span className="hidden sm:inline">Adicionar Aluno</span>
                      </button>
                    </div>

                    <div className="mb-6 relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <i className="ph ph-magnifying-glass text-[20px] text-slate-400"></i>
                      </div>
                      <input
                        type="text"
                        className="block w-full pl-10 pr-3 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 shadow-sm transition-shadow"
                        placeholder="Buscar aluno de Pilates pelo nome..."
                        value={searchTerm}
                        onChange={(e) => { setSearchTerm(e.target.value); setPagePilates(1); }}
                      />
                    </div>

                    <div className="grid gap-4">
                      {(() => {
                        const filteredPilates = patientsVisiveis.filter(p => (p.faz_pilates || p.pilates_cancelado_em || p.pilates_suspenso_em) && (p.nome || '').toLowerCase().includes((searchTerm || '').toLowerCase()));
                        const totalPilates = filteredPilates.length;
                        const pilatesPage = filteredPilates.slice((pagePilates - 1) * limitPilates, pagePilates * limitPilates);
                        
                        if (pilatesPage.length === 0) {
                          return (
                            <div className="text-center py-10 bg-white rounded-xl border border-slate-200 text-slate-500">
                              Nenhum aluno de Pilates encontrado.
                            </div>
                          );
                        }
                        
                        return (
                          <>
                            {pilatesPage.map(patient => {
                              const pilatesInativo = !patient.faz_pilates && !!patient.pilates_cancelado_em;
                          const pilatesSuspenso = !patient.faz_pilates && !!patient.pilates_suspenso_em && !patient.pilates_cancelado_em;
                          return (
                          <div key={patient.id} 
                            className={`p-4 md:p-5 rounded-xl border shadow-sm transition-all flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 group overflow-hidden max-w-full ${pilatesInativo ? 'bg-amber-50/60 border-amber-200' : pilatesSuspenso ? 'bg-yellow-50/70 border-yellow-300' : 'bg-white border-slate-200 hover:shadow-md'}`}>
                            <div className="flex items-center gap-4 cursor-pointer flex-1 min-w-0" onClick={() => { setActiveTab('dashboard'); setSelectedPatient(patient); setPatientSubTab('perfil'); }}>
                              <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg flex-shrink-0 ${pilatesInativo ? 'bg-amber-100 text-amber-800' : pilatesSuspenso ? 'bg-yellow-100 text-yellow-700' : 'bg-emerald-100 text-emerald-700'}`}>
                                {pilatesSuspenso ? <i className="ph ph-pause-circle text-2xl"></i> : patient.nome.charAt(0)}
                              </div>
                              <div className="min-w-0 flex-1">
                                <h3 className={`font-bold text-lg truncate transition-colors ${pilatesInativo ? 'line-through text-slate-500' : pilatesSuspenso ? 'text-slate-700' : 'text-slate-800 group-hover:text-emerald-600'}`}>{patient.nome}</h3>
                                {pilatesInativo ? (
                                  <p className="text-[11px] font-bold text-amber-800 mt-0.5">Matrícula cancelada em {patient.pilates_cancelado_em}</p>
                                ) : null}
                                {pilatesSuspenso ? (
                                  <div className="mt-0.5">
                                    <p className="text-[11px] font-bold text-yellow-700">
                                      ⏸ Tratamento suspenso desde {patient.pilates_suspenso_em}
                                      {patient.pilates_retorno_previsto ? ` · Retorno previsto: ${patient.pilates_retorno_previsto}` : ''}
                                    </p>
                                    {patient.pilates_motivo_suspensao && (
                                      <p className="text-[11px] text-slate-500 mt-0.5 truncate">Motivo: {patient.pilates_motivo_suspensao}</p>
                                    )}
                                  </div>
                                ) : null}
                                <div className="flex flex-wrap items-center gap-2 mt-0.5">
                                  <span className={`text-xs font-semibold ${pilatesInativo ? 'text-amber-800' : pilatesSuspenso ? 'text-yellow-700' : 'text-emerald-700'}`}>Vence dia {patient.dia_vencimento_pilates || '--'}</span>
                                  {patient.horario_pilates && <span className="text-xs bg-slate-100 text-slate-600 font-semibold px-2 py-0.5 rounded-full flex items-center gap-1"><i className="ph ph-clock"></i> {patient.horario_pilates}</span>}
                                  {patient.dias_semana_pilates && patient.dias_semana_pilates.split(',').map(d => (
                                    <span key={d} className={`text-xs font-bold px-2 py-0.5 rounded-full ${pilatesInativo ? 'bg-amber-100 text-amber-900' : pilatesSuspenso ? 'bg-yellow-100 text-yellow-800' : 'bg-emerald-100 text-emerald-700'}`}>{d}</span>
                                  ))}
                                </div>
                              </div>
                            </div>
                            
                            <div className="flex items-center justify-end gap-2 flex-wrap pt-3 sm:pt-0 border-t sm:border-t-0 border-slate-100 shrink-0">
                              {(pilatesInativo || pilatesSuspenso) ? (
                                <>
                                  <button
                                    type="button"
                                    onClick={(e) => { e.stopPropagation(); setReativarModal({ open: true, patient, tipo: 'pilates' }); }}
                                    className="flex items-center justify-center gap-2 px-4 py-2.5 bg-emerald-600 text-white rounded-xl hover:bg-emerald-700 transition-colors shadow-sm font-bold text-sm"
                                    title="Reativar matrícula no Pilates"
                                  >
                                    <i className="ph ph-arrow-u-up-left text-lg"></i> Reativar
                                  </button>
                                  {(!usuarioRestritoComoFisio(currentUser)) && (
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setPilatesHistoryModal({ open: true, patientId: patient.id, pacienteNome: patient.nome });
                                      }}
                                      className="flex items-center justify-center p-2.5 bg-blue-50 text-blue-700 rounded-xl hover:bg-blue-100 transition-colors"
                                      title="Histórico de presenças"
                                    >
                                      <i className="ph ph-clock-counter-clockwise text-lg"></i>
                                    </button>
                                  )}
                                </>
                              ) : (
                                <>
                                  {(!usuarioRestritoComoFisio(currentUser)) && (
                                    <>
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSuspenderFisioModal({ open: true, patient, motivo: '', dataRetorno: '', tipo: 'pilates' });
                                        }}
                                        className="flex items-center justify-center p-2.5 bg-amber-50 text-amber-700 rounded-xl hover:bg-amber-100 transition-colors"
                                        title="Suspender Tratamento (Pausa Temporária)"
                                      >
                                        <i className="ph ph-pause-circle text-lg"></i>
                                      </button>
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setFinModalForm({ id: null, tipo: 'receita', descricao: `Pilates - Adiantamento - ${patient.nome}`, valor: patient.valor_mensalidade_pilates || '150.00', data: new Date().toISOString().split('T')[0], categoria: 'Pilates', metodo: '', status: 'pago', recorrente: false });
                                          setFinModalOpen(true);
                                        }}
                                        className="flex items-center justify-center p-2.5 bg-slate-100 text-slate-700 rounded-xl hover:bg-slate-200 transition-colors"
                                        title="Adiantar Pagamento"
                                      >
                                        <i className="ph ph-currency-circle-dollar text-lg"></i>
                                      </button>

                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setPilatesEnrollForm({
                                            patientId: String(patient.id),
                                            valorMensalidade: patient.valor_mensalidade_pilates || '150.00',
                                            diaVencimento: patient.dia_vencimento_pilates || '10',
                                            diasSemana: patient.dias_semana_pilates ? patient.dias_semana_pilates.split(',').map(d => d.trim()) : [],
                                            horario: patient.horario_pilates || '',
                                            professionalId: String(patient.fisio1_id || '')
                                          });
                                          setPilatesEnrollSearch(patient.nome);
                                          setPilatesEnrollOpen(true);
                                        }}
                                        className="flex items-center justify-center p-2.5 bg-violet-50 text-violet-700 rounded-xl hover:bg-violet-100 transition-colors"
                                        title="Editar Dados do Pilates"
                                      >
                                        <i className="ph ph-pencil-simple text-lg"></i>
                                      </button>
                                    </>
                                  )}

                              {(!usuarioRestritoComoFisio(currentUser)) && (
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setPilatesHistoryModal({ open: true, patientId: patient.id, pacienteNome: patient.nome });
                                  }}
                                  className="flex items-center justify-center p-2.5 bg-blue-50 text-blue-700 rounded-xl hover:bg-blue-100 transition-colors"
                                  title="Histórico de Assinaturas"
                                >
                                  <i className="ph ph-clock-counter-clockwise text-lg"></i>
                                </button>
                              )}

                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setAgendaEditId(null);
                                  setAgendaForm({
                                    date: new Date().toISOString().split('T')[0],
                                    start: '',
                                    end: '',
                                    patientId: String(patient.id),
                                    patientName: patient.nome,
                                    title: 'Pilates (Reposição)',
                                    professionalId: '',
                                    paymentValue: '0,00',
                                    paymentStatus: 'Pago',
                                    paymentMethod: 'Reposição',
                                    pilatesEvent: true
                                  });
                                  setAgendaModalOpen(true);
                                }}
                                className="flex items-center justify-center p-2.5 bg-orange-50 text-orange-600 rounded-xl hover:bg-orange-100 transition-colors border border-orange-100"
                                title="Marcar Reposição de Aula"
                              >
                                <i className="ph ph-arrow-counter-clockwise text-lg"></i>
                              </button>

                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setPresenceFlowCtx({
                                    patientId: patient.id,
                                    patientName: patient.nome,
                                    procedure: 'Pilates (Mensalidade)',
                                    type: 'pilates_mensalidade'
                                  });
                                }}
                                className="flex items-center justify-center gap-2 px-4 py-2.5 bg-emerald-600 text-white rounded-xl hover:bg-emerald-700 transition-colors shadow-sm font-bold text-sm"
                                title="Assinar Sessão de Pilates"
                              >
                                <i className="ph ph-signature text-lg"></i> Assinar Sessão
                              </button>

                                  {(!usuarioRestritoComoFisio(currentUser)) && (
                                    <button
                                      type="button"
                                      onClick={(e) => { e.stopPropagation(); handlePilatesCancelEnroll(patient); }}
                                      className="flex items-center justify-center w-9 h-9 bg-red-50 text-red-500 rounded-xl hover:bg-red-100 hover:text-red-700 transition-colors border border-red-100"
                                      title="Cancelar matrícula (mantém nome na lista)"
                                    >
                                      <i className="ph ph-x-circle text-lg"></i>
                                    </button>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                          );
                        })}
                        {totalPilates > 0 && renderPagination(pagePilates, setPagePilates, limitPilates, setLimitPilates, totalPilates)}
                      </>
                    );
                  })()}
                    </div>
                  </div>
                )}

                {activeTab === 'list' && (
                  <div className="p-4 md:p-8">
                    <div className="flex justify-between items-center mb-6">
                      <h2 className="text-2xl font-bold text-slate-800">Pacientes</h2>
                      {(!usuarioRestritoComoFisio(currentUser)) && (
                        <button 
                          onClick={() => {
                            setNewPatient({ nome: '', dataNascimento: '', idade: '', sexo: '', estadoCivil: '', profissao: '', endereco: '', bairro: '', cidade: '', telefone: '', cpf: '', rg: '', planoSaude: 'Não', qualPlano: '', indicacao: '', responsavel: '', fisio1_id: null, fisio2_id: null, faz_pilates: false, faz_fisio: false, valor_mensalidade_pilates: '', dia_vencimento_pilates: '', valor_sessao_fisio: '', horario_fisio: '', dias_semana_fisio: '', forma_pagamento_fisio: '' });
                            setIsDualFisio(false);
                            setIsEditingPatient(false);
                            setEditingPatientId(null);
                            setActiveTab('new_patient');
                            setSelectedPatient(null);
                          }}
                          className={`flex items-center gap-2 text-white px-4 py-2 rounded-lg transition-colors shadow-sm ${t.btn}`}
                        >
                          <i className="ph ph-plus text-[20px]"></i> Novo Paciente
                        </button>
                      )}
                    </div>

                    {currentUser?.ver_todos && (
                      <div className="flex gap-2 mb-6 p-1 bg-slate-100 rounded-xl w-fit">
                        <button 
                          onClick={() => { setPatientListView('all'); setPageList(1); }}
                          className={`px-4 py-2 rounded-lg text-sm font-bold transition-all flex items-center gap-2 ${patientListView === 'all' ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}
                        >
                          <i className="ph ph-globe"></i> Todos os Pacientes
                        </button>
                        <button 
                          onClick={() => { setPatientListView('mine'); setPageList(1); }}
                          className={`px-4 py-2 rounded-lg text-sm font-bold transition-all flex items-center gap-2 ${patientListView === 'mine' ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}
                        >
                          <i className="ph ph-user"></i> Meus Pacientes
                        </button>
                      </div>
                    )}

                    <div className="mb-6 relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <i className="ph ph-magnifying-glass text-[20px] text-slate-400"></i>
                      </div>
                      <input
                        type="text"
                        className="block w-full pl-10 pr-3 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 shadow-sm transition-shadow"
                        placeholder="Buscar paciente pelo nome ou CPF..."
                        value={searchTerm}
                        onChange={(e) => { setSearchTerm(e.target.value); setPageList(1); }}
                      />
                    </div>

                    <div className="grid gap-4">
                      {(() => {
                        const totalList = filteredPatients.length;
                        const listPage = filteredPatients.slice((pageList - 1) * limitList, pageList * limitList);
                        
                        if (listPage.length === 0) {
                          return (
                            <div className="text-center py-10 bg-white rounded-xl border border-slate-200 text-slate-500">
                              Nenhum paciente encontrado com essa busca.
                            </div>
                          );
                        }
                        
                        return (
                          <>
                            {listPage.map(patient => {
                          const fisioSuspenso = !patient.faz_fisio && !patient.faz_osteopatia && !!patient.fisio_suspenso_em && !patient.fisio_cancelado_em;
                          const pilatesSuspenso = !patient.faz_pilates && !!patient.pilates_suspenso_em && !patient.pilates_cancelado_em;
                          const isSuspenso = fisioSuspenso || pilatesSuspenso;
                          
                          return (
                          <div key={patient.id} 
                            className={`p-4 md:p-5 rounded-xl border shadow-sm transition-all flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 group overflow-hidden max-w-full ${isSuspenso ? 'bg-yellow-50/70 border-yellow-300' : 'bg-white border-slate-200 hover:shadow-md'}`}>
                            <div className="flex items-center gap-4 cursor-pointer flex-1 min-w-0" onClick={() => selectPatient(patient)}>
                              <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg flex-shrink-0 ${isSuspenso ? 'bg-yellow-100 text-yellow-700' : 'bg-emerald-100 text-emerald-700'}`}>
                                {isSuspenso ? <i className="ph ph-pause-circle text-2xl"></i> : patient.nome.charAt(0)}
                              </div>
                              <div className="min-w-0 flex-1">
                                <h3 className={`font-bold text-lg truncate transition-colors ${isSuspenso ? 'text-slate-700' : 'text-slate-800 group-hover:text-emerald-600'}`}>{patient.nome}</h3>
                                {isSuspenso && (
                                  <p className="text-[11px] font-bold text-yellow-700 mt-0.5">
                                    ⏸ Tratamento Suspenso ({fisioSuspenso && pilatesSuspenso ? 'Fisioterapia e Pilates' : fisioSuspenso ? 'Fisioterapia' : 'Pilates'})
                                  </p>
                                )}
                                <p className="text-sm text-slate-500 truncate">Idade: {patient.idade} anos • CPF: {patient.cpf}</p>
                                <p className="text-xs text-slate-400 truncate md:hidden">Tel: {patient.telefone}</p>
                              </div>
                            </div>
                            
                            <div className="flex items-center justify-end gap-1 pt-3 sm:pt-0 border-t sm:border-t-0 border-slate-100 shrink-0">
                              {(!usuarioRestritoComoFisio(currentUser)) && (
                                <>
                                  <button 
                                    type="button"
                                    onClick={(e) => { e.stopPropagation(); selectPatient(patient, 'termo_imagem'); }} 
                                    className={`p-2 rounded-lg transition-colors ${patient.hasTermoImagem ? 'text-emerald-600 bg-emerald-50 hover:bg-emerald-100' : 'text-slate-400 hover:text-slate-600 hover:bg-slate-100'}`}
                                    title={patient.hasTermoImagem ? 'Consentimento de Imagem (Assinado)' : 'Consentimento de Imagem (Pendente)'}
                                  >
                                    <i className="ph ph-camera text-xl"></i>
                                  </button>
                                  <button 
                                    type="button"
                                    onClick={(e) => { e.stopPropagation(); selectPatient(patient, 'termo_comp'); }} 
                                    className={`p-2 rounded-lg transition-colors ${patient.hasTermoComparecimento ? 'text-emerald-600 bg-emerald-50 hover:bg-emerald-100' : 'text-slate-400 hover:bg-slate-100'}`}
                                    title={patient.hasTermoComparecimento ? 'Termo de Comparecimento (Assinado)' : 'Termo de Comparecimento (Pendente)'}
                                  >
                                    <i className="ph ph-article text-xl"></i>
                                  </button>
                                  <div className="w-px h-6 bg-slate-100 mx-1 hidden sm:block"></div>
                                  <button 
                                    type="button"
                                    onClick={(e) => { e.stopPropagation(); setPackageModalCtx({ patientId: patient.id, patientName: patient.nome, id: null }); }} 
                                    className="p-2.5 text-emerald-600 hover:bg-emerald-50 rounded-lg transition-colors" 
                                    title="Vender Pacote"
                                  >
                                    <i className="ph ph-shopping-bag text-xl"></i>
                                  </button>
                                  {isSuspenso ? (
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setReativarModal({ open: true, patient, tipo: 'fisio' });
                                      }}
                                      className="p-2.5 text-sky-600 hover:bg-sky-50 rounded-lg transition-colors"
                                      title="Retomar Tratamento"
                                    >
                                      <i className="ph ph-play-circle text-xl"></i>
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setSuspenderFisioModal({ open: true, patient, motivo: '', dataRetorno: '', tipo: 'fisio' });
                                      }}
                                      className="p-2.5 text-amber-600 hover:bg-amber-50 rounded-lg transition-colors"
                                      title="Suspender Tratamento (Pausa Temporária)"
                                    >
                                      <i className="ph ph-pause-circle text-xl"></i>
                                    </button>
                                  )}

                                </>
                              )}

                              <button onClick={() => selectPatient(patient)} className="p-2.5 text-slate-400 hover:text-emerald-600 hover:bg-emerald-50 rounded-lg transition-colors" title="Visualizar">
                                <i className="ph ph-eye text-xl"></i>
                              </button>
                              {(!usuarioRestritoComoFisio(currentUser)) && (
                                <>
                                  <button onClick={(e) => { e.stopPropagation(); handleEditPatient(patient); }} className="p-2.5 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors" title="Editar">
                                    <i className="ph ph-pencil text-xl"></i>
                                  </button>
                                  <button onClick={(e) => { e.stopPropagation(); setPatientToDelete(patient); }} className="p-2.5 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors" title="Excluir">
                                    <i className="ph ph-trash text-xl"></i>
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                          );
                        })}
                        {totalList > 0 && renderPagination(pageList, setPageList, limitList, setLimitList, totalList)}
                      </>
                    );
                  })()}
                    </div>
                  </div>
                )}
                {activeTab === 'fisioterapia' && (
                  <div className="p-4 md:p-8">
                    <div className="flex justify-between items-center mb-6">
                      <h2 className="text-2xl font-bold text-slate-800">Alunos Fisioterapia</h2>
                      <button type="button" onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setFisioEnrollForm({ patientId: '', fisio1_id: '', valorSessao: '150.00', diasSemana: [], horario: '', formaPagamento: 'sessao', qtdSessoes: '10' });
                        setFisioEnrollSearch('');
                        setFisioEnrollModalOpen(true);
                      }} className="flex items-center gap-2 bg-sky-600 text-white px-4 py-2 md:px-5 md:py-2.5 rounded-xl font-bold hover:bg-sky-700 transition-colors shadow-md text-sm md:text-base">
                        <i className="ph ph-plus-circle text-lg md:text-xl"></i> Adicionar Aluno
                      </button>
                    </div>

                    <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-200 mb-6">
                      <div className="relative">
                        <i className="ph ph-magnifying-glass absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-lg"></i>
                        <input
                          type="text"
                          placeholder="Buscar aluno por nome..."
                          className="w-full pl-10 pr-4 py-3 bg-slate-50 border-none focus:ring-2 focus:ring-sky-500 rounded-lg font-medium text-slate-700 transition-all placeholder-slate-400"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="grid gap-4">
                      {(() => {
                        const filteredFisio = patientsVisiveis.filter(p => (p.faz_fisio || p.faz_osteopatia || p.fisio_cancelado_em || p.fisio_suspenso_em) && (p.nome || '').toLowerCase().includes((searchTerm || '').toLowerCase()));
                        const totalFisio = filteredFisio.length;
                        const fisioPage = filteredFisio.slice((pageFisio - 1) * limitFisio, pageFisio * limitFisio);
                        
                        if (fisioPage.length === 0) {
                          return (
                            <div className="text-center py-10 bg-white rounded-xl border border-slate-200 text-slate-500">
                              Nenhum aluno de Fisioterapia encontrado.
                            </div>
                          );
                        }
                        
                        return (
                          <>
                            {fisioPage.map(patient => {
                              const fisioInativo = !patient.faz_fisio && !patient.faz_osteopatia && !!patient.fisio_cancelado_em;
                          const fisioSuspenso = !patient.faz_fisio && !patient.faz_osteopatia && !!patient.fisio_suspenso_em && !patient.fisio_cancelado_em;
                          return (
                          <div key={patient.id} 
                            className={`p-4 md:p-5 rounded-xl border shadow-sm transition-all flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 group overflow-hidden max-w-full ${fisioInativo ? 'bg-amber-50/60 border-amber-200' : fisioSuspenso ? 'bg-yellow-50/70 border-yellow-300' : 'bg-white border-slate-200 hover:shadow-md'}`}>
                            <div className="flex items-center gap-4 cursor-pointer flex-1 min-w-0" onClick={() => { setActiveTab('dashboard'); setSelectedPatient(patient); setPatientSubTab('perfil'); }}>
                              <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg flex-shrink-0 ${fisioInativo ? 'bg-amber-100 text-amber-800' : fisioSuspenso ? 'bg-yellow-100 text-yellow-700' : 'bg-sky-100 text-sky-700'}`}>
                                {fisioSuspenso ? <i className="ph ph-pause-circle text-2xl"></i> : patient.nome.charAt(0)}
                              </div>
                              <div className="min-w-0 flex-1">
                                <h3 className={`font-bold text-lg truncate transition-colors ${fisioInativo ? 'line-through text-slate-500' : fisioSuspenso ? 'text-slate-700' : 'text-slate-800 group-hover:text-sky-600'}`}>{patient.nome}</h3>
                                {fisioInativo ? (
                                  <p className="text-[11px] font-bold text-amber-800 mt-0.5">Tratamento finalizado em {patient.fisio_cancelado_em}</p>
                                ) : null}
                                {fisioSuspenso ? (
                                  <div className="mt-0.5">
                                    <p className="text-[11px] font-bold text-yellow-700">
                                      ⏸ Tratamento suspenso desde {patient.fisio_suspenso_em}
                                      {patient.fisio_retorno_previsto ? ` · Retorno previsto: ${patient.fisio_retorno_previsto}` : ''}
                                    </p>
                                    {patient.fisio_motivo_suspensao && (
                                      <p className="text-[11px] text-slate-500 mt-0.5 truncate">Motivo: {patient.fisio_motivo_suspensao}</p>
                                    )}
                                  </div>
                                ) : null}
                                <div className="flex flex-wrap items-center gap-2 mt-0.5">
                                  <span className={`text-xs font-semibold ${fisioInativo ? 'text-amber-800' : fisioSuspenso ? 'text-yellow-700' : 'text-sky-700'}`}>Fisioterapia</span>
                                  {patient.horario_fisio && (
                                    <span className="text-[11px] px-2 py-0.5 bg-slate-100 text-slate-600 rounded-md font-medium border border-slate-200">
                                      <i className="ph ph-clock mr-1"></i>{patient.horario_fisio}
                                    </span>
                                  )}
                                  {patient.dias_semana_fisio && (
                                    <span className="text-[11px] px-2 py-0.5 bg-slate-100 text-slate-600 rounded-md font-medium border border-slate-200">
                                      <i className="ph ph-calendar-blank mr-1"></i>{patient.dias_semana_fisio.replace(/,/g, ', ')}
                                    </span>
                                  )}
                                  {patient.forma_pagamento_fisio === 'pacote' && (
                                    <span className="text-[11px] px-2 py-0.5 bg-purple-100 text-purple-700 rounded-md font-bold border border-purple-200">
                                      Pacote
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            
                            <div className="flex items-center justify-end gap-2 flex-wrap pt-3 sm:pt-0 border-t sm:border-t-0 border-slate-100 shrink-0">
                              {(fisioInativo || fisioSuspenso) ? (
                                <>
                                  <button
                                    type="button"
                                    onClick={(e) => { e.stopPropagation(); setReativarModal({ open: true, patient, tipo: 'fisio' }); }}
                                    className="flex items-center justify-center gap-2 px-4 py-2.5 bg-sky-600 text-white rounded-xl hover:bg-sky-700 transition-colors shadow-sm font-bold text-sm"
                                    title="Retomar Fisioterapia"
                                  >
                                    <i className="ph ph-arrow-u-up-left text-lg"></i> Retomar
                                  </button>
                                </>
                              ) : (
                                <>
                                  {(!usuarioRestritoComoFisio(currentUser)) && (
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setFisioEnrollForm({
                                          patientId: String(patient.id),
                                          fisio1_id: patient.fisio1_id || '',
                                          valorSessao: patient.valor_sessao_fisio || '150.00',
                                          diasSemana: patient.dias_semana_fisio ? patient.dias_semana_fisio.split(',').map(d => d.trim()) : [],
                                          horario: patient.horario_fisio || '',
                                          formaPagamento: patient.forma_pagamento_fisio || 'sessao',
                                          qtdSessoes: '10'
                                        });
                                        setFisioEnrollSearch(patient.nome);
                                        setFisioEnrollModalOpen(true);
                                      }}
                                      className="flex items-center justify-center p-2.5 bg-violet-50 text-violet-700 rounded-xl hover:bg-violet-100 transition-colors"
                                      title="Editar Dados da Fisioterapia"
                                    >
                                      <i className="ph ph-pencil-simple text-lg"></i>
                                    </button>
                                  )}

                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setPresenceFlowCtx({
                                        patientId: patient.id,
                                        patientName: patient.nome,
                                        procedure: 'Sessão de Fisioterapia',
                                        type: 'fisioterapia'
                                      });
                                    }}
                                    className="flex items-center justify-center gap-2 px-4 py-2.5 bg-sky-600 text-white rounded-xl hover:bg-sky-700 transition-colors shadow-sm font-bold text-sm"
                                    title="Assinar Sessão de Fisioterapia"
                                  >
                                    <i className="ph ph-signature text-lg"></i> Assinar Sessão
                                  </button>

                                  {(!usuarioRestritoComoFisio(currentUser)) && (
                                    <>
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSuspenderFisioModal({ open: true, patient, motivo: '', dataRetorno: '', tipo: 'ambos' });
                                        }}
                                        className="flex items-center justify-center gap-1.5 px-3 py-2.5 bg-amber-50 text-amber-700 border border-amber-200 rounded-xl hover:bg-amber-100 transition-colors font-bold text-sm"
                                        title="Suspender Tratamento (Pausa Temporária)"
                                      >
                                        <i className="ph ph-pause-circle text-lg"></i> Suspender
                                      </button>

                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleFisioSoftCancel(patient.id);
                                        }}
                                        className="flex items-center justify-center p-2.5 bg-red-50 text-red-700 rounded-xl hover:bg-red-100 transition-colors"
                                        title="Finalizar Tratamento"
                                      >
                                        <i className="ph ph-power text-lg"></i>
                                      </button>
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                          );
                        })}
                        {totalFisio > 0 && renderPagination(pageFisio, setPageFisio, limitFisio, setLimitFisio, totalFisio)}
                      </>
                    );
                  })()}
                    </div>
                  </div>

                )}

                {activeTab === 'agenda' && (() => {
                  const pad2 = (n) => String(n).padStart(2, '0');
                  const toDateKey = rcAgendaToDateKey;
                  const addDays = rcAgendaAddDays;
                  const addMonths = rcAgendaAddMonths;
                  const startOfWeekSunday = rcAgendaStartOfWeekSun;
                  const anchor = new Date(agendaAnchorTs);
                  anchor.setHours(0, 0, 0, 0);
                  const weekStart = startOfWeekSunday(anchor);
                  const weekDays = [0, 1, 2, 3, 4, 5, 6].map((i) => addDays(weekStart, i));
                  const fmtR = (a, b) =>
                    `${a.toLocaleDateString('pt-BR', { day: 'numeric', month: 'short', year: 'numeric' })} – ${b.toLocaleDateString('pt-BR', { day: 'numeric', month: 'short', year: 'numeric' })}`;
                  let rangeLabel = '';
                  if (agendaViewMode === 'day') {
                    rangeLabel = anchor.toLocaleDateString('pt-BR', {
                      weekday: 'long',
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric',
                    });
                  } else if (agendaViewMode === 'week') {
                    rangeLabel = fmtR(weekStart, addDays(weekStart, 6));
                  } else {
                    const y = anchor.getFullYear();
                    const m = anchor.getMonth();
                    rangeLabel = fmtR(new Date(y, m, 1), new Date(y, m + 1, 0));
                  }
                  const HOURS = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];
                  const WEEKDAYS_PT = ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sábado'];
                  // Filtro de visibilidade por profissional e suspensões
                  const agendaEvVisible = (ev) => {
                    if (ev.patientId) {
                      const pat = patients.find(p => String(p.id) === String(ev.patientId));
                      if (pat) {
                        const fisioSuspenso = !pat.faz_fisio && !pat.faz_osteopatia && !!pat.fisio_suspenso_em && !pat.fisio_cancelado_em;
                        const pilatesSuspenso = !pat.faz_pilates && !!pat.pilates_suspenso_em && !pat.pilates_cancelado_em;
                        if (ev.fisioEvent && fisioSuspenso) return false;
                        if (ev.pilatesEvent && pilatesSuspenso) return false;
                      }
                    }
                    if (usuarioRestritoComoFisio(currentUser)) {
                      return String(ev.professionalId) === String(currentUser.id) || String(ev.patientId) && patients.some(p => String(p.id) === String(ev.patientId) && (p.fisio1_id == currentUser.id || p.fisio2_id == currentUser.id));
                    }
                    return true;
                  };
                  const enhancedAgendaEvents = agendaEvents.map((ev) => {
                    if (!ev.pilatesEvent) return ev;
                    const evDate = ev.date || '';
                    const evYYYYMM = evDate.slice(0, 7);
                    const recId = `pil_${evYYYYMM}_${ev.patientId}`;
                    const finEntry = finEntries.find(e => e.id === recId);
                    if (!finEntry) return ev;
                    
                    const isPago = finEntry.status === 'pago';
                    const todayDate = new Date().toISOString().split('T')[0];
                    const isAtrasado = !isPago && finEntry.data && finEntry.data < todayDate;
                    
                    return {
                      ...ev,
                      paymentStatus: isPago ? 'Pago' : isAtrasado ? 'Atrasado' : 'Pendente',
                      paymentOk: isPago,
                      paymentPending: !isPago
                    };
                  });
                  const filteredEv = enhancedAgendaEvents.filter(
                    (ev) => agendaEvVisible(ev) && (!agendaTeamFilter || String(ev.professionalId) === String(agendaTeamFilter))
                  );
                  const addMinutesToHHMM = (hhmm, minutesToAdd) => {
                    const m = String(hhmm || '').match(/^(\d{2}):(\d{2})$/);
                    if (!m) return hhmm;
                    const h = Number(m[1]);
                    const mm = Number(m[2]);
                    if (Number.isNaN(h) || Number.isNaN(mm)) return hhmm;
                    const total = h * 60 + mm + minutesToAdd;
                    const h2 = Math.floor((total + 24 * 60) % (24 * 60) / 60);
                    const m2 = (total + 24 * 60) % 60;
                    return `${String(h2).padStart(2, '0')}:${String(m2).padStart(2, '0')}`;
                  };
                  const displayEndTime = (ev) => {
                    const s = String(ev?.start || '').trim();
                    const e = String(ev?.end || '').trim();
                    if (!s) return e || '';
                    if (!e || e === s || e === '--:--') return addMinutesToHHMM(s, 50);
                    return e;
                  };
                  const computeOverlaps = (evs) => {
                    const getTime = (hhmm) => {
                      const [h, m] = String(hhmm||'').split(':').map(Number);
                      return (h||0)*60 + (m||0);
                    };
                    const processed = evs.map(e => ({
                      ...e,
                      _start: getTime(e.start),
                      _end: getTime(displayEndTime(e))
                    }));
                    const groups = [];
                    let currentGroup = [];
                    let currentGroupEnd = 0;
                    processed.forEach(ev => {
                      if (currentGroup.length === 0) {
                        currentGroup.push(ev);
                        currentGroupEnd = ev._end;
                      } else {
                        if (ev._start < currentGroupEnd) {
                          currentGroup.push(ev);
                          currentGroupEnd = Math.max(currentGroupEnd, ev._end);
                        } else {
                          groups.push(currentGroup);
                          currentGroup = [ev];
                          currentGroupEnd = ev._end;
                        }
                      }
                    });
                    if (currentGroup.length > 0) groups.push(currentGroup);
                    groups.forEach(group => {
                       const cols = [];
                       group.forEach(ev => {
                         let placed = false;
                         for (let i = 0; i < cols.length; i++) {
                           const lastEvInCol = cols[i][cols[i].length - 1];
                           if (lastEvInCol._end <= ev._start) {
                             cols[i].push(ev);
                             ev._col = i;
                             placed = true;
                             break;
                           }
                         }
                         if (!placed) {
                           cols.push([ev]);
                           ev._col = cols.length - 1;
                         }
                       });
                       const totalCols = cols.length;
                       group.forEach(ev => { ev._totalCols = totalCols; });
                    });
                    return processed;
                  };

                  const eventsForDay = (d) => {
                    const k = toDateKey(d);
                    const evs = filteredEv.filter((e) => e.date === k).sort((a, b) => a.start.localeCompare(b.start));
                    return computeOverlaps(evs);
                  };
                  const isToday = (day) => toDateKey(day) === toDateKey(new Date());
                  const profName = (id) => {
                    if (id == null || id === '') return '—';
                    const u = usersList.find((x) => String(x.id) === String(id));
                    return u?.nome || '—';
                  };
                  const goTodayAgenda = () => {
                    const t = new Date();
                    t.setHours(0, 0, 0, 0);
                    setAgendaAnchorTs(t.getTime());
                  };
                  const goPrevAgenda = () => {
                    const a = new Date(agendaAnchorTs);
                    if (agendaViewMode === 'day') setAgendaAnchorTs(addDays(a, -1).getTime());
                    else if (agendaViewMode === 'week') setAgendaAnchorTs(addDays(a, -7).getTime());
                    else setAgendaAnchorTs(addMonths(a, -1).getTime());
                  };
                  const goNextAgenda = () => {
                    const a = new Date(agendaAnchorTs);
                    if (agendaViewMode === 'day') setAgendaAnchorTs(addDays(a, 1).getTime());
                    else if (agendaViewMode === 'week') setAgendaAnchorTs(addDays(a, 7).getTime());
                    else setAgendaAnchorTs(addMonths(a, 1).getTime());
                  };
                  const monthGrid = (() => {
                    const y = anchor.getFullYear();
                    const m = anchor.getMonth();
                    const first = new Date(y, m, 1);
                    const start = startOfWeekSunday(first);
                    return Array.from({ length: 42 }, (_, i) => addDays(start, i));
                  })();
                  return (
                    <div className="p-4 md:p-8 max-w-[1200px] mx-auto w-full animate-fadeIn">
                      <div className="mb-6">
                        <h2 className="text-2xl font-bold text-emerald-800">Agenda da Clínica</h2>
                        <p className="text-sm text-slate-500 mt-1">
                          {currentUser?.nome} · {formatNiveisLabel(currentUser?.nivel)}
                        </p>
                      </div>

                      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-4 mb-4 flex flex-wrap items-center justify-between gap-4">
                        <div className="flex flex-wrap items-center gap-2">
                          <button type="button" onClick={goPrevAgenda} className="p-2 rounded-lg hover:bg-slate-100 text-slate-600" aria-label="Anterior">
                            <i className="ph ph-caret-left text-xl"></i>
                          </button>
                          <button type="button" onClick={goTodayAgenda} className="px-3 py-2 rounded-lg bg-emerald-100 text-emerald-800 font-bold text-sm">
                            HOJE
                          </button>
                          <button type="button" onClick={goNextAgenda} className="p-2 rounded-lg hover:bg-slate-100 text-slate-600" aria-label="Próximo">
                            <i className="ph ph-caret-right text-xl"></i>
                          </button>
                          <span className="font-semibold text-slate-800 text-sm md:text-base ml-1">{rangeLabel}</span>
                        </div>
                        <div className="inline-flex rounded-lg border border-slate-200 overflow-hidden bg-slate-50">
                          {[
                            { id: 'day', label: 'Dia' },
                            { id: 'week', label: 'Semana' },
                            { id: 'month', label: 'Mês' },
                          ].map((seg) => (
                            <button
                              key={seg.id}
                              type="button"
                              onClick={() => setAgendaViewMode(seg.id)}
                              className={`px-4 py-2 text-xs font-bold transition-colors ${
                                agendaViewMode === seg.id
                                  ? 'bg-white text-emerald-700 shadow-sm border-b-2 border-emerald-600 -mb-px'
                                  : 'text-slate-500 hover:text-slate-700'
                              }`}
                            >
                              {seg.label}
                            </button>
                          ))}
                        </div>
                        <div className="flex flex-wrap items-center gap-2">
                          <select
                            className="border border-slate-300 rounded-lg px-3 py-2 text-sm font-medium text-slate-700 bg-white min-w-[160px]"
                            value={agendaTeamFilter}
                            onChange={(e) => setAgendaTeamFilter(e.target.value)}
                          >
                            <option value="">Equipe Completa</option>
                            {usersList.map((u) => (
                              <option key={u.id} value={String(u.id)}>
                                {u.nome}
                              </option>
                            ))}
                          </select>
                          <button
                            type="button"
                            onClick={() => {
                              setAgendaEditId(null);
                              setAgendaForm({
                                date: toDateKey(anchor),
                                start: '',
                                end: '',
                                patientId: '',
                                patientName: '',
                                title: '',
                                professionalId: currentUser?.id != null ? String(currentUser.id) : '',
                                paymentValue: '150,00',
                                paymentStatus: 'Pendente',
                                paymentMethod: '',
                              });
                              setAgendaModalOpen(true);
                            }}
                            className={`flex items-center gap-2 text-white px-4 py-2 rounded-lg font-bold text-sm shadow-sm ${t.btn}`}
                          >
                            <i className="ph ph-plus text-lg"></i> Agendar
                          </button>
                        </div>
                      </div>

                      {agendaViewMode === 'month' ? (
                        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-4 max-h-[min(72vh,780px)] overflow-y-auto overflow-x-auto">
                          <div className="grid grid-cols-7 gap-1 mb-2 text-center text-xs font-bold text-slate-500">
                            {WEEKDAYS_PT.map((w) => (
                              <div key={w}>{w.slice(0, 3)}</div>
                            ))}
                          </div>
                          <div className="grid grid-cols-7 gap-1">
                            {monthGrid.map((day) => {
                              const inMonth = day.getMonth() === anchor.getMonth();
                              const k = toDateKey(day);
                              const evs = eventsForDay(day);
                              return (
                                <div
                                  key={k}
                                  className={`min-h-[72px] rounded-lg border p-1 text-left ${inMonth ? 'bg-white border-slate-200' : 'bg-slate-50 border-slate-100 opacity-60'}`}
                                >
                                  <div className={`text-xs font-bold ${isToday(day) ? 'text-emerald-700' : 'text-slate-800'}`}>{day.getDate()}</div>
                                  {evs.slice(0, 2).map((ev) => (
                                    <div key={ev.id} className="text-[10px] mt-1 px-1 py-0.5 rounded bg-emerald-100 text-emerald-900 truncate" title={`${ev.start} ${ev.title}`}>
                                      {ev.start} {ev.title}
                                    </div>
                                  ))}
                                  {evs.length > 2 ? (
                                    <div className="text-[10px] text-slate-500 mt-0.5">+{evs.length - 2}</div>
                                  ) : null}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ) : agendaViewMode === 'day' ? (
                        <div className="bg-white rounded-xl border border-slate-200 shadow-sm max-h-[min(72vh,780px)] overflow-y-auto overflow-x-auto">
                          <div className="sticky top-0 z-10 px-4 py-3 border-b border-slate-200 font-bold text-slate-800 bg-slate-50">
                            {WEEKDAYS_PT[anchor.getDay()]}, {anchor.getDate()}
                          </div>
                          <div className="grid grid-cols-[56px_1fr] min-h-[520px]">
                            <div className="border-r border-slate-200 bg-slate-50">
                              {HOURS.map((h) => (
                                <div key={h} className="h-12 text-right pr-2 pt-1 text-xs text-slate-500">
                                  {pad2(h)}:00
                                </div>
                              ))}
                            </div>
                            <div className="relative px-2 pb-2">
                              {HOURS.map((h) => (
                                <div key={h} className="h-12 border-b border-slate-100 box-border" />
                              ))}
                              <div className="absolute left-2 right-2 top-0 bottom-2 pointer-events-none">
                                {eventsForDay(anchor).map((ev) => {
                                  const [sh, sm] = ev.start.split(':').map(Number);
                                  const endDisp = displayEndTime(ev);
                                  const [eh, em] = String(endDisp || ev.end || ev.start).split(':').map(Number);
                                  const top = ((sh - 7) * 60 + sm) * (48 / 60);
                                  const dur = (eh * 60 + em - (sh * 60 + sm)) * (48 / 60);
                                  const patientLabel = String(ev.patientName || ev.title || '').trim() || 'Paciente';
                                  const profLabel = String(ev.professionalName || '').trim() || profName(ev.professionalId);
                                  const timeLabel = `${ev.start} - ${endDisp || ev.end || ev.start}`;
                                  const short = dur < 44; // menos de ~55min
                                  return (
                                    <div
                                      key={ev.id}
                                      className="pointer-events-auto absolute rounded-xl border border-orange-200 bg-gradient-to-r from-orange-100 to-orange-50 shadow-sm overflow-hidden"
                                      style={{
                                        top: Math.max(0, top),
                                        height: Math.max(36, dur),
                                        left: `${(ev._col / ev._totalCols) * 100}%`,
                                        width: `${100 / ev._totalCols}%`,
                                      }}
                                    >
                                      <button
                                        type="button"
                                        aria-label="Excluir agendamento"
                                        className="absolute top-1 right-1 z-10 flex h-5 w-5 shrink-0 items-center justify-center rounded-md border border-orange-200/80 bg-white/90 text-[11px] font-bold leading-none text-orange-800 shadow-sm hover:border-red-300 hover:bg-red-50 hover:text-red-600"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (!confirm('Excluir este agendamento da agenda?')) return;
                                          const next = agendaEventsRef.current.filter((x) => String(x.id) !== String(ev.id));
                                          persistAgendaEvents(next);
                                          agendaEventsRef.current = next;
                                          showToast('Agendamento removido.', 'info');
                                        }}
                                      >
                                        ×
                                      </button>
                                      <div className="px-2.5 py-1.5 pr-7">
                                        <div className="text-[10px] font-extrabold text-orange-800 leading-tight">{timeLabel}</div>
                                        <div className="mt-0.5 text-[11px] font-extrabold text-slate-900 truncate leading-tight">{patientLabel}</div>
                                        {!short ? (
                                          <div className="text-[10px] font-semibold text-slate-600 truncate leading-tight">{profLabel}</div>
                                        ) : null}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="bg-white rounded-xl border border-slate-200 shadow-sm max-h-[min(72vh,780px)] overflow-y-auto overflow-x-auto">
                          <div className="sticky top-0 z-10 grid grid-cols-[56px_repeat(7,minmax(72px,1fr))] border-b border-slate-200 bg-slate-50 min-w-[720px]">
                            <div />
                            {weekDays.map((day) => (
                              <div
                                key={toDateKey(day)}
                                className={`text-center py-2 border-l border-slate-200 text-xs font-bold ${isToday(day) ? 'text-emerald-700' : 'text-slate-800'}`}
                              >
                                <div>{WEEKDAYS_PT[day.getDay()]}</div>
                                <div className="text-lg mt-0.5">{day.getDate()}</div>
                              </div>
                            ))}
                          </div>
                          <div className="grid grid-cols-[56px_repeat(7,minmax(72px,1fr))] min-h-[520px] min-w-[720px]">
                            <div className="border-r border-slate-200 bg-slate-50">
                              {HOURS.map((h) => (
                                <div key={h} className="h-12 text-right pr-2 pt-1 text-xs text-slate-500">
                                  {pad2(h)}:00
                                </div>
                              ))}
                            </div>
                            {weekDays.map((day) => (
                              <div key={toDateKey(day)} className="border-l border-slate-200 relative">
                                {HOURS.map((h) => (
                                  <div key={h} className="h-12 border-b border-slate-100 box-border" />
                                ))}
                                <div className="absolute left-0.5 right-0.5 top-0 bottom-0 pointer-events-none">
                                  {eventsForDay(day).map((ev) => {
                                    const [sh, sm] = ev.start.split(':').map(Number);
                                    const endDisp = displayEndTime(ev);
                                    const [eh, em] = String(endDisp || ev.end || ev.start).split(':').map(Number);
                                    const top = ((sh - 7) * 60 + sm) * (48 / 60);
                                    const dur = (eh * 60 + em - (sh * 60 + sm)) * (48 / 60);
                                    const patientLabel = String(ev.patientName || ev.title || '').trim() || 'Paciente';
                                    const profLabel = String(ev.professionalName || '').trim() || profName(ev.professionalId);
                                    const timeLabel = `${ev.start} - ${endDisp || ev.end || ev.start}`;
                                    const short = dur < 44;
                                    return (
                                      <div
                                        key={ev.id}
                                        className="pointer-events-auto absolute rounded-lg border border-orange-200 bg-gradient-to-r from-orange-100 to-orange-50 text-orange-900 overflow-hidden shadow-[0_1px_2px_rgba(0,0,0,0.06)]"
                                        style={{
                                          top: Math.max(0, top),
                                          height: Math.max(26, dur),
                                          left: `${(ev._col / ev._totalCols) * 100}%`,
                                          width: `${100 / ev._totalCols}%`,
                                        }}
                                      >
                                        <button
                                          type="button"
                                          aria-label="Excluir agendamento"
                                          className="absolute top-0.5 right-0.5 z-10 flex h-4 w-4 shrink-0 items-center justify-center rounded border border-orange-200/80 bg-white/95 text-[10px] font-bold leading-none text-orange-800 hover:border-red-300 hover:bg-red-50 hover:text-red-600"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            if (!confirm('Excluir este agendamento da agenda?')) return;
                                            const next = agendaEventsRef.current.filter((x) => String(x.id) !== String(ev.id));
                                            persistAgendaEvents(next);
                                            agendaEventsRef.current = next;
                                            showToast('Agendamento removido.', 'info');
                                          }}
                                        >
                                          ×
                                        </button>
                                        <div className="px-2 py-1 pr-5">
                                          <div className="text-[9px] text-orange-800 font-extrabold leading-tight">{timeLabel}</div>
                                          <div className="truncate text-[10px] text-slate-900 font-extrabold leading-tight">{patientLabel}</div>
                                          {!short ? (
                                            <div className="truncate text-[9px] text-slate-600 font-semibold leading-tight">{profLabel}</div>
                                          ) : null}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      <p className="text-center text-xs text-slate-500 mt-4">
                        Os agendamentos ficam guardados neste navegador (localStorage) até existir API no servidor.
                      </p>
                    </div>
                  );
                })()}

                {activeTab === 'fila_hoje' && (() => {
                  const todayKey = filaDate;
                  const [fy, fm, fd] = todayKey.split('-');
                  const todayLabel = new Date(fy, fm - 1, fd).toLocaleDateString('pt-BR', { day: 'numeric', month: 'long' });
                  
                  const enhancedAgendaEvents = agendaEvents.map((ev) => {
                    if (!ev.pilatesEvent) return ev;
                    const evDate = ev.date || '';
                    const evYYYYMM = evDate.slice(0, 7);
                    const recId = `pil_${evYYYYMM}_${ev.patientId}`;
                    const finEntry = finEntries.find(e => e.id === recId);
                    if (!finEntry) return ev;
                    
                    const isPago = finEntry.status === 'pago';
                    const todayDate = new Date().toISOString().split('T')[0];
                    const isAtrasado = !isPago && finEntry.data && finEntry.data < todayDate;
                    
                    return {
                      ...ev,
                      paymentStatus: isPago ? 'Pago' : isAtrasado ? 'Atrasado' : 'Pendente',
                      paymentOk: isPago,
                      paymentPending: !isPago
                    };
                  });

                  const profNameQ = (id) => {
                    if (id == null || id === '') return '—';
                    const u = usersList.find((x) => String(x.id) === String(id));
                    return u?.nome || '—';
                  };

                  const seenQueueKeys = new Set();
                  const queue = enhancedAgendaEvents
                    .filter((e) => {
                      if (e.date !== todayKey) return false;
                      
                      if (e.patientId) {
                        const pat = patients.find(p => String(p.id) === String(e.patientId));
                        if (pat) {
                          const fisioSuspenso = !pat.faz_fisio && !pat.faz_osteopatia && !!pat.fisio_suspenso_em && !pat.fisio_cancelado_em;
                          const pilatesSuspenso = !pat.faz_pilates && !!pat.pilates_suspenso_em && !pat.pilates_cancelado_em;
                          if (e.fisioEvent && fisioSuspenso) return false;
                          if (e.pilatesEvent && pilatesSuspenso) return false;
                        }
                      }
                      
                      if (usuarioRestritoComoFisio(currentUser)) {
                        // Fisio restrito: só eventos vinculados a ele
                        if (String(e.professionalId) === String(currentUser.id)) return true;
                        const pat = patients.find(p => String(p.id) === String(e.patientId));
                        if (!(pat && (pat.fisio1_id == currentUser.id || pat.fisio2_id == currentUser.id))) return false;
                      }
                      
                      const pId = e.patientId || e.patientName || e.title || 'unknown';
                      const key = `${pId}_${e.start}_${e.professionalId}`;
                      if (seenQueueKeys.has(key)) return false;
                      seenQueueKeys.add(key);
                      
                      return true;
                    })
                    .filter((e) => {
                      if (!searchFila) return true;
                      const q = searchFila.toLowerCase();
                      const patientName = String(e.patientName || e.title || '').toLowerCase();
                      const profNameStr = profNameQ(e.professionalId).toLowerCase();
                      return patientName.includes(q) || profNameStr.includes(q);
                    })
                    .sort((a, b) => a.start.localeCompare(b.start));

                  const totalFila = queue.length;
                  const queuePage = queue.slice((pageFila - 1) * limitFila, pageFila * limitFila);

                  const patchEv = (id, patch) => {
                    persistAgendaEvents(agendaEvents.map((x) => (x.id === id ? { ...x, ...patch } : x)));
                  };
                  const qe = (ev) => ({
                    ...ev,
                    confirmed: ev.confirmed === false ? false : true,
                    paymentPending: ev.paymentPending === false ? false : true,
                    notified: !!ev.notified,
                    paymentOk: !!ev.paymentOk,
                    arrived: !!ev.arrived,
                    presence: ev.presence === 'present' || ev.presence === 'registered' ? ev.presence : 'none',
                  });
                  const openNewToday = () => {
                    setAgendaEditId(null);
                    setAgendaForm({
                      date: todayKey,
                      start: '',
                      end: '',
                      patientId: '',
                      patientName: '',
                      title: '',
                      professionalId: currentUser?.id != null ? String(currentUser.id) : '',
                      paymentValue: '150,00',
                      paymentStatus: 'Pendente',
                      paymentMethod: '',
                    });
                    setAgendaModalOpen(true);
                  };
                  return (
                    <div className="px-3 sm:px-5 md:px-8 lg:px-12 xl:px-16 2xl:px-20 py-4 md:py-8 w-full max-w-[1920px] mx-auto animate-fadeIn">
                      <div className="bg-white rounded-2xl border border-slate-200 border-t-4 border-t-emerald-500 shadow-lg shadow-emerald-900/[0.06] overflow-hidden">
                        <div className="flex flex-wrap items-center justify-between gap-4 px-5 py-4 border-b border-emerald-100 bg-gradient-to-r from-emerald-50/95 via-emerald-50/40 to-white">
                          <div className="flex items-center gap-3 text-slate-800 font-bold text-lg">
                            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-100 text-emerald-700 shadow-sm shadow-emerald-600/10">
                              <i className="ph ph-calendar-blank text-2xl"></i>
                            </span>
                            <span className="text-emerald-950 flex items-center gap-2">
                              Fila do Dia: 
                              <input 
                                type="date" 
                                value={filaDate} 
                                onChange={(e) => { setFilaDate(e.target.value); setPageFila(1); }} 
                                className="ml-2 rounded-lg border-emerald-200 bg-emerald-50 text-emerald-800 focus:ring-emerald-500 font-bold px-3 py-1 text-sm outline-none cursor-pointer"
                              />
                            </span>
                          </div>
                          <div className="flex flex-col sm:flex-row gap-3 items-center w-full sm:w-auto">
                            <div className="relative">
                              <i className="ph ph-magnifying-glass absolute left-3 top-1/2 -translate-y-1/2 text-emerald-600/50"></i>
                              <input
                                type="text"
                                placeholder="Pesquisar paciente..."
                                value={searchFila}
                                onChange={(e) => { setSearchFila(e.target.value); setPageFila(1); }}
                                className="w-full sm:w-64 pl-10 pr-4 py-2 rounded-xl border border-emerald-200 bg-emerald-50 focus:bg-white focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 text-sm transition-all outline-none"
                              />
                            </div>
                            <button
                              type="button"
                              onClick={openNewToday}
                              className="rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-2 text-sm font-bold shadow-md shadow-emerald-700/25 transition-colors whitespace-nowrap"
                            >
                              Agendar Novo
                            </button>
                          </div>
                        </div>
                        <div className="p-4 md:p-6 lg:p-8">
                          {queuePage.length === 0 ? (
                            <div className="text-center py-16 text-slate-500">
                              <i className="ph ph-list-bullets text-4xl text-emerald-200 mb-3 block"></i>
                              Nenhum agendamento encontrado.
                            </div>
                          ) : (
                            <div className="flex flex-col gap-3">
                              {queuePage.map((raw) => {
                                const ev = qe(raw);
                                return (
                                  <div
                                    key={ev.id}
                                    className="flex flex-col lg:flex-row lg:items-center gap-4 p-4 md:p-5 rounded-xl border border-slate-200 border-l-[5px] border-l-emerald-500 bg-gradient-to-r from-emerald-50/35 to-white shadow-sm hover:shadow-md hover:shadow-emerald-900/10 transition-shadow"
                                  >
                                    <div className="flex items-start gap-4 min-w-0 flex-1">
                                      <div className="flex items-center gap-2 text-emerald-900 font-extrabold text-lg shrink-0 tabular-nums">
                                        <i className="ph ph-clock text-emerald-600"></i>
                                        {ev.start}
                                      </div>
                                      <div className="min-w-0 flex-1">
                                        <div className="flex items-center gap-2 font-bold text-slate-900 uppercase tracking-tight truncate">
                                          <i className="ph ph-user text-emerald-600"></i>
                                          {ev.patientName || ev.title || 'Sem título'}
                                          {ev.title === 'Pilates (Reposição)' && <span className="text-orange-500 text-xs ml-1">(Reposição de Aula)</span>}
                                          {(() => {
                                            const pn = (ev.patientName || ev.title || '').trim();
                                            const activePkg = packages.find(p => p.patientName === pn && p.active && p.remaining > 0);
                                            if (!activePkg) return null;
                                            const r = activePkg.remaining;
                                            const cls = r <= 1 ? 'bg-red-100 text-red-700 border-red-200' : r <= 3 ? 'bg-amber-100 text-amber-700 border-amber-200' : 'bg-indigo-100 text-indigo-700 border-indigo-200';
                                            return (
                                              <span className={`inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-full border normal-case tracking-normal ${cls}`}>
                                                <i className="ph ph-package"></i> {r}/{activePkg.totalSessions}
                                              </span>
                                            );
                                          })()}
                                        </div>
                                        <p className="text-sm text-slate-500 mt-1">
                                          Profissional: <span className="font-semibold text-emerald-800">{profNameQ(ev.professionalId)}</span>
                                        </p>
                                        <div className="flex flex-wrap gap-2 mt-3">
                                          <AgendaStatusDropdown 
                                            status={ev.appointmentStatus || (ev.status ? ev.status : (ev.confirmed ? 'Confirmado' : 'Marcado'))}
                                            onChange={(newStatus) => patchEv(ev.id, { appointmentStatus: newStatus, confirmed: newStatus === 'Confirmado' || newStatus === 'Atendido' })}
                                          />

                                          {(userTemNivel(currentUser, 'Administrador') || userTemNivel(currentUser, 'Super Administrador') || userTemNivel(currentUser, 'Recepcionista')) && (
                                            <>
                                              <button
                                                type="button"
                                                onClick={() => {
                                                  if (ev.pilatesEvent) {
                                                    showToast('O pagamento de Pilates é feito na aba Financeiro (Mensalidade).', 'info');
                                                    return;
                                                  }
                                                  if (ev.paymentStatus === 'Pacote' || ev.paymentMethod === 'Pacote') {
                                                    showToast('Sessão vinculada a pacote! A baixa será automática quando o profissional salvar a evolução.', 'info');
                                                    return;
                                                  }
                                                  setPaymentModalCtx({ ...ev, profName: profNameQ(ev.professionalId) });
                                                }}
                                                className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold border transition-colors ${
                                                  ev.paymentStatus === 'Pago' || (!ev.paymentPending && ev.paymentStatus !== 'Atrasado')
                                                    ? 'bg-emerald-100 text-emerald-900 border-emerald-200 hover:bg-emerald-200'
                                                    : ev.paymentStatus === 'Atrasado'
                                                    ? 'bg-red-100 text-red-900 border-red-300 hover:bg-red-200 animate-pulse'
                                                    : 'bg-amber-100 text-amber-900 border-amber-200 hover:bg-amber-200'
                                                }`}
                                              >
                                                <span className="font-black">$</span> {ev.paymentStatus || (ev.paymentPending ? 'Pendente' : 'Pago')}
                                              </button>

                                              <button
                                                type="button"
                                                onClick={() => setPackageModalCtx({ ...ev, profName: profNameQ(ev.professionalId) })}
                                                className="inline-flex items-center justify-center w-8 h-8 rounded-full border-2 border-emerald-300 text-emerald-600 bg-emerald-50/80 hover:bg-emerald-100 transition-colors"
                                                title="Vender Pacote"
                                              >
                                                <i className="ph ph-shopping-cart"></i>
                                              </button>

                                              <button
                                                type="button"
                                                onClick={() => {
                                                  let phone = '';
                                                  if (ev.patientId) {
                                                    const pt = patients.find(p => String(p.id) === String(ev.patientId));
                                                    if (pt && pt.telefone) phone = String(pt.telefone).replace(/\D/g, '');
                                                  }
                                                  if (phone && phone.length <= 11) phone = '55' + phone; 
                                                  const params = {
                                                    agendaEventId: ev.id,
                                                    date: ev.date,
                                                    time: ev.start,
                                                    patientName: (ev.patientName || ev.pacienteNome || ev.nomePaciente || '').trim() || 'Paciente',
                                                    profName: profNameQ(ev.professionalId)
                                                  };
                                                  const confirmUrl = `${window.location.origin}${window.location.pathname}?confirm_appointment=${encodeURIComponent(btoa(JSON.stringify(params)))}`;
                                                  
                                                  // Calcula o rótulo correto da data (hoje / amanhã / DD/MM) com base no fuso local
                                                  const _now = new Date();
                                                  const _pad = (n) => String(n).padStart(2, '0');
                                                  const actualTodayDate = `${_now.getFullYear()}-${_pad(_now.getMonth() + 1)}-${_pad(_now.getDate())}`;
                                                  const _tmrw = new Date(_now);
                                                  _tmrw.setDate(_tmrw.getDate() + 1);
                                                  const tomorrowDate = `${_tmrw.getFullYear()}-${_pad(_tmrw.getMonth() + 1)}-${_pad(_tmrw.getDate())}`;

                                                  let diaStr = 'hoje';
                                                  if (ev.date && ev.date === tomorrowDate) {
                                                    diaStr = 'amanhã';
                                                  } else if (ev.date && ev.date !== actualTodayDate) {
                                                    const parts = ev.date.split('-');
                                                    if (parts.length === 3) {
                                                      diaStr = `dia ${parts[2]}/${parts[1]}/${parts[0]}`;
                                                    }
                                                  }
                                                  
                                                  const text = `Olá ${params.patientName}! Tudo bem? Passando para lembrar e confirmar a sua sessão de ${diaStr} às ${ev.start} com ${params.profName}.\n\nPor favor, confirme clicando no link abaixo:\n\n${confirmUrl}`;
                                                  patchEv(ev.id, { notified: true });
                                                  window.open(`https://wa.me/${phone}?text=${encodeURIComponent(text)}`, '_blank');
                                                }}
                                                className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold border transition-colors ${
                                                  ev.notified
                                                    ? 'bg-emerald-100 text-emerald-800 border-emerald-200'
                                                    : 'bg-slate-100 text-slate-500 border-slate-200 hover:bg-slate-200'
                                                }`}
                                              >
                                                <i className="ph ph-whatsapp-logo text-green-600 text-sm"></i> {ev.notified ? 'Link Enviado' : 'Enviar Link'}
                                              </button>
                                            </>
                                          )}

                                          {ev.arrived ? (
                                            <div className="flex items-center gap-1">
                                              {String(ev.professionalId) === String(currentUser.id) && ev.professionalResponse === 'aguardar' ? (
                                                <button
                                                  type="button"
                                                  onClick={() => {
                                                    patchEv(ev.id, { professionalResponse: 'pode_entrar', responseNotified: false });
                                                    try {
                                                      localStorage.setItem('rc_system_pings', JSON.stringify({
                                                          type: 'RESPONSE_ALERT',
                                                          statusMsg: 'autorizou a entrada',
                                                          patientName: ev.patientName || ev.nomePaciente || ev.title,
                                                          senderProfId: currentUser.id,
                                                          hash: Math.random(),
                                                          ts: Date.now()
                                                      }));
                                                    } catch(e) {}
                                                  }}
                                                  className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold border transition-colors bg-blue-100 text-blue-900 border-blue-300 hover:bg-blue-200"
                                                  title="Chamar paciente agora"
                                                >
                                                  <i className="ph ph-speaker-high"></i> Chamar Paciente
                                                </button>
                                              ) : null}

                                              {(userTemNivel(currentUser, 'Administrador') || userTemNivel(currentUser, 'Super Administrador') || userTemNivel(currentUser, 'Recepcionista')) ? (
                                                <>
                                                  <button
                                                    type="button"
                                                    onClick={() => {
                                                      patchEv(ev.id, { receptionNotified: false, professionalResponse: null, responseNotified: false });
                                                      const msg = `${ev.patientName || 'O paciente'} continua aguardando você na recepção!`;
                                                      showToast(`Novo aviso enviado ao profissional!`, 'success');
                                                      try {
                                                        localStorage.setItem('rc_system_pings', JSON.stringify({
                                                            type: 'ARRIVAL_ALERT',
                                                            targetProfId: ev.professionalId,
                                                            eventId: ev.id,
                                                            patientName: ev.patientName || ev.nomePaciente || ev.title,
                                                            message: msg,
                                                            hash: Math.random(),
                                                            ts: Date.now()
                                                        }));
                                                      } catch(e) {}
                                                    }}
                                                    className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold border transition-colors bg-emerald-100 text-emerald-900 border-emerald-300 hover:bg-emerald-200"
                                                    title="Tocar campainha novamente"
                                                  >
                                                    <i className="ph ph-bell-ringing"></i> Avisar Novamente
                                                  </button>
                                                  <button
                                                    type="button"
                                                    onClick={() => patchEv(ev.id, { arrived: false, receptionNotified: false, professionalResponse: null, responseNotified: false })}
                                                    className="text-slate-400 hover:text-red-500 transition-colors p-1"
                                                    title="Desfazer chegada"
                                                  >
                                                    <i className="ph ph-x-circle text-lg"></i>
                                                  </button>
                                                </>
                                              ) : null}
                                            </div>
                                          ) : (
                                            (userTemNivel(currentUser, 'Administrador') || userTemNivel(currentUser, 'Super Administrador') || userTemNivel(currentUser, 'Recepcionista')) ? (
                                              <button
                                                type="button"
                                                onClick={() => {
                                                  patchEv(ev.id, { arrived: true, receptionNotified: false, professionalResponse: null, responseNotified: false });
                                                  const msg = `${ev.patientName || 'O paciente'} chegou na recepção e está aguardando você!`;
                                                  showToast(`Aviso de chegada enviado ao profissional!`, 'success');
                                                  try {
                                                    localStorage.setItem('rc_system_pings', JSON.stringify({
                                                        type: 'ARRIVAL_ALERT',
                                                        targetProfId: ev.professionalId,
                                                        eventId: ev.id,
                                                        patientName: ev.patientName || ev.nomePaciente || ev.title,
                                                        message: msg,
                                                        hash: Math.random(),
                                                        ts: Date.now()
                                                    }));
                                                  } catch(e) {}
                                                }}
                                                className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold border transition-colors bg-slate-100 text-slate-500 border-slate-200 hover:bg-slate-200"
                                                title="Anunciar Chegada"
                                              >
                                                <i className="ph ph-bell"></i> Avisar Chegada
                                              </button>
                                            ) : null
                                          )}

                                          <button
                                            type="button"
                                            onClick={() => {
                                              const pat = patients.find(p => String(p.id) === String(ev.patientId));
                                              setPresenceFlowCtx({
                                                patientName: (ev.patientName || ev.pacienteNome || ev.nomePaciente || ev.title || '').trim() || 'Paciente',
                                                patientPhone: pat ? pat.telefone : '',
                                                professionalName: profNameQ(ev.professionalId),
                                                professionalId: ev.professionalId != null ? String(ev.professionalId) : '',
                                                agendaEventId: ev.id,
                                                date: ev.date,
                                                time: ev.start,
                                                procedure: ev.procedure || ev.title || '',
                                                type: ev.type || '',
                                                startAtStep: 'choose',
                                                remoteToken: null,
                                              });
                                            }}
                                            className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold border transition-colors ${
                                              ev.presence === 'registered' || ev.presence === 'present'
                                                ? 'bg-emerald-100 text-emerald-900 border-emerald-300'
                                                : 'bg-slate-100 text-slate-600 border-slate-300 hover:bg-emerald-50 hover:border-emerald-200'
                                            }`}
                                          >
                                            <i className={`ph ${(ev.presence === 'registered' || ev.presence === 'present') ? 'ph-check-circle' : 'ph-identification-badge'}`}></i>
                                            {(ev.presence === 'registered' || ev.presence === 'present') ? 'Presença confirmada' : 'Assinar Presença'}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex items-center justify-end gap-2 shrink-0 border-t lg:border-t-0 border-slate-100 pt-3 lg:pt-0">
                                      {(!usuarioRestritoComoFisio(currentUser)) && (
                                        <>
                                          <button
                                            type="button"
                                            title="Editar"
                                            onClick={() => {
                                              setAgendaEditId(ev.id);
                                              setAgendaForm({
                                                date: ev.date,
                                                start: ev.start || '',
                                                end: ev.end || ev.start || '',
                                                patientId: ev.patientId != null ? String(ev.patientId) : '',
                                                patientName: ev.patientName || '',
                                                title: ev.title || '',
                                                professionalId: ev.professionalId != null ? String(ev.professionalId) : '',
                                                paymentValue: ev.paymentValue != null ? String(ev.paymentValue) : '150,00',
                                                paymentStatus: ev.paymentStatus != null ? String(ev.paymentStatus) : (ev.paymentPending ? 'Pendente' : 'Pago'),
                                                paymentMethod: ev.paymentMethod != null ? String(ev.paymentMethod) : '',
                                              });
                                              setAgendaModalOpen(true);
                                            }}
                                            className="p-2.5 rounded-full border-2 border-emerald-200 text-emerald-800 hover:bg-emerald-50"
                                          >
                                            <i className="ph ph-pencil-simple text-lg"></i>
                                          </button>
                                          <button
                                            type="button"
                                            title="Imprimir Recibo"
                                            onClick={() => {
                                              setTimeout(() => window.print(), 300);
                                              showToast('Imprimindo recibo para ' + (ev.patientName || 'Paciente'), 'success');
                                            }}
                                            className="p-2.5 rounded-full border-2 border-emerald-200 text-emerald-700 hover:bg-emerald-50"
                                          >
                                            <i className="ph ph-file-text text-lg"></i>
                                          </button>
                                          <button
                                            type="button"
                                            title="Excluir"
                                            onClick={() => {
                                              if (window.confirm('Remover este agendamento?')) {
                                                persistAgendaEvents(agendaEvents.filter((x) => x.id !== ev.id));
                                                const linkedFin = finEntries.filter(f => String(f.agendaEventId) === String(ev.id));
                                                if (linkedFin.length > 0) {
                                                  persistFinEntries(finEntries.filter(f => String(f.agendaEventId) !== String(ev.id)));
                                                }
                                                showToast('Agendamento excluído.', 'success');
                                              }
                                            }}
                                            className="p-2.5 rounded-full border border-red-200 text-red-600 hover:bg-red-50"
                                          >
                                            <i className="ph ph-trash text-lg"></i>
                                          </button>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                          {queuePage.length > 0 && renderPagination(pageFila, setPageFila, limitFila, setLimitFila, totalFila)}
                        </div>
                      </div>
                      


                      <p className="text-center text-xs text-slate-600 mt-4 flex flex-wrap items-center justify-center gap-2">
                        <i className="ph ph-leaf text-emerald-600"></i>
                        <span>Estados da fila (badges) são guardados neste navegador juntos com a agenda.</span>
                      </p>


                    </div>
                  );
                })()}

                {activeTab === 'presencas' && (() => {
                  const todayK = rcAgendaToDateKey(new Date());
                  const q = (presenceSearch || '').trim().toLowerCase();
                  const filtered = presenceRecords.filter((r) => {
                    if (presenceDateFilter && r.date !== presenceDateFilter) return false;
                    if (!q) return true;
                    const pn = (r.patientName || '').toLowerCase();
                    const pr = (r.professionalName || '').toLowerCase();
                    return pn.includes(q) || pr.includes(q);
                  });
                  const nTotal = presenceRecords.length;
                  const nSig = presenceRecords.filter((r) => r.signatureDataUrl).length;
                  const nSelf = presenceRecords.filter((r) => r.selfieDataUrl).length;
                  const todayAgenda = agendaEvents.filter((e) => {
                    if (e.date !== todayK) return false;
                    if (usuarioRestritoComoFisio(currentUser)) {
                      if (String(e.professionalId) === String(currentUser.id)) return true;
                      const pat = patients.find(p => String(p.id) === String(e.patientId));
                      return pat && (pat.fisio1_id == currentUser.id || pat.fisio2_id == currentUser.id);
                    }
                    return true;
                  });
                  const hasRecordForEvent = (eid) => presenceRecords.some((r) => r.agendaEventId === eid);
                  const pendingToday = todayAgenda.filter((e) => !hasRecordForEvent(e.id)).length;
                  const selectedName = presenceSelectedPatient ? String(presenceSelectedPatient) : '';
                  const recordsForSelected = selectedName
                    ? presenceRecords
                        .filter((r) => String(r.patientName) === selectedName)
                        .sort((a, b) => (String(b.date) + ' ' + String(b.time)).localeCompare(String(a.date) + ' ' + String(a.time)))
                    : [];
                  const rcPresenceProfName = (r) => {
                    const direct = String(r?.professionalName || '').trim();
                    if (direct) return direct;
                    const pid = r?.professionalId != null && r?.professionalId !== '' ? String(r.professionalId) : '';
                    if (!pid) return '—';
                    const u = usersList.find((x) => String(x.id) === pid);
                    return u?.nome || '—';
                  };
                  const rcPresencePatientName = (r) => {
                    const direct = String(r?.patientName || '').trim();
                    if (direct && !/^consulta$/i.test(direct)) return direct;
                    const evId = r?.agendaEventId;
                    if (evId != null) {
                      const ev = agendaEvents.find((e) => String(e.id) === String(evId));
                      const fromEv = String(ev?.patientName || ev?.pacienteNome || ev?.nomePaciente || ev?.title || '').trim();
                      if (fromEv && !/^consulta$/i.test(fromEv)) return fromEv;
                    }
                    return direct || 'Paciente';
                  };
                  const patientCards = (() => {
                    if (selectedName) return [];
                    const byName = new Map();
                    const toSortKey = (r) => {
                      const dt = `${String(r?.date || '')} ${String(r?.time || '')}`.trim();
                      if (dt && dt !== '-') return dt;
                      return String(r?.createdAt || '');
                    };
                    for (const r of filtered) {
                      const name = rcPresencePatientName(r);
                      const prev = byName.get(name) || { name, latest: r, count: 0, hasSig: false, hasSelf: false, latestKey: '' };
                      const k = toSortKey(r);
                      const prevK = prev.latestKey || toSortKey(prev.latest);
                      const latest = k.localeCompare(prevK) > 0 ? r : prev.latest;
                      byName.set(name, {
                        name,
                        latest,
                        count: prev.count + 1,
                        hasSig: prev.hasSig || !!r.signatureDataUrl,
                        hasSelf: prev.hasSelf || !!r.selfieDataUrl,
                        latestKey: k.localeCompare(prevK) > 0 ? k : prevK,
                      });
                    }
                    return Array.from(byName.values()).sort((a, b) => String(b.latestKey).localeCompare(String(a.latestKey)));
                  })();
                  return (
                    <div className="min-h-full bg-gradient-to-br from-indigo-50/90 via-violet-50/50 to-emerald-50/80 p-4 md:p-8 animate-fadeIn">
                      <div className="max-w-[1200px] mx-auto w-full">
                        {selectedName ? (
                          <div className="bg-white rounded-2xl shadow-lg border border-slate-200/80 p-5 md:p-6 mb-6">
                            <div className="flex flex-wrap items-center justify-between gap-4">
                              <div>
                                <button
                                  type="button"
                                  onClick={() => setPresenceSelectedPatient(null)}
                                  className="inline-flex items-center gap-2 text-sm font-bold text-slate-600 hover:text-emerald-700"
                                >
                                  <i className="ph ph-arrow-left"></i> Voltar
                                </button>
                                <h2 className="text-xl md:text-2xl font-extrabold text-slate-900 mt-2">
                                  Linha do Tempo: <span className="text-violet-700">{selectedName}</span>
                                </h2>
                                <p className="text-sm text-slate-500 mt-1">
                                  {recordsForSelected.length} presença(s) registradas no sistema
                                  {recordsForSelected[0]?.professionalName ? (
                                    <>
                                      {' '}
                                      (Profissional:{' '}
                                      <span className="font-semibold text-slate-700">{recordsForSelected[0].professionalName}</span>)
                                    </>
                                  ) : null}
                                </p>
                              </div>
                              <button
                                type="button"
                                onClick={() => {
                                  setPresenceSelectedPatient(null);
                                  setActiveTab('list');
                                }}
                                className="px-5 py-3 rounded-xl bg-slate-50 hover:bg-slate-100 border border-slate-200 text-slate-700 font-bold"
                              >
                                Voltar para Pacientes
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
                            <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight">Registro de Presenças</h2>
                            <div className="flex items-center gap-2 text-sm font-semibold text-emerald-800 bg-white/80 px-4 py-2 rounded-full border border-emerald-200 shadow-sm">
                              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-emerald-500 text-white">
                                <i className="ph ph-check"></i>
                              </span>
                              Presenças da Recepção
                            </div>
                          </div>
                        )}
                        {!selectedName ? (
                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
                          <div className="bg-white rounded-2xl p-5 shadow-md border border-slate-100 flex items-center gap-4">
                            <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-emerald-100 text-emerald-600">
                              <i className="ph ph-check-circle text-2xl"></i>
                            </span>
                            <div>
                              <div className="text-2xl font-black text-slate-900">{nTotal}</div>
                              <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Presenças confirmadas</div>
                            </div>
                          </div>
                          <div className="bg-white rounded-2xl p-5 shadow-md border border-slate-100 flex items-center gap-4">
                            <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-violet-100 text-violet-600">
                              <i className="ph ph-pen-nib text-2xl"></i>
                            </span>
                            <div>
                              <div className="text-2xl font-black text-slate-900">{nSig}</div>
                              <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Assinaturas coletadas</div>
                            </div>
                          </div>
                          <div className="bg-white rounded-2xl p-5 shadow-md border border-slate-100 flex items-center gap-4">
                            <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-orange-100 text-orange-600">
                              <i className="ph ph-camera text-2xl"></i>
                            </span>
                            <div>
                              <div className="text-2xl font-black text-slate-900">{nSelf}</div>
                              <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Selfies registradas</div>
                            </div>
                          </div>
                          <div className="bg-white rounded-2xl p-5 shadow-md border border-slate-100 flex items-center gap-4">
                            <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-amber-100 text-amber-700">
                              <i className="ph ph-hourglass text-2xl"></i>
                            </span>
                            <div>
                              <div className="text-2xl font-black text-slate-900">{pendingToday}</div>
                              <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Sem confirmação (hoje)</div>
                            </div>
                          </div>
                        </div>
                        ) : null}
                        <div className="bg-white rounded-2xl shadow-lg border border-slate-200/80 p-5 md:p-6">
                          {!selectedName ? (
                          <div className="flex flex-col md:flex-row md:items-center gap-4 mb-6">
                            <div className="relative flex-1">
                              <i className="ph ph-magnifying-glass absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-xl"></i>
                              <input
                                className="w-full pl-11 pr-4 py-3 rounded-xl border border-slate-200 text-sm font-medium focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                                placeholder="Buscar paciente ou profissional…"
                                value={presenceSearch}
                                onChange={(e) => setPresenceSearch(e.target.value)}
                              />
                            </div>
                            <div className="flex flex-wrap items-center gap-3">
                              <input
                                type="date"
                                className="px-3 py-3 rounded-xl border border-slate-200 text-sm"
                                value={presenceDateFilter}
                                onChange={(e) => setPresenceDateFilter(e.target.value)}
                              />
                              <span className="text-sm font-bold text-slate-600 whitespace-nowrap">{filtered.length} registro(s)</span>
                            </div>
                          </div>
                          ) : null}
                          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-start">
                            {(selectedName ? recordsForSelected : filtered).length === 0 ? (
                              <div className="text-center py-16 text-slate-500 border border-dashed border-slate-200 rounded-2xl">
                                Nenhum registro encontrado.
                              </div>
                            ) : (
                              (selectedName ? recordsForSelected : patientCards).map((row) => {
                                const r = selectedName ? row : row.latest;
                                const name = selectedName ? rcPresencePatientName(r) : String(row.name || 'Paciente');
                                const initials = (name || '?').charAt(0).toUpperCase();
                                const dDisp = r.date
                                  ? (() => {
                                      const [y, m, d] = String(r.date).split('-');
                                      return d && m && y ? `${d}/${m}/${y}` : String(r.date);
                                    })()
                                  : '—';
                                const visitsCount = selectedName ? recordsForSelected.length : row.count;
                                const plural = visitsCount === 1 ? 'visita' : 'visitas';
                                const hasSig = selectedName ? !!r.signatureDataUrl : row.hasSig;
                                const hasSelf = selectedName ? !!r.selfieDataUrl : row.hasSelf;
                                if (selectedName) {
                                  const createdLabel = r.createdAt ? new Date(r.createdAt).toLocaleString('pt-BR') : '—';
                                  const procLabel = r.procedure ? r.procedure : (r.type === 'pilates_reposicao' ? 'Pilates (Reposição)' : (r.type === 'pilates_mensalidade' ? 'Pilates (Mensalidade)' : (r.type === 'fisioterapia' ? 'Fisioterapia' : 'Sessão')));
                                  const title = `${procLabel} — ${dDisp}${r.time ? ` às ${r.time}` : ''}`;
                                  return (
                                    <div
                                      key={r.id}
                                      className="bg-white rounded-2xl shadow-lg border border-slate-200/80 p-5 md:p-6"
                                    >
                                      <div className="flex items-start gap-4">
                                        <div className="mt-1 h-3 w-3 rounded-full bg-violet-600 ring-4 ring-violet-100" />
                                        <div className="min-w-0 flex-1">
                                          <div className="flex items-start justify-between gap-4">
                                            <div className="min-w-0">
                                              <div className="font-bold text-slate-900">{title}</div>
                                              <div className="mt-1 text-xs text-slate-500 flex flex-wrap items-center gap-x-3 gap-y-1">
                                                <span className="inline-flex items-center gap-1">
                                                  <i className="ph ph-check-circle text-emerald-600"></i>
                                                  Confirmado por {r.method === 'link' ? 'Link' : 'Atendente'}
                                                </span>
                                              </div>
                                              <div className="mt-2 text-xs font-semibold text-emerald-700">
                                                Registrado em {createdLabel}
                                              </div>
                                            </div>
                                            <div className="flex items-center gap-2 shrink-0">
                                              {r.selfieDataUrl ? (
                                                <button type="button" onClick={(e) => { e.stopPropagation(); setZoomedImage(r.selfieDataUrl); }} className="h-11 w-11 rounded-xl overflow-hidden border border-slate-200 bg-white shadow-sm">
                                                  <img src={r.selfieDataUrl} alt="Selfie" className="w-full h-full object-cover" />
                                                </button>
                                              ) : null}
                                              {r.signatureDataUrl ? (
                                                <button type="button" onClick={(e) => { e.stopPropagation(); setZoomedImage(r.signatureDataUrl); }} className="h-11 w-11 rounded-xl overflow-hidden border border-slate-200 bg-white shadow-sm">
                                                  <img src={r.signatureDataUrl} alt="Assinatura" className="w-full h-full object-cover" />
                                                </button>
                                              ) : null}
                                              <button type="button" title="Excluir" onClick={(e) => { e.stopPropagation(); const n = presenceRecords.filter(x => x.id !== r.id); setPresenceRecords(n); rcPresenceRecordsSave(n); showToast('Registro excluído com sucesso!', 'success'); }} className="h-11 w-11 flex items-center justify-center rounded-xl bg-red-50 text-red-500 hover:bg-red-100 hover:text-red-700 transition-colors border border-red-100 shadow-sm ml-1">
                                                <i className="ph ph-x pr-0.5 text-lg font-bold"></i>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                                const displayName = String(name || '').trim() || 'Paciente';
                                const lines = displayName.split(/\s+/).reduce(
                                  (acc, part) => {
                                    const next = acc[acc.length - 1] ? `${acc[acc.length - 1]} ${part}` : part;
                                    if (next.length > 22 && acc.length < 2) acc.push(part);
                                    else acc[acc.length - 1] = next;
                                    return acc;
                                  },
                                  ['']
                                );
                                const line1 = lines[0].trim() || displayName;
                                const line2 = lines[1] ? lines[1].trim() : '';

                                return (
                                  <div
                                    key={selectedName ? r.id : displayName}
                                    className="rounded-3xl border border-indigo-100 bg-white p-5 shadow-sm hover:shadow-md hover:shadow-indigo-900/5 transition-shadow cursor-pointer w-full"
                                    onClick={() => {
                                      if (!selectedName) setPresenceSelectedPatient(displayName);
                                    }}
                                  >
                                    <div className="flex items-start gap-4">
                                      <div className="h-12 w-12 rounded-full bg-indigo-50 text-indigo-700 flex items-center justify-center font-bold text-xl shrink-0 mt-0.5">
                                        {initials}
                                      </div>
                                      <div className="min-w-0 flex-1">
                                        <div className="flex items-start justify-between gap-3">
                                          <div className="min-w-0 mt-1">
                                            <div className="font-bold text-slate-800 text-[17px] leading-tight uppercase">
                                              {displayName}
                                            </div>
                                          </div>
                                          {!selectedName ? (
                                            <div className="flex flex-col items-center justify-center bg-indigo-600 text-white rounded-xl px-3 py-1 shadow-sm shrink-0 min-w-[3.5rem] mt-0.5">
                                              <span className="font-bold text-base leading-none">{visitsCount}</span>
                                              <span className="text-[10px] font-medium leading-tight">{visitsCount === 1 ? 'visita' : 'visitas'}</span>
                                            </div>
                                          ) : null}
                                        </div>

                                        <div className="mt-3 space-y-1">
                                          <div className="text-[14px] text-slate-500">
                                            <span className="font-bold">Profissional:</span> {rcPresenceProfName(r)}
                                          </div>
                                          <div className="text-[14px] text-slate-500">
                                            <span className="font-bold">Última Presença:</span> {dDisp}
                                            {r.time ? <span className="ml-1">às {r.time}</span> : null}
                                          </div>
                                        </div>

                                        <div className="mt-4 flex items-center gap-2 rounded-xl bg-emerald-50/70 px-3 py-2.5">
                                          <i className="ph ph-check-circle text-emerald-500 text-lg"></i>
                                          <span className="text-sm font-medium text-emerald-500">
                                            Última verificação: {r.method === 'link' ? 'Link' : 'Atendente'}
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    {selectedName ? (
                                      <div className="mt-4 flex items-center justify-between">
                                        <div className="text-xs text-slate-500 font-semibold">
                                          Registrado em {r.createdAt ? new Date(r.createdAt).toLocaleString('pt-BR') : '—'}
                                        </div>
                                        <div className="flex gap-2">
                                          {r.selfieDataUrl ? (
                                            <button type="button" onClick={(e) => { e.stopPropagation(); setZoomedImage(r.selfieDataUrl); }} className="h-11 w-11 rounded-xl overflow-hidden border border-slate-200 bg-white shadow-sm">
                                              <img src={r.selfieDataUrl} alt="Selfie" className="w-full h-full object-cover" />
                                            </button>
                                          ) : null}
                                          {r.signatureDataUrl ? (
                                            <button type="button" onClick={(e) => { e.stopPropagation(); setZoomedImage(r.signatureDataUrl); }} className="h-11 w-11 rounded-xl overflow-hidden border border-slate-200 bg-white shadow-sm">
                                              <img src={r.signatureDataUrl} alt="Assinatura" className="w-full h-full object-cover" />
                                            </button>
                                          ) : null}
                                          <button type="button" title="Excluir" onClick={(e) => { e.stopPropagation(); const n = presenceRecords.filter(x => x.id !== r.id); setPresenceRecords(n); rcPresenceRecordsSave(n); showToast('Registro excluído com sucesso!', 'success'); }} className="h-11 w-11 flex items-center justify-center rounded-xl bg-red-50 text-red-500 hover:bg-red-100 hover:text-red-700 transition-colors border border-red-100 shadow-sm ml-1">
                                            <i className="ph ph-x pr-0.5 text-lg font-bold"></i>
                                          </button>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                );
                              })
                            )}
                          </div>
                        </div>
                        <p className="text-center text-xs text-slate-500 mt-6">
                          Dados armazenados localmente neste navegador (localStorage).
                        </p>
                      </div>
                    </div>
                  );
                })()}

                <ConfirmPresenceFlow
                  open={!!presenceFlowCtx}
                  context={presenceFlowCtx}
                  onClose={() => setPresenceFlowCtx(null)}
                  onSaved={handlePresenceSaved}
                  onShowToast={showToast}
                />

                {professionalArrivalAlert && (
                  <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fadeIn">
                    <div className="bg-white rounded-3xl shadow-2xl max-w-sm w-full p-6 text-center border border-slate-200">
                      <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ph ph-bell-ringing text-3xl"></i>
                      </div>
                      <h3 className="text-xl font-bold text-slate-800 mb-2">Paciente Chegou!</h3>
                      <p className="text-slate-600 mb-6">
                        <strong className="text-slate-800 block text-lg mb-1">{professionalArrivalAlert.patientName || 'O paciente'}</strong>
                        está aguardando na recepção.
                      </p>
                      <div className="flex gap-3">
                        <button
                          type="button"
                          onClick={() => {
                            const newEvents = [...agendaEventsRef.current];
                            const idx = newEvents.findIndex(e => e.id === professionalArrivalAlert.id);
                            if (idx >= 0) {
                              newEvents[idx] = { ...newEvents[idx], professionalResponse: 'aguardar' };
                              persistAgendaEvents(newEvents);
                            }
                            setProfessionalArrivalAlert(null);
                            try { 
                              localStorage.setItem('rc_system_pings', JSON.stringify({ 
                                type: 'RESPONSE_ALERT', 
                                statusMsg: 'pediu para aguardar',
                                patientName: professionalArrivalAlert.patientName,
                                senderProfId: currentUser.id,
                                ts: Date.now() 
                              })); 
                            } catch(e) {}
                          }}
                          className="flex-1 py-3 rounded-xl font-bold bg-amber-100 text-amber-800 hover:bg-amber-200 transition-colors"
                        >
                          Aguardar
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            const newEvents = [...agendaEventsRef.current];
                            const idx = newEvents.findIndex(e => e.id === professionalArrivalAlert.id);
                            if (idx >= 0) {
                              newEvents[idx] = { ...newEvents[idx], professionalResponse: 'pode_entrar' };
                              persistAgendaEvents(newEvents);
                            }
                            setProfessionalArrivalAlert(null);
                            try { 
                              localStorage.setItem('rc_system_pings', JSON.stringify({ 
                                type: 'RESPONSE_ALERT', 
                                statusMsg: 'autorizou a entrada',
                                patientName: professionalArrivalAlert.patientName,
                                senderProfId: currentUser.id,
                                ts: Date.now() 
                              })); 
                            } catch(e) {}
                          }}
                          className="flex-1 py-3 rounded-xl font-bold bg-emerald-500 text-white hover:bg-emerald-600 shadow-md shadow-emerald-500/20 transition-colors"
                        >
                          Pode Entrar
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {receptionResponseAlert && (
                  <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fadeIn">
                    <div className="bg-white rounded-3xl shadow-2xl max-w-sm w-full p-6 text-center border border-slate-200">
                      <div className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 ${receptionResponseAlert.professionalResponse === 'pode_entrar' ? 'bg-emerald-100 text-emerald-600' : 'bg-amber-100 text-amber-600'}`}>
                        <i className={`ph ${receptionResponseAlert.professionalResponse === 'pode_entrar' ? 'ph-check-circle' : 'ph-clock'} text-3xl`}></i>
                      </div>
                      <h3 className="text-xl font-bold text-slate-800 mb-2">Resposta do Profissional</h3>
                      <p className="text-slate-600 mb-6">
                        O profissional 
                        <strong className="text-slate-800 font-bold"> {receptionResponseAlert.professionalResponse === 'pode_entrar' ? 'autorizou a entrada' : 'pediu para aguardar'} </strong> 
                        do paciente 
                        <strong className="text-slate-800 block text-lg mt-1">{receptionResponseAlert.patientName || 'O paciente'}</strong>
                      </p>
                      <button
                        type="button"
                        onClick={() => setReceptionResponseAlert(null)}
                        className="w-full py-3 rounded-xl font-bold bg-blue-500 text-white hover:bg-blue-600 shadow-md transition-colors"
                      >
                        OK, ciente
                      </button>
                    </div>
                  </div>
                )}

                {agendaModalOpen ? (
                        <div
                          className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-slate-900/50"
                          role="dialog"
                          aria-modal="true"
                          onClick={() => { setAgendaModalOpen(false); setAgendaEditId(null); setAgendaPatientSearch(''); setAgendaPatientDropdownOpen(false); }}
                        >
                          <div className="bg-[#d9d9d9] rounded-3xl shadow-2xl max-w-xl w-full p-6 border border-slate-200/70" onClick={(e) => { e.stopPropagation(); setAgendaPatientDropdownOpen(false); }}>
                            <div className="flex items-center justify-between gap-3 mb-4">
                              <h3 className="text-lg font-extrabold text-slate-900 flex items-center gap-2">
                                <i className="ph ph-calendar-plus text-emerald-700 text-xl"></i>
                                {agendaEditId ? 'Editar Consulta' : 'Agendar Nova Consulta'}
                              </h3>
                              <button type="button" onClick={() => { setAgendaModalOpen(false); setAgendaEditId(null); setAgendaPatientSearch(''); setAgendaPatientDropdownOpen(false); }} className="p-2 rounded-full text-slate-500 hover:bg-white/60">
                                <i className="ph ph-x text-xl"></i>
                              </button>
                            </div>
                            <form
                              onSubmit={(e) => {
                                e.preventDefault();
                                const pid = String(agendaForm.patientId || '').trim();
                                const pObj = pid ? patients.find((p) => String(p.id) === pid) : null;
                                const patientName = (agendaForm.patientName || pObj?.nome || '').trim();
                                const profId = String(agendaForm.professionalId || '').trim();
                                const profObj = profId ? usersList.find((u) => String(u.id) === profId) : null;
                                const professionalName = (profObj?.nome || '').trim();
                                const time = String(agendaForm.start || '').trim();
                                if (!patientName) { showToast('Selecione um paciente.', 'error'); return; }
                                if (!agendaForm.date) { showToast('Selecione a data.', 'error'); return; }
                                if (!time || time === '--:--') { showToast('Selecione o horário.', 'error'); return; }
                                if (!profId && agendaForm.title !== 'Pilates (Reposição)') { showToast('Selecione o profissional.', 'error'); return; }
                                const title = agendaForm.title === 'Pilates (Reposição)' ? 'Pilates (Reposição)' : patientName;
                                const payStatus = String(agendaForm.paymentStatus || 'Pendente');
                                const paymentPending = payStatus.toLowerCase().includes('pend');
                                const paymentOk = !paymentPending;
                                if (agendaEditId) {
                                  const prev = agendaEvents.find((x) => x.id === agendaEditId);
                                  if (prev) {
                                    persistAgendaEvents(
                                      agendaEvents.map((x) =>
                                        x.id === agendaEditId
                                          ? {
                                              ...prev,
                                              date: agendaForm.date,
                                              start: time,
                                              end: time,
                                              title,
                                              patientId: pid,
                                              patientName,
                                              professionalId: profId,
                                              professionalName,
                                              paymentValue: agendaForm.paymentValue || '',
                                              paymentStatus: payStatus,
                                              paymentMethod: agendaForm.paymentMethod || '',
                                              paymentPending,
                                              paymentOk,
                                            }
                                          : x
                                      )
                                    );
                                  }
                                  setAgendaEditId(null);
                                  setAgendaModalOpen(false);
                                  setAgendaPatientSearch('');
                                  setAgendaPatientDropdownOpen(false);
                                  return;
                                }
                                const id = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
                                persistAgendaEvents([
                                  ...agendaEvents,
                                  {
                                    id,
                                    date: agendaForm.date,
                                    start: time,
                                    end: time,
                                    title,
                                    patientId: pid,
                                    patientName,
                                    professionalId: profId,
                                    professionalName,
                                    appointmentStatus: 'Marcado',
                                    confirmed: false,
                                    paymentPending,
                                    notified: false,
                                    paymentOk,
                                    arrived: false,
                                    presence: 'none',
                                    paymentValue: agendaForm.paymentValue || '',
                                    paymentStatus: payStatus,
                                    paymentMethod: agendaForm.paymentMethod || '',
                                  },
                                ]);
                                setAgendaModalOpen(false);
                              }}
                            >
                              <div className="space-y-4">
                                <div>
                                  <label className="block text-xs font-bold text-slate-700 mb-2">Paciente</label>
                                  <div className="relative">
                                    <div
                                      className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 shadow-sm cursor-pointer flex justify-between items-center"
                                      onClick={(e) => { e.stopPropagation(); setAgendaPatientDropdownOpen(!agendaPatientDropdownOpen); }}
                                    >
                                      <span>
                                        {agendaForm.patientId 
                                          ? (patients.find(p => String(p.id) === String(agendaForm.patientId))?.nome || 'Paciente selecionado')
                                          : 'Selecione um paciente cadastrado...'}
                                      </span>
                                      <i className={`ph ph-caret-${agendaPatientDropdownOpen ? 'up' : 'down'} text-slate-400`}></i>
                                    </div>
                                    
                                    {agendaPatientDropdownOpen && (
                                      <div className="absolute z-10 w-full mt-1 bg-white border border-slate-200 rounded-xl shadow-lg max-h-60 flex flex-col top-full overflow-hidden" onClick={(e) => e.stopPropagation()}>
                                        <div className="p-2 border-b border-slate-100 sticky top-0 bg-white z-20">
                                          <input
                                            type="text"
                                            className="w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-emerald-500"
                                            placeholder="Buscar paciente..."
                                            value={agendaPatientSearch}
                                            onChange={(e) => setAgendaPatientSearch(e.target.value)}
                                            onClick={(e) => e.stopPropagation()}
                                            autoFocus
                                          />
                                        </div>
                                        <div className="overflow-y-auto flex-1 rc-sidebar-scroll">
                                          <div
                                            className="px-4 py-2.5 hover:bg-slate-50 cursor-pointer text-sm text-slate-700"
                                            onClick={() => {
                                              setAgendaForm({ ...agendaForm, patientId: '', patientName: '', professionalId: '' });
                                              setAgendaPatientDropdownOpen(false);
                                              setAgendaPatientSearch('');
                                            }}
                                          >
                                            <span className="italic">Limpar seleção</span>
                                          </div>
                                          {patientsVisiveis
                                            .filter(p => (p.nome || '').toLowerCase().includes((agendaPatientSearch || '').toLowerCase()) || (p.cpf && p.cpf.includes(agendaPatientSearch)))
                                            .map((p) => (
                                              <div
                                                key={p.id}
                                                className={`px-4 py-2.5 cursor-pointer text-sm ${String(agendaForm.patientId) === String(p.id) ? 'bg-emerald-50/70 text-emerald-700 font-semibold' : 'hover:bg-slate-50 text-slate-700'}`}
                                                onClick={() => {
                                                  const profVal = p?.fisio1_id || p?.fisio2_id || agendaForm.professionalId || '';
                                                  setAgendaForm({ ...agendaForm, patientId: String(p.id), patientName: p.nome, professionalId: String(profVal) });
                                                  setAgendaPatientDropdownOpen(false);
                                                  setAgendaPatientSearch('');
                                                }}
                                              >
                                                {p.nome} {p.cpf ? <span className="text-xs text-slate-400 ml-1">({p.cpf})</span> : null}
                                              </div>
                                          ))}
                                          {patientsVisiveis.filter(p => (p.nome || '').toLowerCase().includes((agendaPatientSearch || '').toLowerCase()) || (p.cpf && p.cpf.includes(agendaPatientSearch))).length === 0 && (
                                              <div className="px-4 py-3 text-sm text-slate-500 text-center italic">
                                                Nenhum paciente encontrado.
                                              </div>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                  <div>
                                    <label className="block text-xs font-bold text-slate-700 mb-2">Data</label>
                                    <div className="relative">
                                      <input
                                        type="date"
                                        className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 shadow-sm"
                                        value={agendaForm.date}
                                        onChange={(e) => setAgendaForm({ ...agendaForm, date: e.target.value })}
                                      />
                                    </div>
                                  </div>
                                  <div>
                                    <label className="block text-xs font-bold text-slate-700 mb-2">Horário</label>
                                    <div className="relative">
                                      <input
                                        type="time"
                                        className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 shadow-sm"
                                        value={agendaForm.start}
                                        onChange={(e) => {
                                          const v = e.target.value;
                                          const add50 = (hhmm) => {
                                            const m = String(hhmm || '').match(/^(\d{2}):(\d{2})$/);
                                            if (!m) return hhmm;
                                            const h = Number(m[1]);
                                            const mm = Number(m[2]);
                                            const total = h * 60 + mm + 50;
                                            const h2 = Math.floor(((total % (24 * 60)) + (24 * 60)) % (24 * 60) / 60);
                                            const m2 = ((total % (24 * 60)) + (24 * 60)) % 60;
                                            return `${String(h2).padStart(2, '0')}:${String(m2).padStart(2, '0')}`;
                                          };
                                          setAgendaForm({ ...agendaForm, start: v, end: add50(v) });
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>

                                {agendaForm.title !== 'Pilates (Reposição)' && (
                                  <>
                                    <div>
                                      <label className="block text-xs font-bold text-slate-700 mb-2">Profissional</label>
                                      <select
                                        className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 shadow-sm"
                                        value={agendaForm.professionalId}
                                        onChange={(e) => setAgendaForm({ ...agendaForm, professionalId: e.target.value })}
                                      >
                                        <option value="">Selecione o profissional...</option>
                                        {usersList.map((u) => (
                                          <option key={u.id} value={String(u.id)}>{u.nome}</option>
                                        ))}
                                      </select>
                                    </div>

                                    <div className="border-t border-slate-300/60 pt-4">
                                      <div className="flex items-center gap-2 font-extrabold text-slate-800 mb-3">
                                        <i className="ph ph-currency-dollar text-violet-600"></i>
                                        Informações de Pagamento
                                      </div>
                                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                        <div>
                                          <label className="block text-xs font-bold text-slate-700 mb-2">Valor (R$)</label>
                                          <input
                                            type="text"
                                            className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 shadow-sm"
                                            value={agendaForm.paymentValue}
                                            onChange={(e) => setAgendaForm({ ...agendaForm, paymentValue: e.target.value })}
                                          />
                                        </div>
                                        <div>
                                          <label className="block text-xs font-bold text-slate-700 mb-2">Status Pagamento</label>
                                          <select
                                            className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 shadow-sm"
                                            value={agendaForm.paymentStatus}
                                            onChange={(e) => setAgendaForm({ ...agendaForm, paymentStatus: e.target.value })}
                                          >
                                            <option value="Pendente">Pendente</option>
                                            <option value="Pago">Pago</option>
                                          </select>
                                        </div>
                                      </div>
                                      <div className="mt-4">
                                        <label className="block text-xs font-bold text-slate-700 mb-2">Forma de Pagamento</label>
                                        <select
                                          className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 shadow-sm"
                                          value={agendaForm.paymentMethod}
                                          onChange={(e) => setAgendaForm({ ...agendaForm, paymentMethod: e.target.value })}
                                        >
                                          <option value="">Selecione...</option>
                                          <option value="Pix">Pix</option>
                                          <option value="Cartão">Cartão</option>
                                          <option value="Dinheiro">Dinheiro</option>
                                          <option value="Transferência">Transferência</option>
                                        </select>
                                      </div>
                                    </div>
                                  </>
                                )}

                                <div className="pt-2 flex items-center justify-between gap-3">
                                  <button type="button" className="flex-1 py-3 rounded-xl font-extrabold bg-white/70 hover:bg-white border border-slate-200 text-slate-700" onClick={() => { setAgendaModalOpen(false); setAgendaEditId(null); setAgendaPatientSearch(''); setAgendaPatientDropdownOpen(false); }}>
                                    Cancelar
                                  </button>
                                  <button type="submit" className="flex-1 py-3 rounded-xl font-extrabold bg-violet-600 hover:bg-violet-700 text-white shadow-lg shadow-violet-600/25 flex items-center justify-center gap-2">
                                    <i className="ph ph-check-circle text-xl"></i> Confirmar Agendamento
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      ) : null}

                {activeTab === 'financeiro' && (() => {
                  /* ── helpers de parse ── */
                  const parseVal = (v) => { const n = parseFloat(String(v || '0').replace(/\./g, '').replace(',', '.')); return isNaN(n) ? 0 : n; };
                  const today = new Date(); 
                  const todayStr = today.toISOString().split('T')[0];
                  const startOfWeek = new Date(today); startOfWeek.setDate(today.getDate() - today.getDay());
                  const weekStr = startOfWeek.toISOString().split('T')[0];
                  const monthStr = todayStr.slice(0, 7);

                  /* ── normalizar agenda como receitas automáticas ── */
                  const agendaAsEntries = agendaEvents
                    .filter(ev => !ev.pilatesEvent && ev.paymentStatus !== 'Pacote')
                    .map(ev => ({
                    id: 'ag_' + ev.id,
                    tipo: 'receita',
                    descricao: ev.patientName || ev.title || 'Consulta',
                    valor: ev.paymentValue || '0',
                    data: ev.date || '',
                    categoria: ev.fisioEvent ? 'Fisioterapia' : 'Consulta',
                    metodo: ev.paymentMethod || '',
                    status: (!ev.paymentPending && ev.paymentStatus === 'Pago') ? 'pago' : 'pendente',
                    origem: 'agenda',
                    profissionalId: ev.professionalId,
                    profissionalNome: ev.professionalName || '',
                    paymentDeletedFromFin: ev.paymentDeletedFromFin || false,
                  }));

                  /* ── entries manuais normalizados ── */
                  const manualNorm = finEntries.map(e => ({
                    ...e,
                    status: e.status || 'pendente',
                    origem: 'manual',
                  }));

                  /* ── merge tudo ── */
                  const allEntries = [...agendaAsEntries, ...manualNorm];

                  /* ── filtragem ── */
                  const filtered = allEntries.filter(e => {
                    // Se for da agenda e foi "deletado" do financeiro, some daqui
                    if (e.origem === 'agenda' && e.paymentDeletedFromFin) return false;

                    if (finPeriodo === 'hoje' && e.data !== todayStr) return false;
                    if (finPeriodo === 'semana' && e.data < weekStr) return false;
                    if (finPeriodo === 'mes' && !e.data?.startsWith(monthStr)) return false;
                    if (finProf && String(e.profissionalId) !== String(finProf)) return false;
                    if (finMetodo && e.metodo !== finMetodo) return false;
                    return true;
                  });

                  const receitas = filtered.filter(e => e.tipo === 'receita' && e.status === 'pago');
                  const pendentesRec = filtered.filter(e => e.tipo === 'receita' && e.status === 'pendente');
                  const despesasPagas = filtered.filter(e => e.tipo === 'despesa' && e.status === 'pago');
                  const despesasPend = filtered.filter(e => e.tipo === 'despesa' && e.status === 'pendente');
                  const receitaTotal = receitas.reduce((s, e) => s + parseVal(e.valor), 0);
                  const aReceber = pendentesRec.reduce((s, e) => s + parseVal(e.valor), 0);
                  const despesaTotal = despesasPagas.reduce((s, e) => s + parseVal(e.valor), 0);
                  const despesaPendTotal = despesasPend.reduce((s, e) => s + parseVal(e.valor), 0);
                  const saldo = receitaTotal - despesaTotal;

                  /* ── gráfico 7 dias ── */
                  const last7 = Array.from({ length: 7 }, (_, i) => {
                    const d = new Date(today); d.setDate(today.getDate() - (6 - i));
                    const ds = d.toISOString().split('T')[0];
                    const dayRec = allEntries.filter(e => e.data === ds && e.tipo === 'receita' && e.status === 'pago').reduce((s, e) => s + parseVal(e.valor), 0);
                    const dayDesp = allEntries.filter(e => e.data === ds && e.tipo === 'despesa').reduce((s, e) => s + parseVal(e.valor), 0);
                    const dayLabel = d.toLocaleDateString('pt-BR', { weekday: 'short' }).replace('.', '');
                    const dateLabel = String(d.getDate()).padStart(2, '0') + '/' + String(d.getMonth() + 1).padStart(2, '0');
                    return { ds, rec: dayRec, desp: dayDesp, dayLabel, dateLabel };
                  });
                  const maxChart = Math.max(...last7.map(d => Math.max(d.rec, d.desp)), 1);

                  /* ── métodos únicos ── */
                  const metodos = [...new Set(allEntries.map(e => e.metodo).filter(Boolean))];

                  /* ── tabela ordenada ── */
                  const sorted = [...filtered].sort((a, b) => {
                    const cDate = (a.data || '').localeCompare(b.data || '');
                    if (cDate !== 0) return cDate;
                    // Se as datas são iguais, coloca os Pendentes no topo
                    if (a.status === 'pendente' && b.status !== 'pendente') return -1;
                    if (b.status === 'pendente' && a.status !== 'pendente') return 1;
                    return 0;
                  });

                  /* ── handlers ── */
                  const openFinModal = (tipo) => {
                    setFinModalForm({ id: null, tipo, descricao: '', valor: '', data: todayStr, categoria: '', metodo: '', status: 'pendente', recorrente: false });
                    setFinModalOpen(true);
                  };
                  const handleFinEdit = (entry) => {
                    setFinModalForm({ ...entry });
                    setFinModalOpen(true);
                  };
                  const handleFinDelete = (id) => {
                    if (!confirm('Deseja excluir este lançamento?')) return;
                    if (String(id).startsWith('ag_')) {
                      /* Agenda: marcamos como excluído do financeiro sem apagar o agendamento */
                      const realId = String(id).replace('ag_', '');
                      persistAgendaEvents(agendaEvents.map(x => x.id === realId ? { 
                        ...x,
                        paymentStatus: 'Pendente', 
                        paymentPending: true, 
                        paymentMethod: '', 
                        paymentValue: '0', 
                        paymentDeletedFromFin: true 
                      } : x));
                      showToast('Lançamento da agenda removido do financeiro.', 'success');
                    } else {
                      /* Manual */
                      persistFinEntries(finEntries.filter(e => String(e.id) !== String(id)));
                      showToast('Lançamento excluído!', 'success');
                    }
                  };
                  const handleFinToggleStatus = (entry) => {
                    if (entry.origem === 'agenda') return; /* agenda status é gerenciado lá */
                    const newStatus = entry.status === 'pago' ? 'pendente' : 'pago';
                    persistFinEntries(finEntries.map(e => e.id === entry.id ? { ...e, status: newStatus } : e));
                    showToast(newStatus === 'pago' ? 'Marcado como Pago!' : 'Marcado como Pendente.', 'success');
                  };

                  return (
                  <div className="p-4 md:p-8 animate-fadeIn">
                    {/* Header + Botões */}
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
                      <div>
                        <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-3">
                          <i className="ph ph-chart-line-up text-emerald-600"></i> Painel Financeiro
                        </h2>
                        <p className="text-slate-500 text-sm">Receitas automáticas das consultas + lançamentos manuais</p>
                      </div>
                      <div className="flex gap-3">
                        <button onClick={() => openFinModal('receita')} className="flex items-center gap-2 px-4 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white font-bold rounded-xl shadow-md shadow-emerald-200 transition-all text-sm">
                          <i className="ph ph-plus-circle text-lg"></i> Nova Receita
                        </button>
                        <button onClick={() => openFinModal('despesa')} className="flex items-center gap-2 px-4 py-2.5 bg-red-500 hover:bg-red-600 text-white font-bold rounded-xl shadow-md shadow-red-200 transition-all text-sm">
                          <i className="ph ph-minus-circle text-lg"></i> Nova Despesa
                        </button>
                      </div>
                    </div>

                    {/* Filtros */}
                    <div className="flex flex-wrap gap-3 mb-6">
                      {[
                        { key: 'hoje', label: 'Hoje' },
                        { key: 'semana', label: 'Esta Semana' },
                        { key: 'mes', label: 'Este Mês' },
                        { key: 'todos', label: 'Todos' },
                      ].map(f => (
                        <button key={f.key} onClick={() => setFinPeriodo(f.key)}
                          className={`px-4 py-2 rounded-xl text-sm font-bold transition-all ${finPeriodo === f.key ? 'bg-emerald-600 text-white shadow-md shadow-emerald-200' : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'}`}
                        >{f.label}</button>
                      ))}
                      <select value={finProf} onChange={e => setFinProf(e.target.value)}
                        className="px-4 py-2 rounded-xl text-sm font-semibold border border-slate-200 bg-white text-slate-700 shadow-sm">
                        <option value="">Todos Profissionais</option>
                        {usersList.map(u => <option key={u.id} value={String(u.id)}>{u.nome}</option>)}
                      </select>
                      <select value={finMetodo} onChange={e => setFinMetodo(e.target.value)}
                        className="px-4 py-2 rounded-xl text-sm font-semibold border border-slate-200 bg-white text-slate-700 shadow-sm">
                        <option value="">Todas Formas</option>
                        {metodos.map(m => <option key={m} value={m}>{m}</option>)}
                      </select>
                    </div>

                    {/* KPI Cards */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-8">
                      {/* Receita Recebida */}
                      <div className="bg-gradient-to-br from-emerald-500 to-emerald-700 rounded-2xl p-5 text-white shadow-lg shadow-emerald-200/50 relative overflow-hidden">
                        <div className="absolute -right-4 -top-4 w-24 h-24 rounded-full bg-white/10"></div>
                        <div className="flex items-center gap-3 mb-3">
                          <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
                            <i className="ph ph-arrow-circle-up text-[22px]"></i>
                          </div>
                          <span className="text-sm font-semibold text-emerald-100">Receitas</span>
                        </div>
                        <p className="text-3xl font-black">R$ {receitaTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
                        <p className="text-xs text-emerald-200 mt-1">{receitas.length} recebimento(s)</p>
                      </div>
                      {/* Despesas */}
                      <div className="bg-gradient-to-br from-red-500 to-rose-600 rounded-2xl p-5 text-white shadow-lg shadow-red-200/50 relative overflow-hidden">
                        <div className="absolute -right-4 -top-4 w-24 h-24 rounded-full bg-white/10"></div>
                        <div className="flex items-center gap-3 mb-3">
                          <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
                            <i className="ph ph-arrow-circle-down text-[22px]"></i>
                          </div>
                          <span className="text-sm font-semibold text-red-100">Despesas</span>
                        </div>
                        <p className="text-3xl font-black">R$ {(despesaTotal + despesaPendTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
                        <p className="text-xs text-red-200 mt-1">{despesasPagas.length} paga(s) · {despesasPend.length} pendente(s)</p>
                      </div>
                      {/* A Receber */}
                      <div className="bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl p-5 text-white shadow-lg shadow-orange-200/50 relative overflow-hidden">
                        <div className="absolute -right-4 -top-4 w-24 h-24 rounded-full bg-white/10"></div>
                        <div className="flex items-center gap-3 mb-3">
                          <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
                            <i className="ph ph-hourglass-medium text-[22px]"></i>
                          </div>
                          <span className="text-sm font-semibold text-orange-100">A Receber</span>
                        </div>
                        <p className="text-3xl font-black">R$ {aReceber.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
                        <p className="text-xs text-orange-200 mt-1">{pendentesRec.length} receita(s) · {despesasPend.length} despesa(s)</p>
                      </div>
                      {/* Saldo */}
                      <div className={`bg-gradient-to-br ${saldo >= 0 ? 'from-slate-700 to-slate-900' : 'from-red-800 to-red-950'} rounded-2xl p-5 text-white shadow-lg shadow-slate-300/50 relative overflow-hidden`}>
                        <div className="absolute -right-4 -top-4 w-24 h-24 rounded-full bg-white/10"></div>
                        <div className="flex items-center gap-3 mb-3">
                          <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
                            <i className="ph ph-scales text-[22px]"></i>
                          </div>
                          <span className="text-sm font-semibold text-slate-300">Saldo</span>
                        </div>
                        <p className="text-3xl font-black">R$ {saldo.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
                        <p className="text-xs text-slate-400 mt-1">receitas − despesas</p>
                      </div>
                    </div>

                    {/* Tabela de movimentações */}
                    <div className="grid grid-cols-1 gap-6">
                      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
                        <div className="p-4 border-b border-slate-100 flex items-center justify-between">
                          <h3 className="text-sm font-bold text-slate-700 flex items-center gap-2">
                            <i className="ph ph-list-dashes text-indigo-600"></i> Movimentações ({sorted.length})
                          </h3>
                        </div>
                        <div className="overflow-x-auto max-h-[480px] overflow-y-auto">
                          <table className="w-full text-sm">
                            <thead className="bg-slate-50 sticky top-0">
                              <tr>
                                <th className="text-left px-4 py-3 font-bold text-slate-600 text-xs uppercase">Data</th>
                                <th className="text-center px-4 py-3 font-bold text-slate-600 text-xs uppercase">Tipo</th>
                                <th className="text-left px-4 py-3 font-bold text-slate-600 text-xs uppercase">Descrição</th>
                                <th className="text-center px-4 py-3 font-bold text-slate-600 text-xs uppercase hidden sm:table-cell">Categoria</th>
                                <th className="text-right px-4 py-3 font-bold text-slate-600 text-xs uppercase">Valor</th>
                                <th className="text-center px-4 py-3 font-bold text-slate-600 text-xs uppercase hidden sm:table-cell">Forma</th>
                                <th className="text-center px-4 py-3 font-bold text-slate-600 text-xs uppercase">Status</th>
                                <th className="text-center px-4 py-3 font-bold text-slate-600 text-xs uppercase w-10"></th>
                              </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100">
                              {sorted.length === 0 ? (
                                <tr>
                                  <td colSpan="8" className="px-4 py-12 text-center text-slate-400">
                                    <i className="ph ph-empty text-4xl mb-2 block"></i>
                                    Nenhuma movimentação encontrada para este período.
                                  </td>
                                </tr>
                              ) : (() => {
                                const totalFin = sorted.length;
                                const finPage = sorted.slice((pageFin - 1) * limitFin, pageFin * limitFin);
                                return (
                                  <>
                                    {finPage.map((e, idx) => {
                                      const isReceita = e.tipo === 'receita';
                                      const isPago = e.status === 'pago';
                                      const todayDate = new Date().toISOString().split('T')[0];
                                      const isAtrasado = !isPago && e.data && e.data < todayDate;
                                      const dateFormatted = e.data ? new Date(e.data + 'T12:00:00').toLocaleDateString('pt-BR') : '-';
                                      return (
                                        <tr key={e.id || idx} className="hover:bg-slate-50/80 transition-colors">
                                          <td className="px-4 py-3 font-semibold text-slate-700 whitespace-nowrap">{dateFormatted}</td>
                                          <td className="px-4 py-3 text-center">
                                            <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-bold ${isReceita ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-600'}`}>
                                              <i className={`ph ${isReceita ? 'ph-arrow-up' : 'ph-arrow-down'} text-sm`}></i>
                                              {isReceita ? 'Receita' : 'Despesa'}
                                            </span>
                                          </td>
                                          <td className="px-4 py-3 text-slate-700 font-medium">
                                            <div className="flex items-center gap-2">
                                              <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${isReceita ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-600'}`}>
                                                {(e.descricao || '?').charAt(0).toUpperCase()}
                                              </div>
                                              <div className="truncate max-w-[180px]">
                                                <span>{e.descricao || '-'}</span>
                                                {e.origem === 'agenda' && <span className="text-[10px] text-slate-400 ml-1">(consulta)</span>}
                                              </div>
                                            </div>
                                          </td>
                                          <td className="px-4 py-3 text-center text-slate-500 text-xs hidden sm:table-cell">{e.categoria || '-'}</td>
                                          <td className={`px-4 py-3 text-right font-bold whitespace-nowrap ${isReceita ? 'text-emerald-700' : 'text-red-600'}`}>
                                            {isReceita ? '+' : '−'} R$ {e.valor || '0,00'}
                                          </td>
                                          <td className="px-4 py-3 text-center hidden sm:table-cell">
                                            {e.metodo ? (
                                              <span className="inline-flex items-center gap-1 px-2 py-1 rounded-lg bg-slate-100 text-xs font-semibold text-slate-600">
                                                <i className={`ph ${e.metodo === 'PIX' ? 'ph-qr-code' : e.metodo === 'Dinheiro' ? 'ph-money' : 'ph-credit-card'} text-sm`}></i>
                                                {e.metodo}
                                              </span>
                                            ) : <span className="text-slate-300">—</span>}
                                          </td>
                                          <td className="px-4 py-3 text-center">
                                            <button
                                              onClick={() => handleFinToggleStatus(e)}
                                              className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-bold transition-all ${isPago ? 'bg-emerald-100 text-emerald-700' : isAtrasado ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'} ${e.origem !== 'agenda' ? 'cursor-pointer hover:shadow-md hover:scale-105' : 'cursor-default'}`}
                                              title={'Clique para alternar status'}
                                            >
                                              <i className={`ph ${isPago ? 'ph-check-circle' : isAtrasado ? 'ph-warning-circle' : 'ph-clock'} text-sm`}></i>
                                              {isPago ? 'Pago' : isAtrasado ? 'Atrasado' : 'Pendente'}
                                            </button>
                                            {e.recorrente && <span className="block text-[10px] text-indigo-500 font-bold mt-0.5"><i className="ph ph-arrows-clockwise"></i> Recorrente</span>}
                                          </td>
                                          <td className="px-4 py-3 text-center">
                                            <div className="flex items-center justify-center gap-2">
                                              <button onClick={() => handleFinEdit(e)} className="text-indigo-400 hover:text-indigo-600 transition-colors p-1" title="Editar">
                                                <i className="ph ph-pencil-simple text-lg"></i>
                                              </button>
                                              <button onClick={() => handleFinDelete(e.id)} className="text-red-400 hover:text-red-600 transition-colors p-1" title="Excluir">
                                                <i className="ph ph-trash text-lg"></i>
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                    {totalFin > 0 && (
                                      <tr>
                                        <td colSpan="8" className="p-4 bg-white border-t border-slate-100">
                                          {renderPagination(pageFin, setPageFin, limitFin, setLimitFin, totalFin)}
                                        </td>
                                      </tr>
                                    )}
                                  </>
                                );
                              })()}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                  </div>
                  );
                })()}

                {activeTab === 'birthday' && (
                  <div className="p-4 md:p-8 animate-fadeIn">
                    <div className="flex justify-between items-center mb-6">
                      <div>
                        <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-3">
                          <i className="ph ph-cake text-rose-500"></i> Aniversariantes do Dia
                        </h2>
                        <p className="text-slate-500 text-sm">Parabenize seus pacientes nesta data especial!</p>
                      </div>
                    </div>

                    <div className="grid gap-4">
                      {birthdayPatients.length === 0 ? (
                        <div className="text-center py-20 bg-white rounded-2xl border border-dashed border-slate-300">
                          <i className="ph ph-calendar-blank text-[48px] text-slate-300 mb-3"></i>
                          <p className="text-slate-500 font-medium">Nenhum aniversariante encontrado para hoje.</p>
                        </div>
                      ) : (
                        birthdayPatients.map(patient => (
                          <div key={patient.id} 
                            className="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm hover:shadow-md transition-all flex flex-col sm:flex-row sm:items-center gap-4 group">
                            <div className="flex items-center gap-4 flex-1 cursor-pointer" onClick={() => selectPatient(patient)}>
                              <div className="w-14 h-14 rounded-2xl bg-rose-100 text-rose-600 flex items-center justify-center font-bold text-xl shadow-sm group-hover:scale-110 transition-transform">
                                {patient.nome.charAt(0)}
                              </div>
                              <div className="flex-1 min-w-0">
                                <h3 className="font-bold text-lg text-slate-800 group-hover:text-rose-600 transition-colors truncate">{patient.nome}</h3>
                                <div className="flex items-center gap-3 mt-1">
                                  <span className="text-sm px-2 py-0.5 bg-slate-100 rounded text-slate-600 font-medium">{patient.idade} anos</span>
                                  <span className="text-sm text-slate-400 flex items-center gap-1">
                                    <i className="ph ph-phone"></i> {patient.telefone}
                                  </span>
                                </div>
                              </div>
                            </div>
                            
                            <div className="flex items-center gap-2">
                              <a 
                                href={`https://wa.me/55${patient.telefone?.replace(/\D/g, '')}?text=${encodeURIComponent(systemSettings.birthdayMessage?.replace('{nome}', patient.nome.split(' ')[0]) || '')}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex-1 sm:flex-none flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white px-5 py-2.5 rounded-xl font-bold transition-all shadow-lg hover:shadow-emerald-200"
                              >
                                <i className="ph ph-whatsapp-logo text-xl"></i>
                                Parabenizar
                              </a>
                              <button 
                                onClick={() => selectPatient(patient)} 
                                className="p-2.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-xl transition-all"
                                title="Ver Prontuário"
                              >
                                <i className="ph ph-eye text-xl"></i>
                              </button>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                )}

                {activeTab === 'new_patient' && (
                  <div className="p-8 max-w-5xl mx-auto w-full">
                    <h2 className="text-3xl font-bold text-slate-800 mb-6 border-b pb-4">{isEditingPatient ? 'Editar Paciente' : 'Cadastrar Novo Paciente'}</h2>
                    <form onSubmit={handleSaveNewPatient}>
                      <FormSection title="Dados Cadastrais">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          <InputGroup label="Nome Completo" value={newPatient.nome} onChange={e => setNewPatient({...newPatient, nome: e.target.value})} required={true} className="md:col-span-2" />
                          
                          <InputGroup 
                            label="CPF" 
                            value={newPatient.cpf} 
                            onChange={e => setNewPatient({...newPatient, cpf: e.target.value})} 
                            actionIcon={isLoadingCpf ? <i className="ph ph-spinner animate-spin text-[18px]"></i> : <i className="ph ph-magnifying-glass text-[18px]" title="Buscar CPF"></i>} 
                            onActionClick={handleBuscarCPF}
                          />
                          <InputGroup label="RG" value={newPatient.rg} onChange={e => setNewPatient({...newPatient, rg: e.target.value})} />
                          
                          <InputGroup label="Data de Nasc." value={newPatient.dataNascimento} onChange={e => setNewPatient({...newPatient, dataNascimento: e.target.value})} type="date" />
                          <InputGroup label="Idade" value={newPatient.idade} onChange={e => setNewPatient({...newPatient, idade: e.target.value})} />
                          <InputGroup label="Estado Civil" value={newPatient.estadoCivil} onChange={e => setNewPatient({...newPatient, estadoCivil: e.target.value})} />
                          
                          <InputGroup label="Profissão/Ocupação" value={newPatient.profissao} onChange={e => setNewPatient({...newPatient, profissao: e.target.value})} />
                          <InputGroup label="Telefone Principal" value={newPatient.telefone} onChange={e => setNewPatient({...newPatient, telefone: e.target.value})} />
                          <InputGroup label="Telefone Secundário" value={newPatient.telefone2} onChange={e => setNewPatient({...newPatient, telefone2: e.target.value})} />
                          
                          <InputGroup 
                            label="CEP" 
                            value={newPatient.cep} 
                            onChange={e => setNewPatient({...newPatient, cep: e.target.value})} 
                            placeholder="Ex: 57300000"
                            actionIcon={isLoadingCep ? <i className="ph ph-spinner animate-spin text-[18px]"></i> : <i className="ph ph-magnifying-glass text-[18px]" title="Buscar CEP"></i>} 
                            onActionClick={handleBuscarCEP}
                          />
                          
                          <InputGroup label="Endereço (Rua/Av)" value={newPatient.endereco} onChange={e => setNewPatient({...newPatient, endereco: e.target.value})} className="md:col-span-2" />
                          
                          <InputGroup label="Número" value={newPatient.numero} onChange={e => setNewPatient({...newPatient, numero: e.target.value})} />
                          <InputGroup label="Bairro" value={newPatient.bairro} onChange={e => setNewPatient({...newPatient, bairro: e.target.value})} />
                          <InputGroup label="Cidade" value={newPatient.cidade} onChange={e => setNewPatient({...newPatient, cidade: e.target.value})} />
                          
                          <InputGroup label="UF" value={newPatient.uf} onChange={e => setNewPatient({...newPatient, uf: e.target.value})} />
                          <InputGroup label="Possui Plano de Saúde?" value={newPatient.planoSaude} onChange={e => setNewPatient({...newPatient, planoSaude: e.target.value})} />
                          <InputGroup label="Indicação" value={newPatient.indicacao} onChange={e => setNewPatient({...newPatient, indicacao: e.target.value})} />
                          <InputGroup label="Responsável (se houver)" value={newPatient.responsavel} onChange={e => setNewPatient({...newPatient, responsavel: e.target.value})} />
                        </div>
                      </FormSection>

                      {currentUser?.role === 'superadmin' && (
                        <FormSection title="Tratamentos">
                          <div className="flex flex-col gap-4">
                            <label className="flex items-center gap-2 cursor-pointer text-sm font-semibold text-slate-700">
                              <input
                                type="checkbox"
                                checked={newPatient.faz_fisio}
                                onChange={(e) => setNewPatient({ ...newPatient, faz_fisio: e.target.checked })}
                                className="w-5 h-5 rounded border-slate-300 text-sky-600 focus:ring-sky-500"
                              />
                              Paciente faz Fisioterapia
                            </label>

                            <label className="flex items-center gap-2 cursor-pointer text-sm font-semibold text-slate-700">
                              <input
                                type="checkbox"
                                checked={newPatient.faz_pilates}
                                onChange={(e) => setNewPatient({ ...newPatient, faz_pilates: e.target.checked })}
                                className="w-5 h-5 rounded border-slate-300 text-emerald-600 focus:ring-emerald-500"
                              />
                              Paciente é aluno de Pilates
                            </label>
                            {newPatient.faz_pilates && (
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2 animate-fadeIn p-4 bg-slate-50 border border-slate-200 rounded-xl">
                                <InputGroup
                                  label="Valor da Mensalidade (R$)"
                                  type="number"
                                  step="0.01"
                                  value={newPatient.valor_mensalidade_pilates}
                                  onChange={e => setNewPatient({ ...newPatient, valor_mensalidade_pilates: e.target.value })}
                                  placeholder="Ex: 160.00"
                                />
                                <InputGroup
                                  label="Dia do Vencimento"
                                  type="number"
                                  value={newPatient.dia_vencimento_pilates}
                                  onChange={e => setNewPatient({ ...newPatient, dia_vencimento_pilates: e.target.value })}
                                  placeholder="Ex: 10"
                                  min="1"
                                  max="31"
                                />
                                <p className="text-xs text-slate-500 md:col-span-2">O sistema gerará automaticamente uma cobrança no Financeiro todo mês no dia do vencimento.</p>
                              </div>
                            )}
                          </div>
                        </FormSection>
                      )}


                      <FormSection title="Atribuição de Profissionais">
                        <div className="flex flex-col gap-4">
                          <div className="flex gap-4 mb-2">
                            <button 
                              type="button" 
                              onClick={() => {
                                setIsDualFisio(false);
                                setNewPatient({...newPatient, fisio2_id: null});
                              }}
                              className={`flex-1 py-3 px-4 rounded-xl font-bold border-2 transition-all flex items-center justify-center gap-2 ${!isDualFisio ? 'border-emerald-500 bg-emerald-50 text-emerald-700' : 'border-slate-200 text-slate-500 hover:bg-slate-50'}`}
                            >
                              <i className="ph ph-user"></i> 1 Profissional
                            </button>
                            <button 
                              type="button" 
                              onClick={() => {
                                setIsDualFisio(true);
                              }}
                              className={`flex-1 py-3 px-4 rounded-xl font-bold border-2 transition-all flex items-center justify-center gap-2 ${isDualFisio ? 'border-emerald-500 bg-emerald-50 text-emerald-700' : 'border-slate-200 text-slate-500 hover:bg-slate-50'}`}
                            >
                              <i className="ph ph-users-three"></i> 2 Profissionais
                            </button>
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="flex flex-col">
                              <label className="text-sm font-semibold text-slate-600 mb-1">Profissional 1</label>
                              <select 
                                value={newPatient.fisio1_id || ''} 
                                onChange={e => setNewPatient({...newPatient, fisio1_id: e.target.value || null})}
                                className="px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 bg-white text-slate-700"
                              >
                                <option value="">Selecione o Profissional...</option>
                                {usersList.filter(userPodeAtribuirComoProfissional).map(u => (
                                  <option key={u.id} value={u.id}>{u.nome}</option>
                                ))}
                              </select>
                            </div>

                            {isDualFisio && (
                              <div className="flex flex-col animate-fadeIn">
                                <label className="text-sm font-semibold text-slate-600 mb-1">Profissional 2 (opcional)</label>
                                <select 
                                  value={newPatient.fisio2_id || ''} 
                                  onChange={e => setNewPatient({...newPatient, fisio2_id: e.target.value || null})}
                                  className="px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 bg-white text-slate-700"
                                >
                                  <option value="">Nenhum segundo profissional</option>
                                  {usersList.filter(u => userPodeAtribuirComoProfissional(u) && u.id != newPatient.fisio1_id).map(u => (
                                    <option key={u.id} value={u.id}>{u.nome}</option>
                                  ))}
                                </select>
                              </div>
                            )}
                          </div>
                          
                          {newPatient.fisio1_id && (
                            <div className="mt-2 p-3 bg-emerald-50 border border-emerald-100 rounded-lg">
                              <p className="text-sm text-emerald-800 flex items-center gap-2">
                                <i className="ph ph-check-circle"></i> 
                                Paciente será atendido por: 
                                <strong> {usersList.find(u => u.id == newPatient.fisio1_id)?.nome}</strong>
                                {newPatient.fisio2_id && <span> e <strong>{usersList.find(u => u.id == newPatient.fisio2_id)?.nome}</strong></span>}
                              </p>
                            </div>
                          )}
                        </div>
                      </FormSection>
                      <div className="flex justify-end mt-6 gap-4">
                        <button type="button" onClick={() => setActiveTab('list')} className="px-6 py-2 border border-slate-300 rounded-lg text-slate-600 font-bold hover:bg-slate-100 transition-colors">Cancelar</button>
                        <button type="submit" className={`text-white px-6 py-2 rounded-lg flex items-center gap-2 font-bold shadow-md transition-colors duration-300 ${t.btn}`}><i className="ph ph-floppy-disk text-[18px]"></i> {isEditingPatient ? 'Atualizar Dados' : 'Salvar Paciente'}</button>
                      </div>
                    </form>
                  </div>
                )}

                {activeTab === 'settings' && (userTemNivel(currentUser, 'Administrador') || userTemNivel(currentUser, 'Super Administrador') || userTemNivel(currentUser, 'Recepcionista') || currentUser?.ver_todos) && (
                  <div className="p-8 max-w-5xl mx-auto w-full">
                    <h2 className="text-3xl font-bold text-slate-800 mb-6 border-b pb-4">Configurações</h2>
                    
                    <div className="flex gap-2 mb-6 border-b border-slate-200 pb-px overflow-x-auto">
                      <button onClick={() => setSettingsTab('geral')} className={`flex items-center gap-2 px-4 py-3 font-semibold text-sm transition-colors border-b-2 ${settingsTab === 'geral' ? t.activeTab : 'border-transparent text-slate-500 hover:text-slate-700'}`}>
                        <i className="ph ph-buildings text-[18px]"></i> Geral (Empresa)
                      </button>
                      
                      {(userTemNivel(currentUser, 'Super Administrador') || userTemNivel(currentUser, 'Administrador')) && (
                        <button onClick={() => setSettingsTab('sistema')} className={`flex items-center gap-2 px-4 py-3 font-semibold text-sm transition-colors border-b-2 ${settingsTab === 'sistema' ? t.activeTab : 'border-transparent text-slate-500 hover:text-slate-700'}`}>
                          <i className="ph ph-hard-drives text-[18px]"></i> Sistema e APIs
                        </button>
                      )}
                      
                      <button onClick={() => setSettingsTab('usuarios')} className={`flex items-center gap-2 px-4 py-3 font-semibold text-sm transition-colors border-b-2 ${settingsTab === 'usuarios' ? t.activeTab : 'border-transparent text-slate-500 hover:text-slate-700'}`}>
                        <i className="ph ph-user-gear text-[18px]"></i> Usuários
                      </button>
                      <button onClick={() => setSettingsTab('mensagens')} className={`flex items-center gap-2 px-4 py-3 font-semibold text-sm transition-colors border-b-2 ${settingsTab === 'mensagens' ? t.activeTab : 'border-transparent text-slate-500 hover:text-slate-700'}`}>
                        <i className="ph ph-chat-circle-text text-[18px]"></i> Mensagens
                      </button>
                      <button onClick={() => setSettingsTab('personalizacao')} className={`flex items-center gap-2 px-4 py-3 font-semibold text-sm transition-colors border-b-2 ${settingsTab === 'personalizacao' ? t.activeTab : 'border-transparent text-slate-500 hover:text-slate-700'}`}>
                        <i className="ph ph-palette text-[18px]"></i> Personalização
                      </button>
                    </div>

                    {settingsTab === 'geral' && (
                      <div className="space-y-6">
                        <FormSection title="Dados da Empresa">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <InputGroup label="Razão Social" value={companyData.razaoSocial} onChange={e => setCompanyData({...companyData, razaoSocial: e.target.value})} placeholder="Razão Social Ltda" />
                            <InputGroup label="Nome Fantasia" value={companyData.nomeFantasia} onChange={e => setCompanyData({...companyData, nomeFantasia: e.target.value})} placeholder="Real Clínica Integrada" />
                            
                            <InputGroup 
                              label="CNPJ" 
                              value={companyData.cnpj} 
                              onChange={e => setCompanyData({...companyData, cnpj: e.target.value})} 
                              placeholder="Somente os números" 
                              actionIcon={isLoadingCnpj ? <i className="ph ph-spinner animate-spin text-[18px]"></i> : <i className="ph ph-magnifying-glass text-[18px]" title="Buscar CNPJ"></i>}
                              onActionClick={handleBuscarCNPJ}
                            />
                            
                            <InputGroup label="Inscrição Estadual" value={companyData.inscricaoEstadual} onChange={e => setCompanyData({...companyData, inscricaoEstadual: e.target.value})} placeholder="Isento" />
                            <InputGroup label="Regime Tributário (Simples Nacional)" value={companyData.regimeTributario} onChange={e => setCompanyData({...companyData, regimeTributario: e.target.value})} placeholder="Optante / Não Optante" className="md:col-span-2" />
                          </div>
                        </FormSection>
                        <FormSection title="Contato e Endereço">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <InputGroup label="Telefone Principal" value={companyData.telefone} onChange={e => setCompanyData({...companyData, telefone: e.target.value})} placeholder="(82) 3530-4187" />
                            <InputGroup label="E-mail de Contato" value={companyData.email} onChange={e => setCompanyData({...companyData, email: e.target.value})} placeholder="contato@realclinica.com" />
                            <InputGroup label="Endereço Completo" value={companyData.endereco} onChange={e => setCompanyData({...companyData, endereco: e.target.value})} placeholder="Rua Expedicionário Brasileiro, 1275" className="md:col-span-2" />
                          </div>
                          <div className="mt-4 flex justify-end">
                            <button onClick={() => handleSaveSettings('company')} className={`text-white px-6 py-2 rounded-lg flex items-center gap-2 font-bold transition-colors duration-300 ${t.btn}`}><i className="ph ph-floppy-disk text-[18px]"></i> Salvar Informações</button>
                          </div>
                        </FormSection>
                        <FormSection title="Configurações de Recebimento (PIX)">
                          <p className="text-sm text-slate-600 mb-6">Estas informações serão exibidas ao final do agendamento ou nas cobranças enviadas por WhatsApp para os pacientes.</p>
                          <div className="flex items-start gap-4 pt-4">
                              <i className="ph ph-qr-code text-[24px] text-emerald-600 mt-1"></i>
                              <div className="flex-1">
                                <InputGroup 
                                  label="Chave PIX (CPF, Celular, Email ou Aleatória)" 
                                  placeholder="000.000.000-00" 
                                  value={systemSettings.pixKey || ''} 
                                  onChange={(e) => setSystemSettings({...systemSettings, pixKey: e.target.value})} 
                                />
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                                  <InputGroup 
                                    label="Nome do Titular/Empresa (Sem acentos)" 
                                    placeholder="Ex: Real Clinica" 
                                    value={systemSettings.pixName || ''} 
                                    onChange={(e) => setSystemSettings({...systemSettings, pixName: e.target.value})} 
                                  />
                                  <InputGroup 
                                    label="Cidade (Sem acentos)" 
                                    placeholder="Ex: Arapiraca" 
                                    value={systemSettings.pixCity || ''} 
                                    onChange={(e) => setSystemSettings({...systemSettings, pixCity: e.target.value})} 
                                  />
                                </div>
                                <p className="text-xs text-slate-500 mt-2 mb-4">Estas informações são obrigatórias pelo Banco Central para gerar o QR Code Dinâmico com o valor exato da consulta.</p>
                              </div>
                            </div>
                            <div className="mt-4 flex justify-end">
                              <button onClick={() => handleSaveSettings('system')} className="bg-emerald-600 text-white px-6 py-2 rounded-lg flex items-center gap-2 hover:bg-emerald-700 font-bold"><i className="ph ph-floppy-disk text-[18px]"></i> Salvar Código PIX</button>
                            </div>
                        </FormSection>
                      </div>
                    )}

                    {settingsTab === 'sistema' && (userTemNivel(currentUser, 'Administrador') || userTemNivel(currentUser, 'Super Administrador')) && (
                      <div className="space-y-6">
                        <FormSection title="Integrações de API">
                          <div className="flex flex-col gap-6">
                            <div className="flex items-start gap-4">
                              <i className="ph ph-key text-[24px] text-emerald-600 mt-1"></i>
                              <div className="flex-1">
                                <InputGroup 
                                  label="Token API de CPF e CNPJ" 
                                  placeholder="Cole aqui seu token de acesso da API" 
                                  value={systemSettings.tokenCpf} 
                                  onChange={(e) => setSystemSettings({...systemSettings, tokenCpf: e.target.value})} 
                                />
                                <p className="text-xs text-slate-500 mt-1">Utilizado para consulta automática de dados através do CPF e do CNPJ (APIBrasil).</p>
                              </div>
                            </div>
                            
                            <div className="flex items-start gap-4">
                              <i className="ph ph-key text-[24px] text-emerald-600 mt-1"></i>
                              <div className="flex-1">
                                <InputGroup 
                                  label="Token API de CEP (Serpro / ConectaGov)" 
                                  placeholder="Cole aqui seu token Bearer OAuth2" 
                                  value={systemSettings.tokenCep} 
                                  onChange={(e) => setSystemSettings({...systemSettings, tokenCep: e.target.value})} 
                                />
                                <p className="text-xs text-slate-500 mt-1">Utilizado para preenchimento automático do endereço com a API oficial do Governo (Serpro).</p>
                              </div>
                            </div>
                            
                          </div>
                        </FormSection>
                        <FormSection title="Servidor de E-mail (SMTP)">
                          <p className="text-sm text-slate-600 mb-4">Usado para <strong>recuperação de senha</strong> (link por e-mail), lembretes e outros envios. Hostinger: em geral <code className="text-xs bg-slate-100 px-1 rounded">smtp.hostinger.com</code>, porta <strong>465</strong> (SSL) ou <strong>587</strong> (TLS). Salve após alterar usuário ou senha.</p>
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <InputGroup label="Servidor SMTP" value={smtpSettings.server} onChange={e => setSmtpSettings({...smtpSettings, server: e.target.value})} placeholder="smtp.seudominio.com" className="md:col-span-2" />
                            <InputGroup label="Porta" value={smtpSettings.port} onChange={e => setSmtpSettings({...smtpSettings, port: e.target.value})} placeholder="587 ou 465" />
                            <InputGroup label="Usuário de E-mail" value={smtpSettings.user} onChange={e => setSmtpSettings({...smtpSettings, user: e.target.value})} placeholder="envios@realclinica.com" className="md:col-span-2" />
                            <InputGroup label="Senha" type="password" value={smtpSettings.password} onChange={e => setSmtpSettings({...smtpSettings, password: e.target.value})} placeholder="áááááႬDž¡Â¬ǁƒá€¦Â¡Â¬Â¢áááááႬDž¡Â¬ǁƒá€¦Â¡Â¬Â¢áááááႬDž¡Â¬ǁƒá€¦Â¡Â¬Â¢áááááႬDž¡Â¬ǁƒá€¦Â¡Â¬Â¢áááááႬDž¡Â¬ǁƒá€¦Â¡Â¬Â¢áááááႬDž¡Â¬ǁƒá€¦Â¡Â¬Â¢áááááႬDž¡Â¬ǁƒá€¦Â¡Â¬Â¢áááááႬDž¡Â¬ǁƒá€¦Â¡Â¬Â¢" />
                          </div>
                          <div className="mt-4 flex justify-end">
                            <button onClick={() => handleSaveSettings('system')} className="bg-emerald-600 text-white px-6 py-2 rounded-lg flex items-center gap-2 hover:bg-emerald-700 font-bold"><i className="ph ph-floppy-disk text-[18px]"></i> Salvar Configurações</button>
                          </div>
                        </FormSection>
                      </div>
                    )}

                    {settingsTab === 'mensagens' && (
                      <div className="space-y-6">
                        <FormSection title="Mensagem de parabéns aos pacientes">
                          <p className="text-sm text-slate-600 mb-4">
                            Texto usado na lista <strong>Aniversariantes</strong> ao abrir o WhatsApp para cumprimentar o paciente. Ajuste o tom da clínica e salve.
                          </p>
                          <div className="flex flex-col lg:flex-row gap-6">
                            <div className="flex-1 space-y-3">
                              <label className="text-sm font-semibold text-slate-700">Modelo da mensagem</label>
                              <textarea
                                className="block w-full px-4 py-3 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500 shadow-sm min-h-[140px] text-slate-800"
                                placeholder={'Olá {nome}, a Real Clínica Integrada deseja um feliz aniversário!'}
                                value={systemSettings.birthdayMessage || ''}
                                onChange={(e) => setSystemSettings({ ...systemSettings, birthdayMessage: e.target.value })}
                              />
                              <p className="text-xs text-slate-500">
                                Use <code className="bg-slate-100 px-1.5 py-0.5 rounded text-slate-700">{'{nome}'}</code> onde quiser o <strong>primeiro nome</strong> do paciente (troca automática ao enviar).
                              </p>
                            </div>
                            <div className="lg:w-80 shrink-0 rounded-xl border border-slate-200 bg-slate-50 p-4">
                              <p className="text-xs font-bold uppercase tracking-wide text-slate-500 mb-2">Pré-visualização</p>
                              <div className="rounded-lg bg-white border border-slate-200 p-3 text-sm text-slate-700 min-h-[100px] whitespace-pre-wrap">
                                {(systemSettings.birthdayMessage || '')
                                  .replace(/\{nome\}/gi, 'Maria')}
                              </div>
                              <p className="text-[11px] text-slate-400 mt-2">Exemplo com o nome "Maria".</p>
                            </div>
                          </div>
                          <div className="mt-6 flex flex-wrap items-center justify-end gap-3 border-t border-slate-100 pt-6">
                            <button
                              type="button"
                              onClick={() => setSystemSettings({
                                ...systemSettings,
                                birthdayMessage: 'Olá {nome}, a Real Clínica Integrada deseja um feliz aniversário!'
                              })}
                              className="px-4 py-2 text-sm font-semibold text-slate-600 border border-slate-300 rounded-lg hover:bg-slate-50"
                            >
                              Restaurar texto padrão
                            </button>
                            <button
                              onClick={() => handleSaveSettings('mensagens')}
                              className={`text-white px-6 py-2 rounded-lg flex items-center gap-2 font-bold shadow-md transition-colors ${t.btn}`}
                            >
                              <i className="ph ph-floppy-disk text-[18px]"></i> Salvar mensagem
                            </button>
                          </div>
                        </FormSection>
                      </div>
                    )}

                    {settingsTab === 'usuarios' && (
                      <div className="space-y-6">
                        {!editingUser ? (
                          <>
                            <div className="flex justify-between items-center mb-4">
                              <h3 className="text-lg font-bold text-slate-800">Usuários do Sistema</h3>
                              <button onClick={() => setEditingUser({ nome: '', email: '', senha: '', nivel: 'Fisioterapeuta' })} className={`text-white px-4 py-2 rounded-lg flex items-center gap-2 font-bold text-sm transition-colors duration-300 shadow-sm ${t.btn}`}><i className="ph ph-plus text-[16px]"></i> Novo Usuário</button>
                            </div>
                            <div className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
                              {/* Desktop Table View */}
                              <table className="hidden md:table w-full text-sm text-left">
                                <thead className="text-xs text-slate-500 uppercase bg-slate-50 border-b">
                                  <tr>
                                    <th className="px-6 py-4">Nome</th>
                                    <th className="px-6 py-4">E-mail</th>
                                    <th className="px-6 py-4">Nível de Acesso</th>
                                    <th className="px-6 py-4 text-right">Ações</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {usersList.map(user => (
                                    <tr key={user.id} className="border-b hover:bg-slate-50 transition-colors">
                                      <td className="px-6 py-4 font-semibold text-slate-700">{user.nome}</td>
                                      <td className="px-6 py-4">{user.email}</td>
                                      <td className="px-6 py-4">
                                        <span className={`px-2 py-1 rounded text-xs font-bold ${badgeClassUsuarioLista(user)}`}>
                                          {etiquetaNivelOuNomeLista(user)}
                                        </span>
                                      </td>
                                      <td className="px-6 py-4 text-right flex justify-end gap-4">
                                        <button onClick={() => setEditingUser(user)} className="text-blue-500 hover:text-blue-700 transition-colors" title="Editar Usuário"><i className="ph ph-pencil-simple text-[18px]"></i></button>
                                        <button onClick={() => setUserToDelete(user)} className="text-red-400 hover:text-red-600 transition-colors" title="Excluir Usuário"><i className="ph ph-trash text-[18px]"></i></button>
                                      </td>
                                    </tr>
                                  ))}
                                  {usersList.length === 0 && (
                                    <tr>
                                      <td colSpan="4" className="px-6 py-8 text-center text-slate-500">Nenhum usuário cadastrado.</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>

                              {/* Mobile Card View */}
                              <div className="md:hidden divide-y divide-slate-100">
                                {usersList.map((user, idx) => (
                                  <div key={idx} className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex flex-col gap-3 overflow-hidden max-w-full">
                                    <div className="flex items-center justify-between gap-2 min-w-0">
                                      <div className="flex items-center gap-3 min-w-0 flex-1">
                                        <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center font-bold text-slate-600 shadow-inner shrink-0">
                                          {user.nome.charAt(0)}
                                        </div>
                                        <div className="min-w-0 flex-1">
                                          <h4 className="font-bold text-slate-800 truncate">{user.nome}</h4>
                                          <p className="text-xs text-slate-500 truncate">{user.email}</p>
                                        </div>
                                      </div>
                                      <span className={`shrink-0 px-2 py-0.5 rounded text-[10px] font-bold ${badgeClassUsuarioLista(user)}`}>
                                        {etiquetaNivelOuNomeLista(user)}
                                      </span>
                                    </div>
                                    <div className="flex justify-end gap-4 pt-2 border-t border-slate-50">
                                      <button onClick={() => setEditingUser(user)} className="flex items-center gap-1 text-sm text-blue-600 font-bold"><i className="ph ph-pencil-simple text-lg"></i> Editar</button>
                                      <button onClick={() => setUserToDelete(user)} className="flex items-center gap-1 text-sm text-red-500 font-bold"><i className="ph ph-trash text-lg"></i> Excluir</button>
                                    </div>
                                  </div>
                                ))}
                                {usersList.length === 0 && (
                                  <div className="p-8 text-center text-slate-500">Nenhum usuário cadastrado.</div>
                                )}
                              </div>
                            </div>

                            {userToDelete && (
                              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                                <div className="bg-white p-6 rounded-xl shadow-2xl max-w-sm w-full mx-4 border border-slate-200">
                                  <div className="flex items-center gap-3 mb-4 text-red-600">
                                    <i className="ph ph-trash text-[24px]"></i>
                                    <h3 className="text-lg font-bold">Excluir Usuário</h3>
                                  </div>
                                  <p className="text-slate-600 mb-6">Tem certeza que deseja excluir o utilizador <b>{userToDelete.nome}</b>? Esta ação Não pode ser desfeita.</p>
                                  <div className="flex justify-end gap-3">
                                    <button onClick={() => setUserToDelete(null)} className="px-4 py-2 border border-slate-300 rounded-lg text-slate-600 font-bold hover:bg-slate-100 transition-colors">Cancelar</button>
                                    <button onClick={executeDeleteUser} className="px-4 py-2 bg-red-600 text-white rounded-lg font-bold hover:bg-red-700 transition-colors">Sim, Excluir</button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          <FormSection title={editingUser.id ? "Editar Usuário" : "Cadastrar Novo Usuário"}>
                            <form onSubmit={handleSaveUser}>
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                <InputGroup label="Nome Completo" value={editingUser.nome} onChange={e => setEditingUser({...editingUser, nome: e.target.value})} required />
                                <InputGroup label="E-mail de Acesso" type="email" value={editingUser.email} onChange={e => setEditingUser({...editingUser, email: e.target.value})} required />
                                <InputGroup label="Senha" type="text" value={editingUser.senha} onChange={e => setEditingUser({...editingUser, senha: e.target.value})} required />

                                <div className="md:col-span-2 space-y-4 rounded-xl border border-slate-200 bg-slate-50/80 p-4">
                                  <div>
                                    <label className="text-sm font-semibold text-slate-700 block mb-2">Funções profissionais (pode marcar mais de uma)</label>
                                    <div className="flex flex-wrap gap-6">
                                      <label className="inline-flex items-center gap-2 cursor-pointer text-sm text-slate-700">
                                        <input
                                          type="checkbox"
                                          checked={userTemNivel({ nivel: editingUser.nivel }, 'Fisioterapeuta')}
                                          onChange={() => {
                                            const { admin, pros } = splitNiveisEditor(editingUser.nivel);
                                            const next = pros.includes('Fisioterapeuta')
                                              ? pros.filter((x) => x !== 'Fisioterapeuta')
                                              : [...pros, 'Fisioterapeuta'];
                                            setEditingUser({ ...editingUser, nivel: buildNivelFromEditor(admin, next) });
                                          }}
                                          className="rounded border-slate-300 text-emerald-600 focus:ring-emerald-500"
                                        />
                                        Fisioterapeuta
                                      </label>
                                      <label className="inline-flex items-center gap-2 cursor-pointer text-sm text-slate-700">
                                        <input
                                          type="checkbox"
                                          checked={userTemNivel({ nivel: editingUser.nivel }, 'Instrutor de Pilates')}
                                          onChange={() => {
                                            const { admin, pros } = splitNiveisEditor(editingUser.nivel);
                                            const next = pros.includes('Instrutor de Pilates')
                                              ? pros.filter((x) => x !== 'Instrutor de Pilates')
                                              : [...pros, 'Instrutor de Pilates'];
                                            setEditingUser({ ...editingUser, nivel: buildNivelFromEditor(admin, next) });
                                          }}
                                          className="rounded border-slate-300 text-emerald-600 focus:ring-emerald-500"
                                        />
                                        Instrutor de Pilates
                                      </label>
                                      <label className="inline-flex items-center gap-2 cursor-pointer text-sm text-slate-700">
                                        <input
                                          type="checkbox"
                                          checked={editorTemFisioEPilates(editingUser.nivel)}
                                          onChange={() => {
                                            const { admin, pros } = splitNiveisEditor(editingUser.nivel);
                                            const hasBoth =
                                              pros.includes('Fisioterapeuta') &&
                                              pros.includes('Instrutor de Pilates');
                                            const next = hasBoth
                                              ? pros.filter(
                                                  (x) => x !== 'Fisioterapeuta' && x !== 'Instrutor de Pilates'
                                                )
                                              : [...new Set([...pros, 'Fisioterapeuta', 'Instrutor de Pilates'])];
                                            setEditingUser({ ...editingUser, nivel: buildNivelFromEditor(admin, next) });
                                          }}
                                          className="rounded border-slate-300 text-emerald-600 focus:ring-emerald-500"
                                        />
                                        Fisioterapeuta / Instrutor de Pilates
                                      </label>
                                    </div>
                                  </div>
                                  <div className="max-w-md">
                                    <label className="text-sm font-semibold text-slate-700 block mb-1">Perfil administrativo / recepção (opcional, um só)</label>
                                    <select
                                      value={splitNiveisEditor(editingUser.nivel).admin}
                                      onChange={(e) => {
                                        const v = e.target.value;
                                        const { pros } = splitNiveisEditor(editingUser.nivel);
                                        setEditingUser({ ...editingUser, nivel: buildNivelFromEditor(v, pros) });
                                      }}
                                      className="px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 w-full bg-white text-slate-700"
                                    >
                                      <option value="">Nenhum (somente funções marcadas acima)</option>
                                      <option value="Recepcionista">Recepcionista</option>
                                      <option value="Administrador">Administrador</option>
                                      {userTemNivel(currentUser, 'Super Administrador') && (
                                        <option value="Super Administrador">Super Administrador</option>
                                      )}
                                    </select>
                                  </div>
                                  <p className="text-xs text-slate-500">Use a opção combinada «Fisioterapeuta / Instrutor de Pilates» quando a pessoa exerce as duas funções, ou marque as caixas separadas. O sistema guarda tudo no mesmo usuário.</p>
                                </div>
                                {userTemNivel(currentUser, 'Super Administrador') && (
                                <div className="flex items-center gap-2 md:col-span-2 bg-slate-50 p-3 rounded-lg border border-slate-200 mt-2">
                                  <input 
                                    type="checkbox" 
                                    id="verTodosPacientes" 
                                    checked={editingUser.ver_todos || false} 
                                    onChange={e => setEditingUser({...editingUser, ver_todos: e.target.checked})}
                                    className="w-4 h-4 text-emerald-600 focus:ring-emerald-500 border-slate-300 rounded"
                                  />
                                  <label htmlFor="verTodosPacientes" className="text-sm font-semibold text-slate-700 cursor-pointer">
                                    Dona da Clínica / Acesso Total (Visualiza todos os pacientes mesmo sendo Fisioterapeuta)
                                  </label>
                                </div>
                                )}
                              </div>
                              <div className="flex justify-end gap-3 border-t pt-6 mt-2">
                                <button type="button" onClick={() => setEditingUser(null)} className="px-6 py-2 border border-slate-300 rounded-lg text-slate-600 font-bold hover:bg-slate-100 transition-colors">Cancelar</button>
                                <button type="submit" className={`text-white px-6 py-2 rounded-lg flex items-center gap-2 font-bold shadow-md transition-colors duration-300 ${t.btn}`}><i className="ph ph-floppy-disk text-[18px]"></i> Salvar Usuário</button>
                              </div>
                            </form>
                          </FormSection>
                        )}
                      </div>
                    )}

                    {settingsTab === 'personalizacao' && (
                      <div className="space-y-6">
                        <FormSection title="Identidade Visual">
                          <div className="flex flex-col md:flex-row gap-6 items-start">
                            
                            <div className="relative">
                              <input type="file" id="logoUpload" accept="image/*" className="hidden" onChange={(e) => handleImageUpload(e, 'logo')} />
                              <label htmlFor="logoUpload" className="w-32 h-32 border-2 border-dashed border-slate-300 rounded-lg flex flex-col items-center justify-center text-slate-400 bg-slate-50 hover:bg-slate-100 cursor-pointer transition-colors overflow-hidden relative group">
                                {theme.logoUrl ? (
                                  <>
                                    <img src={theme.logoUrl} alt="Logo" className="w-full h-full object-contain p-2" />
                                    <div className="absolute inset-0 bg-black/50 hidden group-hover:flex items-center justify-center text-white text-xs font-bold text-center p-2">Trocar Imagem</div>
                                  </>
                                ) : (
                                  <>
                                    <i className={`ph ph-pulse text-[32px] mb-2 transition-colors duration-300 ${t.icon}`}></i>
                                    <span className="text-xs font-semibold text-center px-2">Alterar Logo</span>
                                  </>
                                )}
                              </label>
                              {theme.logoUrl && <button onClick={() => setTheme({...theme, logoUrl: null})} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold shadow hover:bg-red-600 transition-colors">X</button>}
                            </div>

                            <div className="flex-1 space-y-6">
                              
                              <div>
                                <label className="text-sm font-semibold text-slate-600 block mb-3">Cor Principal do Sistema</label>
                                <div className="flex gap-4">
                                  <div onClick={() => setTheme({...theme, color: 'emerald'})} className={`w-8 h-8 rounded-full bg-emerald-600 cursor-pointer transition-all ${theme.color === 'emerald' ? 'ring-2 ring-offset-2 ring-emerald-600 scale-110' : 'opacity-50 hover:opacity-100'}`} title="Verde Clínico"></div>
                                  <div onClick={() => setTheme({...theme, color: 'blue'})} className={`w-8 h-8 rounded-full bg-blue-600 cursor-pointer transition-all ${theme.color === 'blue' ? 'ring-2 ring-offset-2 ring-blue-600 scale-110' : 'opacity-50 hover:opacity-100'}`} title="Azul Mǩdico"></div>
                                  <div onClick={() => setTheme({...theme, color: 'indigo'})} className={`w-8 h-8 rounded-full bg-indigo-600 cursor-pointer transition-all ${theme.color === 'indigo' ? 'ring-2 ring-offset-2 ring-indigo-600 scale-110' : 'opacity-50 hover:opacity-100'}`} title="Ǎndigo"></div>
                                  <div onClick={() => setTheme({...theme, color: 'rose'})} className={`w-8 h-8 rounded-full bg-rose-600 cursor-pointer transition-all ${theme.color === 'rose' ? 'ring-2 ring-offset-2 ring-rose-600 scale-110' : 'opacity-50 hover:opacity-100'}`} title="Rosa/Vermelho"></div>
                                </div>
                              </div>

                              <div className="pt-4 border-t border-slate-100">
                                <label className="text-sm font-semibold text-slate-600 block mb-1">Ícone do aplicativo (atalho na tela inicial e aba do navegador)</label>
                                <p className="text-xs text-slate-500 mb-3">Opcional. Se vazio, o sistema usa a <strong>logo principal</strong> acima. Use imagem <strong>quadrada</strong> (ex.: 512×512, PNG ou JPG). Após <strong>Salvar personalização</strong>, o servidor grava o arquivo <code className="text-[11px] bg-slate-100 px-1 rounded">custom-pwa-icon.png</code> — necessário para o ícone aparecer ao instalar no iPhone/Android (URLs internas do navegador não bastam).</p>
                                <div className="flex flex-wrap items-center gap-4">
                                  <div className="relative">
                                    <input type="file" id="appIconUpload" accept="image/*" className="hidden" onChange={(e) => handleImageUpload(e, 'appIcon')} />
                                    <label htmlFor="appIconUpload" className="w-24 h-24 border-2 border-dashed border-slate-300 rounded-xl flex flex-col items-center justify-center text-slate-400 bg-slate-50 hover:bg-slate-100 cursor-pointer transition-colors overflow-hidden relative group">
                                      {theme.appIconUrl ? (
                                        <>
                                          <img src={theme.appIconUrl} alt="" className="w-full h-full object-cover" />
                                          <div className="absolute inset-0 bg-black/50 hidden group-hover:flex items-center justify-center text-white text-[10px] font-bold text-center px-1">Trocar</div>
                                        </>
                                      ) : (
                                        <>
                                          <i className={`ph ph-device-mobile text-2xl mb-1 ${t.icon}`}></i>
                                          <span className="text-[10px] font-semibold text-center px-1 leading-tight">Enviar ícone</span>
                                        </>
                                      )}
                                    </label>
                                    {theme.appIconUrl && (
                                      <button type="button" onClick={() => setTheme({...theme, appIconUrl: null})} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold shadow hover:bg-red-600 transition-colors" title="Remover ícone do app">X</button>
                                    )}
                                  </div>
                                  <p className="text-[11px] text-slate-500 max-w-md">Após salvar, atualize o atalho no celular (remova e adicione de novo à tela inicial) para ver o novo ícone.</p>
                                </div>
                              </div>
                              
                              <div className="pt-2">
                                <label className="text-sm font-semibold text-slate-600 block mb-2">Fundo dos Relatórios e Fichas (Timbrado)</label>
                                <input type="file" id="bgUpload" accept="image/*" className="hidden" onChange={(e) => handleImageUpload(e, 'bg')} />
                                <label htmlFor="bgUpload" className="inline-block bg-white border border-slate-300 text-slate-700 px-4 py-2 rounded-lg text-sm font-bold shadow-sm hover:bg-slate-50 transition-colors cursor-pointer">
                                  Fazer Upload da Imagem Timbrada
                                </label>
                                <p className="text-xs text-slate-500 mt-2">Esta imagem aparecerá de fundo quando você imprimir a ficha do paciente.</p>
                                
                                {theme.backgroundUrl && (
                                  <div className="mt-4 border border-slate-300 rounded-lg relative inline-block overflow-hidden shadow-sm bg-white">
                                    <img src={theme.backgroundUrl} alt="Fundo Timbrado" className="h-40 w-auto object-cover opacity-60" />
                                    <div className="absolute inset-0 flex items-center justify-center font-bold text-slate-700 bg-white/30 backdrop-blur-[1px]">Preview do Fundo</div>
                                    <button onClick={() => setTheme({...theme, backgroundUrl: null})} className="absolute top-2 right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold shadow hover:bg-red-600 transition-colors">X</button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="mt-6 flex justify-end border-t border-slate-100 pt-6">
                            <button onClick={() => handleSaveSettings('theme')} className={`text-white px-6 py-2 rounded-lg flex items-center gap-2 font-bold transition-colors duration-300 ${t.btn}`}><i className="ph ph-floppy-disk text-[18px]"></i> Salvar Personalização</button>
                          </div>
                        </FormSection>
                      </div>
                    )}
                    
                  </div>
                )}

                {activeTab === 'dashboard' && selectedPatient && (
                  <div className="p-4 md:p-8 max-w-5xl mx-auto pb-32 md:pb-8">
                    
                    <div className="mb-6 pb-6 border-b border-slate-200 flex flex-col md:flex-row justify-between items-center md:items-end gap-4 text-center md:text-left">
                      <div className="w-full">
                        <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-1">{selectedPatient.nome}</h2>
                        <div className="text-slate-500 flex flex-col md:flex-row items-center md:items-start gap-2 md:gap-4 text-sm md:text-base">
                          <span className="bg-slate-100 md:bg-transparent px-2 py-0.5 rounded md:p-0 font-medium">{selectedPatient.idade} anos ({formatDnForDisplay(selectedPatient)})</span>
                          <span className="hidden md:inline text-slate-300">|</span>
                          <span className="flex items-center gap-1"><i className="ph ph-phone text-emerald-600 md:hidden"></i> {selectedPatient.telefone}</span>
                          <span className="hidden md:inline text-slate-300">|</span>
                          <span className="flex items-center gap-1"><i className="ph ph-identification-card text-emerald-600 md:hidden"></i> CPF: {selectedPatient.cpf}</span>
                        </div>
                      </div>
                    </div>

                    {patientSubTab === 'perfil' && (
                      <FormSection title="Dados Cadastrais">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          <InputGroup label="Nome Completo" value={selectedPatient.nome} readOnly className="md:col-span-2" />
                          <InputGroup label="CPF" value={selectedPatient.cpf} readOnly />
                          
                          <InputGroup label="Data de Nasc." value={selectedPatient.data_nascimento || selectedPatient.dataNascimento || ''} type="date" readOnly />
                          <InputGroup label="Idade" value={selectedPatient.idade} readOnly />
                          <InputGroup label="Estado Civil" value={selectedPatient.estadoCivil} readOnly />
                          
                          <InputGroup label="Profissão/Ocupação" value={selectedPatient.profissao} readOnly />
                          <InputGroup label="Telefone Principal" value={selectedPatient.telefone} readOnly />
                          <InputGroup label="Telefone Secundário" value={selectedPatient.telefone2} readOnly />
                          
                          <InputGroup label="CEP" value={selectedPatient.cep} readOnly />
                          <InputGroup label="Endereço (Rua/Av)" value={selectedPatient.endereco} className="md:col-span-2" readOnly />
                          
                          <InputGroup label="Número" value={selectedPatient.numero} readOnly />
                          <InputGroup label="Bairro" value={selectedPatient.bairro} readOnly />
                          <InputGroup label="Cidade" value={selectedPatient.cidade} readOnly />
                          
                          <InputGroup label="UF" value={selectedPatient.uf} readOnly />
                          <InputGroup label="Possui Plano de Saúde?" value={selectedPatient.planoSaude} readOnly />
                          <InputGroup label="Indicação" value={selectedPatient.indicacao} readOnly />
                          <InputGroup label="Responsável" value={selectedPatient.responsavel} readOnly />
                        </div>

                        {(!usuarioRestritoComoFisio(currentUser)) && (
                          <div className="mt-8 flex flex-wrap gap-3 pt-6 border-t border-slate-100">
                            <button
                              type="button"
                              onClick={() => setPackageModalCtx({ 
                                patientId: selectedPatient.id, 
                                patientName: selectedPatient.nome, 
                                id: null 
                              })}
                              className="flex items-center gap-2 px-6 py-3 bg-emerald-600 text-white rounded-xl font-bold hover:bg-emerald-700 transition-all shadow-md active:scale-95 shadow-emerald-200"
                            >
                              <i className="ph ph-shopping-bag text-xl"></i>
                              Vender Novo Pacote
                            </button>
                          </div>
                        )}

                        <FormSection title="Plano de Pilates" className="mt-8">
                          <div className="flex flex-col gap-2">
                            <div className="flex items-center gap-2">
                              <i className={`ph ${selectedPatient.faz_pilates ? 'ph-check-circle text-emerald-600' : 'ph-x-circle text-slate-400'} text-xl`}></i>
                              <span className="font-semibold text-slate-700">{selectedPatient.faz_pilates ? 'É aluno de Pilates' : 'Não é aluno de Pilates'}</span>
                            </div>
                            {selectedPatient.faz_pilates && (
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2 p-4 bg-slate-50 border border-slate-200 rounded-xl">
                                <InputGroup label="Valor da Mensalidade" value={selectedPatient.valor_mensalidade_pilates ? `R$ ${Number(selectedPatient.valor_mensalidade_pilates).toFixed(2).replace('.', ',')}` : ''} readOnly />
                                <InputGroup label="Dia de Vencimento" value={selectedPatient.dia_vencimento_pilates || ''} readOnly />
                              </div>
                            )}
                          </div>
                        </FormSection>

                        {(selectedPatient.fisio1_id || selectedPatient.fisio2_id) && (
                          <div className="mt-6 p-4 bg-emerald-50 border border-emerald-100 rounded-xl">
                            <h4 className="text-sm font-bold text-emerald-800 uppercase mb-2 flex items-center gap-2">
                              <i className="ph ph-stethoscope"></i> Especialistas Responsáveis
                            </h4>
                            <div className="flex flex-wrap gap-3">
                              {selectedPatient.fisio1_id && (
                                <div className="bg-white px-3 py-2 rounded-lg border border-emerald-200 shadow-sm flex items-center gap-2">
                                  <div className="w-8 h-8 rounded-full bg-emerald-600 text-white flex items-center justify-center font-bold text-xs">
                                    {usersList.find(u => u.id == selectedPatient.fisio1_id)?.nome?.charAt(0)}
                                  </div>
                                  <span className="text-sm font-semibold text-slate-700">{usersList.find(u => u.id == selectedPatient.fisio1_id)?.nome}</span>
                                </div>
                              )}
                              {selectedPatient.fisio2_id && (
                                <div className="bg-white px-3 py-2 rounded-lg border border-emerald-200 shadow-sm flex items-center gap-2">
                                  <div className="w-8 h-8 rounded-full bg-emerald-600 text-white flex items-center justify-center font-bold text-xs">
                                    {usersList.find(u => u.id == selectedPatient.fisio2_id)?.nome?.charAt(0)}
                                  </div>
                                  <span className="text-sm font-semibold text-slate-700">{usersList.find(u => u.id == selectedPatient.fisio2_id)?.nome}</span>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </FormSection>
                    )}

                    {patientSubTab === 'fisio_aval' && (
                      <div>
                         
                        <form onSubmit={handleSaveFisioEval}>
                          <FormSection title="Anamnese - Fisioterapia">
                             <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mb-4">
                               <InputGroup label="Data da Avaliação" type="date" value={fisioEval.data} onChange={e => setFisioEval({...fisioEval, data: e.target.value})} />
                             </div>
                            <TextAreaGroup label="Queixa Principal" value={fisioEval.queixaPrincipal} onChange={e => setFisioEval({...fisioEval, queixaPrincipal: e.target.value})} />
                            <TextAreaGroup label="História da Doença Atual (HDA)" value={fisioEval.hda} onChange={e => setFisioEval({...fisioEval, hda: e.target.value})} />
                            <TextAreaGroup label="Antecedentes Pessoais e Familiares" value={fisioEval.antecedentes} onChange={e => setFisioEval({...fisioEval, antecedentes: e.target.value})} />
                            <TextAreaGroup label="Hábitos de Vida" value={fisioEval.habitosVida} onChange={e => setFisioEval({...fisioEval, habitosVida: e.target.value})} />
                            <TextAreaGroup label="Exames Complementares" value={fisioEval.exames} onChange={e => setFisioEval({...fisioEval, exames: e.target.value})} />
                          </FormSection>

                          <FormSection title="Exame Físico">
                            <TextAreaGroup label="Inspeção" value={fisioEval.inspecao} onChange={e => setFisioEval({...fisioEval, inspecao: e.target.value})} />
                            <TextAreaGroup label="Palpação" value={fisioEval.palpacao} onChange={e => setFisioEval({...fisioEval, palpacao: e.target.value})} />
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              <InputGroup label="Goniometria" value={fisioEval.goniometria} onChange={e => setFisioEval({...fisioEval, goniometria: e.target.value})} />
                              <InputGroup label="Grau de força" value={fisioEval.grauForca} onChange={e => setFisioEval({...fisioEval, grauForca: e.target.value})} />
                            </div>
                          </FormSection>

                          <FormSection title="Planejamento Terapêutico">
                            <TextAreaGroup label="Objetivos do Tratamento" value={fisioEval.objetivos} onChange={e => setFisioEval({...fisioEval, objetivos: e.target.value})} />
                            <TextAreaGroup label="Conduta Inicial" value={fisioEval.conduta} onChange={e => setFisioEval({...fisioEval, conduta: e.target.value})} />
                          </FormSection>

                          <div className="flex flex-col sm:flex-row justify-end items-center gap-3 mb-10 p-4 bg-slate-50 border border-slate-200 rounded-xl shadow-sm">
                            <button type="button" onClick={handleNewFisioEval} className="w-full sm:w-auto px-6 py-3 rounded-xl font-bold border-2 border-slate-200 text-slate-600 hover:bg-slate-100 transition-all flex items-center justify-center gap-2 text-sm">
                              <i className="ph ph-plus-circle text-[20px]"></i> Novo Prontuário
                            </button>
                             <button type="button" onClick={() => handlePrintFisio(fisioEval, selectedPatient)} className="w-full sm:w-auto px-6 py-3 rounded-xl font-bold border-2 border-slate-800 text-slate-800 hover:bg-slate-800 hover:text-white transition-all flex items-center justify-center gap-2 text-sm">
                               <i className="ph ph-printer text-[20px]"></i> Imprimir Form
                             </button>
                            <button type="button" onClick={() => {
                              // Logic to switch to a modal or sub-view for this evaluation's evolutions
                              setViewingFisioEvolTable(fisioEval);
                            }} className="w-full sm:w-auto px-6 py-3 rounded-xl font-bold border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white transition-all flex items-center justify-center gap-2 text-sm">
                              <i className="ph ph-calendar-plus text-[20px]"></i> Gerar Evolução
                            </button>
                            <button type="submit" className={`w-full sm:w-auto text-white px-8 py-3 rounded-xl flex items-center justify-center gap-2 font-bold shadow-md transition-colors duration-300 text-sm ${t.btn}`}>
                              <i className="ph ph-floppy-disk text-[22px]"></i> Salvar Prontuário
                            </button>
                          </div>
                        </form>
 
                        {(selectedPatient.avaliacoesFisio || []).length > 0 && (
                          <FormSection title="Histórico de Prontuários">
                            <div className="space-y-3 mb-6 mt-6">
                              {(selectedPatient.avaliacoesFisio || []).map((aval, idx) => (
                                <div key={idx} className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-3 bg-white border border-slate-200 rounded-xl gap-3 hover:shadow-md transition-shadow">
                                  <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-full bg-sky-100 text-sky-700 flex items-center justify-center">
                                      <i className="ph ph-file-text text-xl text-sky-600"></i>
                                    </div>
                                    <span className="font-bold text-slate-700">Prontuário de {aval.data}</span>
                                  </div>
                                  <div className="flex gap-2 w-full sm:w-auto">
                                     <button type="button" onClick={() => handleVerFisioEval(aval)} className="flex-1 sm:flex-none text-sky-600 hover:text-sky-800 p-2 rounded-lg bg-sky-50 hover:bg-sky-100 transition-colors flex items-center justify-center gap-2 font-semibold text-sm" title="Carregar / Editar">
                                       <i className="ph ph-pencil-simple text-lg"></i> <span className="sm:hidden">Editar</span>
                                     </button>
                                     <button type="button" onClick={() => handlePrintFisio(aval, selectedPatient)} className="text-slate-600 hover:text-slate-800 p-2 rounded-lg bg-slate-100 hover:bg-slate-200 transition-colors flex items-center justify-center" title="Imprimir">
                                       <i className="ph ph-printer text-lg"></i>
                                     </button>
                                     <button type="button" onClick={() => handleDeleteFisioEval(aval)} className="text-red-500 hover:text-red-700 p-2 rounded-lg bg-red-50 hover:bg-red-100 transition-colors flex items-center justify-center" title="Excluir">
                                       <i className="ph ph-trash text-lg"></i>
                                     </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </FormSection>
                        )}
                      </div>
                    )}

                    {patientSubTab === 'pilates_aval' && (
                      <div>
                        <form onSubmit={handleSavePilatesEval} className="space-y-6 pb-20">
                          <FormSection title="1. Identificação e Anamnese">
                            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                              <div className="md:col-span-2"><InputGroup label="Escolaridade" value={pilatesEval.escolaridade} onChange={e => setPilatesEval({...pilatesEval, escolaridade: e.target.value})} /></div>
                              <div className="md:col-span-2"><InputGroup label="Ocupação" value={pilatesEval.ocupacao} onChange={e => setPilatesEval({...pilatesEval, ocupacao: e.target.value})} /></div>
                              
                              <RadioYesNo label="Indicação médica?" value={pilatesEval.indicacaoMedica} onChange={v => setPilatesEval({...pilatesEval, indicacaoMedica: v})} />
                              
                              <div className="md:col-span-2 flex gap-4">
                                <RadioYesNo label="Já praticou pilates?" value={pilatesEval.praticouPilates} onChange={v => setPilatesEval({...pilatesEval, praticouPilates: v})} />
                                {pilatesEval.praticouPilates === 'Sim' && (
                                   <InputGroup label="Quanto tempo?" value={pilatesEval.tempoPratica} onChange={e => setPilatesEval({...pilatesEval, tempoPratica: e.target.value})} />
                                )}
                              </div>
                            </div>
                          </FormSection>

                          <FormSection title="2. Estilo de Vida e Hábitos">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                              <div className="col-span-1 md:col-span-3 grid grid-cols-1 md:grid-cols-3 gap-4 p-4 bg-slate-50 border rounded-lg">
                                <RadioYesNo label="Sedentário?" value={pilatesEval.sedentario} onChange={v => setPilatesEval({...pilatesEval, sedentario: v})} />
                                {pilatesEval.sedentario === 'Sim' ? (
                                  <InputGroup label="Há quanto tempo?" value={pilatesEval.tempoSedentario} onChange={e => setPilatesEval({...pilatesEval, tempoSedentario: e.target.value})} />
                                ) : (
                                  <>
                                    <InputGroup label="Qual outra atividade?" value={pilatesEval.outraAtividade} onChange={e => setPilatesEval({...pilatesEval, outraAtividade: e.target.value})} />
                                    <InputGroup label="Frequência" value={pilatesEval.frequencia} onChange={e => setPilatesEval({...pilatesEval, frequencia: e.target.value})} />
                                  </>
                                )}
                              </div>
                              <RadioYesNo label="Fumante?" value={pilatesEval.fumante} onChange={v => setPilatesEval({...pilatesEval, fumante: v})} />
                              <div className="flex gap-4">
                                <RadioYesNo label="Consome álcool?" value={pilatesEval.alcool} onChange={v => setPilatesEval({...pilatesEval, alcool: v})} />
                                {pilatesEval.alcool === 'Sim' && <InputGroup label="Frequência" value={pilatesEval.alcoolFreq} onChange={e => setPilatesEval({...pilatesEval, alcoolFreq: e.target.value})} />}
                              </div>
                              <InputGroup label="Faz uso de algum medicamento?" value={pilatesEval.medicamentos} onChange={e => setPilatesEval({...pilatesEval, medicamentos: e.target.value})} />
                            </div>
                          </FormSection>

                          <FormSection title="3. Queixas e Histórico Clínico">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              <TextAreaGroup label="Queixa principal" value={pilatesEval.queixaPrincipal} onChange={e => setPilatesEval({...pilatesEval, queixaPrincipal: e.target.value})} />
                              <TextAreaGroup label="Outras queixas" value={pilatesEval.outrasQueixas} onChange={e => setPilatesEval({...pilatesEval, outrasQueixas: e.target.value})} />
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-4 gap-y-4 gap-x-6 mt-4 p-4 bg-slate-50 border rounded-lg">
                              <RadioYesNo label="Neurológicos" value={pilatesEval.neurologicos} onChange={v => setPilatesEval({...pilatesEval, neurologicos: v})} />
                              <RadioYesNo label="Respiratórios" value={pilatesEval.respiratorios} onChange={v => setPilatesEval({...pilatesEval, respiratorios: v})} />
                              <RadioYesNo label="Cardíacos" value={pilatesEval.cardiacos} onChange={v => setPilatesEval({...pilatesEval, cardiacos: v})} />
                              <RadioYesNo label="Osteomioarticulares" value={pilatesEval.osteomioarticulares} onChange={v => setPilatesEval({...pilatesEval, osteomioarticulares: v})} />
                              <RadioYesNo label="Psicológicos" value={pilatesEval.psicologicos} onChange={v => setPilatesEval({...pilatesEval, psicologicos: v})} />
                              <RadioYesNo label="Hipertensão" value={pilatesEval.hipertensao} onChange={v => setPilatesEval({...pilatesEval, hipertensao: v})} />
                              <RadioYesNo label="Diabetes" value={pilatesEval.diabetes} onChange={v => setPilatesEval({...pilatesEval, diabetes: v})} />
                              <RadioYesNo label="Fratura/Cirurgia?" value={pilatesEval.fraturaCirurgia} onChange={v => setPilatesEval({...pilatesEval, fraturaCirurgia: v})} />
                              {pilatesEval.fraturaCirurgia === 'Sim' && <div className="col-span-4 mt-2"><InputGroup label="Descrição da Fratura/Cirurgia" value={pilatesEval.descFraturaCirurgia} onChange={e => setPilatesEval({...pilatesEval, descFraturaCirurgia: e.target.value})} /></div>}
                            </div>
                            <div className="mt-4">
                              <TextAreaGroup label="Exames de imagem" value={pilatesEval.examesImagem} onChange={e => setPilatesEval({...pilatesEval, examesImagem: e.target.value})} />
                            </div>
                          </FormSection>

                          <FormSection title="4. Avaliação Postural">
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                              {/* CABELJA */}
                              <div className="p-4 bg-emerald-50/30 border border-emerald-100 rounded-lg space-y-3">
                                <h4 className="font-bold text-emerald-800 text-sm border-b border-emerald-100 pb-1 flex items-center gap-2"><i className="ph ph-user-focus"></i> CABELJA</h4>
                                <SelectGroup label="Vista Anterior" value={pilatesEval.cabecaAnt} options={['Normal', 'Rotacionada', 'Inclinada direita', 'Inclinada esquerda']} onChange={v => setPilatesEval({...pilatesEval, cabecaAnt: v})} />
                                <SelectGroup label="Vista Lateral" value={pilatesEval.cabecaLat} options={['Normal', 'Anteriorizada', 'Posteriorizada']} onChange={v => setPilatesEval({...pilatesEval, cabecaLat: v})} />
                              </div>

                              {/* OMBROS */}
                              <div className="p-4 bg-emerald-50/30 border border-emerald-100 rounded-lg space-y-3">
                                <h4 className="font-bold text-emerald-800 text-sm border-b border-emerald-100 pb-1 flex items-center gap-2"><i className="ph ph-arrows-out"></i> OMBROS</h4>
                                <SelectGroup label="Vista Anterior" value={pilatesEval.ombrosAnt} options={['Simǩtricos', 'Elevado D', 'Elevado E']} onChange={v => setPilatesEval({...pilatesEval, ombrosAnt: v})} />
                                <SelectGroup label="Vista Lateral" value={pilatesEval.ombrosLat} options={['Normal', 'Protruso', 'Retraído']} onChange={v => setPilatesEval({...pilatesEval, ombrosLat: v})} />
                                <SelectGroup label="Vista Posterior" value={pilatesEval.ombrosPost} options={['Normal', 'Escápula Alada', 'Escápula Retraída']} onChange={v => setPilatesEval({...pilatesEval, ombrosPost: v})} />
                              </div>

                              {/* COLUNA */}
                              <div className="p-4 bg-emerald-50/30 border border-emerald-100 rounded-lg space-y-3">
                                <h4 className="font-bold text-emerald-800 text-sm border-b border-emerald-100 pb-1 flex items-center gap-2"><i className="ph ph-activity"></i> COLUNA</h4>
                                <div className="grid grid-cols-2 gap-2">
                                  <SelectGroup label="Cervical (Lat)" value={pilatesEval.colunaLatCervical} options={['Normal', 'Hiperlordose', 'Hipercifose', 'Retificação']} onChange={v => setPilatesEval({...pilatesEval, colunaLatCervical: v})} />
                                  <SelectGroup label="Torácica (Lat)" value={pilatesEval.colunaLatToracica} options={['Normal', 'Hiperlordose', 'Hipercifose', 'Retificação']} onChange={v => setPilatesEval({...pilatesEval, colunaLatToracica: v})} />
                                  <SelectGroup label="Lombar (Lat)" value={pilatesEval.colunaLatLombar} options={['Normal', 'Hiperlordose', 'Hipercifose', 'Retificação']} onChange={v => setPilatesEval({...pilatesEval, colunaLatLombar: v})} />
                                  <SelectGroup label="Visão Post." value={pilatesEval.colunaPost} options={['Normal', 'Escoliose']} onChange={v => setPilatesEval({...pilatesEval, colunaPost: v})} />
                                </div>
                                {pilatesEval.colunaPost === 'Escoliose' && <InputGroup label="Descreva a escoliose" value={pilatesEval.colunaPostDesc} onChange={e => setPilatesEval({...pilatesEval, colunaPostDesc: e.target.value})} />}
                              </div>

                              {/* QUADRIL */}
                              <div className="p-4 bg-emerald-50/30 border border-emerald-100 rounded-lg space-y-3">
                                <h4 className="font-bold text-emerald-800 text-sm border-b border-emerald-100 pb-1 flex items-center gap-2"><i className="ph ph-circle-half"></i> QUADRIL</h4>
                                <SelectGroup label="Classificação" value={pilatesEval.quadril} options={['Normal', 'Anterioridade', 'Posterioridade', 'Abertura', 'Fechamento']} onChange={v => setPilatesEval({...pilatesEval, quadril: v})} />
                              </div>

                              {/* JOELHOS */}
                              <div className="p-4 bg-emerald-50/30 border border-emerald-100 rounded-lg space-y-3">
                                <h4 className="font-bold text-emerald-800 text-sm border-b border-emerald-100 pb-1 flex items-center gap-2"><i className="ph ph-selection-background"></i> JOELHOS</h4>
                                <SelectGroup label="Vista Anterior" value={pilatesEval.joelhosAnt} options={['Normal', 'Genuvalgo', 'Genuvaro']} onChange={v => setPilatesEval({...pilatesEval, joelhosAnt: v})} />
                                <SelectGroup label="Vista Lateral" value={pilatesEval.joelhosLat} options={['Normal', 'Genu Recurvato', 'Genu Flexo']} onChange={v => setPilatesEval({...pilatesEval, joelhosLat: v})} />
                              </div>

                              {/* PÉS */}
                              <div className="p-4 bg-emerald-50/30 border border-emerald-100 rounded-lg space-y-2">
                                <h4 className="font-bold text-emerald-800 text-sm border-b border-emerald-100 pb-1 flex items-center gap-2"><i className="ph ph-footprints"></i> PÉS</h4>
                                <div className="grid grid-cols-2 gap-x-4 gap-y-1">
                                  <label className="flex items-center gap-2 text-xs font-bold text-slate-700 col-span-2">
                                    <input type="checkbox" checked={pilatesEval.pesNormal} onChange={e => {
                                      if(e.target.checked) {
                                        setPilatesEval({...pilatesEval, pesNormal: true, pesPlanoD: false, pesPlanoE: false, pesCavoD: false, pesCavoE: false, pesValgoD: false, pesValgoE: false, pesVaroD: false, pesVaroE: false});
                                      } else {
                                        setPilatesEval({...pilatesEval, pesNormal: false});
                                      }
                                    }} /> NORMAL
                                  </label>
                                  <div className="text-[10px] font-bold text-slate-400 mt-1 uppercase border-t pt-1 col-span-2">Alterações</div>
                                  <label className="flex items-center gap-1 text-[11px]"><input type="checkbox" checked={pilatesEval.pesPlanoD} onChange={e => setPilatesEval({...pilatesEval, pesPlanoD: e.target.checked, pesNormal: !e.target.checked ? pilatesEval.pesNormal : false})} /> PLANO D</label>
                                  <label className="flex items-center gap-1 text-[11px]"><input type="checkbox" checked={pilatesEval.pesPlanoE} onChange={e => setPilatesEval({...pilatesEval, pesPlanoE: e.target.checked, pesNormal: !e.target.checked ? pilatesEval.pesNormal : false})} /> PLANO E</label>
                                  <label className="flex items-center gap-1 text-[11px]"><input type="checkbox" checked={pilatesEval.pesCavoD} onChange={e => setPilatesEval({...pilatesEval, pesCavoD: e.target.checked, pesNormal: !e.target.checked ? pilatesEval.pesNormal : false})} /> CAVO D</label>
                                  <label className="flex items-center gap-1 text-[11px]"><input type="checkbox" checked={pilatesEval.pesCavoE} onChange={e => setPilatesEval({...pilatesEval, pesCavoE: e.target.checked, pesNormal: !e.target.checked ? pilatesEval.pesNormal : false})} /> CAVO E</label>
                                  <label className="flex items-center gap-1 text-[11px]"><input type="checkbox" checked={pilatesEval.pesValgoD} onChange={e => setPilatesEval({...pilatesEval, pesValgoD: e.target.checked, pesNormal: !e.target.checked ? pilatesEval.pesNormal : false})} /> VALGO D</label>
                                  <label className="flex items-center gap-1 text-[11px]"><input type="checkbox" checked={pilatesEval.pesValgoE} onChange={e => setPilatesEval({...pilatesEval, pesValgoE: e.target.checked, pesNormal: !e.target.checked ? pilatesEval.pesNormal : false})} /> VALGO E</label>
                                  <label className="flex items-center gap-1 text-[11px]"><input type="checkbox" checked={pilatesEval.pesVaroD} onChange={e => setPilatesEval({...pilatesEval, pesVaroD: e.target.checked, pesNormal: !e.target.checked ? pilatesEval.pesNormal : false})} /> VARO D</label>
                                  <label className="flex items-center gap-1 text-[11px]"><input type="checkbox" checked={pilatesEval.pesVaroE} onChange={e => setPilatesEval({...pilatesEval, pesVaroE: e.target.checked, pesNormal: !e.target.checked ? pilatesEval.pesNormal : false})} /> VARO E</label>
                                </div>
                              </div>
                            </div>
                          </FormSection>

                          <FormSection title="5. Conclusões e Objetivos">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              <TextAreaGroup label="Conclusões" value={pilatesEval.conclusoes} onChange={e => setPilatesEval({...pilatesEval, conclusoes: e.target.value})} />
                              <TextAreaGroup label="Objetivos" value={pilatesEval.objetivos} onChange={e => setPilatesEval({...pilatesEval, objetivos: e.target.value})} />
                            </div>
                          </FormSection>

                          {/* Footer de Ações Fixo no Mobile */}
                          <div className="fixed bottom-0 left-0 right-0 z-[100] bg-white border-t border-slate-200 p-4 shadow-[0_-10px_25px_-5px_rgba(0,0,0,0.1)] md:relative md:bottom-auto md:left-auto md:right-auto md:z-auto md:bg-transparent md:border-t-0 md:p-0 md:shadow-none md:mt-10">
                            <div className="flex flex-col sm:flex-row justify-end items-center gap-3 max-w-5xl mx-auto">
                              <button type="button" onClick={handleNewPilatesEval} className="w-full sm:w-auto px-6 py-3 rounded-xl font-bold border-2 border-slate-200 text-slate-600 hover:bg-slate-50 transition-all flex items-center justify-center gap-2 text-sm">
                                <i className="ph ph-plus-circle text-[20px]"></i> Nova Avaliação
                              </button>
                              <button type="button" onClick={() => setSignatureModal({ isOpen: true, role: 'FisioPilates' })} className={`w-full sm:w-auto px-6 py-3 rounded-xl font-bold border-2 transition-all flex items-center justify-center gap-2 text-sm ${pilatesEval.assinaturaFisio ? 'border-emerald-500 bg-emerald-50 text-emerald-700' : 'border-slate-200 text-slate-600 hover:bg-slate-50'}`}>
                                <i className={`ph ${pilatesEval.assinaturaFisio ? 'ph-check-circle' : 'ph-signature'} text-[20px]`}></i> {pilatesEval.assinaturaFisio ? 'Rubricado' : 'Assinar'}
                              </button>
                              <button type="submit" className={`w-full sm:w-auto text-white px-10 py-3 rounded-xl flex items-center justify-center gap-2 font-bold shadow-lg transition-all active:scale-95 text-sm ${t.btn}`}>
                                <i className="ph ph-floppy-disk text-[22px]"></i> SALVAR AVALIAÇÃO
                              </button>
                            </div>
                          </div>
                         </form>

                        {(selectedPatient.avaliacoesPilates || []).length > 0 && (
                          <FormSection title="Histórico de Avaliações Pilates">
                            <div className="space-y-3">
                              {(selectedPatient.avaliacoesPilates || []).map((aval, idx) => (
                                <div key={idx} className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-3 bg-slate-50 border border-slate-200 rounded-lg gap-3 hover:shadow-sm transition-shadow">
                                  <span className="font-bold text-slate-700"><i className="ph ph-clipboard-text mr-2 text-emerald-600"></i>Avaliação em {aval.data}</span>
                                  <div className="flex gap-2 w-full sm:w-auto">
                                     <button type="button" onClick={() => handleVerPilatesEval(aval)} className="flex-1 sm:flex-none text-emerald-600 hover:text-emerald-800 p-2 rounded-lg bg-emerald-100/50 hover:bg-emerald-100 transition-colors flex items-center justify-center gap-2 font-semibold text-sm" title="Carregar / Editar">
                                       <i className="ph ph-pencil-simple text-lg"></i> <span className="sm:hidden">Editar</span>
                                     </button>
                                     <button type="button" onClick={() => handlePrintPilates(aval, selectedPatient)} className="text-slate-600 hover:text-slate-800 p-2 rounded-lg bg-slate-200/50 hover:bg-slate-200 transition-colors flex items-center justify-center" title="Imprimir">
                                       <i className="ph ph-printer text-lg"></i>
                                     </button>
                                     <button type="button" onClick={() => handleDeletePilatesEval(aval)} className="text-red-500 hover:text-red-700 p-2 rounded-lg bg-red-100/50 hover:bg-red-100 transition-colors flex items-center justify-center" title="Excluir">
                                       <i className="ph ph-trash text-lg"></i>
                                     </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </FormSection>
                        )}
                      </div>
                    )}

                    {patientSubTab === 'fisio_evol' && (
                      <div className="space-y-8 pb-32">
                        {/* Prontuário Clínico Visual Header */}
                        <div className="bg-white rounded-2xl border border-slate-200 shadow-xl overflow-hidden print:shadow-none print:border-slate-300">
                          <div className="bg-emerald-600 p-4 text-white flex justify-between items-center print:bg-slate-100 print:text-slate-800">
                            <h3 className="text-xl font-bold flex items-center gap-2">
                              <i className="ph ph-file-text text-[24px]"></i>
                              AVALIAÇÃO OSTEOPÁTICA
                            </h3>
                            <button 
                              onClick={() => {
                                handleSaveSettings('patient_clinical_header');
                              }}
                              className="bg-white/20 hover:bg-white/30 text-white px-4 py-1.5 rounded-lg text-sm font-bold transition-all flex items-center gap-2 border border-white/20 print:hidden"
                            >
                              <i className="ph ph-floppy-disk"></i> Salvar Informações Clínicas
                            </button>
                            <button 
                              onClick={() => setShowOsteoHistorico(true)}
                              className="bg-white/10 hover:bg-white/20 text-white px-4 py-1.5 rounded-lg text-sm font-bold transition-all flex items-center gap-2 border border-white/20 print:hidden ml-2"
                              title="Ver histórico de avaliações salvas"
                            >
                              <i className="ph ph-clock-counter-clockwise"></i> Histórico
                            </button>
                            <button 
                              onClick={() => setShowOsteoVisualizar(true)}
                              className="bg-white/10 hover:bg-white/20 text-white px-4 py-1.5 rounded-lg text-sm font-bold transition-all flex items-center gap-2 border border-white/20 print:hidden ml-2"
                              title="Visualizar prontuário completo"
                            >
                              <i className="ph ph-eye"></i> Visualizar
                            </button>
                          </div>

                          {/* Modal Histórico Osteopático */}
                          {showOsteoHistorico && (
                            <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" onClick={() => setShowOsteoHistorico(false)}>
                              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col" onClick={e => e.stopPropagation()}>
                                <div className="bg-emerald-600 p-4 rounded-t-2xl flex justify-between items-center text-white">
                                  <h3 className="font-bold text-lg flex items-center gap-2"><i className="ph ph-clock-counter-clockwise text-xl"></i> Histórico de Avaliações Osteopáticas</h3>
                                  <button onClick={() => setShowOsteoHistorico(false)} className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"><i className="ph ph-x text-xl"></i></button>
                                </div>
                                <div className="overflow-y-auto flex-1 p-4 space-y-3">
                                  {((selectedPatient.avaliacoesOsteopatia || []).filter(a => a.dataHora)).length === 0 ? (
                                    <div className="text-center text-slate-400 py-10">
                                      <i className="ph ph-archive text-4xl mb-2 block"></i>
                                      <p>Nenhum histórico salvo ainda.<br/>Clique em "Salvar Informações Clínicas" para registrar.</p>
                                    </div>
                                  ) : (
                                    [...(selectedPatient.avaliacoesOsteopatia || []).filter(a => a.dataHora)].reverse().map((snap, idx) => (
                                      <div key={snap.id || idx} className="border border-slate-200 rounded-xl p-4 bg-slate-50 hover:bg-emerald-50/30 transition-colors">
                                        <div className="flex items-center justify-between mb-3">
                                          <div className="flex items-center gap-2">
                                            <span className="bg-emerald-100 text-emerald-800 border border-emerald-200 text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1">
                                              <i className="ph ph-calendar-blank"></i> {snap.dataHora}
                                            </span>
                                            {idx === 0 && <span className="bg-blue-100 text-blue-700 text-xs font-bold px-2 py-0.5 rounded-full">Mais recente</span>}
                                          </div>
                                          <button
                                            onClick={() => {
                                              const currentEval = selectedPatient.avaliacoesOsteopatia?.[0] || {};
                                              const updatedEval = {
                                                ...currentEval,
                                                queixaPrincipal: snap.queixaPrincipal || '',
                                                inspecao: snap.inspecao || '',
                                                palpacao: snap.palpacao || '',
                                              };
                                              const updatedAvals = [updatedEval, ...(selectedPatient.avaliacoesOsteopatia || []).slice(1)];
                                              const updated = {
                                                ...selectedPatient,
                                                avaliacoesOsteopatia: updatedAvals,
                                                disfuncaoOP: snap.disfuncaoOP || selectedPatient.disfuncaoOP,
                                                tratamentoGeral: snap.tratamento || selectedPatient.tratamentoGeral,
                                              };
                                              setSelectedPatient(updated);
                                              setPatients(patients.map(p => p.id === updated.id ? updated : p));
                                              setShowOsteoHistorico(false);
                                              showToast('Avaliação carregada nos campos!');
                                            }}
                                            className="flex items-center gap-1.5 bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-bold px-3 py-1.5 rounded-lg transition-colors"
                                          >
                                            <i className="ph ph-arrow-square-out text-sm"></i> Abrir
                                          </button>
                                        </div>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
                                          {snap.queixaPrincipal && <div><span className="text-[10px] font-bold uppercase text-slate-400 block">Queixa Principal</span><p className="text-slate-700 line-clamp-3">{snap.queixaPrincipal}</p></div>}
                                          {snap.disfuncaoOP && <div><span className="text-[10px] font-bold uppercase text-slate-400 block">Disfunção O.P.</span><p className="text-slate-700 line-clamp-3">{snap.disfuncaoOP}</p></div>}
                                          {snap.inspecao && <div><span className="text-[10px] font-bold uppercase text-slate-400 block">Inspeção</span><p className="text-slate-700 line-clamp-2">{snap.inspecao}</p></div>}
                                          {snap.palpacao && <div><span className="text-[10px] font-bold uppercase text-slate-400 block">Palpação</span><p className="text-slate-700 line-clamp-2">{snap.palpacao}</p></div>}
                                          {snap.tratamento && <div className="sm:col-span-2"><span className="text-[10px] font-bold uppercase text-slate-400 block">Tratamento</span><p className="text-slate-700 line-clamp-3">{snap.tratamento}</p></div>}
                                        </div>
                                      </div>
                                    ))
                                  )}
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Modal Visualizar Prontuário Osteopático Completo */}
                          {showOsteoVisualizar && (
                            <div className="fixed inset-0 bg-black/70 z-50 flex items-start justify-center p-4 overflow-y-auto" onClick={() => setShowOsteoVisualizar(false)}>
                              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl my-6" onClick={e => e.stopPropagation()}>
                                <div className="bg-emerald-700 p-5 rounded-t-2xl text-white flex justify-between items-start">
                                  <div>
                                    <p className="text-emerald-200 text-xs font-bold uppercase tracking-widest mb-1">Prontuário Osteopático</p>
                                    <h2 className="text-2xl font-bold">{selectedPatient.nome}</h2>
                                    <p className="text-emerald-200 text-sm mt-1">{selectedPatient.cidade} - {selectedPatient.uf} &nbsp;|&nbsp; Tel: {selectedPatient.telefone}</p>
                                  </div>
                                  <div className="flex gap-2">
                                    <button onClick={() => window.print()} className="p-2 bg-white/20 hover:bg-white/30 rounded-lg transition-colors" title="Imprimir"><i className="ph ph-printer text-xl"></i></button>
                                    <button onClick={() => setShowOsteoVisualizar(false)} className="p-2 bg-white/20 hover:bg-white/30 rounded-lg transition-colors"><i className="ph ph-x text-xl"></i></button>
                                  </div>
                                </div>
                                <div className="border-b border-slate-200">
                                  <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-slate-200">
                                    <div className="p-4"><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">Data de Nasc.</span><p className="font-semibold text-slate-700">{selectedPatient.data_nascimento}</p></div>
                                    <div className="p-4"><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">Sexo</span><p className="font-semibold text-slate-700">{selectedPatient.sexo}</p></div>
                                    <div className="p-4"><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">Estado Civil</span><p className="font-semibold text-slate-700">{selectedPatient.estado_civil}</p></div>
                                    <div className="p-4"><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">Profissão</span><p className="font-semibold text-slate-700">{selectedPatient.profissao}</p></div>
                                  </div>
                                </div>
                                <div className="p-6 space-y-5">
                                  {(selectedPatient.avaliacoesOsteopatia?.[0]?.queixaPrincipal) && (
                                    <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                                      <span className="text-[11px] uppercase font-bold text-emerald-700 tracking-wider block mb-2">Queixa Principal / História</span>
                                      <p className="text-slate-800 text-sm leading-relaxed whitespace-pre-wrap">{selectedPatient.avaliacoesOsteopatia[0].queixaPrincipal}</p>
                                    </div>
                                  )}
                                  {(selectedPatient.avaliacoesOsteopatia?.[0]?.inspecao || selectedPatient.avaliacoesOsteopatia?.[0]?.palpacao) && (
                                    <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                                      <span className="text-[11px] uppercase font-bold text-emerald-700 tracking-wider block mb-3">Exame Físico</span>
                                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        {selectedPatient.avaliacoesOsteopatia?.[0]?.inspecao && (
                                          <div><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">Inspeção</span><p className="text-slate-800 text-sm leading-relaxed whitespace-pre-wrap">{selectedPatient.avaliacoesOsteopatia[0].inspecao}</p></div>
                                        )}
                                        {selectedPatient.avaliacoesOsteopatia?.[0]?.palpacao && (
                                          <div><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">Palpação</span><p className="text-slate-800 text-sm leading-relaxed whitespace-pre-wrap">{selectedPatient.avaliacoesOsteopatia[0].palpacao}</p></div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {(selectedPatient.disfuncaoOP || selectedPatient.disfuncao_op) && (
                                      <div className="bg-emerald-50 rounded-xl p-4 border border-emerald-200">
                                        <span className="text-[11px] uppercase font-bold text-emerald-700 tracking-wider block mb-2">Disfunção O.P.</span>
                                        <p className="text-slate-800 text-sm leading-relaxed whitespace-pre-wrap">{selectedPatient.disfuncaoOP || selectedPatient.disfuncao_op}</p>
                                      </div>
                                    )}
                                    {(selectedPatient.tratamentoGeral || selectedPatient.tratamento_geral) && (
                                      <div className="bg-emerald-50 rounded-xl p-4 border border-emerald-200">
                                        <span className="text-[11px] uppercase font-bold text-emerald-700 tracking-wider block mb-2">Tratamento</span>
                                        <p className="text-slate-800 text-sm leading-relaxed whitespace-pre-wrap">{selectedPatient.tratamentoGeral || selectedPatient.tratamento_geral}</p>
                                      </div>
                                    )}
                                  </div>
                                  {(selectedPatient.bodyMapMarkers || []).length > 0 && (
                                    <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                                      <span className="text-[11px] uppercase font-bold text-emerald-700 tracking-wider block mb-3">Mapa Corporal — Pontos de Dor ({(selectedPatient.bodyMapMarkers || []).length})</span>
                                      
                                      <div className="flex flex-col md:flex-row gap-6 items-start">
                                        {/* Visual Body Map (Read Only) */}
                                        <div className="flex justify-center bg-white p-4 rounded-xl border border-slate-200 shrink-0">
                                          {['Frente', 'Verso'].map((lado, sideIdx) => (
                                            <div key={lado} className="flex flex-col items-center mx-2">
                                              <span className="text-[9px] font-bold text-slate-400 mb-1 uppercase">{lado}</span>
                                              <div className="relative border border-slate-200 rounded-lg bg-slate-50" style={{width: 110, height: 240}}>
                                                <svg viewBox="0 0 130 280" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" style={{pointerEvents:'none'}}>
                                                  <ellipse cx="65" cy="28" rx="18" ry="22" fill="none" stroke="#94a3b8" strokeWidth="2"/>
                                                  <rect x="58" y="48" width="14" height="14" fill="none" stroke="#94a3b8" strokeWidth="1.5" rx="3"/>
                                                  <path d="M38 62 C32 70 28 95 30 120 L100 120 C102 95 98 70 92 62 Z" fill="none" stroke="#94a3b8" strokeWidth="2"/>
                                                  <path d="M38 62 C28 60 18 65 15 78 L22 80 C24 70 32 67 38 68Z" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                                  <path d="M92 62 C102 60 112 65 115 78 L108 80 C106 70 98 67 92 68Z" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                                  <path d="M15 78 C12 95 11 115 13 135" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round"/>
                                                  <path d="M115 78 C118 95 119 115 117 135" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round"/>
                                                  <path d="M13 135 C12 152 14 165 13 175" fill="none" stroke="#94a3b8" strokeWidth="1.8" strokeLinecap="round"/>
                                                  <path d="M117 135 C118 152 116 165 117 175" fill="none" stroke="#94a3b8" strokeWidth="1.8" strokeLinecap="round"/>
                                                  <ellipse cx="13" cy="180" rx="5" ry="7" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                                  <ellipse cx="117" cy="180" rx="5" ry="7" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                                  <path d="M30 120 C30 130 28 140 32 148 L98 148 C102 140 100 130 100 120" fill="none" stroke="#94a3b8" strokeWidth="2"/>
                                                  <path d="M32 148 C30 170 30 195 32 220" fill="none" stroke="#94a3b8" strokeWidth="2.5" strokeLinecap="round"/>
                                                  <path d="M98 148 C100 170 100 195 98 220" fill="none" stroke="#94a3b8" strokeWidth="2.5" strokeLinecap="round"/>
                                                  <ellipse cx="32" cy="205" rx="6" ry="4" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                                  <ellipse cx="98" cy="205" rx="6" ry="4" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                                  <path d="M32 209 C31 225 31 240 32 255" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round"/>
                                                  <path d="M98 209 C99 225 99 240 98 255" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round"/>
                                                  <path d="M32 255 C28 260 20 262 17 260 C17 265 22 268 35 266 C35 265 33 258 32 255Z" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                                  <path d="M98 255 C102 260 110 262 113 260 C113 265 108 268 95 266 C95 265 97 258 98 255Z" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                                  <line x1="65" y1="62" x2="65" y2="120" stroke="#cbd5e1" strokeWidth="0.8" strokeDasharray="3,3"/>
                                                </svg>
                                                {(selectedPatient.bodyMapMarkers || []).filter(m => m.side === sideIdx).map((marker) => (
                                                  <div key={marker.id} className="absolute flex items-center justify-center pointer-events-none" style={{ left: `${marker.x}%`, top: `${marker.y}%`, transform: 'translate(-50%, -50%)', zIndex: 10 }}>
                                                    <div className="bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-[9px] font-bold shadow-md shadow-red-500/40">
                                                      {marker.label.replace('P','')}
                                                    </div>
                                                  </div>
                                                ))}
                                              </div>
                                            </div>
                                          ))}
                                        </div>

                                        {/* Markers List */}
                                        <div className="flex-1 space-y-2 w-full">
                                          {(selectedPatient.bodyMapMarkers || []).map((m, i) => (
                                            <div key={i} className="flex items-start gap-3 bg-white border border-slate-200 p-2.5 rounded-lg">
                                              <span className="flex items-center gap-1 bg-red-50 border border-red-200 text-red-700 text-xs font-bold px-2 py-1 rounded-full shrink-0">
                                                <span className="w-2 h-2 bg-red-500 rounded-full inline-block"></span>{m.label} <span className="text-slate-400 font-normal">({m.side === 0 ? 'Frente' : 'Verso'})</span>
                                              </span>
                                              {m.obs && <p className="text-slate-700 text-sm">{m.obs}</p>}
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {(selectedPatient.evolucoesOsteopatia || []).length > 0 && (
                                    <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                                      <span className="text-[11px] uppercase font-bold text-emerald-700 tracking-wider block mb-3">Histórico de Evoluções ({(selectedPatient.evolucoesOsteopatia || []).length} sessões)</span>
                                      <div className="space-y-3">
                                        {[...(selectedPatient.evolucoesOsteopatia || [])].reverse().map((ev, i) => (
                                          <div key={i} className="bg-white border border-slate-200 rounded-xl p-3">
                                            <span className="bg-emerald-100 text-emerald-800 text-xs font-bold px-2 py-1 rounded-md inline-flex items-center gap-1 mb-2"><i className="ph ph-calendar-blank"></i> Sessão {ev.data}</span>
                                            <p className="text-slate-700 text-sm whitespace-pre-wrap">{ev.evolucao}</p>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="bg-slate-50 p-4 rounded-b-2xl border-t border-slate-200 text-center text-[10px] text-slate-400 font-medium">
                                  REAL CLÍNICA INTEGRADA • PRONTUÁRIO OSTEOPÁTICO — {selectedPatient.nome} — {new Date().toLocaleDateString('pt-BR')}
                                </div>
                              </div>
                            </div>
                          )}

                          <div className="p-6 md:p-8 space-y-8">
                            {/* Dados Cadastrais (Read-only Table Look) */}
                            <div className="border border-slate-200 rounded-xl overflow-hidden">
                              <div className="grid grid-cols-1 md:grid-cols-4 border-b border-slate-200 bg-slate-50/50">
                                <div className="p-3 border-r border-slate-200"><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">Nome</span><p className="font-bold text-slate-700 truncate">{selectedPatient.nome}</p></div>
                                <div className="p-3 border-r border-slate-200"><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">Data de Nasc. (DN)</span><p className="font-semibold text-slate-700">{selectedPatient.data_nascimento}</p></div>
                                <div className="p-3 border-r border-slate-200"><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">Sexo</span><p className="font-semibold text-slate-700">{selectedPatient.sexo}</p></div>
                                <div className="p-3"><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">Estado Civil</span><p className="font-semibold text-slate-700">{selectedPatient.estado_civil}</p></div>
                              </div>
                              <div className="grid grid-cols-1 md:grid-cols-3 border-b border-slate-200">
                                <div className="p-3 border-r border-slate-200"><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">Profissão</span><p className="font-medium text-slate-600">{selectedPatient.profissao}</p></div>
                                <div className="p-3 border-r border-slate-200 md:col-span-2"><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">Endereço</span><p className="font-medium text-slate-600 truncate">{selectedPatient.endereco}, {selectedPatient.numero} - {selectedPatient.bairro}</p></div>
                              </div>
                              <div className="grid grid-cols-1 md:grid-cols-4 border-b border-slate-200 bg-slate-50/50">
                                <div className="p-3 border-r border-slate-200"><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">Cidade</span><p className="font-medium text-slate-600">{selectedPatient.cidade} - {selectedPatient.uf}</p></div>
                                <div className="p-3 border-r border-slate-200"><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">CEP</span><p className="font-medium text-slate-600">{selectedPatient.cep}</p></div>
                                <div className="p-3 border-r border-slate-200"><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">Telefone / Celular</span><p className="font-medium text-slate-600">{selectedPatient.telefone}</p></div>
                                <div className="p-3"><span className="text-[10px] uppercase font-bold text-slate-400 block mb-1">CPF / RG</span><p className="font-medium text-slate-600">{selectedPatient.cpf} / {selectedPatient.rg || '-'}</p></div>
                              </div>
                            </div>

                            {/* Seções Clínicas e Mapa Corporal */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                              <div className="space-y-6">
                                <div className="p-4 bg-slate-50 rounded-xl border border-slate-200">
                                  <label className="text-sm font-bold text-slate-700 uppercase tracking-wider block mb-2 px-1">Queixa Principal / História</label>
                                  <textarea 
                                    className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 min-h-[120px] bg-white text-sm"
                                    value={selectedPatient.avaliacoesOsteopatia?.[0]?.queixaPrincipal || ''}
                                    onChange={(e) => {
                                      const updated = {...selectedPatient};
                                      if(!updated.avaliacoesOsteopatia) updated.avaliacoesOsteopatia = [{}];
                                      if(!updated.avaliacoesOsteopatia[0]) updated.avaliacoesOsteopatia[0] = {};
                                      updated.avaliacoesOsteopatia[0].queixaPrincipal = e.target.value;
                                      setSelectedPatient(updated);
                                      setPatients(patients.map(p => p.id === updated.id ? updated : p));
                                    }}
                                    placeholder="Descreva a queixa principal do paciente..."
                                  />
                                </div>
                                <div className="p-4 bg-slate-50 rounded-xl border border-slate-200">
                                  <label className="text-sm font-bold text-slate-700 uppercase tracking-wider block mb-2 px-1">Exame Físico (Inspeção / Palpação)</label>
                                  <div className="space-y-3">
                                    <textarea 
                                      className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 h-20 bg-white text-sm"
                                      value={selectedPatient.avaliacoesOsteopatia?.[0]?.inspecao || ''}
                                      onChange={(e) => {
                                        const updated = {...selectedPatient};
                                        if(!updated.avaliacoesOsteopatia) updated.avaliacoesOsteopatia = [{}];
                                        if(!updated.avaliacoesOsteopatia[0]) updated.avaliacoesOsteopatia[0] = {};
                                        updated.avaliacoesOsteopatia[0].inspecao = e.target.value;
                                        setSelectedPatient(updated);
                                        setPatients(patients.map(p => p.id === updated.id ? updated : p));
                                      }}
                                      placeholder="Inspeção..."
                                    />
                                    <textarea 
                                      className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 h-20 bg-white text-sm"
                                      value={selectedPatient.avaliacoesOsteopatia?.[0]?.palpacao || ''}
                                      onChange={(e) => {
                                        const updated = {...selectedPatient};
                                        if(!updated.avaliacoesOsteopatia) updated.avaliacoesOsteopatia = [{}];
                                        if(!updated.avaliacoesOsteopatia[0]) updated.avaliacoesOsteopatia[0] = {};
                                        updated.avaliacoesOsteopatia[0].palpacao = e.target.value;
                                        setSelectedPatient(updated);
                                        setPatients(patients.map(p => p.id === updated.id ? updated : p));
                                      }}
                                      placeholder="Palpação..."
                                    />
                                  </div>
                                </div>
                                <div className="p-4 bg-emerald-50/50 rounded-xl border border-emerald-200">
                                  <label className="text-sm font-bold text-emerald-800 uppercase tracking-wider block mb-2 px-1">Disfunção O.P.</label>
                                  <textarea 
                                    className="w-full p-3 border border-emerald-300 rounded-lg focus:ring-2 focus:ring-emerald-500 h-24 bg-white text-sm"
                                    value={selectedPatient.disfuncaoOP ?? selectedPatient.disfuncao_op ?? ''}
                                    onChange={(e) => {
                                      const updated = {...selectedPatient, disfuncaoOP: e.target.value};
                                      setSelectedPatient(updated);
                                      setPatients(patients.map(p => p.id === updated.id ? updated : p));
                                    }}
                                    placeholder="Descreva a disfunação observada..."
                                  />
                                </div>
                                <div className="p-4 bg-emerald-50/50 rounded-xl border border-emerald-200">
                                  <label className="text-sm font-bold text-emerald-800 uppercase tracking-wider block mb-2 px-1">Tratamento</label>
                                  <textarea 
                                    className="w-full p-3 border border-emerald-300 rounded-lg focus:ring-2 focus:ring-emerald-500 h-24 bg-white text-sm"
                                    value={selectedPatient.tratamentoGeral ?? selectedPatient.tratamento_geral ?? ''}
                                    onChange={(e) => {
                                      const updated = {...selectedPatient, tratamentoGeral: e.target.value};
                                      setSelectedPatient(updated);
                                      setPatients(patients.map(p => p.id === updated.id ? updated : p));
                                    }}
                                    placeholder="Planejamento do tratamento..."
                                  />
                                </div>
                              </div>

                              <div className="flex flex-col p-4 bg-white border border-slate-200 rounded-2xl">
                                <div className="flex items-center justify-between mb-3">
                                  <h4 className="text-xs font-bold text-slate-500 uppercase tracking-widest">Mapa Corporal Interativo</h4>
                                  {(selectedPatient.bodyMapMarkers || []).length > 0 && (
                                    <button type="button" onClick={() => { const u = {...selectedPatient, bodyMapMarkers: []}; setSelectedPatient(u); setPatients(patients.map(p => p.id === u.id ? u : p)); }} className="text-[10px] text-red-400 hover:text-red-600 border border-red-200 px-2 py-0.5 rounded-full transition-colors">Limpar Marcações</button>
                                  )}
                                </div>
                                <p className="text-[10px] text-slate-400 mb-3 italic">Clique na silhueta para marcar pontos de dor. Clique em um ponto vermelho para removê-lo.</p>

                                                                {/* Mapa corporal com imagem real */}
                                <div className="flex justify-center">
                                  {['Frente', 'Verso'].map((lado, sideIdx) => (
                                    <div key={lado} className="flex flex-col items-center mx-2">
                                      <span className="text-[10px] font-bold text-slate-400 mb-1 uppercase">{lado}</span>
                                      <div
                                        className="relative cursor-crosshair border border-slate-200 rounded-xl bg-slate-50 hover:bg-emerald-50/30 transition-colors"
                                        style={{width: 130, height: 280}}
                                        onClick={(e) => {
                                          const rect = e.currentTarget.getBoundingClientRect();
                                          const x = ((e.clientX - rect.left) / rect.width * 100).toFixed(1);
                                          const y = ((e.clientY - rect.top) / rect.height * 100).toFixed(1);
                                          const markers = selectedPatient.bodyMapMarkers || [];
                                          const newMarker = { id: Date.now(), side: sideIdx, x: parseFloat(x), y: parseFloat(y), label: `P${markers.length + 1}`, obs: "" };
                                          const updated = {...selectedPatient, bodyMapMarkers: [...markers, newMarker]};
                                          setSelectedPatient(updated);
                                          setPatients(patients.map(p => p.id === updated.id ? updated : p));
                                        }}
                                      >
                                        <svg viewBox="0 0 130 280" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" style={{pointerEvents:'none'}}>
                                          <ellipse cx="65" cy="28" rx="18" ry="22" fill="none" stroke="#94a3b8" strokeWidth="2"/>
                                          <rect x="58" y="48" width="14" height="14" fill="none" stroke="#94a3b8" strokeWidth="1.5" rx="3"/>
                                          <path d="M38 62 C32 70 28 95 30 120 L100 120 C102 95 98 70 92 62 Z" fill="none" stroke="#94a3b8" strokeWidth="2"/>
                                          <path d="M38 62 C28 60 18 65 15 78 L22 80 C24 70 32 67 38 68Z" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                          <path d="M92 62 C102 60 112 65 115 78 L108 80 C106 70 98 67 92 68Z" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                          <path d="M15 78 C12 95 11 115 13 135" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round"/>
                                          <path d="M115 78 C118 95 119 115 117 135" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round"/>
                                          <path d="M13 135 C12 152 14 165 13 175" fill="none" stroke="#94a3b8" strokeWidth="1.8" strokeLinecap="round"/>
                                          <path d="M117 135 C118 152 116 165 117 175" fill="none" stroke="#94a3b8" strokeWidth="1.8" strokeLinecap="round"/>
                                          <ellipse cx="13" cy="180" rx="5" ry="7" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                          <ellipse cx="117" cy="180" rx="5" ry="7" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                          <path d="M30 120 C30 130 28 140 32 148 L98 148 C102 140 100 130 100 120" fill="none" stroke="#94a3b8" strokeWidth="2"/>
                                          <path d="M32 148 C30 170 30 195 32 220" fill="none" stroke="#94a3b8" strokeWidth="2.5" strokeLinecap="round"/>
                                          <path d="M98 148 C100 170 100 195 98 220" fill="none" stroke="#94a3b8" strokeWidth="2.5" strokeLinecap="round"/>
                                          <ellipse cx="32" cy="205" rx="6" ry="4" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                          <ellipse cx="98" cy="205" rx="6" ry="4" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                          <path d="M32 209 C31 225 31 240 32 255" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round"/>
                                          <path d="M98 209 C99 225 99 240 98 255" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round"/>
                                          <path d="M32 255 C28 260 20 262 17 260 C17 265 22 268 35 266 C35 265 33 258 32 255Z" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                          <path d="M98 255 C102 260 110 262 113 260 C113 265 108 268 95 266 C95 265 97 258 98 255Z" fill="none" stroke="#94a3b8" strokeWidth="1.5"/>
                                          <line x1="65" y1="62" x2="65" y2="120" stroke="#cbd5e1" strokeWidth="0.8" strokeDasharray="3,3"/>
                                        </svg>

                                        {(selectedPatient.bodyMapMarkers || []).filter(m => m.side === sideIdx).map((marker) => (
                                          <div
                                            key={marker.id}
                                            className="absolute flex items-center justify-center"
                                            style={{
                                              left: `${marker.x}%`,
                                              top: `${marker.y}%`,
                                              transform: 'translate(-50%, -50%)',
                                              pointerEvents: 'auto',
                                              zIndex: 10
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              const updated = {...selectedPatient, bodyMapMarkers: (selectedPatient.bodyMapMarkers || []).filter(m => m.id !== marker.id)};
                                              setSelectedPatient(updated);
                                              setPatients(patients.map(p => p.id === updated.id ? updated : p));
                                            }}
                                            title={`Remover ${marker.label}`}
                                          >
                                            <div className="w-5 h-5 bg-red-500 rounded-full border-2 border-white shadow-md flex items-center justify-center" style={{animation:'pulse 2s infinite'}}>
                                              <span className="text-[8px] font-black text-white leading-none">{marker.label.replace('P','')}</span>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  ))}
                                </div>

                                                                 {(selectedPatient.bodyMapMarkers || []).length > 0 && (
                                  <div className="mt-4 border-t border-slate-100 pt-3">
                                    <p className="text-[10px] font-bold text-slate-400 uppercase mb-2">Pontos Marcados e Observações ({(selectedPatient.bodyMapMarkers || []).length})</p>
                                    <div className="space-y-2">
                                      {(selectedPatient.bodyMapMarkers || []).map(m => (
                                        <div key={m.id} className="flex items-center gap-2 bg-slate-50 p-2 rounded-lg border border-slate-200 hover:bg-emerald-50 transition-colors">
                                          <span className="flex items-center gap-1 bg-red-50 border border-red-200 text-red-700 text-[10px] font-bold px-2 py-1 rounded-full shrink-0">
                                            <span className="w-2 h-2 bg-red-500 rounded-full"></span>
                                            {m.label}
                                          </span>
                                          <input 
                                            type="text" 
                                            className="flex-1 bg-white border border-slate-200 rounded px-2 py-1 text-[11px] focus:ring-1 focus:ring-emerald-500 outline-none" 
                                            placeholder="Observação da dor/lesão..."
                                            value={m.obs || ''}
                                            onChange={(e) => {
                                              const updatedMarkers = selectedPatient.bodyMapMarkers.map(x => x.id === m.id ? {...x, obs: e.target.value} : x);
                                              const u = {...selectedPatient, bodyMapMarkers: updatedMarkers};
                                              setSelectedPatient(u);
                                              setPatients(patients.map(p => p.id === u.id ? u : p));
                                            }}
                                          />
                                          <button type="button" onClick={() => { const u = {...selectedPatient, bodyMapMarkers: (selectedPatient.bodyMapMarkers || []).filter(x => x.id !== m.id)}; setSelectedPatient(u); setPatients(patients.map(p => p.id === u.id ? u : p)); }} className="text-red-400 hover:text-red-600 font-black p-1">
                                            <i className="ph ph-trash"></i>
                                          </button>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          
                          <div className="bg-slate-50 p-4 border-t border-slate-200 text-center text-[10px] text-slate-400 font-medium">
                            REAL CLÍNICA INTEGRADA • PRONTUÁRIO GERADO DIGITALMENTE EM {new Date().toLocaleDateString()}
                          </div>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                        <div className="lg:col-span-1">
                          <FormSection title="Nova Evolução">
                            <form onSubmit={handleSaveOsteopatiaEvol}>
                              <TextAreaGroup label="Descrição da Evolução" value={osteopatiaEvol.evolucao} onChange={e => setOsteopatiaEvol({evolucao: e.target.value})} rows={6} />
                               
                               <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
                                 <button type="button" onClick={() => setSignatureModal({ isOpen: true, role: 'OsteoPaciente' })} className={`py-2 px-3 rounded-lg border-2 flex items-center justify-center gap-2 font-bold transition-all ${osteopatiaEvol.assinaturaPaciente ? 'border-emerald-500 bg-emerald-50 text-emerald-700' : 'border-slate-200 text-slate-600 hover:bg-slate-50'}`}>
                                   <i className={`ph ${osteopatiaEvol.assinaturaPaciente ? 'ph-check-circle' : 'ph-user-focus'} text-xl`}></i>
                                   {osteopatiaEvol.assinaturaPaciente ? 'Paciente Assinou' : 'Assinatura Paciente'}
                                 </button>
                                 <button type="button" onClick={() => setSignatureModal({ isOpen: true, role: 'OsteoFisio' })} className={`py-2 px-3 rounded-lg border-2 flex items-center justify-center gap-2 font-bold transition-all ${osteopatiaEvol.assinaturaFisio ? 'border-emerald-500 bg-emerald-50 text-emerald-700' : 'border-slate-200 text-slate-600 hover:bg-slate-50'}`}>
                                   <i className={`ph ${osteopatiaEvol.assinaturaFisio ? 'ph-check-circle' : 'ph-identification-badge'} text-xl`}></i>
                                   {osteopatiaEvol.assinaturaFisio ? 'Fisio Assinou' : 'Assinatura Fisio'}
                                 </button>
                               </div>

                               {(osteopatiaEvol.assinaturaPaciente || osteopatiaEvol.assinaturaFisio) && (
                                 <div className="mt-4 p-3 bg-slate-50 border rounded-lg grid grid-cols-2 gap-4">
                                   {osteopatiaEvol.assinaturaPaciente && (
                                     <div className="flex flex-col items-center">
                                       <span className="text-[10px] uppercase font-bold text-slate-400 mb-1">Paciente</span>
                                       <div className="relative">
                                         <img src={osteopatiaEvol.assinaturaPaciente} className="h-12 object-contain bg-white border rounded" alt="Assinatura" />
                                         {osteopatiaEvol.fotoPaciente && <img src={osteopatiaEvol.fotoPaciente} className="absolute -top-2 -right-2 h-8 w-8 rounded-full border-2 border-white shadow-md object-cover" alt="Selfie" />}
                                       </div>
                                     </div>
                                   )}
                                   {osteopatiaEvol.assinaturaFisio && (
                                     <div className="flex flex-col items-center">
                                       <span className="text-[10px] uppercase font-bold text-slate-400 mb-1">Osteopata</span>
                                       <div className="relative">
                                         <img src={osteopatiaEvol.assinaturaFisio} className="h-12 object-contain bg-white border rounded" alt="Assinatura" />
                                         {osteopatiaEvol.fotoFisio && <img src={osteopatiaEvol.fotoFisio} className="absolute -top-2 -right-2 h-8 w-8 rounded-full border-2 border-white shadow-md object-cover" alt="Selfie" />}
                                       </div>
                                     </div>
                                   )}
                                 </div>
                               )}

                               <div className="flex justify-end gap-3 mt-6 w-full items-center">
                                 <button type="button" onClick={() => {
                                   const text = `Olá! Por favor, utilize o link abaixo para assinar sua evolução da sessão de hoje:\n${window.location.origin}${window.location.pathname}?patient_sign=${selectedPatient.id}`;
                                   window.open(`https://wa.me/${selectedPatient.telefone.replace(/\D/g, '')}?text=${encodeURIComponent(text)}`, '_blank');
                                 }} title="Enviar Link WhatsApp" className="p-2.5 rounded-lg border border-emerald-200 text-emerald-600 hover:bg-emerald-50 transition-colors flex items-center justify-center">
                                   <i className="ph ph-whatsapp-logo text-[24px]"></i>
                                 </button>
                                 <button type="button" onClick={() => handlePrintHistory('EVOLUÇÃO OSTEOPÁTICA', selectedPatient.evolucoesOsteopatia || [], selectedPatient)} title="Imprimir Histórico" className="p-2.5 rounded-lg border border-slate-200 text-slate-500 hover:bg-slate-100 hover:text-slate-800 transition-colors flex items-center justify-center">
                                   <i className="ph ph-printer text-[22px]"></i>
                                 </button>
                                 <button type="submit" className={`text-white px-8 py-2.5 rounded-lg flex justify-center items-center gap-2 font-bold transition-colors shadow-sm w-full sm:w-auto ${t.btn}`}>
                                   <i className="ph ph-plus text-[20px]"></i> Salvar
                                 </button>
                               </div>
                            </form>
                          </FormSection>
                        </div>
                        
                        <div className="lg:col-span-2">
                          <FormSection title="Histórico de Tratamento">
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4">
                              {(selectedPatient.evolucoesOsteopatia || []).length === 0 ? (
                                <div className="col-span-full border border-dashed border-slate-300 rounded-xl p-6 text-center text-slate-500">Nenhuma evolução registrada.</div>
                              ) : (selectedPatient.evolucoesOsteopatia || []).map((ev, idx) => (
                                <div key={idx} className="bg-white border rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow flex flex-col justify-between">
                                  <div>
                                     <div className="flex justify-between items-center mb-3">
                                       <span className="bg-emerald-50 text-emerald-800 border border-emerald-200 text-xs font-bold px-2.5 py-1 rounded-md"><i className="ph ph-calendar-blank mr-1"></i>Sessão {ev.data}</span>
                                     </div>
                                     <p className="text-slate-700 text-sm whitespace-pre-wrap flex-1">{ev.evolucao}</p>
                                   {(ev.assinaturaPaciente || ev.assinaturaFisio) && (
                                     <div className="mt-3 p-2 bg-slate-50 rounded-lg flex gap-4 border border-slate-100">
                                       {ev.assinaturaPaciente && (
                                         <div className="flex-1 flex flex-col items-center">
                                           <span className="text-[9px] uppercase font-bold text-slate-400">Paciente</span>
                                           <div className="relative mt-1 cursor-zoom-in" onClick={() => setZoomedImage(ev.assinaturaPaciente)}>
                                             <img src={ev.assinaturaPaciente} className="h-10 object-contain" alt="Assinatura" />
                                             {ev.fotoPaciente && (
                                               <img 
                                                 src={ev.fotoPaciente} 
                                                 className="absolute -top-1 -right-1 h-6 w-6 rounded-full border border-white shadow-sm object-cover hover:scale-125 transition-transform" 
                                                 alt="Selfie" 
                                                 onClick={(e) => { e.stopPropagation(); setZoomedImage(ev.fotoPaciente); }}
                                               />
                                             )}
                                           </div>
                                         </div>
                                       )}
                                       {ev.assinaturaFisio && (
                                         <div className="flex-1 flex flex-col items-center">
                                           <span className="text-[9px] uppercase font-bold text-slate-400">Fisio</span>
                                           <div className="relative mt-1 cursor-zoom-in" onClick={() => setZoomedImage(ev.assinaturaFisio)}>
                                             <img src={ev.assinaturaFisio} className="h-10 object-contain" alt="Assinatura" />
                                             {ev.fotoFisio && (
                                               <img 
                                                 src={ev.fotoFisio} 
                                                 className="absolute -top-1 -right-1 h-6 w-6 rounded-full border border-white shadow-sm object-cover hover:scale-125 transition-transform" 
                                                 alt="Selfie" 
                                                 onClick={(e) => { e.stopPropagation(); setZoomedImage(ev.fotoFisio); }}
                                               />
                                             )}
                                           </div>
                                         </div>
                                       )}
                                     </div>
                                   )}
                                  </div>
                                  <div className="flex justify-end gap-2 mt-4 pt-3 border-t border-slate-100">
                                     <button type="button" onClick={() => handleVerOsteopatiaEvol(ev)} className="text-emerald-600 hover:text-emerald-800 p-1.5 rounded-lg hover:bg-emerald-50 transition-colors" title="Editar / Ver">
                                       <i className="ph ph-pencil-simple text-lg"></i>
                                     </button>
                                     <button type="button" onClick={() => handleDeleteOsteopatiaEvol(ev)} className="text-red-500 hover:text-red-700 p-1.5 rounded-lg hover:bg-red-50 transition-colors" title="Excluir">
                                       <i className="ph ph-trash text-lg"></i>
                                     </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </FormSection>
                        </div>
                      </div>
                    </div>
                  )}

                    {patientSubTab === 'pilates_evol' && (
                      <div>
                        <FormSection title="Registrar Sessão de Pilates">
                          <form onSubmit={handleSavePilatesEvol} className="space-y-6">
                            <div className="flex gap-6 items-center border-b pb-4">
                              <RadioYesNo label="Reposição?" value={pilatesEvol.reposicao} onChange={v => setPilatesEvol({...pilatesEvol, reposicao: v})} />
                              <InputGroup label="Nome do Instrutor" value={pilatesEvol.instrutor} onChange={e => setPilatesEvol({...pilatesEvol, instrutor: e.target.value})} />
                            </div>

                            <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 font-semibold text-emerald-800 bg-emerald-50 p-4 rounded-xl border border-emerald-100">
                              <label className="flex items-center gap-3 cursor-pointer hover:bg-emerald-100/50 p-1 rounded-lg transition-colors"><input type="checkbox" className="w-5 h-5 text-emerald-600 rounded border-emerald-300" checked={pilatesEvol.matPilates} onChange={e => setPilatesEvol({...pilatesEvol, matPilates: e.target.checked})} /> MAT Pilates</label>
                              <label className="flex items-center gap-3 cursor-pointer hover:bg-emerald-100/50 p-1 rounded-lg transition-colors"><input type="checkbox" className="w-5 h-5 text-emerald-600 rounded border-emerald-300" checked={pilatesEvol.maquinario} onChange={e => setPilatesEvol({...pilatesEvol, maquinario: e.target.checked})} /> MAQUINÁRIO</label>
                              <label className="flex items-center gap-3 cursor-pointer hover:bg-emerald-100/50 p-1 rounded-lg transition-colors"><input type="checkbox" className="w-5 h-5 text-emerald-600 rounded border-emerald-300" checked={pilatesEvol.equilibrio} onChange={e => setPilatesEvol({...pilatesEvol, equilibrio: e.target.checked})} /> EQUILÍBRIO</label>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                              <div className="space-y-4">
                                <div className="p-4 border rounded-lg bg-slate-50">
                                  <h4 className="font-bold mb-2">MMSS</h4>
                                  <div className="flex gap-4">
                                    <label className="flex items-center gap-2"><input type="checkbox" className="w-4 h-4" checked={pilatesEvol.mmssAlong} onChange={e => setPilatesEvol({...pilatesEvol, mmssAlong: e.target.checked})} /> Alongamento</label>
                                    <label className="flex items-center gap-2"><input type="checkbox" className="w-4 h-4" checked={pilatesEvol.mmssFort} onChange={e => setPilatesEvol({...pilatesEvol, mmssFort: e.target.checked})} /> Fortalecimento</label>
                                  </div>
                                </div>
                                <div className="p-4 border rounded-lg bg-slate-50">
                                  <h4 className="font-bold mb-2">MMIS</h4>
                                  <div className="flex gap-4">
                                    <label className="flex items-center gap-2"><input type="checkbox" className="w-4 h-4" checked={pilatesEvol.mmisAlong} onChange={e => setPilatesEvol({...pilatesEvol, mmisAlong: e.target.checked})} /> Alongamento</label>
                                    <label className="flex items-center gap-2"><input type="checkbox" className="w-4 h-4" checked={pilatesEvol.mmisFort} onChange={e => setPilatesEvol({...pilatesEvol, mmisFort: e.target.checked})} /> Fortalecimento</label>
                                  </div>
                                </div>
                              </div>

                              <div className="p-4 border rounded-lg bg-slate-50">
                                <h4 className="font-bold mb-3">TRONCO</h4>
                                <div className="space-y-3">
                                  <div className="flex items-center justify-between"><span className="w-12 font-medium">C.A.:</span><label><input type="checkbox" className="mr-1" checked={pilatesEvol.caAlong} onChange={e=>setPilatesEvol({...pilatesEvol, caAlong: e.target.checked})}/> alongamento</label><label><input type="checkbox" className="mr-1" checked={pilatesEvol.caFort} onChange={e=>setPilatesEvol({...pilatesEvol, caFort: e.target.checked})}/> fortalecimento</label></div>
                                  <div className="flex items-center justify-between"><span className="w-12 font-medium">C.P.:</span><label><input type="checkbox" className="mr-1" checked={pilatesEvol.cpAlong} onChange={e=>setPilatesEvol({...pilatesEvol, cpAlong: e.target.checked})}/> alongamento</label><label><input type="checkbox" className="mr-1" checked={pilatesEvol.cpFort} onChange={e=>setPilatesEvol({...pilatesEvol, cpFort: e.target.checked})}/> fortalecimento</label></div>
                                  <div className="flex items-center justify-between"><span className="w-12 font-medium">C.L.:</span><label><input type="checkbox" className="mr-1" checked={pilatesEvol.clAlong} onChange={e=>setPilatesEvol({...pilatesEvol, clAlong: e.target.checked})}/> alongamento</label><label><input type="checkbox" className="mr-1" checked={pilatesEvol.clFort} onChange={e=>setPilatesEvol({...pilatesEvol, clFort: e.target.checked})}/> fortalecimento</label></div>
                                  <div className="flex items-center justify-between"><span className="w-12 font-medium">Rots.:</span><label><input type="checkbox" className="mr-1" checked={pilatesEvol.rotsAlong} onChange={e=>setPilatesEvol({...pilatesEvol, rotsAlong: e.target.checked})}/> alongamento</label><label><input type="checkbox" className="mr-1" checked={pilatesEvol.rotsFort} onChange={e=>setPilatesEvol({...pilatesEvol, rotsFort: e.target.checked})}/> fortalecimento</label></div>
                                </div>
                              </div>
                            </div>

                            <TextAreaGroup label="Observações" value={pilatesEvol.obs} onChange={e => setPilatesEvol({...pilatesEvol, obs: e.target.value})} rows={2} />

                            <div className="flex justify-end pt-2">
                              <button type="submit" className={`text-white px-6 py-2 rounded-lg flex items-center gap-2 font-bold transition-colors duration-300 ${t.btn}`}>
                                <i className="ph ph-plus text-[18px]"></i> Salvar Ficha de Sessão
                              </button>
                            </div>
                          </form>
                        </FormSection>

                        {(selectedPatient.evolucoesPilates || []).length > 0 && (
                          <FormSection title="Histórico de Sessões Pilates">
                             <div className="space-y-4">
                                {(selectedPatient.evolucoesPilates || []).map((ev, idx) => (
                                  <div key={idx} id={`pilates-card-${idx}`} className="border p-4 rounded-xl bg-white shadow-sm flex flex-col md:flex-row gap-4 justify-between hover:shadow-md transition-shadow">
                                    <div className="flex-1">
                                      <div className="font-bold text-lg text-emerald-800 mb-1">{ev.data} <span className="text-sm font-normal text-slate-500 bg-slate-100 px-2 py-0.5 rounded ml-2">Instrutor: {ev.instrutor || 'Não informado'}</span></div>
                                      <div className="text-sm text-slate-700 mt-2 bg-slate-50 p-2 rounded border border-slate-100">
                                        <span className="font-semibold text-xs uppercase text-slate-500 block mb-1">Modalidades:</span>
                                        {[ev.matPilates && 'MAT', ev.maquinario && 'Maquinário', ev.equilibrio && 'Equilíbrio'].filter(Boolean).join(', ') || 'Nenhuma selecionada'}
                                      </div>
                                      {ev.obs && <div className="text-sm mt-3 text-slate-600 italic border-l-2 border-emerald-300 pl-3">"{ev.obs}"</div>}
                                    </div>
                                    <div className="flex flex-col gap-3 min-w-[120px]">
                                      {ev.reposicao === 'Sim' && (
                                        <div className="text-xs font-bold text-orange-600 bg-orange-50 px-2 py-1 rounded text-center border border-orange-200">
                                            Reposição
                                        </div>
                                      )}
                                      <div className="flex flex-col gap-2 mt-auto">
                                         <button type="button" onClick={() => {
                                            const originalTitle = document.title;
                                            document.title = `Ficha de Sessão - ${selectedPatient.nome} - ${ev.data}`;
                                            const printWin = window.open('', '_blank');
                                            
                                            // Helper for checkboxes
                                            const cb = (bool) => bool ? '&#x2611;' : '&#x2610;';

                                            const htmlCode = `
                                            <html>
                                            <head>
                                                <title>Imprimir Ficha</title>
                                                <style>
                                                    body { font-family: 'Arial', sans-serif; padding: 40px; color: #333; }
                                                    .header { display: flex; align-items: center; border-bottom: 2px solid #10b981; padding-bottom: 20px; margin-bottom: 20px; }
                                                    .header img { height: 60px; margin-right: 20px; }
                                                    .header h1 { font-size: 24px; margin: 0; color: #065f46; }
                                                    .info-bar { display: flex; justify-content: space-between; background: #ecfdf5; padding: 10px; border-radius: 6px; border: 1px solid #d1fae5; margin-bottom: 20px; font-size: 14px; }
                                                    .section-title { font-size: 18px; font-weight: bold; margin-top: 30px; margin-bottom: 10px; color: #0f766e; border-bottom: 1px dashed #ccc; padding-bottom: 5px; }
                                                    .grid-container { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
                                                    .box { border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; background: #fafafa; }
                                                    .box h4 { margin-top: 0; margin-bottom: 10px; font-size: 14px; color: #475569; text-transform: uppercase; }
                                                    .check-row { display: flex; align-items: center; gap: 15px; margin-bottom: 8px; font-size: 14px; }
                                                    .obs-box { border: 1px solid #e2e8f0; padding: 15px; border-radius: 8px; margin-top: 20px; min-height: 80px; font-style: italic; color: #475569; }
                                                    .signatures { display: flex; justify-content: space-around; margin-top: 60px; text-align: center; font-size: 14px; color: #64748b; }
                                                    .sig-box img { max-height: 80px; display: block; margin: 0 auto; mix-blend-mode: multiply; }
                                                    .sig-box hr { border: 0; border-top: 1px solid #94a3b8; width: 250px; margin: 5px auto; }
                                                </style>
                                            </head>
                                            <body>
                                                <div class="header">
                                                    <img src="${window.APP_ASSETS.logo}" alt="Logo" />
                                                    <div>
                                                        <h1>Evolução de Pilates</h1>
                                                        <div style="font-size: 14px; margin-top: 5px;">Registro Clínico Oficial</div>
                                                    </div>
                                                </div>

                                                <div class="info-bar">
                                                    <div><strong>Paciente:</strong> ${selectedPatient.nome}</div>
                                                    <div><strong>Data:</strong> ${ev.data}</div>
                                                    <div><strong>Instrutor:</strong> ${ev.instrutor || 'Não informado'}</div>
                                                    <div><strong>Reposição:</strong> ${ev.reposicao}</div>
                                                </div>

                                                <div class="section-title">1. Modalidades Aplicadas</div>
                                                <div class="check-row" style="font-size: 16px;">
                                                    <span style="font-family: monospace; font-size: 1.2em;">${cb(ev.matPilates)}</span> MAT Pilates &nbsp;&nbsp;&nbsp;
                                                    <span style="font-family: monospace; font-size: 1.2em;">${cb(ev.maquinario)}</span> MAQUINÁRIO &nbsp;&nbsp;&nbsp;
                                                    <span style="font-family: monospace; font-size: 1.2em;">${cb(ev.equilibrio)}</span> EQUILÍBRIO
                                                </div>

                                                <div class="section-title">2. Exercícios Realizados</div>
                                                <div class="grid-container">
                                                    <div>
                                                        <div class="box" style="margin-bottom: 20px;">
                                                            <h4>Membros Superiores (MMSS)</h4>
                                                            <div class="check-row">
                                                                <span style="font-family: monospace; font-size: 1.2em;">${cb(ev.mmssAlong)}</span> Alongamento &nbsp;&nbsp;
                                                                <span style="font-family: monospace; font-size: 1.2em;">${cb(ev.mmssFort)}</span> Fortalecimento
                                                            </div>
                                                        </div>
                                                        <div class="box">
                                                            <h4>Membros Inferiores (MMIS)</h4>
                                                            <div class="check-row">
                                                                <span style="font-family: monospace; font-size: 1.2em;">${cb(ev.mmisAlong)}</span> Alongamento &nbsp;&nbsp;
                                                                <span style="font-family: monospace; font-size: 1.2em;">${cb(ev.mmisFort)}</span> Fortalecimento
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="box">
                                                        <h4>TRONCO</h4>
                                                        <table style="width: 100%; text-align: left; font-size: 14px; border-collapse: collapse;">
                                                            <tr style="border-bottom: 1px solid #e2e8f0;"><th style="padding: 6px 0;">C.A. (Cadeia Ant.)</th><td><span style="font-family: monospace; font-size: 1.2em;">${cb(ev.caAlong)}</span> along.</td><td><span style="font-family: monospace; font-size: 1.2em;">${cb(ev.caFort)}</span> fort.</td></tr>
                                                            <tr style="border-bottom: 1px solid #e2e8f0;"><th style="padding: 6px 0;">C.P. (Cadeia Post.)</th><td><span style="font-family: monospace; font-size: 1.2em;">${cb(ev.cpAlong)}</span> along.</td><td><span style="font-family: monospace; font-size: 1.2em;">${cb(ev.cpFort)}</span> fort.</td></tr>
                                                            <tr style="border-bottom: 1px solid #e2e8f0;"><th style="padding: 6px 0;">C.L. (Cadeia Lat.)</th><td><span style="font-family: monospace; font-size: 1.2em;">${cb(ev.clAlong)}</span> along.</td><td><span style="font-family: monospace; font-size: 1.2em;">${cb(ev.clFort)}</span> fort.</td></tr>
                                                            <tr><th style="padding: 6px 0;">Rotações</th><td><span style="font-family: monospace; font-size: 1.2em;">${cb(ev.rotsAlong)}</span> along.</td><td><span style="font-family: monospace; font-size: 1.2em;">${cb(ev.rotsFort)}</span> fort.</td></tr>
                                                        </table>
                                                    </div>
                                                </div>

                                                <div class="section-title">3. Observações Adicionais</div>
                                                <div class="obs-box">
                                                    ${ev.obs ? ev.obs.replace(/\\n/g, '<br/>') : 'Nenhuma observação registrada nesta sessão.'}
                                                </div>

                                                <div class="signatures">
                                                    <div class="sig-box">
                                                        ${ev.assinaturaFisio ? '<img src="'+ev.assinaturaFisio+'"/>' : '<div style="height: 80px;"></div>'}
                                                        <hr/>
                                                        <strong>${ev.instrutor || 'Profissional'}</strong><br/>Instrutor/Fisioterapeuta
                                                    </div>
                                                    <div class="sig-box">
                                                        ${ev.assinaturaPaciente ? '<img src="'+ev.assinaturaPaciente+'"/>' : '<div style="height: 80px;"></div>'}
                                                        <hr/>
                                                        <strong>${selectedPatient.nome}</strong><br/>Paciente
                                                    </div>
                                                </div>
                                            </body>
                                            </html>
                                            `;
                                            printWin.document.write(htmlCode);
                                            printWin.document.close();
                                            printWin.setTimeout(() => { printWin.print(); printWin.close(); }, 700);
                                            document.title = originalTitle;
                                         }} className="w-full text-slate-600 hover:bg-slate-100 py-1.5 rounded-lg border border-slate-200 flex items-center justify-center gap-1 text-sm font-bold transition-colors" title="Imprimir Ficha">
                                           <i className="ph ph-printer text-lg"></i> Imprimir
                                         </button>
                                         <button type="button" onClick={() => setViewSignatures(ev)} className="w-full text-blue-600 hover:bg-blue-50 py-1.5 rounded-lg border border-blue-200 flex items-center justify-center gap-1 text-sm font-bold transition-colors" title="Ver Assinaturas">
                                           <i className="ph ph-pen-nib text-lg"></i> Assinaturas
                                         </button>
                                         <button type="button" onClick={() => setViewingPilatesEvol(ev)} className="w-full text-indigo-600 hover:bg-indigo-50 py-1.5 rounded-lg border border-indigo-200 flex items-center justify-center gap-1 text-sm font-bold transition-colors" title="Visualizar Ficha">
                                           <i className="ph ph-eye text-lg"></i> Visualizar
                                         </button>
                                         <button type="button" onClick={() => handleVerPilatesEvol(ev)} className="w-full text-emerald-600 hover:bg-emerald-50 py-1.5 rounded-lg border border-emerald-200 flex items-center justify-center gap-1 text-sm font-bold transition-colors" title="Editar">
                                           <i className="ph ph-pencil-simple text-lg"></i> Editar
                                         </button>
                                         <button type="button" onClick={() => handleDeletePilatesEvol(ev)} className="w-full text-red-500 hover:text-red-700 hover:bg-red-50 py-1.5 rounded border border-red-200 flex items-center justify-center transition-colors" title="Excluir">
                                           <i className="ph ph-trash text-[18px]"></i> &nbsp; Excluir
                                         </button>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                             </div>
                          </FormSection>
                        )}
                      </div>
                    )}

                    
                    {patientSubTab === 'termo_imagem' && (
                      <div className="p-4 md:p-8 animate-fadeIn">
                        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-200">
                          <div className="bg-emerald-800 text-white p-6 flex justify-between items-center text-left">
                            <h3 className="text-xl font-bold flex items-center gap-2"><i className="ph ph-camera"></i> Consentimento de Uso de Imagem</h3>
                            <button onClick={() => handlePrintTermoImagem(selectedPatient)} className="bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg text-sm font-bold flex items-center gap-2 transition-colors">
                              <i className="ph ph-printer"></i> Imprimir PDF
                            </button>
                          </div>
                          <div className="p-8 text-slate-700 leading-relaxed text-justify space-y-4 text-left">
                            <p>Eu, <b>{selectedPatient.nome}</b>, portador do CPF <b>{selectedPatient.cpf}</b>, autorizo o uso de minha imagem pela <b>Real Clínica Integrada</b> para fins exclusivos de acompanhamento clínico e registro de evoluação terapêutica.</p>
                            <p>Esta autorização Ç© concedida de forma gratuita, abrangendo o uso da imagem acima mencionada em todo o território nacional e no exterior, das seguintes formas: (I) No prontuário eletrÇ´nico do paciente; (II) Em apresentações de casos clínicos entre profissionais da saúde da clínica.</p>
                            <p>Fica eleito o foro da comarca de Arapiraca/AL para dirimir quaisquer eventuais questões oriundas deste termo.</p>
                            
                            <div className="mt-12 p-8 border-2 border-dashed border-slate-200 rounded-2xl bg-slate-50 flex flex-col items-center">
                              {selectedPatient.termoImagem ? (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full border-t pt-6 bg-white p-6 rounded-xl shadow-sm">
                                  <div className="flex flex-col items-center">
                                    <span className="text-xs font-bold text-slate-400 uppercase mb-4 tracking-widest">Assinatura Digital</span>
                                    <img src={selectedPatient.termoImagem.assinatura} className="h-32 object-contain border-b-2 border-slate-200 pb-2 cursor-zoom-in" onClick={() => setZoomedImage(selectedPatient.termoImagem.assinatura)} />
                                    <p className="text-xs text-slate-400 mt-2 italic">Assinado em {selectedPatient.termoImagem.data}</p>
                                  </div>
                                  <div className="flex flex-col items-center">
                                    <span className="text-xs font-bold text-slate-400 uppercase mb-4 tracking-widest">Selfie de Segurança</span>
                                    <div className="w-32 h-32 rounded-2xl overflow-hidden shadow-lg border-4 border-white cursor-zoom-in" onClick={() => setZoomedImage(selectedPatient.termoImagem.foto)}>
                                      <img src={selectedPatient.termoImagem.foto} className="w-full h-full object-cover" />
                                    </div>
                                  </div>
                                  <div className="col-span-full flex justify-center mt-6">
                                    <button 
                                      onClick={() => {
                                        const updated = {...selectedPatient, termoImagem: null};
                                        setSelectedPatient(updated);
                                        setPatients(patients.map(p => p.id === updated.id ? updated : p));
                                        persistPatientData(updated);
                                        showToast("Assinatura do termo de imagem removida.", "info");
                                      }}
                                      className="text-red-500 hover:text-red-700 text-xs font-bold flex items-center gap-1 border border-red-200 px-3 py-1.5 rounded-lg hover:bg-red-50 transition-colors"
                                    >
                                      <i className="ph ph-trash"></i> Excluir Assinatura e Foto
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <button onClick={() => setSignatureModal({ 
                                  isOpen: true, 
                                  role: 'Paciente', 
                                  callback: (sig, photo) => {
                                    const updated = {...selectedPatient, termoImagem: { assinatura: sig, foto: photo, data: new Date().toLocaleDateString('pt-BR') }};
                                    setSelectedPatient(updated);
                                    setPatients(patients.map(p => p.id === updated.id ? updated : p));
                                    persistPatientData(updated);
                                    showToast('Termo de Imagem assinado com sucesso!');
                                  }
                                })} className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-4 px-10 rounded-2xl shadow-lg transform hover:scale-105 transition-all flex items-center gap-3">
                                  <i className="ph ph-pen-nib text-2xl"></i> Capturar Assinatura e Foto
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {patientSubTab === 'termo_comp' && (
                      <div className="p-4 md:p-8 animate-fadeIn">
                        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-200">
                          <div className="bg-emerald-900 text-white p-6 flex justify-between items-center text-left">
                            <h3 className="text-xl font-bold flex items-center gap-2"><i className="ph ph-article"></i> Termo de Comparecimento e Cancelamento</h3>
                            <button onClick={() => handlePrintTermoComparecimento(selectedPatient)} className="bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg text-sm font-bold flex items-center gap-2 transition-colors">
                              <i className="ph ph-printer"></i> Imprimir PDF
                            </button>
                          </div>
                          <div className="p-8 text-slate-700 leading-relaxed text-justify space-y-5 text-left">
                            <p>
                              Eu, <b>{selectedPatient.nome}</b>, Estado civil <b>{selectedPatient.estadoCivil || '__________'}</b>, inscrito no CPF sob o nº <b>{selectedPatient.cpf}</b>, residente e domiciliado na rua: <b>{selectedPatient.endereco || '__________' || selectedPatient.rua}</b>, Nº <b>{selectedPatient.numero || '___'}</b>. Bairro: <b>{selectedPatient.bairro || '__________'}</b>, Cidade: <b>{selectedPatient.cidade || 'Arapiraca/AL'}</b>.
                            </p>
                            <p>O atendimento Ç© um horário reservado exclusivamente para você. Para garantir organização e respeito á agenda, seguem as orientações:</p>
                            <p>Me comprometo a <b>Real Clínica Integrada, Unidade de Saúde</b>, a comunicar minha remarcação ou o cancelamento do meu atendimento com 24 horas de antecedência, caso o aviso não seja dado dentro desse prazo, a sessão será considerada realizada e o valor cobrado normalmente.</p>
                            <p>Em casos de doença ou imprevistos justificáveis, a sessão poderá ser remarcada sem prejuízo, mediante comunicação o quanto antes.</p>
                            <p>O não comparecimento sem aviso prÇ©vio será considerado como falta, sem reposiação.</p>
                            <p>Agradecemos pela compreensão e colaboração.</p>
                            
                            <div className="mt-12 p-8 border-2 border-dashed border-slate-200 rounded-2xl bg-slate-50 flex flex-col items-center">
                              {selectedPatient.termoComparecimento ? (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full border-t pt-6 bg-white p-6 rounded-xl shadow-sm">
                                  <div className="flex flex-col items-center">
                                    <span className="text-xs font-bold text-slate-400 uppercase mb-4 tracking-widest">Assinatura Digital</span>
                                    <img src={selectedPatient.termoComparecimento.assinatura} className="h-32 object-contain border-b-2 border-slate-200 pb-2 cursor-zoom-in" onClick={() => setZoomedImage(selectedPatient.termoComparecimento.assinatura)} />
                                    <p className="text-xs text-slate-400 mt-2 italic">Assinado em {selectedPatient.termoComparecimento.data}</p>
                                  </div>
                                  <div className="flex flex-col items-center">
                                    <span className="text-xs font-bold text-slate-400 uppercase mb-4 tracking-widest">Selfie de Segurança</span>
                                    <div className="w-32 h-32 rounded-2xl overflow-hidden shadow-lg border-4 border-white cursor-zoom-in" onClick={() => setZoomedImage(selectedPatient.termoComparecimento.foto)}>
                                      <img src={selectedPatient.termoComparecimento.foto} className="w-full h-full object-cover" />
                                    </div>
                                  </div>
                                  <div className="col-span-full flex justify-center mt-6">
                                    <button 
                                      onClick={() => {
                                        const updated = {...selectedPatient, termoComparecimento: null};
                                        setSelectedPatient(updated);
                                        setPatients(patients.map(p => p.id === updated.id ? updated : p));
                                        persistPatientData(updated);
                                        showToast("Assinatura do termo de comparecimento removida.", "info");
                                      }}
                                      className="text-red-500 hover:text-red-700 text-xs font-bold flex items-center gap-1 border border-red-200 px-3 py-1.5 rounded-lg hover:bg-red-50 transition-colors"
                                    >
                                      <i className="ph ph-trash"></i> Excluir Assinatura e Foto
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <button onClick={() => setSignatureModal({ 
                                  isOpen: true, 
                                  role: 'Paciente', 
                                  callback: (sig, photo) => {
                                    const updated = {...selectedPatient, termoComparecimento: { assinatura: sig, foto: photo, data: new Date().toLocaleDateString('pt-BR') }};
                                    setSelectedPatient(updated);
                                    setPatients(patients.map(p => p.id === updated.id ? updated : p));
                                    persistPatientData(updated);
                                    showToast('Termo de Comparecimento assinado com sucesso!');
                                  }
                                })} className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-4 px-10 rounded-2xl shadow-lg transform hover:scale-105 transition-all flex items-center gap-3">
                                  <i className="ph ph-pen-nib text-2xl"></i> Assinar Termo de Regras
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {patientToDelete && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
                  <div className="bg-white p-6 rounded-xl shadow-2xl max-w-sm w-full mx-4 border border-slate-200">
                    <div className="flex items-center gap-3 mb-4 text-red-600">
                      <i className="ph ph-trash text-[24px]"></i>
                      <h3 className="text-lg font-bold">Excluir Paciente</h3>
                    </div>
                    <p className="text-slate-600 mb-6">Tem certeza que deseja excluir o paciente <b>{patientToDelete.nome}</b>? Todos os seus prontuários e evoluções serão removidos permanentemente.</p>
                    <div className="flex justify-end gap-3">
                      <button onClick={() => setPatientToDelete(null)} className="px-4 py-2 border border-slate-300 rounded-lg text-slate-600 font-bold hover:bg-slate-100 transition-colors">Cancelar</button>
                      <button onClick={executeDeletePatient} className="px-4 py-2 bg-red-600 text-white rounded-lg font-bold hover:bg-red-700 transition-colors">Sim, Excluir</button>
                    </div>
                  </div>
                </div>
              )}

              {viewingPilatesEvol && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[110] p-4 animate-fadeIn">
                  <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col scale-in">
                    <div className="bg-emerald-900 text-white p-4 flex justify-between items-center text-left">
                      <div className="flex items-center gap-3">
                        <i className="ph ph-eye text-[24px]"></i>
                        <div>
                          <h3 className="text-xl font-bold">Detalhes da Sessão</h3>
                           <p className="text-emerald-200 text-sm">Realizada em {viewingPilatesEvol.data}</p>
                        </div>
                      </div>
                      <button onClick={() => setViewingPilatesEvol(null)} className="text-white/80 hover:text-white"><i className="ph ph-x text-[28px]"></i></button>
                    </div>
                    
                    <div className="p-6 overflow-y-auto space-y-6 text-left">
                      <div className="grid grid-cols-2 gap-4 text-sm">
                        <div className="bg-slate-50 p-3 rounded-lg border">
                          <span className="text-slate-500 block">Instrutor</span>
                          <span className="font-bold text-slate-800">{viewingPilatesEvol.instrutor || 'Não informado'}</span>
                        </div>
                        <div className="bg-slate-50 p-3 rounded-lg border">
                          <span className="text-slate-500 block">Modalidades</span>
                          <span className="font-bold text-slate-800">
                            {[viewingPilatesEvol.matPilates && 'MAT', viewingPilatesEvol.maquinario && 'Maquinário', viewingPilatesEvol.equilibrio && 'Equilíbrio'].filter(Boolean).join(', ') || 'Nenhuma'}
                          </span>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="border rounded-xl overflow-hidden">
                          <div className="bg-slate-100 p-2 font-bold text-xs uppercase text-slate-600 border-b">Exercícios MMSS / MMIS</div>
                          <div className="p-3 space-y-2 text-sm">
                            <div className="flex justify-between items-center pb-1 border-b">
                              <span>MMSS Along.</span> {viewingPilatesEvol.mmssAlong ? <i className="ph ph-check-circle text-emerald-500 text-[18px]"></i> : <i className="ph ph-circle text-slate-300"></i>}
                            </div>
                            <div className="flex justify-between items-center pb-1 border-b">
                              <span>MMSS Fort.</span> {viewingPilatesEvol.mmssFort ? <i className="ph ph-check-circle text-emerald-500 text-[18px]"></i> : <i className="ph ph-circle text-slate-300"></i>}
                            </div>
                            <div className="flex justify-between items-center pb-1 border-b">
                              <span>MMIS Along.</span> {viewingPilatesEvol.mmisAlong ? <i className="ph ph-check-circle text-emerald-500 text-[18px]"></i> : <i className="ph ph-circle text-slate-300"></i>}
                            </div>
                            <div className="flex justify-between items-center">
                              <span>MMIS Fort.</span> {viewingPilatesEvol.mmisFort ? <i className="ph ph-check-circle text-emerald-500 text-[18px]"></i> : <i className="ph ph-circle text-slate-300"></i>}
                            </div>
                          </div>
                        </div>

                        <div className="border rounded-xl overflow-hidden">
                          <div className="bg-slate-100 p-2 font-bold text-xs uppercase text-slate-600 border-b">Exercícios Tronco</div>
                          <div className="p-3 space-y-2 text-sm">
                            <div className="flex justify-between items-center pb-1 border-b">
                              <span>C.A. (A/F)</span> 
                              <div className="flex gap-2">
                                {viewingPilatesEvol.caAlong && <span className="bg-emerald-100 text-emerald-700 px-1.5 rounded text-[10px] font-bold">A</span>}
                                {viewingPilatesEvol.caFort && <span className="bg-blue-100 text-blue-700 px-1.5 rounded text-[10px] font-bold">F</span>}
                                {!viewingPilatesEvol.caAlong && !viewingPilatesEvol.caFort && <span className="text-slate-300">-</span>}
                              </div>
                            </div>
                            <div className="flex justify-between items-center pb-1 border-b">
                              <span>C.P. (A/F)</span>
                              <div className="flex gap-2">
                                {viewingPilatesEvol.cpAlong && <span className="bg-emerald-100 text-emerald-700 px-1.5 rounded text-[10px] font-bold">A</span>}
                                {viewingPilatesEvol.cpFort && <span className="bg-blue-100 text-blue-700 px-1.5 rounded text-[10px] font-bold">F</span>}
                                {!viewingPilatesEvol.cpAlong && !viewingPilatesEvol.cpFort && <span className="text-slate-300">-</span>}
                              </div>
                            </div>
                            <div className="flex justify-between items-center pb-1 border-b">
                              <span>C.L. (A/F)</span>
                              <div className="flex gap-2">
                                {viewingPilatesEvol.clAlong && <span className="bg-emerald-100 text-emerald-700 px-1.5 rounded text-[10px] font-bold">A</span>}
                                {viewingPilatesEvol.clFort && <span className="bg-blue-100 text-blue-700 px-1.5 rounded text-[10px] font-bold">F</span>}
                                {!viewingPilatesEvol.clAlong && !viewingPilatesEvol.clFort && <span className="text-slate-300">-</span>}
                              </div>
                            </div>
                            <div className="flex justify-between items-center">
                              <span>Rots (A/F)</span>
                              <div className="flex gap-2">
                                {viewingPilatesEvol.rotsAlong && <span className="bg-emerald-100 text-emerald-700 px-1.5 rounded text-[10px] font-bold">A</span>}
                                {viewingPilatesEvol.rotsFort && <span className="bg-blue-100 text-blue-700 px-1.5 rounded text-[10px] font-bold">F</span>}
                                {!viewingPilatesEvol.rotsAlong && !viewingPilatesEvol.rotsFort && <span className="text-slate-300">-</span>}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {viewingPilatesEvol.obs && (
                        <div className="bg-yellow-50 p-4 rounded-xl border border-yellow-200">
                          <h4 className="font-bold text-yellow-800 mb-1 flex items-center gap-2 text-sm"><i className="ph ph-note"></i> Observações</h4>
                          <p className="text-yellow-900 text-sm whitespace-pre-wrap">{viewingPilatesEvol.obs}</p>
                        </div>
                      )}
                    </div>
                    
                    <div className="p-4 bg-slate-50 border-t flex justify-end">
                      <button onClick={() => setViewingPilatesEvol(null)} className="px-6 py-2 bg-slate-800 text-white rounded-lg font-bold hover:bg-slate-900 transition-colors">Fechar</button>
                    </div>
                  </div>
                </div>
              )}

              {viewingPilatesAval && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[110] p-4 animate-fadeIn">
                  <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col scale-in">
                    <div className="bg-emerald-900 text-white p-4 flex justify-between items-center text-left">
                      <div className="flex items-center gap-3">
                        <i className="ph ph-clipboard-text text-[24px]"></i>
                        <div>
                          <h3 className="text-xl font-bold">Avaliação Pilates Completa</h3>
                          <p className="text-emerald-200 text-sm">Realizada em {viewingPilatesAval.data}</p>
                        </div>
                      </div>
                      <button onClick={() => setViewingPilatesAval(null)} className="text-white/80 hover:text-white"><i className="ph ph-x text-[28px]"></i></button>
                    </div>
                    
                    <div className="p-8 overflow-y-auto space-y-8 text-left text-slate-800">
                       <section>
                         <h4 className="font-bold text-emerald-800 border-b pb-2 mb-4 uppercase text-sm tracking-wider">Informações Iniciais</h4>
                         <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                            <div className="bg-slate-50 p-3 rounded-lg border">
                              <span className="text-slate-500 block">Indicação MÇ©dica</span>
                              <span className="font-bold">{viewingPilatesAval.indicacaoMedica}</span>
                            </div>
                            <div className="bg-slate-50 p-3 rounded-lg border">
                              <span className="text-slate-500 block">Praticou Pilates?</span>
                              <span className="font-bold">{viewingPilatesAval.praticouPilates} {viewingPilatesAval.tempoPratica && `(${viewingPilatesAval.tempoPratica})`}</span>
                            </div>
                            <div className="bg-slate-50 p-3 rounded-lg border">
                              <span className="text-slate-500 block">Sedentário?</span>
                              <span className="font-bold">{viewingPilatesAval.sedentario} {viewingPilatesAval.tempoSedentario && `(${viewingPilatesAval.tempoSedentario})`}</span>
                            </div>
                         </div>
                       </section>

                       <section>
                         <h4 className="font-bold text-emerald-800 border-b pb-2 mb-4 uppercase text-sm tracking-wider">Queixas</h4>
                         <div className="space-y-4">
                            <div className="p-3 bg-slate-50 rounded-lg border">
                              <span className="text-emerald-700 font-bold text-xs uppercase block mb-1">Queixa Principal</span>
                              <p className="text-slate-800 whitespace-pre-wrap">{viewingPilatesAval.queixaPrincipal || '-'}</p>
                            </div>
                            <div className="p-3 bg-slate-50 rounded-lg border">
                              <span className="text-emerald-700 font-bold text-xs uppercase block mb-1">Outras Queixas</span>
                              <p className="text-slate-800 whitespace-pre-wrap">{viewingPilatesAval.outrasQueixas || '-'}</p>
                            </div>
                         </div>
                       </section>

                       <section>
                         <h4 className="font-bold text-emerald-800 border-b pb-2 mb-4 uppercase text-sm tracking-wider">Histórico de Saúde</h4>
                         <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
                            {[
                              {l: 'Neurológicos', v: viewingPilatesAval.neurologicos},
                              {l: 'Respiratórios', v: viewingPilatesAval.respiratorios},
                              {l: 'Cardíacos', v: viewingPilatesAval.cardiacos},
                              {l: 'Osteomioartic.', v: viewingPilatesAval.osteomioarticulares},
                              {l: 'Psicológicos', v: viewingPilatesAval.psicologicos},
                              {l: 'Hipertensão', v: viewingPilatesAval.hipertensao},
                              {l: 'Diabetes', v: viewingPilatesAval.diabetes},
                              {l: 'Cirurgia/Frat.', v: viewingPilatesAval.fraturaCirurgia}
                            ].map((item, i) => (
                              <div key={i} className={`p-2 rounded border flex justify-between items-center ${item.v === 'Sim' ? 'bg-orange-50 border-orange-200 text-orange-700 font-bold' : 'bg-slate-50 text-slate-500'}`}>
                                <span>{item.l}</span>
                                <span>{item.v}</span>
                              </div>
                            ))}
                         </div>
                         {viewingPilatesAval.descFraturaCirurgia && (
                           <div className="mt-3 p-3 bg-orange-50 border border-orange-200 rounded-lg text-sm">
                             <span className="font-bold text-orange-800 block">Detalhes Cirurgia/Fratura:</span>
                             {viewingPilatesAval.descFraturaCirurgia}
                           </div>
                         )}
                       </section>
                    </div>
                    
                    <div className="p-4 bg-slate-50 border-t flex justify-end">
                      <button onClick={() => setViewingPilatesAval(null)} className="px-6 py-2 bg-slate-800 text-white rounded-lg font-bold hover:bg-slate-900 transition-colors">Fechar</button>
                    </div>
                  </div>
                </div>
              )}

              {viewingFisioEvolTable && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[110] p-4 animate-fadeIn">
                  <div className="bg-white rounded-2xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-hidden flex flex-col scale-in">
                    <div className="bg-sky-700 text-white p-4 flex justify-between items-center text-left">
                      <div className="flex items-center gap-3">
                        <i className="ph ph-calendar-plus text-[24px]"></i>
                        <div>
                          <h3 className="text-xl font-bold">Ficha de Evolução do Tratamento</h3>
                          <p className="text-sky-100 text-sm">{selectedPatient?.nome}</p>
                        </div>
                      </div>
                      <button onClick={() => setViewingFisioEvolTable(null)} className="text-white/80 hover:text-white"><i className="ph ph-x text-[28px]"></i></button>
                    </div>
                    
                    <div className="p-6 overflow-y-auto flex-1 bg-slate-50">
                      <div className="bg-white rounded-xl border border-slate-200 overflow-x-auto shadow-sm">
                        <table className="w-full border-collapse text-sm">
                          <thead className="bg-slate-100 text-slate-700 uppercase text-[10px] font-bold hidden md:table-header-group">
                            <tr>
                              <th className="p-3 border text-left w-32 min-w-[120px]">Data</th>
                              <th className="p-3 border text-left min-w-[300px]">Evolução do Caso / Conduta</th>
                              <th className="p-3 border text-center w-40 min-w-[100px]">Ass. Fisio</th>
                              <th className="p-3 border text-center w-40 min-w-[100px]">Ass. Paciente</th>
                              <th className="p-3 border text-center w-16"></th>
                            </tr>
                          </thead>
                          <tbody className="block md:table-row-group">
                            {(viewingFisioEvolTable.evolucoes || []).length === 0 ? (
                              <tr className="block md:table-row">
                                <td colSpan="5" className="p-8 text-center text-slate-400 italic block md:table-cell border-b md:border-0">Nenhuma sessão registrada. Clique no botão abaixo para adicionar.</td>
                              </tr>
                            ) : viewingFisioEvolTable.evolucoes.map(ev => (
                              <tr key={ev.id} className="block md:table-row hover:bg-slate-50 transition-colors border border-slate-200 md:border-0 rounded-xl md:rounded-none mb-4 md:mb-0 shadow-sm md:shadow-none bg-white">
                                <td className="p-3 md:p-2 border-b border-slate-100 md:border block md:table-cell bg-slate-50/50 md:bg-transparent">
                                  <span className="md:hidden text-[10px] font-bold text-slate-400 uppercase block mb-1">Data</span>
                                  <input type="text" value={ev.data} onChange={e => handleUpdateFisioEvolTable(ev.id, 'data', e.target.value)} className="w-full bg-transparent focus:outline-none border-b border-dashed border-slate-300 focus:border-sky-500 font-medium" />
                                </td>
                                <td className="p-3 md:p-2 border-b border-slate-100 md:border block md:table-cell">
                                  <span className="md:hidden text-[10px] font-bold text-slate-400 uppercase block mb-1">Descrição da Evolução</span>
                                  <textarea rows="4" value={ev.evolucao} onChange={e => handleUpdateFisioEvolTable(ev.id, 'evolucao', e.target.value)} className="w-full bg-transparent focus:outline-none border-b border-dashed border-slate-300 focus:border-sky-500 resize-y min-h-[80px] p-2" />
                                </td>
                                <td className="p-3 md:p-2 border-b border-slate-100 md:border block md:table-cell text-center">
                                   <span className="md:hidden text-[10px] font-bold text-slate-400 uppercase block mb-2 w-full text-left">Assinatura Fisio</span>
                                   {ev.assinaturaFisio ? (
                                     <div className="relative inline-block cursor-zoom-in" onClick={() => setZoomedImage(ev.assinaturaFisio)}>
                                       <img src={ev.assinaturaFisio} className="h-10 mx-auto object-contain" />
                                       <button onClick={(e) => { e.stopPropagation(); handleUpdateFisioEvolTable(ev.id, 'assinaturaFisio', null); }} className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-4 h-4 text-[8px] flex items-center justify-center">X</button>
                                     </div>
                                   ) : (
                                      <button onClick={() => setSignatureModal({ isOpen: true, role: 'Fisioterapeuta', callback: (sig) => handleUpdateFisioEvolTable(ev.id, 'assinaturaFisio', sig) })} className="w-full md:w-auto bg-white md:bg-transparent border border-sky-200 md:border-0 rounded-lg py-2 md:py-0 text-sky-600 hover:text-sky-800 text-xs font-bold md:underline shadow-sm md:shadow-none hover:bg-sky-50 md:hover:bg-transparent transition-colors">Assinar Fisio</button>
                                   )}
                                </td>
                                <td className="p-3 md:p-2 border-b border-slate-100 md:border block md:table-cell text-center">
                                   <span className="md:hidden text-[10px] font-bold text-slate-400 uppercase block mb-2 w-full text-left">Assinatura Paciente</span>
                                   {ev.assinaturaPaciente ? (
                                     <div className="relative inline-block cursor-zoom-in" onClick={() => setZoomedImage(ev.assinaturaPaciente)}>
                                       <img src={ev.assinaturaPaciente} className="h-10 mx-auto object-contain" />
                                       <button onClick={(e) => { e.stopPropagation(); handleUpdateFisioEvolTable(ev.id, 'assinaturaPaciente', null); }} className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-4 h-4 text-[8px] flex items-center justify-center">X</button>
                                     </div>
                                   ) : (
                                      <button onClick={() => setSignatureModal({ isOpen: true, role: 'Paciente', callback: (sig) => handleUpdateFisioEvolTable(ev.id, 'assinaturaPaciente', sig) })} className="text-sky-600 hover:text-sky-800 text-xs font-bold underline">Solicitar</button>
                                   )}
                                </td>
                                <td className="p-2 border text-center">
                                  <button onClick={() => {
                                    setViewingFisioEvolTable(prev => ({
                                      ...prev,
                                      evolucoes: prev.evolucoes.filter(item => item.id !== ev.id)
                                    }));
                                  }} className="text-red-400 hover:text-red-600"><i className="ph ph-trash"></i></button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      
                      <div className="mt-4 flex justify-start">
                        <button onClick={handleAddFisioEvolRow} className="flex items-center gap-2 px-4 py-2 bg-sky-600 text-white rounded-lg font-bold hover:bg-sky-700 transition-colors shadow-sm">
                          <i className="ph ph-plus-circle"></i> Adicionar Nova Sessão
                        </button>
                      </div>
                    </div>
                    
                    <div className="p-4 bg-slate-100 border-t flex justify-between items-center">
                      <p className="text-xs text-slate-500 italic">As alterações aqui serão salvas junto com o prontuário clínico.</p>
                      <div className="flex gap-3">
                        <button onClick={() => handlePrintFisioCompleto(viewingFisioEvolTable, selectedPatient)} className="px-6 py-2 border-2 border-sky-800 text-sky-800 rounded-lg font-bold hover:bg-sky-800 hover:text-white transition-colors flex items-center gap-2">
                           <i className="ph ph-printer"></i> Imprimir Tudo
                        </button>
                         <button onClick={() => {
                           setFisioEval(viewingFisioEvolTable);
                           setViewingFisioEvolTable(null);
                           showToast('Evoluções registradas no prontuário local. Lembre-se de SALVAR o prontuário para persistir.', 'info');
                         }} className="px-8 py-2 bg-slate-800 text-white rounded-lg font-bold hover:bg-slate-900 transition-colors">Confirmar Dados</button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

               <ZoomModal imageUrl={zoomedImage} onClose={() => setZoomedImage(null)} />

               {isLoadingDetails && (
                 <div className="fixed inset-0 bg-emerald-900/20 backdrop-blur-sm flex items-center justify-center z-[2000] animate-fadeIn">
                   <div className="bg-white p-6 rounded-2xl shadow-2xl flex flex-col items-center gap-4 border border-emerald-100">
                     <div className="spinner"></div>
                     <p className="font-bold text-emerald-800 animate-pulse">CARREGANDO PRONTUÁRIO...</p>
                   </div>
                 </div>
               )}

               <SignatureModal 
                 isOpen={signatureModal.isOpen} 
                 role={signatureModal.role} 
                 callback={signatureModal.callback} 
                 onClose={() => setSignatureModal({ isOpen: false, role: null, callback: null })}
                 onConfirm={handleSignatureConfirm}
               />

               {dualSignatureFlow.isOpen && (
                 <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[150] p-4 text-slate-800 animate-fadeIn">
                   <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col scale-in">
                     <div className="bg-emerald-800 text-white p-4 flex justify-between items-center text-center">
                       <h3 className="text-xl font-bold flex items-center gap-2"><i className="ph ph-shield-check"></i> Coletor de Assinaturas da Sessão</h3>
                       <button onClick={() => setDualSignatureFlow({ ...dualSignatureFlow, isOpen: false })} className="text-white/80 hover:text-white"><i className="ph ph-x text-2xl"></i></button>
                     </div>
                     <div className="p-8 flex flex-col items-center gap-6 text-center">
                        <p className="text-slate-600 font-medium pb-2 border-b">
                            Para salvar de forma permanente essa ficha de evolução no histórico de {selectedPatient?.nome}, colete as assinaturas (opcional):
                        </p>
                        <div className="flex gap-8 justify-center w-full mt-2">
                           {/* Profissional Card */}
                           <button 
                             type="button" 
                             onClick={() => {
                               setSignatureModal({
                                 isOpen: true, role: 'Fisioterapeuta / Instrutor',
                                 callback: (sig, photo) => setDualSignatureFlow(prev => ({ ...prev, fisioData: { sig, photo } }))
                               });
                             }}
                             className={`flex flex-col items-center p-6 border-2 rounded-xl transition-all w-1/2 min-h-[140px] justify-center gap-3 ${dualSignatureFlow.fisioData ? 'border-emerald-500 bg-emerald-50 shadow-emerald-100/50' : 'border-slate-200 hover:border-emerald-300 hover:bg-slate-50 border-dashed'} shadow-sm`}
                           >
                              <i className={`ph ${dualSignatureFlow.fisioData ? 'ph-check-circle text-emerald-500' : 'ph-stethoscope text-slate-400'} text-4xl`}></i>
                              <span className={`font-bold ${dualSignatureFlow.fisioData ? 'text-emerald-700' : 'text-slate-600'}`}>{dualSignatureFlow.fisioData ? 'Profissional Assinado!' : 'Assinar Profissional'}</span>
                           </button>

                           {/* Paciente Card */}
                           <button 
                             type="button" 
                             onClick={() => {
                               setSignatureModal({
                                 isOpen: true, role: 'Paciente',
                                 callback: (sig, photo) => setDualSignatureFlow(prev => ({ ...prev, ptData: { sig, photo } }))
                               });
                             }}
                             className={`flex flex-col items-center p-6 border-2 rounded-xl transition-all w-1/2 min-h-[140px] justify-center gap-3 ${dualSignatureFlow.ptData ? 'border-emerald-500 bg-emerald-50 shadow-emerald-100/50' : 'border-slate-200 hover:border-emerald-300 hover:bg-slate-50 border-dashed'} shadow-sm`}
                           >
                              <i className={`ph ${dualSignatureFlow.ptData ? 'ph-check-circle text-emerald-500' : 'ph-user-circle text-slate-400'} text-4xl`}></i>
                              <span className={`font-bold ${dualSignatureFlow.ptData ? 'text-emerald-700' : 'text-slate-600'}`}>{dualSignatureFlow.ptData ? 'Paciente Assinado!' : 'Assinar Paciente'}</span>
                           </button>
                        </div>
                     </div>
                     <div className="p-4 border-t bg-slate-50 flex justify-end gap-3">
                       <button type="button" onClick={() => setDualSignatureFlow({ ...dualSignatureFlow, isOpen: false })} className="px-5 py-2 font-bold text-slate-500 hover:bg-slate-200 rounded-lg transition-colors">Cancelar</button>
                       <button 
                         type="button" 
                         onClick={() => {
                            let finalEval = { 
                                ...dualSignatureFlow.payload,
                                assinaturaFisio: dualSignatureFlow.fisioData ? dualSignatureFlow.fisioData.sig : null,
                                fotoFisio: dualSignatureFlow.fisioData ? dualSignatureFlow.fisioData.photo : null,
                                assinaturaPaciente: dualSignatureFlow.ptData ? dualSignatureFlow.ptData.sig : null,
                                fotoPaciente: dualSignatureFlow.ptData ? dualSignatureFlow.ptData.photo : null 
                            };

                            // Auto-deduct pacote para sessão de pilates
                            if (finalEval.assinaturaPaciente && !finalEval.pacoteDebitado) {
                                const pName = (selectedPatient.nome || '').trim();
                                if (decrementPackageForPatient(pName, finalEval.id || Date.now().toString())) {
                                    finalEval.pacoteDebitado = true;
                                }
                            }

                            const prevList = selectedPatient.evolucoesPilates || [];
                            let updatedArray;
                            if (!finalEval.id) {
                                finalEval.id = Date.now().toString();
                                finalEval.data = new Date().toISOString().split('T')[0];
                                updatedArray = [finalEval, ...prevList];
                            } else {
                                updatedArray = prevList.map(item => (item.id === finalEval.id || item === dualSignatureFlow.payload) ? finalEval : item);
                            }
                            updatePatientState({ ...selectedPatient, evolucoesPilates: updatedArray });
                            setPilatesEvol({ ...getEmptyPilatesEvol(), instrutor: currentUser?.nome || '' });
                            showToast('Ficha salva!', 'success');
                            setDualSignatureFlow({ isOpen: false, fisioData: null, ptData: null, payload: null });
                         }}
                         className={`px-6 py-2 rounded-lg flex items-center gap-2 font-bold shadow-md transition-all bg-emerald-600 hover:bg-emerald-700 text-white shadow-emerald-200`}
                       >
                         <i className="ph ph-hard-drives"></i> Salvar no Banco Histórico
                       </button>
                     </div>
                   </div>
                 </div>
               )}


               {viewSignatures && (
                 <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[200] p-4 text-slate-800 animate-fadeIn">
                   <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl overflow-hidden flex flex-col scale-in max-h-[90vh]">
                     <div className="bg-emerald-800 text-white p-4 flex justify-between items-center">
                       <h3 className="text-xl font-bold flex items-center"><i className="ph ph-pen-nib mr-2"></i> Assinaturas da Sessão - {viewSignatures.data}</h3>
                       <button onClick={() => setViewSignatures(null)} className="text-white/80 hover:text-white"><i className="ph ph-x text-2xl"></i></button>
                     </div>
                     <div className="p-6 overflow-y-auto overflow-x-hidden flex flex-col gap-8">
                       <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-center">
                         <div className="border border-slate-200 p-4 rounded-xl shadow-sm bg-slate-50 relative">
                           <h4 className="font-bold text-slate-700 mb-4 border-b pb-2"><i className="ph ph-user-circle text-lg"></i> Paciente</h4>
                           {viewSignatures.fotoPaciente && <img src={viewSignatures.fotoPaciente} alt="Selfie Paciente" className="w-24 h-24 object-cover rounded-full mx-auto mb-4 border-4 border-white shadow-md z-10 relative" />}
                           {viewSignatures.assinaturaPaciente ? (
                              <img src={viewSignatures.assinaturaPaciente} alt="Assinatura" className="max-w-full max-h-[150px] mx-auto filter contrast-125 mix-blend-multiply" />
                           ) : (
                              <p className="text-sm text-slate-400 italic py-8">Nenhuma assinatura registrada.</p>
                           )}
                           <div className="border-t border-slate-300 mt-2 mx-8 pt-1 text-xs uppercase tracking-wider text-slate-500 font-semibold">{selectedPatient?.nome}</div>
                         </div>
                         
                         <div className="border border-emerald-100 p-4 rounded-xl shadow-sm bg-emerald-50/50 relative">
                           <h4 className="font-bold text-emerald-800 mb-4 border-b border-emerald-200 pb-2"><i className="ph ph-stethoscope text-lg"></i> Profissional</h4>
                           {viewSignatures.fotoFisio && <img src={viewSignatures.fotoFisio} alt="Selfie Fisio" className="w-24 h-24 object-cover rounded-full mx-auto mb-4 border-4 border-white shadow-md z-10 relative" />}
                           {viewSignatures.assinaturaFisio ? (
                              <img src={viewSignatures.assinaturaFisio} alt="Assinatura" className="max-w-full max-h-[150px] mx-auto filter contrast-125 mix-blend-multiply" />
                           ) : (
                              <p className="text-sm text-emerald-600/50 italic py-8">Nenhuma assinatura registrada.</p>
                           )}
                           <div className="border-t border-emerald-300 mt-2 mx-8 pt-1 text-xs uppercase tracking-wider text-emerald-700 font-semibold">{viewSignatures.instrutor || 'Fisioterapeuta'}</div>
                         </div>
                       </div>
                     </div>
                     <div className="p-4 border-t bg-slate-50 text-right">
                       <button type="button" onClick={() => setViewSignatures(null)} className="px-5 py-2 font-bold text-slate-600 hover:bg-slate-200 rounded-lg transition-colors">Fechar</button>
                     </div>
                   </div>
                 </div>
               )}


               {/* 🔹 Modal Histórico de Presenças Pilates 🔹 */}
               {pilatesHistoryModal.open && (
                 <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[500] p-4 animate-fadeIn" onClick={() => setPilatesHistoryModal({open: false, patientId: null, pacienteNome: ''})}>
                   <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden flex flex-col max-h-[80vh]" onClick={e => e.stopPropagation()}>
                     <div className="p-5 flex items-center justify-between border-b border-slate-100">
                       <h3 className="text-xl font-bold flex items-center gap-2 text-slate-800">
                         <i className="ph ph-clock-counter-clockwise text-emerald-600 text-2xl"></i> Histórico de Presenças
                       </h3>
                       <button onClick={() => setPilatesHistoryModal({open: false, patientId: null, pacienteNome: ''})} className="text-slate-400 hover:text-slate-600"><i className="ph ph-x text-2xl"></i></button>
                     </div>
                     <div className="p-6 overflow-y-auto">
                       <p className="text-sm font-semibold text-slate-500 mb-4">Aluno: <span className="text-slate-800">{pilatesHistoryModal.pacienteNome}</span></p>
                       <div className="space-y-4">
                         {presenceRecords.filter(r => String(r.patient_id) === String(pilatesHistoryModal.patientId) && r.type === 'pilates_mensalidade').length === 0 ? (
                           <p className="text-center text-slate-400 py-6">Nenhuma presença registrada em Pilates para este aluno.</p>
                         ) : presenceRecords.filter(r => String(r.patient_id) === String(pilatesHistoryModal.patientId) && r.type === 'pilates_mensalidade').sort((a,b) => new Date(b.created_at) - new Date(a.created_at)).map(r => (
                           <div key={r.id} className="p-4 border border-slate-200 rounded-xl bg-slate-50 flex justify-between items-center">
                             <div>
                               <p className="font-bold text-slate-700 text-sm">{new Date(r.created_at).toLocaleString('pt-BR')}</p>
                               <p className="text-xs text-emerald-600 font-semibold mt-1"><i className="ph ph-check-circle"></i> Sessão Assinada</p>
                             </div>
                             {r.patient_signature && (
                               <div className="h-10">
                                 <img src={r.patient_signature} alt="Assinatura" className="h-full object-contain bg-white rounded border border-slate-200" />
                               </div>
                             )}
                           </div>
                         ))}
                       </div>
                     </div>
                   </div>
                 </div>
               )}

               {/* 🔹 Modal Adicionar Aluno ao Pilates 🔹 */}
               {/* Modal Adicionar Aluno Fisioterapia */}
               {fisioEnrollModalOpen && (
                 <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[500] p-4 animate-fadeIn" onClick={() => { setFisioEnrollModalOpen(false); setFisioEnrollSearch(''); }}>
                   <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden" onClick={e => e.stopPropagation()}>
                     {/* Header */}
                     <div className="p-5 flex items-center justify-between bg-sky-600 text-white">
                       <h3 className="text-lg font-bold flex items-center gap-2"><i className="ph ph-user-plus text-2xl"></i> Adicionar à Fisioterapia</h3>
                       <button type="button" onClick={() => { setFisioEnrollModalOpen(false); setFisioEnrollSearch(''); }} className="text-white/70 hover:text-white"><i className="ph ph-x text-2xl"></i></button>
                     </div>

                     <div className="p-6 space-y-5 max-h-[75vh] overflow-y-auto">

                       {/* Busca de paciente */}
                       <div className="relative">
                         <label className="block text-xs font-bold text-slate-700 mb-1">Buscar Paciente *</label>
                         <div className="relative">
                           <i className="ph ph-magnifying-glass absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-lg"></i>
                           <input
                             type="text"
                             autoComplete="off"
                             placeholder="Digite o nome do paciente..."
                             value={fisioEnrollSearch}
                             onChange={e => {
                               setFisioEnrollSearch(e.target.value);
                               if(!e.target.value) setFisioEnrollForm(prev => ({...prev, patientId: ''}));
                             }}
                             className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 focus:border-sky-500 focus:ring-2 focus:ring-sky-200 rounded-xl font-medium text-slate-700 transition-all placeholder-slate-400"
                           />
                         </div>
                         {/* Lista de Sugestões */}
                         {fisioEnrollSearch && !fisioEnrollForm.patientId && (
                           <div className="absolute z-10 w-full mt-1 bg-white border border-slate-200 rounded-xl shadow-lg max-h-48 overflow-y-auto">
                             {patients.filter(p => !p.faz_fisio && (p.nome || '').toLowerCase().includes((fisioEnrollSearch || '').toLowerCase())).slice(0,5).map(p => (
                               <button
                                 key={p.id}
                                 type="button"
                                 className="w-full text-left px-4 py-2.5 hover:bg-sky-50 text-sm font-semibold text-slate-700 border-b last:border-b-0 flex justify-between"
                                 onClick={() => {
                                   setFisioEnrollForm(prev => ({...prev, patientId: p.id}));
                                   setFisioEnrollSearch(p.nome);
                                 }}
                               >
                                 <span>{p.nome}</span>
                                 <span className="text-xs text-slate-400">CPF: {p.cpf || '---'}</span>
                               </button>
                             ))}
                             {patients.filter(p => !p.faz_fisio && (p.nome || '').toLowerCase().includes((fisioEnrollSearch || '').toLowerCase())).length === 0 && (
                               <div className="px-4 py-3 text-sm text-slate-500 text-center italic">Nenhum paciente não matriculado encontrado.</div>
                             )}
                           </div>
                         )}
                       </div>

                       <div className={`grid grid-cols-1 md:grid-cols-${fisioEnrollForm.formaPagamento === 'pacote' ? '3' : '2'} gap-4`}>
                         <div>
                           <label className="block text-xs font-bold text-slate-700 mb-1">Valor da Sessão/Pacote (R$)</label>
                           <input type="number" step="0.01" value={fisioEnrollForm.valorSessao} onChange={e => setFisioEnrollForm({...fisioEnrollForm, valorSessao: e.target.value})} className="w-full px-4 py-3 bg-white border border-slate-200 focus:border-sky-500 focus:ring-2 focus:ring-sky-200 rounded-xl font-medium text-slate-700 transition-all" />
                         </div>
                         <div>
                           <label className="block text-xs font-bold text-slate-700 mb-1">Forma de Pagamento</label>
                           <div className="relative">
                             <select value={fisioEnrollForm.formaPagamento} onChange={e => setFisioEnrollForm({...fisioEnrollForm, formaPagamento: e.target.value})} className="w-full pl-4 pr-10 py-3 bg-white border border-slate-200 focus:border-sky-500 focus:ring-2 focus:ring-sky-200 rounded-xl font-medium text-slate-700 transition-all appearance-none">
                               <option value="sessao">Por Sessão</option>
                               <option value="pacote">Pacote Fechado</option>
                             </select>
                             <i className="ph ph-caret-down absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"></i>
                           </div>
                         </div>
                         {fisioEnrollForm.formaPagamento === 'pacote' && (
                           <div>
                             <label className="block text-xs font-bold text-slate-700 mb-1">Qtd. de Sessões *</label>
                             <input type="number" value={fisioEnrollForm.qtdSessoes} onChange={e => setFisioEnrollForm({...fisioEnrollForm, qtdSessoes: e.target.value})} min="1" className="w-full px-4 py-3 bg-white border border-slate-200 focus:border-sky-500 focus:ring-2 focus:ring-sky-200 rounded-xl font-medium text-slate-700 transition-all" />
                           </div>
                         )}
                       </div>

                       {/* Seleção de Profissional */}
                       <div>
                         <label className="block text-xs font-bold text-slate-700 mb-1">Profissional (Fisioterapeuta) *</label>
                         <div className="relative">
                           <i className="ph ph-stethoscope absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-lg"></i>
                           <select
                             value={fisioEnrollForm.fisio1_id}
                             onChange={e => setFisioEnrollForm(prev => ({...prev, fisio1_id: e.target.value}))}
                             className="w-full pl-10 pr-4 py-3 bg-white border border-slate-200 focus:border-sky-500 focus:ring-2 focus:ring-sky-200 rounded-xl font-medium text-slate-700 transition-all appearance-none"
                           >
                             <option value="">Selecione o profissional...</option>
                             {usersList.filter(u => userPodeAtribuirComoProfissional(u)).map(u => (
                               <option key={u.id} value={u.id}>{u.nome} ({formatNiveisLabel(u.nivel)})</option>
                             ))}
                           </select>
                           <i className="ph ph-caret-down absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"></i>
                         </div>
                       </div>

                       {/* Horário e Dias */}
                       <div>
                         <label className="block text-xs font-bold text-slate-700 mb-1">Horário da Sessão/Consulta *</label>
                         <div className="relative mb-4">
                           <input type="time" value={fisioEnrollForm.horario} onChange={e => setFisioEnrollForm({...fisioEnrollForm, horario: e.target.value})} className="w-full px-4 py-3 bg-white border border-slate-200 focus:border-sky-500 focus:ring-2 focus:ring-sky-200 rounded-xl font-medium text-slate-700 transition-all" />
                         </div>
                         <label className="block text-xs font-bold text-slate-700 mb-2">Dias da Semana *</label>
                         <div className="flex flex-wrap gap-2">
                           {['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'].map(d => (
                             <button
                               key={d}
                               type="button"
                               onClick={() => {
                                 setFisioEnrollForm(prev => {
                                   const newDias = (prev.diasSemana || []).includes(d) ? (prev.diasSemana || []).filter(x => x !== d) : [...(prev.diasSemana || []), d];
                                   return { ...prev, diasSemana: newDias };
                                 });
                               }}
                               className={`px-4 py-2 rounded-xl text-sm font-bold transition-colors ${(fisioEnrollForm.diasSemana || []).includes(d) ? 'bg-sky-600 text-white shadow-sm' : 'bg-white text-slate-600 border border-slate-200 hover:bg-slate-50'}`}
                             >
                               {d}
                             </button>
                           ))}
                         </div>
                       </div>
                     </div>

                     {/* Footer */}
                     <div className="p-5 border-t bg-slate-50 flex justify-end gap-3">
                       <button type="button" onClick={() => { setFisioEnrollModalOpen(false); setFisioEnrollSearch(''); }} className="px-6 py-2.5 rounded-xl font-bold text-slate-600 hover:bg-slate-200 transition-colors">
                         Cancelar
                       </button>
                       <button
                         type="button"
                         onClick={handleFisioEnrollSubmit}
                         disabled={!fisioEnrollForm.patientId || !fisioEnrollForm.fisio1_id}
                         className="px-6 py-2.5 rounded-xl font-bold bg-sky-600 text-white hover:bg-sky-700 transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                       >
                         <i className="ph ph-check-circle text-lg"></i> Matricular Paciente
                       </button>
                     </div>
                   </div>
                 </div>
               )}

               {pilatesEnrollOpen && (
                 <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[500] p-4 animate-fadeIn" onClick={() => { setPilatesEnrollOpen(false); setPilatesEnrollSearch(''); }}>
                   <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden" onClick={e => e.stopPropagation()}>
                     {/* Header */}
                     <div className="p-5 flex items-center justify-between bg-emerald-600 text-white">
                       <h3 className="text-lg font-bold flex items-center gap-2"><i className="ph ph-user-plus text-2xl"></i> Adicionar ao Pilates</h3>
                       <button type="button" onClick={() => { setPilatesEnrollOpen(false); setPilatesEnrollSearch(''); }} className="text-white/70 hover:text-white"><i className="ph ph-x text-2xl"></i></button>
                     </div>

                     <div className="p-6 space-y-5 max-h-[75vh] overflow-y-auto">

                       {/* Busca de paciente */}
                       <div className="relative">
                         <label className="block text-xs font-bold text-slate-700 mb-1">Buscar Paciente *</label>
                         <div className="relative">
                           <i className="ph ph-magnifying-glass absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-lg"></i>
                           <input
                             type="text"
                             autoComplete="off"
                             placeholder="Digite o nome do paciente..."
                             value={pilatesEnrollSearch}
                             onChange={e => { setPilatesEnrollSearch(e.target.value); setPilatesEnrollForm({...pilatesEnrollForm, patientId: ''}); }}
                             className="w-full pl-9 pr-4 py-3 rounded-xl border border-slate-200 text-sm font-semibold text-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-400"
                           />
                         </div>
                         {pilatesEnrollSearch.length >= 1 && !pilatesEnrollForm.patientId && (() => {
                           const matches = patientsVisiveis.filter(p => !p.faz_pilates && !p.pilates_cancelado_em && (p.nome || '').toLowerCase().includes((pilatesEnrollSearch || '').toLowerCase())).slice(0, 8);
                           return matches.length > 0 ? (
                             <div className="absolute z-10 w-full mt-1 bg-white border border-slate-200 rounded-xl shadow-lg overflow-hidden">
                               {matches.map(p => (
                                 <button key={p.id} type="button"
                                   className="w-full text-left px-4 py-3 text-sm hover:bg-emerald-50 font-semibold text-slate-700 border-b border-slate-100 last:border-0 transition-colors"
                                   onClick={() => { setPilatesEnrollForm({...pilatesEnrollForm, patientId: p.id}); setPilatesEnrollSearch(p.nome); }}>
                                   <i className="ph ph-user text-emerald-500 mr-2"></i>{p.nome}
                                 </button>
                               ))}
                             </div>
                           ) : (
                             <div className="absolute z-10 w-full mt-1 bg-white border border-slate-200 rounded-xl shadow-lg px-4 py-3 text-sm text-slate-400">
                               Nenhum paciente encontrado
                             </div>
                           );
                         })()}
                         {pilatesEnrollForm.patientId && (
                           <p className="mt-1.5 text-xs text-emerald-700 font-bold flex items-center gap-1"><i className="ph ph-check-circle"></i> Paciente selecionado</p>
                         )}
                       </div>

                       {/* Valor e Vencimento */}
                       <div className="grid grid-cols-2 gap-4">
                         <div>
                           <label className="block text-xs font-bold text-slate-700 mb-1">Valor Mensalidade (R$)</label>
                           <input type="number" step="0.01" value={pilatesEnrollForm.valorMensalidade} onChange={e => setPilatesEnrollForm({...pilatesEnrollForm, valorMensalidade: e.target.value})} className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm font-semibold text-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-400" />
                         </div>
                         <div>
                           <label className="block text-xs font-bold text-slate-700 mb-1">Dia de Vencimento</label>
                           <input type="number" min="1" max="31" value={pilatesEnrollForm.diaVencimento} onChange={e => setPilatesEnrollForm({...pilatesEnrollForm, diaVencimento: e.target.value})} className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm font-semibold text-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-400" />
                         </div>
                       </div>

                        {/* Profissional Responsável */}
                        <div>
                          <label className="block text-xs font-bold text-slate-700 mb-1">Profissional Responsável</label>
                          <select
                            value={pilatesEnrollForm.professionalId}
                            onChange={e => setPilatesEnrollForm({...pilatesEnrollForm, professionalId: e.target.value})}
                            className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm font-semibold text-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-400 bg-white"
                          >
                            <option value="">— Selecionar profissional —</option>
                            {usersList.filter(u => {
                              const niveis = parseUserNiveis(u.nivel || '');
                              return niveis.some(n => ['Fisioterapeuta','Instrutor de Pilates','Administrador','Super Administrador'].includes(n));
                            }).map(u => (
                              <option key={u.id} value={String(u.id)}>{u.nome}</option>
                            ))}
                          </select>
                        </div>

                        {/* Horário */}
                        <div>
                          <label className="block text-xs font-bold text-slate-700 mb-1">Horário das Aulas</label>
                          <input type="time" value={pilatesEnrollForm.horario} onChange={e => setPilatesEnrollForm({...pilatesEnrollForm, horario: e.target.value})} className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm font-semibold text-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-400" />
                        </div>

                       {/* Dias da Semana */}
                       <div>
                         <label className="block text-xs font-bold text-slate-700 mb-2">Dias de Aula</label>
                         <div className="flex gap-2 flex-wrap">
                           {DIAS_SEMANA.map(dia => {
                             const ativo = (pilatesEnrollForm.diasSemana || []).includes(dia);
                             return (
                               <button key={dia} type="button"
                                 onClick={() => {
                                   const arr = ativo
                                     ? pilatesEnrollForm.diasSemana.filter(d => d !== dia)
                                     : [...pilatesEnrollForm.diasSemana, dia];
                                   setPilatesEnrollForm({...pilatesEnrollForm, diasSemana: arr});
                                 }}
                                 className={`px-4 py-2 rounded-xl text-sm font-bold border-2 transition-all ${
                                   ativo
                                     ? 'bg-emerald-600 text-white border-emerald-600 shadow-md shadow-emerald-200'
                                     : 'bg-white text-slate-600 border-slate-200 hover:border-emerald-400 hover:text-emerald-600'
                                 }`}
                               >{dia}</button>
                             );
                           })}
                         </div>
                       </div>

                     </div>

                     <div className="p-4 bg-slate-50 border-t border-slate-100 flex justify-end gap-3">
                       <button type="button" onClick={() => { setPilatesEnrollOpen(false); setPilatesEnrollSearch(''); }} className="px-5 py-2.5 border border-slate-300 rounded-xl text-slate-600 font-bold hover:bg-slate-100 transition-colors">Cancelar</button>
                       <button type="button" onClick={(e) => { e.preventDefault(); handlePilatesEnrollSubmit(); }} className="px-6 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-bold transition-all shadow-md flex items-center gap-2"><i className="ph ph-floppy-disk"></i> Salvar</button>
                     </div>
                   </div>
                 </div>
               )}

               {deploymentModals}

              {/* ── Modal Vender Pacote (global) ── */}
              {packageModalCtx && (() => {
                const patName = packageModalCtx.patientName || packageModalCtx.title || 'Paciente';
                const existingPkg = packages.find(p => p.patientName === patName && p.remaining > 0 && p.active);
                return (
                <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-slate-900/50 animate-fadeIn">
                  <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl p-6 relative">
                    <button onClick={() => setPackageModalCtx(null)} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600"><i className="ph ph-x text-xl"></i></button>
                    <div className="flex items-center gap-3 mb-6 mt-1">
                      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
                        <i className="ph ph-shopping-bag text-xl"></i>
                      </span>
                      <h2 className="text-xl font-bold text-slate-800">Vender Pacote</h2>
                    </div>
                    <p className="text-sm text-slate-500 mb-4 border-b border-slate-100 pb-4">
                      Vincular novo pacote ao paciente <br/><strong className="text-slate-700 text-base">{patName}</strong>
                    </p>

                    {existingPkg && (
                      <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-xl text-sm">
                        <i className="ph ph-warning text-amber-600 mr-1"></i>
                        <span className="text-amber-700 font-semibold">Este paciente já possui um pacote ativo com {existingPkg.remaining} sessão(ões) restante(s).</span>
                        <p className="text-amber-600 text-xs mt-1">Ao confirmar, o pacote anterior será encerrado e um novo será criado.</p>
                      </div>
                    )}

                    <div className="space-y-4 mb-8">
                      <div>
                        <label className="block text-sm font-bold text-slate-700 mb-1">Quantidade de Sessões</label>
                        <input id="pkg-qty" type="number" defaultValue="10" className="w-full p-3 border border-slate-200 rounded-xl focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none" min="1" />
                      </div>
                      <div>
                        <label className="block text-sm font-bold text-slate-700 mb-1">Valor Total do Pacote (R$)</label>
                        <input id="pkg-valor" type="text" defaultValue="1500,00" className="w-full p-3 border border-slate-200 rounded-xl focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none font-medium tabular-nums" />
                      </div>
                      <div>
                        <label className="block text-sm font-bold text-slate-700 mb-1">Forma de Pagamento</label>
                        <select id="pkg-metodo" className="w-full p-3 border border-slate-200 rounded-xl focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none bg-white font-medium text-slate-700">
                          <option>PIX (À Vista)</option>
                          <option>Cartão de Crédito</option>
                          <option>Cartão de Débito</option>
                          <option>Dinheiro em Espécie</option>
                          <option>Boleto / Múltiplo</option>
                        </select>
                      </div>
                    </div>

                    <div className="flex gap-3 mt-4 pt-4 border-t border-slate-100">
                      <button type="button" onClick={() => setPackageModalCtx(null)} className="flex-1 py-3 bg-slate-100 text-slate-700 rounded-xl font-bold hover:bg-slate-200 transition-colors">
                        Cancelar
                      </button>
                      <button type="button" onClick={() => {
                        const qtyEl = document.getElementById('pkg-qty');
                        const valorEl = document.getElementById('pkg-valor');
                        const metodoEl = document.getElementById('pkg-metodo');
                        const qty = parseInt(qtyEl?.value) || 10;
                        const valor = valorEl?.value || '1500,00';
                        const metodo = metodoEl?.value || 'PIX';
                        const today = new Date().toISOString().split('T')[0];

                        /* encerrar pacote anterior se existir */
                        let updated = packages.map(p => (p.patientName === patName && p.active) ? { ...p, active: false } : p);

                        /* novo pacote */
                        const newPkg = {
                          id: 'pkg_' + Date.now(),
                          patientName: patName,
                          patientId: packageModalCtx.patientId || '',
                          totalSessions: qty,
                          remaining: qty,
                          usedSessions: 0,
                          valor: valor,
                          metodo: metodo,
                          dataCompra: today,
                          active: true,
                          history: [],
                        };
                        updated = [newPkg, ...updated];
                        persistPackages(updated);

                        if (packageModalCtx.id) {
                          patchEv(packageModalCtx.id, { paymentPending: false, paymentStatus: 'Pago', paymentMethod: metodo, paymentValue: valor });
                        } else {
                          const finEntry = {
                            id: 'pkg_fin_' + Date.now(),
                            tipo: 'receita',
                            descricao: `Venda de Pacote: ${qty} sessões - ${patName}`,
                            valor: valor,
                            data: today,
                            categoria: 'Pacote',
                            metodo: metodo,
                            status: 'pago',
                            origem: 'manual'
                          };
                          persistFinEntries([finEntry, ...finEntries]);
                        }

                        showToast(`Pacote de ${qty} sessões vendido para ${patName}!`, 'success');
                        setPackageModalCtx(null);
                      }} className="flex-1 py-3 bg-emerald-600 text-white rounded-xl font-bold hover:bg-emerald-700 transition-colors shadow-md border border-emerald-700/50">
                        Confirmar Venda
                      </button>
                    </div>
                  </div>
                </div>
                );
              })()}

              {/* ── Modal Receber Pagamento (global) ── */}
              {paymentModalCtx && (
                <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-slate-900/50 animate-fadeIn">
                  <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl p-6 relative">
                    <button onClick={() => setPaymentModalCtx(null)} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600"><i className="ph ph-x text-xl"></i></button>
                    <h2 className="text-xl font-bold text-slate-800 mb-2 mt-1">Receber Pagamento</h2>
                    <p className="text-sm text-slate-500 mb-6">Paciente: <strong className="text-slate-700">{paymentModalCtx.patientName || 'Não informado'}</strong></p>
                    
                    <div className="flex gap-2 mb-6 bg-slate-100 p-1 rounded-xl">
                      <button onClick={() => setActivePaymentTab('PIX')} className={`flex-1 py-2 text-sm font-bold flex items-center justify-center gap-2 rounded-lg transition-all ${activePaymentTab === 'PIX' ? 'bg-white text-emerald-700 shadow cursor-default' : 'text-slate-500 hover:text-slate-700 cursor-pointer'}`}><i className="ph ph-qr-code"></i> PIX</button>
                      <button onClick={() => setActivePaymentTab('Espécie')} className={`flex-1 py-2 text-sm font-bold flex items-center justify-center gap-2 rounded-lg transition-all ${activePaymentTab === 'Espécie' ? 'bg-white text-emerald-700 shadow cursor-default' : 'text-slate-500 hover:text-slate-700 cursor-pointer'}`}><i className="ph ph-money"></i> Espécie</button>
                      <button onClick={() => setActivePaymentTab('Cartão')} className={`flex-1 py-2 text-sm font-bold flex items-center justify-center gap-2 rounded-lg transition-all ${activePaymentTab === 'Cartão' ? 'bg-white text-emerald-700 shadow cursor-default' : 'text-slate-500 hover:text-slate-700 cursor-pointer'}`}><i className="ph ph-credit-card"></i> Cartão</button>
                    </div>

                    {activePaymentTab === 'PIX' && (
                      <>
                        <div className="flex flex-col items-center bg-slate-50 rounded-xl border border-slate-200 p-6 mb-6">
                          <div className="w-48 h-48 bg-white border border-slate-200 rounded-xl p-2 shadow-sm mb-4 relative flex items-center justify-center">
                            {systemSettings?.pixKey ? (
                              <img src={`https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(generatePixPayload(systemSettings.pixKey, systemSettings.pixName || companyData?.nome_fantasia || 'Clinica', systemSettings.pixCity || 'Cidade', (paymentModalCtx.paymentValue || '150,00').toString().replace('.', '').replace(',', '.')))}`} alt="QR Code PIX" className="w-full h-full object-contain mix-blend-multiply" />
                            ) : (
                              <div className="text-center text-slate-400 p-4"><i className="ph ph-qr-code text-4xl mb-2 block"></i><p className="text-xs">Chave PIX não configurada (Ajuste em Sistema &gt; Configurações)</p></div>
                            )}
                          </div>
                          <p className="font-bold text-emerald-800 text-lg mb-2 text-center">R$ {paymentModalCtx.paymentValue || '150,00'}</p>
                          <button onClick={() => {
                              navigator.clipboard.writeText(systemSettings?.pixKey || 'Chave não configurada');
                              showToast('Chave PIX copiada para a área de transferência!', 'success');
                            }} className="text-sm font-bold text-indigo-600 bg-indigo-50 px-4 py-2 rounded-lg hover:bg-indigo-100 transition-colors flex items-center gap-2 w-full justify-center"
                          >
                            <i className="ph ph-copy"></i> Copiar Chave ({systemSettings?.pixKey || 'Não config.'})
                          </button>
                        </div>
                        <div className="flex flex-col gap-3">
                          <button type="button" onClick={() => {
                            let phone = '';
                            if (paymentModalCtx.patientId) {
                              const pt = patients.find(p => String(p.id) === String(paymentModalCtx.patientId));
                              if (pt && pt.telefone) phone = String(pt.telefone).replace(/\D/g, '');
                            }
                            if (phone && phone.length <= 11) phone = '55' + phone;
                            const pixK = systemSettings?.pixKey || 'Abaixo';
                            window.open(`https://wa.me/${phone}?text=${encodeURIComponent('Olá! Segue a nossa chave PIX para pagamento da consulta: ' + pixK + ' . Valor: R$ ' + (paymentModalCtx.paymentValue || '150,00'))}`, '_blank');
                          }} className="w-full py-3 bg-slate-800 text-white rounded-xl font-bold flex items-center justify-center gap-2 hover:bg-slate-900 transition-colors">
                            <i className="ph ph-whatsapp-logo text-green-400"></i> Enviar PIX no WhatsApp
                          </button>
                          <button type="button" onClick={() => {
                            patchEv(paymentModalCtx.id, { paymentPending: false, paymentStatus: 'Pago', paymentMethod: 'PIX' });
                            showToast('Pagamento confirmado com sucesso!', 'success');
                            setPaymentModalCtx(null);
                          }} className="w-full py-3 bg-emerald-600 text-white rounded-xl font-bold flex items-center justify-center hover:bg-emerald-700 transition-colors shadow-md border border-emerald-700/50">
                            Confirmar Pagamento PIX
                          </button>
                        </div>
                      </>
                    )}

                    {activePaymentTab === 'Espécie' && (
                      <div className="flex flex-col h-full animate-fadeIn">
                        <div className="flex-1 flex flex-col items-center justify-center bg-slate-50 rounded-xl border border-slate-200 p-8 mb-6">
                          <div className="w-20 h-20 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mb-4 shadow-inner">
                            <i className="ph ph-money text-4xl"></i>
                          </div>
                          <p className="text-slate-500 font-medium text-sm">Valor a ser recebido:</p>
                          <p className="font-black text-emerald-800 text-3xl mt-1">R$ {paymentModalCtx.paymentValue || '150,00'}</p>
                          <p className="text-xs text-slate-400 mt-4 text-center max-w-[200px]">Receba o dinheiro em espécie antes de prosseguir no sistema.</p>
                        </div>
                        <div className="mt-auto">
                          <button type="button" onClick={() => {
                            patchEv(paymentModalCtx.id, { paymentPending: false, paymentStatus: 'Pago', paymentMethod: 'Espécie' });
                            showToast('Pagamento em Espécie confirmado!', 'success');
                            setPaymentModalCtx(null);
                          }} className="w-full py-3 bg-emerald-600 text-white rounded-xl font-bold flex items-center justify-center hover:bg-emerald-700 transition-colors shadow-md border border-emerald-700/50">
                            Confirmar Dinheiro Recebido
                          </button>
                        </div>
                      </div>
                    )}

                    {activePaymentTab === 'Cartão' && (
                      <div className="flex flex-col h-full animate-fadeIn">
                        <div className="flex-1 flex flex-col items-center justify-center bg-slate-50 rounded-xl border border-slate-200 p-8 mb-6 relative overflow-hidden">
                          <div className="w-20 h-20 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center mb-4 relative z-10 shadow-inner">
                            <i className="ph ph-credit-card text-4xl animate-bounce"></i>
                          </div>
                          <p className="text-slate-500 font-medium text-sm relative z-10">Valor a ser cobrado:</p>
                          <p className="font-black text-indigo-800 text-3xl mt-1 relative z-10">R$ {paymentModalCtx.paymentValue || '150,00'}</p>
                          <div className="w-full px-4 py-3 bg-indigo-50 border border-indigo-100 rounded-lg mt-6 flex items-center gap-2 relative z-10">
                            <i className="ph ph-info text-indigo-500 text-xl"></i>
                            <p className="text-xs text-indigo-700 font-medium leading-tight">Passe o cartão do paciente na maquineta física de sua clínica.</p>
                          </div>
                        </div>
                        <div className="mt-auto">
                          <button type="button" onClick={() => {
                            patchEv(paymentModalCtx.id, { paymentPending: false, paymentStatus: 'Pago', paymentMethod: 'Cartão' });
                            showToast('Pagamento no Cartão confirmado!', 'success');
                            setPaymentModalCtx(null);
                          }} className="w-full py-3 bg-indigo-600 text-white rounded-xl font-bold flex items-center justify-center hover:bg-indigo-700 transition-colors shadow-md border border-emerald-700/50 gap-2">
                            <i className="ph ph-check-circle text-lg"></i> Pagamento Aprovado na Maquineta
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* ── Modal Renovação de Pacote (global) ── */}
              {renewalModalCtx && (() => {
                const patName = renewalModalCtx.patientName;
                const pat = patients.find(p => (p.nome || '').trim().toLowerCase() === patName.toLowerCase());
                const phone = (pat?.telefone || pat?.celular || pat?.phone || '').replace(/\D/g, '');
                const msgDefault = `Olá ${patName}! 😊\n\nInformamos que suas sessões do pacote foram finalizadas.\n\nGostaria de renovar seu pacote? Entre em contato conosco para continuar seu tratamento!\n\nEquipe Real Clínica 💚`;
                return (
                <div className="fixed inset-0 z-[300] flex items-center justify-center p-4 bg-slate-900/60 animate-fadeIn" onClick={() => setRenewalModalCtx(null)}>
                  <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()}>
                    <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-5 text-white">
                      <div className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
                          <i className="ph ph-bell-ringing text-2xl"></i>
                        </div>
                        <div>
                          <h3 className="text-lg font-bold">Pacote Finalizado!</h3>
                          <p className="text-sm text-orange-100">Todas as sessões foram utilizadas</p>
                        </div>
                      </div>
                    </div>
                    <div className="p-6 space-y-4">
                      <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl">
                        <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
                          <i className="ph ph-user text-emerald-700 text-xl"></i>
                        </div>
                        <div>
                          <p className="font-bold text-slate-800">{patName}</p>
                          <p className="text-xs text-slate-500">{renewalModalCtx.pkg?.totalSessions} sessões utilizadas · Pacote desde {renewalModalCtx.pkg?.dataCompra || '—'}</p>
                        </div>
                      </div>

                      <div>
                        <label className="block text-xs font-bold text-slate-700 mb-2">
                          <i className="ph ph-whatsapp-logo text-green-600 mr-1"></i> Mensagem de Renovação
                        </label>
                        <textarea id="renewal-msg" defaultValue={msgDefault} rows={5}
                          className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm text-slate-700 resize-none focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none" />
                      </div>

                      {phone && (
                        <p className="text-xs text-slate-500 flex items-center gap-1">
                          <i className="ph ph-phone text-emerald-600"></i> Telefone encontrado: <span className="font-bold text-slate-700">{phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')}</span>
                        </p>
                      )}
                      {!phone && (
                        <p className="text-xs text-amber-600 flex items-center gap-1">
                          <i className="ph ph-warning"></i> Telefone não cadastrado para este paciente. Cadastre o telefone na ficha do paciente.
                        </p>
                      )}
                    </div>
                    <div className="p-4 border-t bg-slate-50 flex flex-wrap gap-3 justify-end">
                      <button onClick={() => setRenewalModalCtx(null)} className="px-5 py-2.5 border border-slate-300 rounded-xl text-slate-600 font-bold hover:bg-slate-100 transition-colors">
                        Fechar
                      </button>
                      <button onClick={() => {
                        const patName2 = renewalModalCtx.patientName;
                        const pat2 = patients.find(p => (p.nome || '').trim().toLowerCase() === patName2.toLowerCase());
                        const ph = (pat2?.telefone || pat2?.celular || pat2?.phone || '').replace(/\D/g, '');
                        setPackageModalCtx({ patientName: patName2, patientId: pat2?.id || '', id: 'renewal_' + Date.now() });
                        setRenewalModalCtx(null);
                      }} className="px-5 py-2.5 bg-emerald-600 text-white rounded-xl font-bold hover:bg-emerald-700 transition-colors shadow-md flex items-center gap-2">
                        <i className="ph ph-shopping-bag text-lg"></i> Renovar Pacote
                      </button>
                      {phone && (
                        <button onClick={() => {
                          const msgEl = document.getElementById('renewal-msg');
                          const msg = encodeURIComponent(msgEl?.value || msgDefault);
                          window.open(`https://wa.me/55${phone}?text=${msg}`, '_blank');
                          showToast('WhatsApp aberto!', 'success');
                        }} className="px-5 py-2.5 bg-green-600 text-white rounded-xl font-bold hover:bg-green-700 transition-colors shadow-md flex items-center gap-2">
                          <i className="ph ph-whatsapp-logo text-lg"></i> Enviar WhatsApp
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                );
              })()}


              {/* ── Modal Novo Lançamento (global) ── */}
              {finModalOpen && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[200] p-4 animate-fadeIn" onClick={() => setFinModalOpen(false)}>
                  <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden" onClick={e => e.stopPropagation()}>
                    <div className={`p-5 flex items-center justify-between ${finModalForm.tipo === 'receita' ? 'bg-emerald-700' : 'bg-red-600'} text-white`}>
                      <h3 className="text-lg font-bold flex items-center gap-2">
                        <i className={`ph ${finModalForm.tipo === 'receita' ? 'ph-arrow-circle-up' : 'ph-arrow-circle-down'} text-2xl`}></i>
                        {finModalForm.id ? 'Editar ' : 'Nova '}
                        {finModalForm.tipo === 'receita' ? 'Receita' : 'Despesa'}
                      </h3>
                      <button onClick={() => setFinModalOpen(false)} className="text-white/70 hover:text-white"><i className="ph ph-x text-2xl"></i></button>
                    </div>
                    <div className="p-6 space-y-4">
                      <div>
                        <label className="block text-xs font-bold text-slate-700 mb-1">Descrição *</label>
                        <input type="text" placeholder={finModalForm.tipo === 'receita' ? 'Ex: Sessão particular, Venda de produto...' : 'Ex: Aluguel, Material, Energia...'} value={finModalForm.descricao} onChange={e => setFinModalForm({...finModalForm, descricao: e.target.value})}
                          className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm font-semibold text-slate-700" />
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-xs font-bold text-slate-700 mb-1">Valor (R$) *</label>
                          <input type="text" placeholder="0,00" value={finModalForm.valor} onChange={e => setFinModalForm({...finModalForm, valor: e.target.value})}
                            className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm font-semibold text-slate-700" />
                        </div>
                        <div>
                          <label className="block text-xs font-bold text-slate-700 mb-1">Data {finModalForm.recorrente ? '(vencimento)' : ''}</label>
                          <input type="date" value={finModalForm.data} onChange={e => setFinModalForm({...finModalForm, data: e.target.value})}
                            className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm font-semibold text-slate-700" />
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-xs font-bold text-slate-700 mb-1">Categoria</label>
                          <select value={finModalForm.categoria} onChange={e => setFinModalForm({...finModalForm, categoria: e.target.value})}
                            className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm font-semibold text-slate-700">
                            <option value="">Selecione...</option>
                            {finModalForm.tipo === 'receita' ? (
                              <>
                                <option>Consulta Particular</option>
                                <option>Sessão de Pilates</option>
                                <option>Pacote</option>
                                <option>Venda de Produto</option>
                                <option>Outro</option>
                              </>
                            ) : (
                              <>
                                <option>Aluguel</option>
                                <option>Energia</option>
                                <option>Água</option>
                                <option>Internet</option>
                                <option>Material</option>
                                <option>Equipamento</option>
                                <option>Manutenção</option>
                                <option>Salário</option>
                                <option>Marketing</option>
                                <option>Impostos</option>
                                <option>Outro</option>
                              </>
                            )}
                          </select>
                        </div>
                        <div>
                          <label className="block text-xs font-bold text-slate-700 mb-1">Forma de Pagamento</label>
                          <select value={finModalForm.metodo} onChange={e => setFinModalForm({...finModalForm, metodo: e.target.value})}
                            className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm font-semibold text-slate-700">
                            <option value="">Selecione...</option>
                            <option>PIX</option>
                            <option>Dinheiro</option>
                            <option>Cartão Crédito</option>
                            <option>Cartão Débito</option>
                            <option>Transferência</option>
                            <option>Boleto</option>
                          </select>
                        </div>
                      </div>

                      {/* Status Toggle */}
                      <div className="flex items-center justify-between bg-slate-50 rounded-xl p-4">
                        <div>
                          <label className="text-xs font-bold text-slate-700">Status do Pagamento</label>
                          <p className="text-[11px] text-slate-400 mt-0.5">Marque como pago ou deixe pendente</p>
                        </div>
                        <button type="button" onClick={() => setFinModalForm({...finModalForm, status: finModalForm.status === 'pago' ? 'pendente' : 'pago'})}
                          className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold transition-all ${finModalForm.status === 'pago' ? 'bg-emerald-600 text-white shadow-md shadow-emerald-200' : 'bg-amber-100 text-amber-700 border border-amber-200'}`}>
                          <i className={`ph ${finModalForm.status === 'pago' ? 'ph-check-circle' : 'ph-clock'} text-lg`}></i>
                          {finModalForm.status === 'pago' ? 'Pago' : 'Pendente'}
                        </button>
                      </div>

                      {/* Recorrente */}
                      <div className="flex items-center justify-between bg-indigo-50 rounded-xl p-4">
                        <div>
                          <label className="text-xs font-bold text-slate-700 flex items-center gap-1.5">
                            <i className="ph ph-arrows-clockwise text-indigo-600"></i> Conta Recorrente
                          </label>
                          <p className="text-[11px] text-slate-400 mt-0.5">Será gerada automaticamente todo mês</p>
                        </div>
                        <button type="button" onClick={() => setFinModalForm({...finModalForm, recorrente: !finModalForm.recorrente})}
                          className={`w-12 h-7 rounded-full transition-all relative ${finModalForm.recorrente ? 'bg-indigo-600' : 'bg-slate-300'}`}>
                          <span className={`absolute top-0.5 w-6 h-6 bg-white rounded-full shadow transition-all ${finModalForm.recorrente ? 'left-[22px]' : 'left-0.5'}`}></span>
                        </button>
                      </div>
                    </div>
                    <div className="p-4 border-t bg-slate-50 flex justify-end gap-3">
                      <button onClick={() => setFinModalOpen(false)} className="px-5 py-2.5 border border-slate-300 rounded-xl text-slate-600 font-bold hover:bg-slate-100 transition-colors">Cancelar</button>
                      <button onClick={handleFinSave}
                        className={`px-6 py-2.5 rounded-xl text-white font-bold shadow-md transition-all flex items-center gap-2 ${finModalForm.tipo === 'receita' ? 'bg-emerald-600 hover:bg-emerald-700 shadow-emerald-200' : 'bg-red-500 hover:bg-red-600 shadow-red-200'}`}>
                        <i className="ph ph-floppy-disk text-lg"></i> Salvar
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {reativarModal.open && (
                <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fadeIn">
                  <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden" onClick={e => e.stopPropagation()}>
                    <div className="bg-sky-600 p-5 flex items-center gap-3 text-white relative">
                      <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center shrink-0">
                        <i className="ph ph-play-circle text-2xl"></i>
                      </div>
                      <div>
                        <h3 className="font-bold text-lg leading-tight">Retomar Tratamento</h3>
                        <p className="text-sky-100 text-sm">Reativar paciente</p>
                      </div>
                      <button onClick={() => setReativarModal({ open: false, patient: null, tipo: 'fisio' })} className="absolute top-4 right-4 text-white/70 hover:text-white p-1 hover:bg-white/10 rounded-lg transition-colors">
                        <i className="ph ph-x text-xl"></i>
                      </button>
                    </div>

                    <div className="p-6">
                      <div className="mb-6 bg-slate-50 border border-slate-100 rounded-xl p-4 flex items-center gap-3">
                        <div className="w-10 h-10 bg-sky-100 text-sky-700 rounded-full flex items-center justify-center font-bold text-lg shrink-0">
                          {reativarModal.patient?.nome.charAt(0)}
                        </div>
                        <div className="min-w-0">
                          <p className="font-bold text-slate-800 truncate">{reativarModal.patient?.nome}</p>
                          <p className="text-xs text-slate-500">Confirme a reativação do tratamento</p>
                        </div>
                      </div>

                      <div className="mb-6">
                         <p className="text-sm text-slate-600">Modalidade a ser retomada: <strong className="text-slate-800 capitalize">{reativarModal.tipo === 'pilates' ? 'Pilates' : 'Fisioterapia'}</strong></p>
                      </div>

                      <div className="bg-sky-50 text-sky-800 text-xs p-3 rounded-xl border border-sky-100 mb-6 flex gap-2">
                        <i className="ph ph-info mt-0.5 text-base shrink-0"></i>
                        <span>
                          {reativarModal.tipo === 'pilates' ? 'Serão gerados novamente os agendamentos das próximas semanas e as mensalidades voltarão a ser lançadas automaticamente. ' : ''}
                          O paciente voltará para a lista de pacientes ativos na modalidade.
                        </span>
                      </div>

                      <div className="flex gap-3">
                        <button onClick={() => setReativarModal({ open: false, patient: null, tipo: 'fisio' })} className="flex-1 py-3 border border-slate-300 rounded-xl text-slate-600 font-bold hover:bg-slate-50 transition-colors">
                          Cancelar
                        </button>
                        <button 
                          onClick={() => {
                            const { patient, tipo } = reativarModal;
                            setReativarModal({ open: false, patient: null, tipo: 'fisio' });
                            if (tipo === 'pilates') {
                               setPilatesEnrollForm({
                                  patientId: patient.id,
                                  valorMensalidade: patient.valor_mensalidade_pilates || '150.00',
                                  diaVencimento: patient.dia_vencimento_pilates || '10',
                                  diasSemana: patient.dias_semana_pilates ? patient.dias_semana_pilates.split(',').map(d=>d.trim()) : [],
                                  horario: patient.horario_pilates || '',
                                  professionalId: patient.fisio1_id || ''
                               });
                               setPilatesEnrollSearch(patient.nome);
                               setPilatesEnrollOpen(true);
                            } else {
                               setFisioEnrollForm({
                                  patientId: patient.id,
                                  fisio1_id: patient.fisio1_id || '',
                                  valorSessao: patient.valor_sessao_fisio || '150.00',
                                  diasSemana: patient.dias_semana_fisio ? patient.dias_semana_fisio.split(',').map(d=>d.trim()) : [],
                                  horario: patient.horario_fisio || '',
                                  formaPagamento: patient.forma_pagamento_fisio || 'sessao',
                                  qtdSessoes: '10'
                               });
                               setFisioEnrollSearch(patient.nome);
                               setFisioEnrollModalOpen(true);
                            }
                          }}
                          className="flex-1 py-3 bg-sky-600 text-white rounded-xl font-bold hover:bg-sky-700 transition-colors shadow-md shadow-sky-200 flex items-center justify-center gap-2"
                        >
                          <i className="ph ph-play-circle text-lg"></i> Confirmar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Modal: Suspender Tratamento Fisioterapia */}
              {suspenderFisioModal.open && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                  <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
                    <div className="p-5 border-b border-slate-100 flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center">
                          <i className="ph ph-pause-circle text-amber-600 text-2xl"></i>
                        </div>
                        <div>
                          <h3 className="font-bold text-slate-800 text-lg">Suspender Tratamento</h3>
                          <p className="text-xs text-slate-500">{suspenderFisioModal.patient?.nome}</p>
                        </div>
                      </div>
                      <button onClick={() => setSuspenderFisioModal({ open: false, patient: null, motivo: '', dataRetorno: '', tipo: 'fisio' })} className="p-2 hover:bg-slate-100 rounded-lg transition-colors">
                        <i className="ph ph-x text-lg text-slate-500"></i>
                      </button>
                    </div>
                    <div className="p-5 space-y-4">

                      {suspenderFisioModal.patient?.faz_fisio && suspenderFisioModal.patient?.faz_pilates && (
                        <div className="flex flex-col gap-2">
                          <label className="text-xs font-bold text-slate-600">Quais modalidades suspender?</label>
                          <div className="flex flex-col gap-2 p-3 border border-slate-200 rounded-xl">
                            <label className="flex items-center gap-2 text-sm cursor-pointer">
                              <input type="radio" name="suspenderTipo" value="ambos" checked={suspenderFisioModal.tipo === 'ambos'} onChange={() => setSuspenderFisioModal(prev => ({ ...prev, tipo: 'ambos' }))} className="text-emerald-500" />
                              Ambos (Fisioterapia e Pilates)
                            </label>
                            <label className="flex items-center gap-2 text-sm cursor-pointer">
                              <input type="radio" name="suspenderTipo" value="fisio" checked={suspenderFisioModal.tipo === 'fisio'} onChange={() => setSuspenderFisioModal(prev => ({ ...prev, tipo: 'fisio' }))} className="text-emerald-500" />
                              Apenas Fisioterapia
                            </label>
                            <label className="flex items-center gap-2 text-sm cursor-pointer">
                              <input type="radio" name="suspenderTipo" value="pilates" checked={suspenderFisioModal.tipo === 'pilates'} onChange={() => setSuspenderFisioModal(prev => ({ ...prev, tipo: 'pilates' }))} className="text-emerald-500" />
                              Apenas Pilates
                            </label>
                          </div>
                        </div>
                      )}

                      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-sm text-amber-800 flex items-start gap-3">
                        <i className="ph ph-warning text-lg flex-shrink-0 mt-0.5"></i>
                        <span>O tratamento será <strong>pausado temporariamente</strong>. O paciente permanece na lista. Para retomar, clique em <strong>Retomar</strong>.</span>
                      </div>

                      <div>
                        <label className="block text-xs font-bold text-slate-600 mb-1.5">Motivo da Suspensão</label>
                        <textarea
                          rows={3}
                          className="w-full border border-slate-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-400 resize-none"
                          placeholder="Ex: Viagem, questões de saúde, dificuldade financeira..."
                          value={suspenderFisioModal.motivo}
                          onChange={(e) => setSuspenderFisioModal(prev => ({ ...prev, motivo: e.target.value }))}
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-bold text-slate-600 mb-1.5">Data de Retorno Prevista <span className="text-slate-400 font-normal">(opcional)</span></label>
                        <input
                          type="date"
                          className="w-full border border-slate-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-400"
                          value={suspenderFisioModal.dataRetorno}
                          onChange={(e) => setSuspenderFisioModal(prev => ({ ...prev, dataRetorno: e.target.value }))}
                        />
                      </div>
                    </div>
                    <div className="p-4 border-t bg-slate-50 flex justify-end gap-3 rounded-b-2xl">
                      <button onClick={() => setSuspenderFisioModal({ open: false, patient: null, motivo: '', dataRetorno: '', tipo: 'fisio' })} className="px-5 py-2.5 border border-slate-300 rounded-xl text-slate-600 font-bold hover:bg-slate-100 transition-colors">
                        Cancelar
                      </button>
                      <button onClick={handleFisioSuspender} className="px-6 py-2.5 bg-amber-500 hover:bg-amber-600 text-white rounded-xl font-bold shadow-md transition-all flex items-center gap-2">
                        <i className="ph ph-pause-circle text-lg"></i> Suspender Tratamento
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Modal: Cancelar Pilates */}
              {pilatesCancelModal.open && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[200] p-4 animate-fadeIn">
                  <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
                    <div className="bg-red-50 p-5 border-b border-red-100 flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
                        <i className="ph ph-warning-circle text-red-600 text-xl"></i>
                      </div>
                      <div>
                        <h3 className="font-bold text-red-800 text-lg">Cancelar Matrícula</h3>
                        <p className="text-xs text-red-600/80">Pilates</p>
                      </div>
                    </div>
                    <div className="p-6">
                      <p className="text-slate-700 text-[15px] mb-4">
                        Deseja realmente cancelar a matrícula de <strong className="text-slate-900">{pilatesCancelModal.patient?.nome}</strong> no Pilates?
                      </p>
                      <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 text-sm text-slate-600 flex items-start gap-3">
                        <i className="ph ph-info text-lg flex-shrink-0 mt-0.5 text-slate-400"></i>
                        <span>O nome continua na lista (riscado). Agendamentos a partir de hoje e parcelas futuras no financeiro serão removidos. Presenças já registradas permanecem.</span>
                      </div>
                    </div>
                    <div className="p-4 bg-slate-50 border-t border-slate-100 flex justify-end gap-3">
                      <button 
                        onClick={() => setPilatesCancelModal({ open: false, patient: null })} 
                        className="px-5 py-2.5 rounded-xl text-slate-600 font-bold hover:bg-slate-200 transition-colors"
                      >
                        Manter
                      </button>
                      <button 
                        onClick={confirmPilatesCancelEnroll} 
                        className="px-6 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-xl font-bold shadow-md shadow-red-600/20 transition-all flex items-center gap-2"
                      >
                        <i className="ph ph-check-circle text-lg"></i> Confirmar Cancelamento
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Toast Container */}

              <div className="toast-container">
                {toasts.map(toast => (
                  <div key={toast.id} className={`toast toast-${toast.type}`}>
                    <div className="flex-shrink-0">
                      {toast.type === 'success' && <i className="ph ph-check-circle text-2xl"></i>}
                      {toast.type === 'error' && <i className="ph ph-warning-circle text-2xl"></i>}
                      {toast.type === 'info' && <i className="ph ph-info text-2xl"></i>}
                    </div>
                    <div className="flex-1 font-semibold text-sm">{toast.message}</div>
                    <button onClick={() => setToasts(prev => prev.filter(t => t.id !== toast.id))} className="text-white/60 hover:text-white transition-colors">
                      <i className="ph ph-x text-lg"></i>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          );
        };

        

export default App;